function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var $parcel$modules = {};
var $parcel$inits = {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
    parcelRequire = function(id) {
        if (id in $parcel$modules) {
            return $parcel$modules[id].exports;
        }
        if (id in $parcel$inits) {
            var init = $parcel$inits[id];
            delete $parcel$inits[id];
            var module = {
                id: id,
                exports: {}
            };
            $parcel$modules[id] = module;
            init.call(module.exports, module, module.exports);
            return module.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    parcelRequire.register = function register(id, init) {
        $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire94c2"] = parcelRequire;
}
var parcelRegister = parcelRequire.register;
if (!$parcel$global.lb) {
    $parcel$global.lb = new Set();
    $parcel$global.bq = [];
    $parcel$global.rlb = (bundle)=>{
        $parcel$global.lb.add(bundle);
        $parcel$global.pq();
    };
    $parcel$global.rwr = (b, r, d)=>{
        $parcel$global.bq.push({
            b,
            r,
            d
        });
        $parcel$global.pq();
    };
    $parcel$global.pq = ()=>{
        var runnableEntry = $parcel$global.bq.find((i)=>{
            return i.d.every((dep)=>{
                return $parcel$global.lb.has(dep);
            });
        });
        if (runnableEntry) {
            $parcel$global.bq = $parcel$global.bq.filter((i)=>{
                return i.b !== runnableEntry.b;
            });
            runnableEntry.r();
            $parcel$global.pq();
        }
    };
}
parcelRegister("294ns", function(module, exports) {
    $parcel$export(module.exports, "setBooleanFeatureFlagResolver", ()=>$7961dd9b522c4cb9$export$ba05d765b8392e5e);
    $parcel$export(module.exports, "getBooleanFF", ()=>$7961dd9b522c4cb9$export$470e5c2be1411c89);
    $parcel$export(module.exports, "fg", ()=>$7961dd9b522c4cb9$export$b40ec24ac8275656);
    var $83Ylp;
    function $7961dd9b522c4cb9$export$ba05d765b8392e5e(flagResolver) {
        (0, (0, parcelRequire("83Ylp")).setBooleanResolver)(flagResolver);
    }
    function $7961dd9b522c4cb9$export$470e5c2be1411c89(name) {
        return (0, (0, parcelRequire("83Ylp")).resolveBooleanFlag)(name);
    }
    function $7961dd9b522c4cb9$export$b40ec24ac8275656(name) {
        return (0, (0, parcelRequire("83Ylp")).resolveBooleanFlag)(name);
    }
});
parcelRegister("83Ylp", function(module, exports) {
    $parcel$export(module.exports, "setBooleanResolver", ()=>$156a2f46705f05e0$export$f2b591175b3e424c);
    $parcel$export(module.exports, "resolveBooleanFlag", ()=>$156a2f46705f05e0$export$6333b6aff9fc6275);
    var $dI0KR;
    var $6cAn5 = parcelRequire("6cAn5");
    const $156a2f46705f05e0$var$pkgName = '@atlaskit/platform-feature-flags';
    const $156a2f46705f05e0$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
    const $156a2f46705f05e0$var$hasProcessEnv = typeof $6cAn5 !== 'undefined' && typeof $6cAn5.env !== 'undefined';
    const $156a2f46705f05e0$var$ENV_ENABLE_PLATFORM_FF = $156a2f46705f05e0$var$hasProcessEnv ? false : false;
    const $156a2f46705f05e0$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $156a2f46705f05e0$var$hasProcessEnv ? false : false;
    const $156a2f46705f05e0$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $156a2f46705f05e0$var$ENV_ENABLE_PLATFORM_FF || $156a2f46705f05e0$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
    const $156a2f46705f05e0$var$DEFAULT_PFF_GLOBAL = {
        earlyResolvedFlags: new Map(),
        booleanResolver: function(flagKey) {
            return false;
        }
    };
    const $156a2f46705f05e0$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
    $156a2f46705f05e0$var$globalVar[$156a2f46705f05e0$export$7e41b1b2bdee3f98] = $156a2f46705f05e0$var$globalVar[$156a2f46705f05e0$export$7e41b1b2bdee3f98] || $156a2f46705f05e0$var$DEFAULT_PFF_GLOBAL;
    function $156a2f46705f05e0$export$f2b591175b3e424c(resolver) {
        $156a2f46705f05e0$var$globalVar[$156a2f46705f05e0$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    }
    function $156a2f46705f05e0$export$6333b6aff9fc6275(flagKey) {
        if ($156a2f46705f05e0$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
            (0, (0, parcelRequire("dI0KR")).debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $156a2f46705f05e0$var$pkgName, flagKey);
            return true;
        }
        try {
            const result = $156a2f46705f05e0$var$globalVar[$156a2f46705f05e0$export$7e41b1b2bdee3f98]?.booleanResolver(flagKey);
            if (typeof result !== 'boolean') {
                console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
                return false;
            }
            return result;
        } catch (e) {
            return false;
        }
    }
});
parcelRegister("dI0KR", function(module, exports) {
    $parcel$export(module.exports, "debug", ()=>$6a73ab67d2282516$export$1c9f709888824e05);
    const $6a73ab67d2282516$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
    const $6a73ab67d2282516$var$DEBUG_MODE = !$6a73ab67d2282516$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
    const $6a73ab67d2282516$export$1c9f709888824e05 = (...args)=>{
        if (!$6a73ab67d2282516$var$DEBUG_MODE) return;
        console.debug(...args);
    };
});
parcelRegister("80CKu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d4c618110f1d03e$export$2e2bcd8739ae039);
    var $2Ebme = parcelRequire("2Ebme");
    var $bJGu2;
    var $53F4E;
    var $glXMz;
    var $eFzu2;
    var $417gZ;
    var $1w00b;
    parcelRequire("8OV2a");
    parcelRequire("4XBve");
    var $5d4c618110f1d03e$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
        var previous = 0;
        var character = 0;
        while(true){
            previous = character;
            character = (0, (0, parcelRequire("bJGu2")).peek)();
            if (previous === 38 && character === 12) points[index] = 1;
            if ((0, (0, parcelRequire("bJGu2")).token)(character)) break;
            (0, (0, parcelRequire("bJGu2")).next)();
        }
        return (0, (0, parcelRequire("bJGu2")).slice)(begin, (0, (0, parcelRequire("bJGu2")).position));
    };
    var $5d4c618110f1d03e$var$toRules = function toRules(parsed, points) {
        var index = -1;
        var character = 44;
        do switch((0, (0, parcelRequire("bJGu2")).token)(character)){
            case 0:
                if (character === 38 && (0, (0, parcelRequire("bJGu2")).peek)() === 12) points[index] = 1;
                parsed[index] += $5d4c618110f1d03e$var$identifierWithPointTracking((0, (0, parcelRequire("bJGu2")).position) - 1, points, index);
                break;
            case 2:
                parsed[index] += (0, (0, parcelRequire("bJGu2")).delimit)(character);
                break;
            case 4:
                if (character === 44) {
                    parsed[++index] = (0, (0, parcelRequire("bJGu2")).peek)() === 58 ? '&\f' : '';
                    points[index] = parsed[index].length;
                    break;
                }
            default:
                parsed[index] += (0, (0, parcelRequire("53F4E")).from)(character);
        }
        while (character = (0, (0, parcelRequire("bJGu2")).next)())
        return parsed;
    };
    var $5d4c618110f1d03e$var$getRules = function getRules(value, points) {
        return (0, (0, parcelRequire("bJGu2")).dealloc)($5d4c618110f1d03e$var$toRules((0, (0, parcelRequire("bJGu2")).alloc)(value), points));
    };
    var $5d4c618110f1d03e$var$fixedElements = new WeakMap();
    var $5d4c618110f1d03e$var$compat = function compat(element) {
        if (element.type !== 'rule' || !element.parent || element.length < 1) return;
        var value = element.value, parent = element.parent;
        var isImplicitRule = element.column === parent.column && element.line === parent.line;
        while(parent.type !== 'rule'){
            parent = parent.parent;
            if (!parent) return;
        }
        if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$5d4c618110f1d03e$var$fixedElements.get(parent)) return;
        if (isImplicitRule) return;
        $5d4c618110f1d03e$var$fixedElements.set(element, true);
        var points = [];
        var rules = $5d4c618110f1d03e$var$getRules(value, points);
        var parentRules = parent.props;
        for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    };
    var $5d4c618110f1d03e$var$removeLabel = function removeLabel(element) {
        if (element.type === 'decl') {
            var value = element.value;
            if (value.charCodeAt(0) === 108 && value.charCodeAt(2) === 98) {
                element["return"] = '';
                element.value = '';
            }
        }
    };
    function $5d4c618110f1d03e$var$prefix(value, length) {
        switch((0, (0, parcelRequire("53F4E")).hash)(value, length)){
            case 5103:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + 'print-' + value + value;
            case 5737:
            case 4201:
            case 3177:
            case 3433:
            case 1641:
            case 4457:
            case 2921:
            case 5572:
            case 6356:
            case 5844:
            case 3191:
            case 6645:
            case 3005:
            case 6391:
            case 5879:
            case 5623:
            case 6135:
            case 4599:
            case 4855:
            case 4215:
            case 6389:
            case 5109:
            case 5365:
            case 5621:
            case 3829:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + value;
            case 5349:
            case 4246:
            case 4810:
            case 6968:
            case 2756:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MOZ) + value + (0, (0, parcelRequire("eFzu2")).MS) + value + value;
            case 6828:
            case 4268:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + value + value;
            case 6165:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + 'flex-' + value + value;
            case 5187:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("53F4E")).replace)(value, /(\w+).+(:[^]+)/, (0, (0, parcelRequire("eFzu2")).WEBKIT) + 'box-$1$2' + (0, (0, parcelRequire("eFzu2")).MS) + 'flex-$1$2') + value;
            case 5443:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + 'flex-item-' + (0, (0, parcelRequire("53F4E")).replace)(value, /flex-|-self/, '') + value;
            case 4675:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + 'flex-line-pack' + (0, (0, parcelRequire("53F4E")).replace)(value, /align-content|flex-|-self/, '') + value;
            case 5548:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, 'shrink', 'negative') + value;
            case 5292:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, 'basis', 'preferred-size') + value;
            case 6060:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + 'box-' + (0, (0, parcelRequire("53F4E")).replace)(value, '-grow', '') + (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, 'grow', 'positive') + value;
            case 4554:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + (0, (0, parcelRequire("53F4E")).replace)(value, /([^-])(transform)/g, '$1' + (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$2') + value;
            case 6187:
                return (0, (0, parcelRequire("53F4E")).replace)((0, (0, parcelRequire("53F4E")).replace)((0, (0, parcelRequire("53F4E")).replace)(value, /(zoom-|grab)/, (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$1'), /(image-set)/, (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$1'), value, '') + value;
            case 5495:
            case 3959:
                return (0, (0, parcelRequire("53F4E")).replace)(value, /(image-set\([^]*)/, (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$1' + '$`$1');
            case 4968:
                return (0, (0, parcelRequire("53F4E")).replace)((0, (0, parcelRequire("53F4E")).replace)(value, /(.+:)(flex-)?(.*)/, (0, (0, parcelRequire("eFzu2")).WEBKIT) + 'box-pack:$3' + (0, (0, parcelRequire("eFzu2")).MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + value;
            case 4095:
            case 3583:
            case 4068:
            case 2532:
                return (0, (0, parcelRequire("53F4E")).replace)(value, /(.+)-inline(.+)/, (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$1$2') + value;
            case 8116:
            case 7059:
            case 5753:
            case 5535:
            case 5445:
            case 5701:
            case 4933:
            case 4677:
            case 5533:
            case 5789:
            case 5021:
            case 4765:
                if ((0, (0, parcelRequire("53F4E")).strlen)(value) - 1 - length > 6) switch((0, (0, parcelRequire("53F4E")).charat)(value, length + 1)){
                    case 109:
                        if ((0, (0, parcelRequire("53F4E")).charat)(value, length + 4) !== 45) break;
                    case 102:
                        return (0, (0, parcelRequire("53F4E")).replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$2-$3' + '$1' + (0, (0, parcelRequire("eFzu2")).MOZ) + ((0, (0, parcelRequire("53F4E")).charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                    case 115:
                        return ~(0, (0, parcelRequire("53F4E")).indexof)(value, 'stretch') ? $5d4c618110f1d03e$var$prefix((0, (0, parcelRequire("53F4E")).replace)(value, 'stretch', 'fill-available'), length) + value : value;
                }
                break;
            case 4949:
                if ((0, (0, parcelRequire("53F4E")).charat)(value, length + 1) !== 115) break;
            case 6444:
                switch((0, (0, parcelRequire("53F4E")).charat)(value, (0, (0, parcelRequire("53F4E")).strlen)(value) - 3 - (~(0, (0, parcelRequire("53F4E")).indexof)(value, '!important') && 10))){
                    case 107:
                        return (0, (0, parcelRequire("53F4E")).replace)(value, ':', ':' + (0, (0, parcelRequire("eFzu2")).WEBKIT)) + value;
                    case 101:
                        return (0, (0, parcelRequire("53F4E")).replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, (0, parcelRequire("eFzu2")).WEBKIT) + ((0, (0, parcelRequire("53F4E")).charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$2$3' + '$1' + (0, (0, parcelRequire("eFzu2")).MS) + '$2box$3') + value;
                }
                break;
            case 5936:
                switch((0, (0, parcelRequire("53F4E")).charat)(value, length + 11)){
                    case 114:
                        return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                    case 108:
                        return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                    case 45:
                        return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
                }
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + value + value;
        }
        return value;
    }
    var $5d4c618110f1d03e$var$prefixer = function prefixer(element, index, children, callback) {
        if (element.length > -1) {
            if (!element["return"]) switch(element.type){
                case 0, (0, parcelRequire("eFzu2")).DECLARATION:
                    element["return"] = $5d4c618110f1d03e$var$prefix(element.value, element.length);
                    break;
                case 0, (0, parcelRequire("eFzu2")).KEYFRAMES:
                    return (0, (0, parcelRequire("1w00b")).serialize)([
                        (0, (0, parcelRequire("bJGu2")).copy)(element, {
                            value: (0, (0, parcelRequire("53F4E")).replace)(element.value, '@', '@' + (0, (0, parcelRequire("eFzu2")).WEBKIT))
                        })
                    ], callback);
                case 0, (0, parcelRequire("eFzu2")).RULESET:
                    if (element.length) return (0, (0, parcelRequire("53F4E")).combine)(element.props, function(value) {
                        switch((0, (0, parcelRequire("53F4E")).match)(value, /(::plac\w+|:read-\w+)/)){
                            case ':read-only':
                            case ':read-write':
                                return (0, (0, parcelRequire("1w00b")).serialize)([
                                    (0, (0, parcelRequire("bJGu2")).copy)(element, {
                                        props: [
                                            (0, (0, parcelRequire("53F4E")).replace)(value, /:(read-\w+)/, ':' + (0, (0, parcelRequire("eFzu2")).MOZ) + '$1')
                                        ]
                                    })
                                ], callback);
                            case '::placeholder':
                                return (0, (0, parcelRequire("1w00b")).serialize)([
                                    (0, (0, parcelRequire("bJGu2")).copy)(element, {
                                        props: [
                                            (0, (0, parcelRequire("53F4E")).replace)(value, /:(plac\w+)/, ':' + (0, (0, parcelRequire("eFzu2")).WEBKIT) + 'input-$1')
                                        ]
                                    }),
                                    (0, (0, parcelRequire("bJGu2")).copy)(element, {
                                        props: [
                                            (0, (0, parcelRequire("53F4E")).replace)(value, /:(plac\w+)/, ':' + (0, (0, parcelRequire("eFzu2")).MOZ) + '$1')
                                        ]
                                    }),
                                    (0, (0, parcelRequire("bJGu2")).copy)(element, {
                                        props: [
                                            (0, (0, parcelRequire("53F4E")).replace)(value, /:(plac\w+)/, (0, (0, parcelRequire("eFzu2")).MS) + 'input-$1')
                                        ]
                                    })
                                ], callback);
                        }
                        return '';
                    });
            }
        }
    };
    var $5d4c618110f1d03e$var$defaultStylisPlugins = [
        $5d4c618110f1d03e$var$prefixer
    ];
    var $5d4c618110f1d03e$export$2e2bcd8739ae039 = function createCache(options) {
        var key = options.key;
        if (key === 'css') {
            var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
            Array.prototype.forEach.call(ssrStyles, function(node) {
                var dataEmotionAttribute = node.getAttribute('data-emotion');
                if (dataEmotionAttribute.indexOf(' ') === -1) return;
                document.head.appendChild(node);
                node.setAttribute('data-s', '');
            });
        }
        var stylisPlugins = options.stylisPlugins || $5d4c618110f1d03e$var$defaultStylisPlugins;
        var inserted = {};
        var container;
        var nodesToHydrate = [];
        container = options.container || document.head;
        Array.prototype.forEach.call(document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
        var _insert;
        var omnipresentPlugins = [
            $5d4c618110f1d03e$var$compat,
            $5d4c618110f1d03e$var$removeLabel
        ];
        var currentSheet;
        var finalizingPlugins = [
            (0, (0, parcelRequire("1w00b")).stringify),
            (0, (0, parcelRequire("417gZ")).rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, (0, parcelRequire("417gZ")).middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, (0, parcelRequire("1w00b")).serialize)((0, (0, parcelRequire("glXMz")).compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
        var cache = {
            key: key,
            sheet: new (0, $2Ebme.StyleSheet)({
                key: key,
                container: container,
                nonce: options.nonce,
                speedy: options.speedy,
                prepend: options.prepend,
                insertionPoint: options.insertionPoint
            }),
            nonce: options.nonce,
            inserted: inserted,
            registered: {},
            insert: _insert
        };
        cache.sheet.hydrate(nodesToHydrate);
        return cache;
    };
});
parcelRegister("bJGu2", function(module, exports) {
    $parcel$export(module.exports, "position", ()=>$88b4da0084620d05$export$5880b8b5730aff45);
    $parcel$export(module.exports, "node", ()=>$88b4da0084620d05$export$35059013cd4a06db);
    $parcel$export(module.exports, "copy", ()=>$88b4da0084620d05$export$784d13d8ee351f07);
    $parcel$export(module.exports, "char", ()=>$88b4da0084620d05$export$eba6f6f03b0a92e7);
    $parcel$export(module.exports, "prev", ()=>$88b4da0084620d05$export$232faf9add678146);
    $parcel$export(module.exports, "next", ()=>$88b4da0084620d05$export$48cfd1e771a65c4f);
    $parcel$export(module.exports, "peek", ()=>$88b4da0084620d05$export$4d3fb11e950abb9e);
    $parcel$export(module.exports, "caret", ()=>$88b4da0084620d05$export$e88cb2efb12ae807);
    $parcel$export(module.exports, "slice", ()=>$88b4da0084620d05$export$58adb3bec8346d0f);
    $parcel$export(module.exports, "token", ()=>$88b4da0084620d05$export$9e1725a4cfeada27);
    $parcel$export(module.exports, "alloc", ()=>$88b4da0084620d05$export$2de70f21292aac9e);
    $parcel$export(module.exports, "dealloc", ()=>$88b4da0084620d05$export$45918ac1574455b1);
    $parcel$export(module.exports, "delimit", ()=>$88b4da0084620d05$export$410ac95b9ec204b8);
    $parcel$export(module.exports, "tokenize", ()=>$88b4da0084620d05$export$660b2ee2d4fb4eff);
    $parcel$export(module.exports, "whitespace", ()=>$88b4da0084620d05$export$7af1228ff777d175);
    $parcel$export(module.exports, "identifier", ()=>$88b4da0084620d05$export$c2ab62c7bf24634);
    $parcel$export(module.exports, "escaping", ()=>$88b4da0084620d05$export$955ba06d119e085e);
    $parcel$export(module.exports, "commenter", ()=>$88b4da0084620d05$export$4254d4e2b3745c4c);
    var $53F4E;
    var $88b4da0084620d05$export$53f1d5ea8de3d7c = 1;
    var $88b4da0084620d05$export$4e0c71f277ca26b3 = 1;
    var $88b4da0084620d05$export$f24224f1c91d8156 = 0;
    var $88b4da0084620d05$export$5880b8b5730aff45 = 0;
    var $88b4da0084620d05$export$c0306caf338ac095 = 0;
    var $88b4da0084620d05$export$30a86d91af8ff6e6 = '';
    function $88b4da0084620d05$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
        return {
            value: value,
            root: root,
            parent: parent,
            type: type,
            props: props,
            children: children,
            line: $88b4da0084620d05$export$53f1d5ea8de3d7c,
            column: $88b4da0084620d05$export$4e0c71f277ca26b3,
            length: length,
            return: ''
        };
    }
    function $88b4da0084620d05$export$784d13d8ee351f07(root, props) {
        return (0, (0, parcelRequire("53F4E")).assign)($88b4da0084620d05$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
            length: -root.length
        }, props);
    }
    function $88b4da0084620d05$export$eba6f6f03b0a92e7() {
        return $88b4da0084620d05$export$c0306caf338ac095;
    }
    function $88b4da0084620d05$export$232faf9add678146() {
        $88b4da0084620d05$export$c0306caf338ac095 = $88b4da0084620d05$export$5880b8b5730aff45 > 0 ? (0, (0, parcelRequire("53F4E")).charat)($88b4da0084620d05$export$30a86d91af8ff6e6, --$88b4da0084620d05$export$5880b8b5730aff45) : 0;
        if ($88b4da0084620d05$export$4e0c71f277ca26b3--, $88b4da0084620d05$export$c0306caf338ac095 === 10) $88b4da0084620d05$export$4e0c71f277ca26b3 = 1, $88b4da0084620d05$export$53f1d5ea8de3d7c--;
        return $88b4da0084620d05$export$c0306caf338ac095;
    }
    function $88b4da0084620d05$export$48cfd1e771a65c4f() {
        $88b4da0084620d05$export$c0306caf338ac095 = $88b4da0084620d05$export$5880b8b5730aff45 < $88b4da0084620d05$export$f24224f1c91d8156 ? (0, (0, parcelRequire("53F4E")).charat)($88b4da0084620d05$export$30a86d91af8ff6e6, $88b4da0084620d05$export$5880b8b5730aff45++) : 0;
        if ($88b4da0084620d05$export$4e0c71f277ca26b3++, $88b4da0084620d05$export$c0306caf338ac095 === 10) $88b4da0084620d05$export$4e0c71f277ca26b3 = 1, $88b4da0084620d05$export$53f1d5ea8de3d7c++;
        return $88b4da0084620d05$export$c0306caf338ac095;
    }
    function $88b4da0084620d05$export$4d3fb11e950abb9e() {
        return (0, (0, parcelRequire("53F4E")).charat)($88b4da0084620d05$export$30a86d91af8ff6e6, $88b4da0084620d05$export$5880b8b5730aff45);
    }
    function $88b4da0084620d05$export$e88cb2efb12ae807() {
        return $88b4da0084620d05$export$5880b8b5730aff45;
    }
    function $88b4da0084620d05$export$58adb3bec8346d0f(begin, end) {
        return (0, (0, parcelRequire("53F4E")).substr)($88b4da0084620d05$export$30a86d91af8ff6e6, begin, end);
    }
    function $88b4da0084620d05$export$9e1725a4cfeada27(type) {
        switch(type){
            case 0:
            case 9:
            case 10:
            case 13:
            case 32:
                return 5;
            case 33:
            case 43:
            case 44:
            case 47:
            case 62:
            case 64:
            case 126:
            case 59:
            case 123:
            case 125:
                return 4;
            case 58:
                return 3;
            case 34:
            case 39:
            case 40:
            case 91:
                return 2;
            case 41:
            case 93:
                return 1;
        }
        return 0;
    }
    function $88b4da0084620d05$export$2de70f21292aac9e(value) {
        return $88b4da0084620d05$export$53f1d5ea8de3d7c = $88b4da0084620d05$export$4e0c71f277ca26b3 = 1, $88b4da0084620d05$export$f24224f1c91d8156 = (0, (0, parcelRequire("53F4E")).strlen)($88b4da0084620d05$export$30a86d91af8ff6e6 = value), $88b4da0084620d05$export$5880b8b5730aff45 = 0, [];
    }
    function $88b4da0084620d05$export$45918ac1574455b1(value) {
        return $88b4da0084620d05$export$30a86d91af8ff6e6 = '', value;
    }
    function $88b4da0084620d05$export$410ac95b9ec204b8(type) {
        return (0, (0, parcelRequire("53F4E")).trim)($88b4da0084620d05$export$58adb3bec8346d0f($88b4da0084620d05$export$5880b8b5730aff45 - 1, $88b4da0084620d05$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
    }
    function $88b4da0084620d05$export$660b2ee2d4fb4eff(value) {
        return $88b4da0084620d05$export$45918ac1574455b1($88b4da0084620d05$export$5f8c09e3ae6f64e1($88b4da0084620d05$export$2de70f21292aac9e(value)));
    }
    function $88b4da0084620d05$export$7af1228ff777d175(type) {
        while($88b4da0084620d05$export$c0306caf338ac095 = $88b4da0084620d05$export$4d3fb11e950abb9e())if ($88b4da0084620d05$export$c0306caf338ac095 < 33) $88b4da0084620d05$export$48cfd1e771a65c4f();
        else break;
        return $88b4da0084620d05$export$9e1725a4cfeada27(type) > 2 || $88b4da0084620d05$export$9e1725a4cfeada27($88b4da0084620d05$export$c0306caf338ac095) > 3 ? '' : ' ';
    }
    function $88b4da0084620d05$export$5f8c09e3ae6f64e1(children) {
        while($88b4da0084620d05$export$48cfd1e771a65c4f())switch($88b4da0084620d05$export$9e1725a4cfeada27($88b4da0084620d05$export$c0306caf338ac095)){
            case 0:
                (0, (0, parcelRequire("53F4E")).append)($88b4da0084620d05$export$c2ab62c7bf24634($88b4da0084620d05$export$5880b8b5730aff45 - 1), children);
                break;
            case 2:
                (0, (0, parcelRequire("53F4E")).append)($88b4da0084620d05$export$410ac95b9ec204b8($88b4da0084620d05$export$c0306caf338ac095), children);
                break;
            default:
                (0, (0, parcelRequire("53F4E")).append)((0, (0, parcelRequire("53F4E")).from)($88b4da0084620d05$export$c0306caf338ac095), children);
        }
        return children;
    }
    function $88b4da0084620d05$export$955ba06d119e085e(index, count) {
        while(--count && $88b4da0084620d05$export$48cfd1e771a65c4f())if ($88b4da0084620d05$export$c0306caf338ac095 < 48 || $88b4da0084620d05$export$c0306caf338ac095 > 102 || $88b4da0084620d05$export$c0306caf338ac095 > 57 && $88b4da0084620d05$export$c0306caf338ac095 < 65 || $88b4da0084620d05$export$c0306caf338ac095 > 70 && $88b4da0084620d05$export$c0306caf338ac095 < 97) break;
        return $88b4da0084620d05$export$58adb3bec8346d0f(index, $88b4da0084620d05$export$e88cb2efb12ae807() + (count < 6 && $88b4da0084620d05$export$4d3fb11e950abb9e() == 32 && $88b4da0084620d05$export$48cfd1e771a65c4f() == 32));
    }
    function $88b4da0084620d05$export$c889f2fcc19dbf12(type) {
        while($88b4da0084620d05$export$48cfd1e771a65c4f())switch($88b4da0084620d05$export$c0306caf338ac095){
            case type:
                return $88b4da0084620d05$export$5880b8b5730aff45;
            case 34:
            case 39:
                if (type !== 34 && type !== 39) $88b4da0084620d05$export$c889f2fcc19dbf12($88b4da0084620d05$export$c0306caf338ac095);
                break;
            case 40:
                if (type === 41) $88b4da0084620d05$export$c889f2fcc19dbf12(type);
                break;
            case 92:
                $88b4da0084620d05$export$48cfd1e771a65c4f();
                break;
        }
        return $88b4da0084620d05$export$5880b8b5730aff45;
    }
    function $88b4da0084620d05$export$4254d4e2b3745c4c(type, index) {
        while($88b4da0084620d05$export$48cfd1e771a65c4f())if (type + $88b4da0084620d05$export$c0306caf338ac095 === 57) break;
        else if (type + $88b4da0084620d05$export$c0306caf338ac095 === 84 && $88b4da0084620d05$export$4d3fb11e950abb9e() === 47) break;
        return '/*' + $88b4da0084620d05$export$58adb3bec8346d0f(index, $88b4da0084620d05$export$5880b8b5730aff45 - 1) + '*' + (0, (0, parcelRequire("53F4E")).from)(type === 47 ? type : $88b4da0084620d05$export$48cfd1e771a65c4f());
    }
    function $88b4da0084620d05$export$c2ab62c7bf24634(index) {
        while(!$88b4da0084620d05$export$9e1725a4cfeada27($88b4da0084620d05$export$4d3fb11e950abb9e()))$88b4da0084620d05$export$48cfd1e771a65c4f();
        return $88b4da0084620d05$export$58adb3bec8346d0f(index, $88b4da0084620d05$export$5880b8b5730aff45);
    }
});
parcelRegister("53F4E", function(module, exports) {
    $parcel$export(module.exports, "abs", ()=>$3aed17fe3e481044$export$2335f513bbd82c6d);
    $parcel$export(module.exports, "from", ()=>$3aed17fe3e481044$export$6788812c4e6611e6);
    $parcel$export(module.exports, "assign", ()=>$3aed17fe3e481044$export$e6e34fd1f2686227);
    $parcel$export(module.exports, "hash", ()=>$3aed17fe3e481044$export$d6af199866bfb566);
    $parcel$export(module.exports, "charat", ()=>$3aed17fe3e481044$export$a9db5e087081082d);
    $parcel$export(module.exports, "trim", ()=>$3aed17fe3e481044$export$87c2784dc9fc4ab);
    $parcel$export(module.exports, "match", ()=>$3aed17fe3e481044$export$4659b591c19bdf3d);
    $parcel$export(module.exports, "replace", ()=>$3aed17fe3e481044$export$77ad94ebf1c2b9ed);
    $parcel$export(module.exports, "indexof", ()=>$3aed17fe3e481044$export$f8e21b1e77979a08);
    $parcel$export(module.exports, "substr", ()=>$3aed17fe3e481044$export$2f35ab04d2335697);
    $parcel$export(module.exports, "strlen", ()=>$3aed17fe3e481044$export$36776f635604f274);
    $parcel$export(module.exports, "sizeof", ()=>$3aed17fe3e481044$export$f9084667e487ed46);
    $parcel$export(module.exports, "append", ()=>$3aed17fe3e481044$export$10d8903dec122b9d);
    $parcel$export(module.exports, "combine", ()=>$3aed17fe3e481044$export$1be1fc439b849fdf);
    var $3aed17fe3e481044$export$2335f513bbd82c6d = Math.abs;
    var $3aed17fe3e481044$export$6788812c4e6611e6 = String.fromCharCode;
    var $3aed17fe3e481044$export$e6e34fd1f2686227 = Object.assign;
    function $3aed17fe3e481044$export$d6af199866bfb566(value, length) {
        return $3aed17fe3e481044$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $3aed17fe3e481044$export$a9db5e087081082d(value, 0)) << 2 ^ $3aed17fe3e481044$export$a9db5e087081082d(value, 1)) << 2 ^ $3aed17fe3e481044$export$a9db5e087081082d(value, 2)) << 2 ^ $3aed17fe3e481044$export$a9db5e087081082d(value, 3) : 0;
    }
    function $3aed17fe3e481044$export$87c2784dc9fc4ab(value) {
        return value.trim();
    }
    function $3aed17fe3e481044$export$4659b591c19bdf3d(value, pattern) {
        return (value = pattern.exec(value)) ? value[0] : value;
    }
    function $3aed17fe3e481044$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
        return value.replace(pattern, replacement);
    }
    function $3aed17fe3e481044$export$f8e21b1e77979a08(value, search) {
        return value.indexOf(search);
    }
    function $3aed17fe3e481044$export$a9db5e087081082d(value, index) {
        return value.charCodeAt(index) | 0;
    }
    function $3aed17fe3e481044$export$2f35ab04d2335697(value, begin, end) {
        return value.slice(begin, end);
    }
    function $3aed17fe3e481044$export$36776f635604f274(value) {
        return value.length;
    }
    function $3aed17fe3e481044$export$f9084667e487ed46(value) {
        return value.length;
    }
    function $3aed17fe3e481044$export$10d8903dec122b9d(value, array) {
        return array.push(value), value;
    }
    function $3aed17fe3e481044$export$1be1fc439b849fdf(array, callback) {
        return array.map(callback).join('');
    }
});
parcelRegister("glXMz", function(module, exports) {
    $parcel$export(module.exports, "compile", ()=>$be7cfb050d23cefc$export$ef7acd7185315e22);
    var $eFzu2;
    var $53F4E;
    var $bJGu2;
    function $be7cfb050d23cefc$export$ef7acd7185315e22(value) {
        return (0, (0, parcelRequire("bJGu2")).dealloc)($be7cfb050d23cefc$export$98e6a39c04603d36('', null, null, null, [
            ''
        ], value = (0, (0, parcelRequire("bJGu2")).alloc)(value), 0, [
            0
        ], value));
    }
    function $be7cfb050d23cefc$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
        var index = 0;
        var offset = 0;
        var length = pseudo;
        var atrule = 0;
        var property = 0;
        var previous = 0;
        var variable = 1;
        var scanning = 1;
        var ampersand = 1;
        var character = 0;
        var type = '';
        var props = rules;
        var children = rulesets;
        var reference = rule;
        var characters = type;
        while(scanning)switch(previous = character, character = (0, (0, parcelRequire("bJGu2")).next)()){
            case 40:
                if (previous != 108 && (0, (0, parcelRequire("53F4E")).charat)(characters, length - 1) == 58) {
                    if ((0, (0, parcelRequire("53F4E")).indexof)(characters += (0, (0, parcelRequire("53F4E")).replace)((0, (0, parcelRequire("bJGu2")).delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                    break;
                }
            case 34:
            case 39:
            case 91:
                characters += (0, (0, parcelRequire("bJGu2")).delimit)(character);
                break;
            case 9:
            case 10:
            case 13:
            case 32:
                characters += (0, (0, parcelRequire("bJGu2")).whitespace)(previous);
                break;
            case 92:
                characters += (0, (0, parcelRequire("bJGu2")).escaping)((0, (0, parcelRequire("bJGu2")).caret)() - 1, 7);
                continue;
            case 47:
                switch((0, (0, parcelRequire("bJGu2")).peek)()){
                    case 42:
                    case 47:
                        (0, (0, parcelRequire("53F4E")).append)($be7cfb050d23cefc$export$4a34f930e789283c((0, (0, parcelRequire("bJGu2")).commenter)((0, (0, parcelRequire("bJGu2")).next)(), (0, (0, parcelRequire("bJGu2")).caret)()), root, parent), declarations);
                        break;
                    default:
                        characters += '/';
                }
                break;
            case 123 * variable:
                points[index++] = (0, (0, parcelRequire("53F4E")).strlen)(characters) * ampersand;
            case 125 * variable:
            case 59:
            case 0:
                switch(character){
                    case 0:
                    case 125:
                        scanning = 0;
                    case 59 + offset:
                        if (ampersand == -1) characters = (0, (0, parcelRequire("53F4E")).replace)(characters, /\f/g, '');
                        if (property > 0 && (0, (0, parcelRequire("53F4E")).strlen)(characters) - length) (0, (0, parcelRequire("53F4E")).append)(property > 32 ? $be7cfb050d23cefc$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $be7cfb050d23cefc$export$f8483753829ec8f3((0, (0, parcelRequire("53F4E")).replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                        break;
                    case 59:
                        characters += ';';
                    default:
                        (0, (0, parcelRequire("53F4E")).append)(reference = $be7cfb050d23cefc$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                        if (character === 123) {
                            if (offset === 0) $be7cfb050d23cefc$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                            else switch(atrule === 99 && (0, (0, parcelRequire("53F4E")).charat)(characters, 3) === 110 ? 100 : atrule){
                                case 100:
                                case 108:
                                case 109:
                                case 115:
                                    $be7cfb050d23cefc$export$98e6a39c04603d36(value, reference, reference, rule && (0, (0, parcelRequire("53F4E")).append)($be7cfb050d23cefc$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                    break;
                                default:
                                    $be7cfb050d23cefc$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                        ''
                                    ], children, 0, points, children);
                            }
                        }
                }
                index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
                break;
            case 58:
                length = 1 + (0, (0, parcelRequire("53F4E")).strlen)(characters), property = previous;
            default:
                if (variable < 1) {
                    if (character == 123) --variable;
                    else if (character == 125 && variable++ == 0 && (0, (0, parcelRequire("bJGu2")).prev)() == 125) continue;
                }
                switch(characters += (0, (0, parcelRequire("53F4E")).from)(character), character * variable){
                    case 38:
                        ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                        break;
                    case 44:
                        points[index++] = ((0, (0, parcelRequire("53F4E")).strlen)(characters) - 1) * ampersand, ampersand = 1;
                        break;
                    case 64:
                        if ((0, (0, parcelRequire("bJGu2")).peek)() === 45) characters += (0, (0, parcelRequire("bJGu2")).delimit)((0, (0, parcelRequire("bJGu2")).next)());
                        atrule = (0, (0, parcelRequire("bJGu2")).peek)(), offset = length = (0, (0, parcelRequire("53F4E")).strlen)(type = characters += (0, (0, parcelRequire("bJGu2")).identifier)((0, (0, parcelRequire("bJGu2")).caret)())), character++;
                        break;
                    case 45:
                        if (previous === 45 && (0, (0, parcelRequire("53F4E")).strlen)(characters) == 2) variable = 0;
                }
        }
        return rulesets;
    }
    function $be7cfb050d23cefc$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
        var post = offset - 1;
        var rule = offset === 0 ? rules : [
            ''
        ];
        var size = (0, (0, parcelRequire("53F4E")).sizeof)(rule);
        for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, (0, parcelRequire("53F4E")).substr)(value, post + 1, post = (0, (0, parcelRequire("53F4E")).abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, (0, parcelRequire("53F4E")).trim)(j > 0 ? rule[x] + ' ' + y : (0, (0, parcelRequire("53F4E")).replace)(y, /&\f/g, rule[x]))) props[k++] = z;
        return (0, (0, parcelRequire("bJGu2")).node)(value, root, parent, offset === 0 ? (0, (0, parcelRequire("eFzu2")).RULESET) : type, props, children, length);
    }
    function $be7cfb050d23cefc$export$4a34f930e789283c(value, root, parent) {
        return (0, (0, parcelRequire("bJGu2")).node)(value, root, parent, (0, (0, parcelRequire("eFzu2")).COMMENT), (0, (0, parcelRequire("53F4E")).from)((0, (0, parcelRequire("bJGu2")).char)()), (0, (0, parcelRequire("53F4E")).substr)(value, 2, -2), 0);
    }
    function $be7cfb050d23cefc$export$f8483753829ec8f3(value, root, parent, length) {
        return (0, (0, parcelRequire("bJGu2")).node)(value, root, parent, (0, (0, parcelRequire("eFzu2")).DECLARATION), (0, (0, parcelRequire("53F4E")).substr)(value, 0, length), (0, (0, parcelRequire("53F4E")).substr)(value, length + 1, -1), length);
    }
});
parcelRegister("eFzu2", function(module, exports) {
    $parcel$export(module.exports, "MS", ()=>$aae06b4bc3fa452d$export$71ad59f2e432cfe8);
    $parcel$export(module.exports, "MOZ", ()=>$aae06b4bc3fa452d$export$2c0f367103c8d01c);
    $parcel$export(module.exports, "WEBKIT", ()=>$aae06b4bc3fa452d$export$39dfd62a25e0fe93);
    $parcel$export(module.exports, "COMMENT", ()=>$aae06b4bc3fa452d$export$a29989082612d0d9);
    $parcel$export(module.exports, "RULESET", ()=>$aae06b4bc3fa452d$export$aa3a2e812ca8570d);
    $parcel$export(module.exports, "DECLARATION", ()=>$aae06b4bc3fa452d$export$527d108ccf083c2b);
    $parcel$export(module.exports, "IMPORT", ()=>$aae06b4bc3fa452d$export$a763edbf796b780a);
    $parcel$export(module.exports, "KEYFRAMES", ()=>$aae06b4bc3fa452d$export$b44a8529a35fcb60);
    $parcel$export(module.exports, "LAYER", ()=>$aae06b4bc3fa452d$export$d773506282b3cfe6);
    var $aae06b4bc3fa452d$export$71ad59f2e432cfe8 = '-ms-';
    var $aae06b4bc3fa452d$export$2c0f367103c8d01c = '-moz-';
    var $aae06b4bc3fa452d$export$39dfd62a25e0fe93 = '-webkit-';
    var $aae06b4bc3fa452d$export$a29989082612d0d9 = 'comm';
    var $aae06b4bc3fa452d$export$aa3a2e812ca8570d = 'rule';
    var $aae06b4bc3fa452d$export$527d108ccf083c2b = 'decl';
    var $aae06b4bc3fa452d$export$d3d35020fa5b54f0 = '@page';
    var $aae06b4bc3fa452d$export$500415a86c544f73 = '@media';
    var $aae06b4bc3fa452d$export$a763edbf796b780a = '@import';
    var $aae06b4bc3fa452d$export$2790aeb8b4e5c826 = '@charset';
    var $aae06b4bc3fa452d$export$1cc683e23b84b133 = '@viewport';
    var $aae06b4bc3fa452d$export$9447a5efea57e862 = '@supports';
    var $aae06b4bc3fa452d$export$ef011b4e114b1fba = '@document';
    var $aae06b4bc3fa452d$export$6aad947bda0f3f46 = '@namespace';
    var $aae06b4bc3fa452d$export$b44a8529a35fcb60 = '@keyframes';
    var $aae06b4bc3fa452d$export$2c16de31893252e6 = '@font-face';
    var $aae06b4bc3fa452d$export$3d846dd52e150c6f = '@counter-style';
    var $aae06b4bc3fa452d$export$22314bfbb57653fe = '@font-feature-values';
    var $aae06b4bc3fa452d$export$d773506282b3cfe6 = '@layer';
});
parcelRegister("417gZ", function(module, exports) {
    $parcel$export(module.exports, "middleware", ()=>$2ecce5abcd4e67bf$export$5a7767152ae0305f);
    $parcel$export(module.exports, "rulesheet", ()=>$2ecce5abcd4e67bf$export$38bcb760f1d4871c);
    var $eFzu2;
    var $53F4E;
    var $bJGu2;
    var $1w00b;
    var $6AisN;
    function $2ecce5abcd4e67bf$export$5a7767152ae0305f(collection) {
        var length = (0, (0, parcelRequire("53F4E")).sizeof)(collection);
        return function(element, index, children, callback) {
            var output = '';
            for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
            return output;
        };
    }
    function $2ecce5abcd4e67bf$export$38bcb760f1d4871c(callback) {
        return function(element) {
            if (!element.root) {
                if (element = element.return) callback(element);
            }
        };
    }
    function $2ecce5abcd4e67bf$export$e08c7d021b829b7a(element, index, children, callback) {
        if (element.length > -1) {
            if (!element.return) switch(element.type){
                case 0, (0, parcelRequire("eFzu2")).DECLARATION:
                    element.return = (0, (0, parcelRequire("6AisN")).prefix)(element.value, element.length, children);
                    return;
                case 0, (0, parcelRequire("eFzu2")).KEYFRAMES:
                    return (0, (0, parcelRequire("1w00b")).serialize)([
                        (0, (0, parcelRequire("bJGu2")).copy)(element, {
                            value: (0, (0, parcelRequire("53F4E")).replace)(element.value, '@', '@' + (0, (0, parcelRequire("eFzu2")).WEBKIT))
                        })
                    ], callback);
                case 0, (0, parcelRequire("eFzu2")).RULESET:
                    if (element.length) return (0, (0, parcelRequire("53F4E")).combine)(element.props, function(value) {
                        switch((0, (0, parcelRequire("53F4E")).match)(value, /(::plac\w+|:read-\w+)/)){
                            case ':read-only':
                            case ':read-write':
                                return (0, (0, parcelRequire("1w00b")).serialize)([
                                    (0, (0, parcelRequire("bJGu2")).copy)(element, {
                                        props: [
                                            (0, (0, parcelRequire("53F4E")).replace)(value, /:(read-\w+)/, ':' + (0, (0, parcelRequire("eFzu2")).MOZ) + '$1')
                                        ]
                                    })
                                ], callback);
                            case '::placeholder':
                                return (0, (0, parcelRequire("1w00b")).serialize)([
                                    (0, (0, parcelRequire("bJGu2")).copy)(element, {
                                        props: [
                                            (0, (0, parcelRequire("53F4E")).replace)(value, /:(plac\w+)/, ':' + (0, (0, parcelRequire("eFzu2")).WEBKIT) + 'input-$1')
                                        ]
                                    }),
                                    (0, (0, parcelRequire("bJGu2")).copy)(element, {
                                        props: [
                                            (0, (0, parcelRequire("53F4E")).replace)(value, /:(plac\w+)/, ':' + (0, (0, parcelRequire("eFzu2")).MOZ) + '$1')
                                        ]
                                    }),
                                    (0, (0, parcelRequire("bJGu2")).copy)(element, {
                                        props: [
                                            (0, (0, parcelRequire("53F4E")).replace)(value, /:(plac\w+)/, (0, (0, parcelRequire("eFzu2")).MS) + 'input-$1')
                                        ]
                                    })
                                ], callback);
                        }
                        return '';
                    });
            }
        }
    }
    function $2ecce5abcd4e67bf$export$76a88f7de6507443(element) {
        switch(element.type){
            case 0, (0, parcelRequire("eFzu2")).RULESET:
                element.props = element.props.map(function(value) {
                    return (0, (0, parcelRequire("53F4E")).combine)((0, (0, parcelRequire("bJGu2")).tokenize)(value), function(value, index, children) {
                        switch((0, (0, parcelRequire("53F4E")).charat)(value, 0)){
                            case 12:
                                return (0, (0, parcelRequire("53F4E")).substr)(value, 1, (0, (0, parcelRequire("53F4E")).strlen)(value));
                            case 0:
                            case 40:
                            case 43:
                            case 62:
                            case 126:
                                return value;
                            case 58:
                                if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, (0, parcelRequire("53F4E")).substr)(children[index], index = 1, -1);
                            case 32:
                                return index === 1 ? '' : value;
                            default:
                                switch(index){
                                    case 0:
                                        element = value;
                                        return (0, (0, parcelRequire("53F4E")).sizeof)(children) > 1 ? '' : value;
                                    case index = (0, (0, parcelRequire("53F4E")).sizeof)(children) - 1:
                                    case 2:
                                        return index === 2 ? value + element + element : value + element;
                                    default:
                                        return value;
                                }
                        }
                    });
                });
        }
    }
});
parcelRegister("1w00b", function(module, exports) {
    $parcel$export(module.exports, "serialize", ()=>$11a8c7f9928c5876$export$dfdc1655ccc5b9cb);
    $parcel$export(module.exports, "stringify", ()=>$11a8c7f9928c5876$export$fac44ee5b035f737);
    var $eFzu2;
    var $53F4E;
    function $11a8c7f9928c5876$export$dfdc1655ccc5b9cb(children, callback) {
        var output = '';
        var length = (0, (0, parcelRequire("53F4E")).sizeof)(children);
        for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
        return output;
    }
    function $11a8c7f9928c5876$export$fac44ee5b035f737(element, index, children, callback) {
        switch(element.type){
            case 0, (0, parcelRequire("eFzu2")).LAYER:
                if (element.children.length) break;
            case 0, (0, parcelRequire("eFzu2")).IMPORT:
            case 0, (0, parcelRequire("eFzu2")).DECLARATION:
                return element.return = element.return || element.value;
            case 0, (0, parcelRequire("eFzu2")).COMMENT:
                return '';
            case 0, (0, parcelRequire("eFzu2")).KEYFRAMES:
                return element.return = element.value + '{' + $11a8c7f9928c5876$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
            case 0, (0, parcelRequire("eFzu2")).RULESET:
                element.value = element.props.join(',');
        }
        return (0, (0, parcelRequire("53F4E")).strlen)(children = $11a8c7f9928c5876$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
    }
});
parcelRegister("6AisN", function(module, exports) {
    $parcel$export(module.exports, "prefix", ()=>$4cb46d52ab9c689c$export$82e9f45cca5ba907);
    var $eFzu2;
    var $53F4E;
    function $4cb46d52ab9c689c$export$82e9f45cca5ba907(value, length, children) {
        switch((0, (0, parcelRequire("53F4E")).hash)(value, length)){
            case 5103:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + 'print-' + value + value;
            case 5737:
            case 4201:
            case 3177:
            case 3433:
            case 1641:
            case 4457:
            case 2921:
            case 5572:
            case 6356:
            case 5844:
            case 3191:
            case 6645:
            case 3005:
            case 6391:
            case 5879:
            case 5623:
            case 6135:
            case 4599:
            case 4855:
            case 4215:
            case 6389:
            case 5109:
            case 5365:
            case 5621:
            case 3829:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + value;
            case 4789:
                return (0, (0, parcelRequire("eFzu2")).MOZ) + value + value;
            case 5349:
            case 4246:
            case 4810:
            case 6968:
            case 2756:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MOZ) + value + (0, (0, parcelRequire("eFzu2")).MS) + value + value;
            case 5936:
                switch((0, (0, parcelRequire("53F4E")).charat)(value, length + 11)){
                    case 114:
                        return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                    case 108:
                        return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                    case 45:
                        return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
                }
            case 6828:
            case 4268:
            case 2903:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + value + value;
            case 6165:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + 'flex-' + value + value;
            case 5187:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("53F4E")).replace)(value, /(\w+).+(:[^]+)/, (0, (0, parcelRequire("eFzu2")).WEBKIT) + 'box-$1$2' + (0, (0, parcelRequire("eFzu2")).MS) + 'flex-$1$2') + value;
            case 5443:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + 'flex-item-' + (0, (0, parcelRequire("53F4E")).replace)(value, /flex-|-self/g, '') + (!(0, (0, parcelRequire("53F4E")).match)(value, /flex-|baseline/) ? (0, (0, parcelRequire("eFzu2")).MS) + 'grid-row-' + (0, (0, parcelRequire("53F4E")).replace)(value, /flex-|-self/g, '') : '') + value;
            case 4675:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + 'flex-line-pack' + (0, (0, parcelRequire("53F4E")).replace)(value, /align-content|flex-|-self/g, '') + value;
            case 5548:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, 'shrink', 'negative') + value;
            case 5292:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, 'basis', 'preferred-size') + value;
            case 6060:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + 'box-' + (0, (0, parcelRequire("53F4E")).replace)(value, '-grow', '') + (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, 'grow', 'positive') + value;
            case 4554:
                return (0, (0, parcelRequire("eFzu2")).WEBKIT) + (0, (0, parcelRequire("53F4E")).replace)(value, /([^-])(transform)/g, '$1' + (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$2') + value;
            case 6187:
                return (0, (0, parcelRequire("53F4E")).replace)((0, (0, parcelRequire("53F4E")).replace)((0, (0, parcelRequire("53F4E")).replace)(value, /(zoom-|grab)/, (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$1'), /(image-set)/, (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$1'), value, '') + value;
            case 5495:
            case 3959:
                return (0, (0, parcelRequire("53F4E")).replace)(value, /(image-set\([^]*)/, (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$1' + '$`$1');
            case 4968:
                return (0, (0, parcelRequire("53F4E")).replace)((0, (0, parcelRequire("53F4E")).replace)(value, /(.+:)(flex-)?(.*)/, (0, (0, parcelRequire("eFzu2")).WEBKIT) + 'box-pack:$3' + (0, (0, parcelRequire("eFzu2")).MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, (0, parcelRequire("eFzu2")).WEBKIT) + value + value;
            case 4200:
                if (!(0, (0, parcelRequire("53F4E")).match)(value, /flex-|baseline/)) return (0, (0, parcelRequire("eFzu2")).MS) + 'grid-column-align' + (0, (0, parcelRequire("53F4E")).substr)(value, length) + value;
                break;
            case 2592:
            case 3360:
                return (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, 'template-', '') + value;
            case 4384:
            case 3616:
                if (children && children.some(function(element, index) {
                    return length = index, (0, (0, parcelRequire("53F4E")).match)(element.props, /grid-\w+-end/);
                })) return ~(0, (0, parcelRequire("53F4E")).indexof)(value + (children = children[length].value), 'span') ? value : (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, '-start', '') + value + (0, (0, parcelRequire("eFzu2")).MS) + 'grid-row-span:' + (~(0, (0, parcelRequire("53F4E")).indexof)(children, 'span') ? (0, (0, parcelRequire("53F4E")).match)(children, /\d+/) : +(0, (0, parcelRequire("53F4E")).match)(children, /\d+/) - +(0, (0, parcelRequire("53F4E")).match)(value, /\d+/)) + ';';
                return (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)(value, '-start', '') + value;
            case 4896:
            case 4128:
                return children && children.some(function(element) {
                    return (0, (0, parcelRequire("53F4E")).match)(element.props, /grid-\w+-start/);
                }) ? value : (0, (0, parcelRequire("eFzu2")).MS) + (0, (0, parcelRequire("53F4E")).replace)((0, (0, parcelRequire("53F4E")).replace)(value, '-end', '-span'), 'span ', '') + value;
            case 4095:
            case 3583:
            case 4068:
            case 2532:
                return (0, (0, parcelRequire("53F4E")).replace)(value, /(.+)-inline(.+)/, (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$1$2') + value;
            case 8116:
            case 7059:
            case 5753:
            case 5535:
            case 5445:
            case 5701:
            case 4933:
            case 4677:
            case 5533:
            case 5789:
            case 5021:
            case 4765:
                if ((0, (0, parcelRequire("53F4E")).strlen)(value) - 1 - length > 6) switch((0, (0, parcelRequire("53F4E")).charat)(value, length + 1)){
                    case 109:
                        if ((0, (0, parcelRequire("53F4E")).charat)(value, length + 4) !== 45) break;
                    case 102:
                        return (0, (0, parcelRequire("53F4E")).replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$2-$3' + '$1' + (0, (0, parcelRequire("eFzu2")).MOZ) + ((0, (0, parcelRequire("53F4E")).charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                    case 115:
                        return ~(0, (0, parcelRequire("53F4E")).indexof)(value, 'stretch') ? $4cb46d52ab9c689c$export$82e9f45cca5ba907((0, (0, parcelRequire("53F4E")).replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
                }
                break;
            case 5152:
            case 5920:
                return (0, (0, parcelRequire("53F4E")).replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                    return (0, (0, parcelRequire("eFzu2")).MS) + a + ':' + b + f + (c ? (0, (0, parcelRequire("eFzu2")).MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
                });
            case 4949:
                if ((0, (0, parcelRequire("53F4E")).charat)(value, length + 6) === 121) return (0, (0, parcelRequire("53F4E")).replace)(value, ':', ':' + (0, (0, parcelRequire("eFzu2")).WEBKIT)) + value;
                break;
            case 6444:
                switch((0, (0, parcelRequire("53F4E")).charat)(value, (0, (0, parcelRequire("53F4E")).charat)(value, 14) === 45 ? 18 : 11)){
                    case 120:
                        return (0, (0, parcelRequire("53F4E")).replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, (0, parcelRequire("eFzu2")).WEBKIT) + ((0, (0, parcelRequire("53F4E")).charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, (0, parcelRequire("eFzu2")).WEBKIT) + '$2$3' + '$1' + (0, (0, parcelRequire("eFzu2")).MS) + '$2box$3') + value;
                    case 100:
                        return (0, (0, parcelRequire("53F4E")).replace)(value, ':', ':' + (0, (0, parcelRequire("eFzu2")).MS)) + value;
                }
                break;
            case 5719:
            case 2647:
            case 2135:
            case 3927:
            case 2391:
                return (0, (0, parcelRequire("53F4E")).replace)(value, 'scroll-', 'scroll-snap-') + value;
        }
        return value;
    }
});
parcelRegister("8OV2a", function(module, exports) {
    var $01a83ee7434b5796$export$2e2bcd8739ae039 = function weakMemoize(func) {
        var cache = new WeakMap();
        return function(arg) {
            if (cache.has(arg)) return cache.get(arg);
            var ret = func(arg);
            cache.set(arg, ret);
            return ret;
        };
    };
});
parcelRegister("4XBve", function(module, exports) {
    function $39c9c3642e47c7d6$export$2e2bcd8739ae039(fn) {
        var cache = Object.create(null);
        return function(arg) {
            if (cache[arg] === undefined) cache[arg] = fn(arg);
            return cache[arg];
        };
    }
});
parcelRegister("k1Pt3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc649d7887d3c632$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fc649d7887d3c632$export$2e2bcd8739ae039 = (0, $5uXOq.createContext)(null);
});
parcelRegister("6ui18", function(module, exports) {
    $parcel$export(module.exports, "setInteractionActiveTrace", ()=>$0601c3635db61070$export$f2e521e495a88544);
    $parcel$export(module.exports, "setActiveTrace", ()=>$0601c3635db61070$export$a1002be327997103);
    $parcel$export(module.exports, "getActiveTrace", ()=>$0601c3635db61070$export$b6ac780db3a3cc77);
    $parcel$export(module.exports, "clearActiveTrace", ()=>$0601c3635db61070$export$17ab21d7be720b);
    $parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", ()=>$0601c3635db61070$export$6e17cce6446848f9);
    var $ir41f;
    const $0601c3635db61070$var$state = {
        context: null
    };
    const $0601c3635db61070$export$295213bc4d0c54ad = ()=>{
        return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
    };
    const $0601c3635db61070$export$f2e521e495a88544 = (interactionId, experienceType)=>{
        $0601c3635db61070$export$a1002be327997103(interactionId.replace(/-/g, ''), $0601c3635db61070$export$295213bc4d0c54ad(), experienceType);
    };
    const $0601c3635db61070$export$a1002be327997103 = (traceId, spanId, type)=>{
        $0601c3635db61070$var$state.context = {
            traceId: traceId,
            spanId: spanId,
            type: type
        };
    };
    const $0601c3635db61070$export$b6ac780db3a3cc77 = ()=>$0601c3635db61070$var$state.context || undefined;
    const $0601c3635db61070$export$17ab21d7be720b = ()=>{
        $0601c3635db61070$var$state.context = null;
    };
    const $0601c3635db61070$export$6e17cce6446848f9 = (_url)=>{
        if ($0601c3635db61070$var$state.context === null) return null;
        const { traceId: traceId, spanId: spanId } = $0601c3635db61070$var$state.context;
        return (0, (0, parcelRequire("ir41f")).makeTraceHttpRequestHeaders)(traceId, spanId);
    };
});
parcelRegister("ir41f", function(module, exports) {
    $parcel$export(module.exports, "makeTraceHttpRequestHeaders", ()=>$d43ecdb0a51c33af$export$1115c5277eb10d5e);
    const $d43ecdb0a51c33af$export$1115c5277eb10d5e = (traceId, spanId)=>({
            'X-B3-TraceId': traceId,
            'X-B3-SpanId': spanId
        });
});
parcelRegister("1WqFo", function(module, exports) {
    $parcel$export(module.exports, "isFedRamp", ()=>$f6f7af55d303a9d8$export$64d6499adf9b2e51);
    function $f6f7af55d303a9d8$export$64d6499adf9b2e51() {
        const global = globalThis;
        const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
        if (env) return env === (0, $ddc5ba965a26499f$export$ce553301d55c2fd8);
        const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
        return matches ? matches.length > 0 : false;
    }
});
const $ddc5ba965a26499f$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $ddc5ba965a26499f$export$f005e2e9f707cb5f = 'commercial';
const $ddc5ba965a26499f$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $ddc5ba965a26499f$export$a739cd5aac835909 = 'stg';
const $ddc5ba965a26499f$export$42dd0cdd351a4a9 = 'prod';
const $ddc5ba965a26499f$export$404582bc18fe4d9e = 'dev';
parcelRegister("aiwW2", function(module, exports) {
    $parcel$export(module.exports, "allFeatureFlagsAccessed", ()=>$b708d7e5a9ec502b$export$5b78c989c8db2561);
    $parcel$export(module.exports, "currentFeatureFlagsAccessed", ()=>$b708d7e5a9ec502b$export$2a5c8df26bb89760);
    $parcel$export(module.exports, "addFeatureFlagAccessed", ()=>$b708d7e5a9ec502b$export$47fade9662f71000);
    var $ihYjH;
    const $b708d7e5a9ec502b$export$5b78c989c8db2561 = new Map();
    const $b708d7e5a9ec502b$export$2a5c8df26bb89760 = new Map();
    const $b708d7e5a9ec502b$export$47fade9662f71000 = (featureFlagName, featureFlagValue)=>{
        try {
            if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
        } catch (_e) {}
        const value = (0, (0, parcelRequire("ihYjH")).redactValue)(featureFlagValue);
        $b708d7e5a9ec502b$export$5b78c989c8db2561.set(featureFlagName, value);
        $b708d7e5a9ec502b$export$2a5c8df26bb89760.set(featureFlagName, value);
    };
});
parcelRegister("ihYjH", function(module, exports) {
    $parcel$export(module.exports, "redactValue", ()=>$a49a428d8edc2ff2$export$fcc03ee4c944962f);
    const $a49a428d8edc2ff2$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $a49a428d8edc2ff2$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $a49a428d8edc2ff2$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $a49a428d8edc2ff2$export$7b4abba432e57989 = (value)=>$a49a428d8edc2ff2$var$isString(value) && $a49a428d8edc2ff2$var$startsAsObject(value) || $a49a428d8edc2ff2$var$isObject(value);
    const $a49a428d8edc2ff2$export$fcc03ee4c944962f = (featureFlagValue)=>$a49a428d8edc2ff2$export$7b4abba432e57989(featureFlagValue) ? (0, $240e7c27c4097a0a$export$42f4885608027d0c) : featureFlagValue;
});
const $240e7c27c4097a0a$export$42f4885608027d0c = 'non_boolean';
parcelRegister("2VkQw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>(parcelRequire("cvquV")).default);
    var $cvquV = parcelRequire("cvquV");
    var $eZdb4 = parcelRequire("eZdb4");
});
parcelRegister("cvquV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab2299e29fc628bf$export$2e2bcd8739ae039);
    var $eZdb4 = parcelRequire("eZdb4");
    var $jcdnZ = parcelRequire("jcdnZ");
    var $eQQhB = parcelRequire("eQQhB");
    var $gXnat = parcelRequire("gXnat");
    class $ab2299e29fc628bf$export$2e2bcd8739ae039 {
        constructor(options){
            (0, $jcdnZ.enforceAttributes)(options, [
                'analyticsHandler'
            ], 'Feature Flag Client');
            const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
            this.flags = new Map();
            this.flagWrapperCache = new Map();
            this.customAttributesExposuresCache = new Set();
            this.trackedFlags = new Set();
            this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
            this.ignoreTypes = ignoreTypes || false;
            this.setFlags(flags || {});
            this.setAnalyticsHandler(analyticsHandler);
        }
        setFlags(flags) {
            if (!(0, $jcdnZ.isObject)(flags)) return;
            Object.entries(flags).forEach(([flagKey, flag])=>{
                this.flags.set(flagKey, flag);
            });
            for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
        }
        setAnalyticsHandler(analyticsHandler) {
            this.analyticsHandler = analyticsHandler;
        }
        setIsAutomaticExposuresEnabled(isEnabled) {
            this.isAutomaticExposuresEnabled = isEnabled;
        }
        getFlagWrapper(flagKey) {
            let wrapper = this.flagWrapperCache.get(flagKey);
            if (wrapper !== undefined) return wrapper;
            const flag = this.flags.get(flagKey);
            if (flag) wrapper = new (0, $gXnat.default)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
            else wrapper = new (0, $eQQhB.default)();
            this.flagWrapperCache.set(flagKey, wrapper);
            return wrapper;
        }
        clear() {
            this.flags.clear();
            this.flagWrapperCache.clear();
            this.trackedFlags.clear();
        }
        getBooleanValue(flagKey, options) {
            (0, $jcdnZ.enforceAttributes)(options, [
                'default'
            ], 'getBooleanValue');
            const wrapper = this.getFlagWrapper(flagKey);
            return wrapper.getBooleanValue(options);
        }
        getVariantValue(flagKey, options) {
            (0, $jcdnZ.enforceAttributes)(options, [
                'default',
                'oneOf'
            ], 'getVariantValue');
            const wrapper = this.getFlagWrapper(flagKey);
            return wrapper.getVariantValue(options);
        }
        getJSONValue(flagKey) {
            const wrapper = this.getFlagWrapper(flagKey);
            return wrapper.getJSONValue();
        }
        getRawValue(flagKey, options) {
            (0, $jcdnZ.enforceAttributes)(options, [
                'default'
            ], 'getRawValue');
            const wrapper = this.getFlagWrapper(flagKey);
            return wrapper.getRawValue(options);
        }
        getFlagEvaluation(flagKey, options) {
            (0, $jcdnZ.enforceAttributes)(options, [
                'default'
            ], 'getRawValue');
            const wrapper = this.getFlagWrapper(flagKey);
            return wrapper.getFlagEvaluation(options);
        }
        trackFeatureFlag(flagKey, options = {}) {
            const triggerReason = options?.triggerReason ? options.triggerReason : (0, $eZdb4.ExposureTriggerReason).Manual;
            const isValueSet = this.flags.has(flagKey) || 'value' in options;
            if (!isValueSet) {
                console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
                return;
            }
            const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
            const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
            if (triggerReason === (0, $eZdb4.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
            else this._trackExposure(flagKey, {
                value: flagValue,
                explanation: flagExplanation
            }, triggerReason);
        }
        trackExposure(flagKey, flag, exposureData = {}) {
            return this._trackExposure(flagKey, flag, (0, $eZdb4.ExposureTriggerReason).Manual, exposureData);
        }
        _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
            if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
            (0, $jcdnZ.checkForReservedAttributes)(exposureData);
            const flagAttributes = {
                flagKey: flagKey,
                reason: flag.explanation.kind,
                ruleId: flag.explanation.ruleId,
                value: flag.value
            };
            this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
        }
        shouldSendEvent(flagKey, customAttributes) {
            return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $jcdnZ.isObjectEmptyOrUndefined)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
        }
        sendAutomaticExposure(flagKey, value, flagExplanation) {
            if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
            const flagAttributes = {
                flagKey: flagKey,
                value: value,
                reason: flagExplanation.kind || 'SIMPLE_EVAL',
                ruleId: flagExplanation.ruleId,
                errorKind: flagExplanation.errorKind
            };
            this.sendExposureEvent(flagAttributes, (0, $eZdb4.ExposureTriggerReason).AutoExposure);
        }
        sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
            if (!this.trackedFlags.has(attributes.flagKey)) {
                const exposureEvent = {
                    action: 'exposed',
                    actionSubject: 'feature',
                    attributes: attributes,
                    tags: [
                        'measurement',
                        exposureTriggerReason
                    ],
                    highPriority: false,
                    source: '@atlaskit/feature-flag-client'
                };
                this.analyticsHandler?.sendOperationalEvent(exposureEvent);
                this.trackedFlags.add(attributes.flagKey);
            }
            if (!(0, $jcdnZ.isObjectEmptyOrUndefined)(customAttributes)) {
                const customeAttributesExposureEvent = {
                    action: 'exposed',
                    actionSubject: 'feature',
                    attributes: Object.assign({}, attributes, customAttributes),
                    tags: [
                        'measurement',
                        (0, $eZdb4.ExposureTriggerReason).hasCustomAttributes,
                        exposureTriggerReason
                    ],
                    highPriority: true,
                    source: '@atlaskit/feature-flag-client'
                };
                this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
                this.customAttributesExposuresCache.add(attributes.flagKey);
            }
        }
        getFlagStats() {
            const flagStats = {};
            for (const [flagKey, wrapper] of this.flagWrapperCache){
                const { evaluationCount: evaluationCount } = wrapper;
                flagStats[flagKey] = {
                    evaluationCount: evaluationCount
                };
            }
            return flagStats;
        }
    }
});
parcelRegister("eZdb4", function(module, exports) {
    $parcel$export(module.exports, "ExposureTriggerReason", ()=>$2f0422d13522afb7$export$2c20ffeba7dbc068);
    var $2f0422d13522afb7$export$2c20ffeba7dbc068;
    (function(ExposureTriggerReason) {
        ExposureTriggerReason["OptIn"] = "optInExposure";
        ExposureTriggerReason["Manual"] = "manualExposure";
        ExposureTriggerReason["Default"] = "defaultExposure";
        ExposureTriggerReason["AutoExposure"] = "autoExposure";
        ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    })($2f0422d13522afb7$export$2c20ffeba7dbc068 || ($2f0422d13522afb7$export$2c20ffeba7dbc068 = {}));
});
parcelRegister("jcdnZ", function(module, exports) {
    $parcel$export(module.exports, "isObject", ()=>$3ad0426f45717468$export$a6cdc56e425d0d0a);
    $parcel$export(module.exports, "isObjectEmptyOrUndefined", ()=>$3ad0426f45717468$export$8ed1df9dbe2e9a7d);
    $parcel$export(module.exports, "enforceAttributes", ()=>$3ad0426f45717468$export$c7d37910dd25ecbf);
    $parcel$export(module.exports, "checkForReservedAttributes", ()=>$3ad0426f45717468$export$891630e169ca14a4);
    const $3ad0426f45717468$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
    const $3ad0426f45717468$export$8ed1df9dbe2e9a7d = (obj)=>{
        return obj ? Object.keys(obj).length === 0 : true;
    };
    const $3ad0426f45717468$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
        attributes.forEach((attribute)=>{
            if (!(attribute in obj)) {
                const title = identifier ? `${identifier}: ` : '';
                throw new Error(`${title}Missing ${attribute}`);
            }
        });
    };
    const $3ad0426f45717468$export$891630e169ca14a4 = (customAttributes)=>{
        const reservedAttributes = [
            'flagKey',
            'ruleId',
            'reason',
            'value',
            'errorKind'
        ];
        const keys = customAttributes ? Object.keys(customAttributes) : [];
        if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
    };
    const $3ad0426f45717468$var$validateFlag = (flagKey, flag)=>{
        if ($3ad0426f45717468$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
    };
    const $3ad0426f45717468$export$410eec87ab950965 = (flags)=>{
        Object.keys(flags).forEach((key)=>$3ad0426f45717468$var$validateFlag(key, flags[key]));
    };
});
parcelRegister("eQQhB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf9da8f2ac509963$export$2e2bcd8739ae039);
    const $bf9da8f2ac509963$export$933245d8afcc8872 = {
        kind: 'ERROR',
        errorKind: 'FLAG_NOT_FOUND'
    };
    class $bf9da8f2ac509963$export$2e2bcd8739ae039 {
        evaluate(defaultValue) {
            return defaultValue;
        }
        getBooleanValue(options) {
            return this.evaluate(options.default);
        }
        getVariantValue(options) {
            return this.evaluate(options.default);
        }
        getJSONValue() {
            return this.evaluate({});
        }
        getRawValue(options) {
            return this.evaluate(options.default);
        }
        getFlagEvaluation(options) {
            const value = this.evaluate(options.default);
            return {
                value: value,
                explanation: $bf9da8f2ac509963$export$933245d8afcc8872
            };
        }
        constructor(){
            this.evaluationCount = -1;
        }
    }
});
parcelRegister("gXnat", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5d1c0154191279a$export$2e2bcd8739ae039);
    var $eZdb4 = parcelRequire("eZdb4");
    class $f5d1c0154191279a$export$2e2bcd8739ae039 {
        constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
            this.flagKey = flagKey;
            this.flag = flag;
            this.evaluationCount = 0;
            this.trackExposure = trackExposure;
            this.sendAutomaticExposure = sendAutomaticExposure;
            this.ignoreTypes = ignoreTypes;
        }
        getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
            let exposureTriggerReason = (0, $eZdb4.ExposureTriggerReason).OptIn;
            if (shouldTrackExposureEvent === undefined) {
                shouldTrackExposureEvent = true;
                exposureTriggerReason = (0, $eZdb4.ExposureTriggerReason).Default;
            }
            if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
                oneOf: oneOf,
                ignoreTypes: ignoreTypes
            });
            let value = this.evaluationResult.value;
            if (this.evaluationResult.didFallbackToDefaultValue) value = defaultValue;
            else if (shouldTrackExposureEvent) this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
            this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
            this.evaluationCount++;
            return {
                value: value,
                explanation: this.evaluationResult.explanation
            };
        }
        computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
            let result = {
                value: this.flag.value,
                explanation: this.flag.explanation,
                didFallbackToDefaultValue: false
            };
            if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
                result.value = defaultValue;
                result.didFallbackToDefaultValue = true;
                result.explanation = {
                    ...result.explanation || {},
                    kind: 'ERROR',
                    errorKind: 'WRONG_TYPE'
                };
            } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
                result.value = defaultValue;
                result.didFallbackToDefaultValue = true;
                result.explanation = {
                    ...result.explanation || {},
                    kind: 'ERROR',
                    errorKind: 'VALIDATION_ERROR'
                };
            }
            return result;
        }
        getBooleanValue(options) {
            const flag = this.getCachedResultOrCompute(options.default, {
                exposureData: options.exposureData,
                shouldTrackExposureEvent: options.shouldTrackExposureEvent,
                oneOf: undefined,
                ignoreTypes: this.ignoreTypes || false
            });
            return flag.value;
        }
        getVariantValue(options) {
            const flag = this.getCachedResultOrCompute(options.default, {
                exposureData: options.exposureData,
                shouldTrackExposureEvent: options.shouldTrackExposureEvent,
                oneOf: options.oneOf,
                ignoreTypes: this.ignoreTypes || false
            });
            return flag.value;
        }
        getJSONValue() {
            return this.getCachedResultOrCompute({}, {
                shouldTrackExposureEvent: false,
                ignoreTypes: this.ignoreTypes
            }).value;
        }
        getRawValue(options) {
            return this.getCachedResultOrCompute(options.default, {
                shouldTrackExposureEvent: options.shouldTrackExposureEvent,
                exposureData: options.exposureData,
                oneOf: undefined,
                ignoreTypes: true
            }).value;
        }
        getFlagEvaluation(options) {
            return this.getCachedResultOrCompute(options.default, {
                shouldTrackExposureEvent: options.shouldTrackExposureEvent,
                exposureData: options.exposureData,
                ignoreTypes: this.ignoreTypes || false
            });
        }
    }
});
parcelRegister("1o4Nl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5df2662d5047000$export$2e2bcd8739ae039);
    var $bXrHm = parcelRequire("bXrHm");
    var $bpIMA;
    var $fYTlD;
    var $92uUR;
    var $c3RJk;
    var $gk4Et;
    var $k0HOQ;
    var $kjpfP;
    var $9E64n;
    var $6P9bw;
    var $gYXWu;
    var $2jDOS;
    var $ikdCB;
    var $aycns;
    var $6fgea;
    var $evS6W;
    var $aR61w;
    var $f8lVk;
    var $ef7xh;
    var $bE87f;
    const $d5df2662d5047000$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
    const $d5df2662d5047000$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
    class $d5df2662d5047000$export$2e2bcd8739ae039 {
        constructor(productInfo, settings = {}){
            this._useStargate = (useStargate)=>{
                if (useStargate == null) return true;
                return useStargate;
            };
            this._endsWith = (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1;
            this._changeInternalUserId = (userId, anonymousId)=>{
                this.eventProcessor.getUser().setUserId(userId);
                if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) this.eventProcessor.getUser().setAnonymousId(anonymousId);
            };
            this._createSubproductGetter = (subproduct)=>(0, (0, parcelRequire("92uUR")).default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
            this._createEmbeddedProductGetter = (embeddedProduct)=>(0, (0, parcelRequire("92uUR")).default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
            this._getLastScreenEvent = ()=>{
                try {
                    return JSON.parse(this._safeSessionStorage.getItem($d5df2662d5047000$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
                } catch (err) {
                    this._safeSessionStorage.removeItem($d5df2662d5047000$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                    return null;
                }
            };
            this._setLastScreenEvent = (event)=>{
                this._safeSessionStorage.setItem($d5df2662d5047000$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                    name: event.name,
                    attributes: event.attributes
                }));
            };
            this._shouldEventBeDelayed = (event)=>{
                if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
                const isEventHighPriority = event.highPriority !== false;
                return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
            };
            this._fireEvent = (identifier, builtEvent, context, callback)=>{
                switch(builtEvent.eventType){
                    case (0, (0, parcelRequire("bpIMA")).eventType).UI:
                    case (0, (0, parcelRequire("bpIMA")).eventType).OPERATIONAL:
                    case (0, (0, parcelRequire("bpIMA")).eventType).TRACK:
                        return this.eventProcessor.track(identifier, builtEvent, context, callback);
                    case (0, (0, parcelRequire("bpIMA")).eventType).SCREEN:
                        return this.eventProcessor.page(identifier, builtEvent, context, callback);
                    case (0, (0, parcelRequire("bpIMA")).eventType).IDENTIFY:
                        return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                    default:
                        throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
                }
            };
            this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
                try {
                    this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                    builtEvent.tags = [
                        ...builtEvent.tags || [],
                        'sentWithDelay'
                    ];
                    this._fireEvent(identifier, builtEvent, context, undefined);
                } finally{
                    this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
                }
            };
            this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
                this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
                if (callback) callback();
            };
            this._processEvent = (identifier, builtEvent, context, callback)=>{
                this._testingCache.saveEvent(builtEvent);
                if (this._shouldEventBeDelayed(builtEvent)) {
                    this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                    return Promise.resolve();
                } else return this._fireEvent(identifier, builtEvent, context, callback);
            };
            this.setEmbeddedProduct = (embeddedProduct)=>{
                this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
                this.resetUIViewedTimers();
            };
            this.clearEmbeddedProduct = ()=>{
                this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
            };
            this.setSubproduct = (subproduct)=>{
                this._productInfo.subproduct = this._createSubproductGetter(subproduct);
                this.resetUIViewedTimers();
            };
            this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
                const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
                Object.keys(capturedOriginTraces).forEach((x)=>{
                    if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
                });
                const originAttributes = {};
                Object.keys(capturedOriginTraces).forEach((x)=>{
                    if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                    else console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
                });
                if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                    action: 'landed',
                    actionSubject: 'origin',
                    source: 'webClient',
                    attributes: {
                        originTracesLanded: originAttributes
                    }
                }, ()=>{});
                return Promise.resolve();
            };
            this.setTenantInfo = (tenantIdType, tenantId)=>{
                if (!tenantIdType) throw new Error('Missing tenantIdType');
                if (tenantIdType !== (0, (0, parcelRequire("bpIMA")).tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
                if (!(0, (0, parcelRequire("bpIMA")).isType)((0, (0, parcelRequire("bpIMA")).tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, (0, parcelRequire("bpIMA")).objectValues)((0, (0, parcelRequire("bpIMA")).tenantType))}]`);
                this._tenantInfo = {
                    tenantIdType: tenantIdType,
                    tenantId: tenantId
                };
            };
            this.clearTenantInfo = ()=>{
                this._tenantInfo = {};
            };
            this.setOrgInfo = (orgId)=>{
                if (!orgId) throw new Error('Missing orgId');
                this._orgInfo = {
                    orgId: orgId
                };
            };
            this.clearOrgInfo = ()=>{
                this._orgInfo = {};
            };
            this.setWorkspaceInfo = (workspaceId)=>{
                if (!workspaceId) throw new Error('Missing workspaceId');
                this._workspaceInfo = {
                    workspaceId: workspaceId
                };
            };
            this.clearWorkspaceInfo = ()=>{
                this._workspaceInfo = {};
            };
            this.setUserInfo = (userIdType, userId)=>{
                (0, (0, parcelRequire("k0HOQ")).validateIdentifyEvent)(userIdType, userId);
                this._changeInternalUserId(userId);
                this._userInfo = {
                    userIdType: userIdType,
                    userId: userId,
                    anonymousId: this.eventProcessor.getUser().getAnonymousId()
                };
            };
            this.clearUserInfo = ()=>{
                this._changeInternalUserId(undefined);
                this._userInfo = {
                    anonymousId: this.eventProcessor.getUser().getAnonymousId()
                };
            };
            this.setAlias = (aliasKeyType, alias)=>{
                if (!aliasKeyType) throw new Error('Missing aliasType');
                if (!(0, (0, parcelRequire("bpIMA")).isType)((0, (0, parcelRequire("bpIMA")).aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, (0, parcelRequire("bpIMA")).objectValues)((0, (0, parcelRequire("bpIMA")).aliasType))}]`);
                this._aliases[aliasKeyType] = alias;
            };
            this.clearAlias = ()=>{
                this._aliases = {};
            };
            this.setGroup = (groupsKeyType, group)=>{
                if (!groupsKeyType) throw new Error('Missing groupType');
                if (!(0, (0, parcelRequire("bpIMA")).isType)((0, (0, parcelRequire("bpIMA")).groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, (0, parcelRequire("bpIMA")).objectValues)((0, (0, parcelRequire("bpIMA")).groupType))}]`);
                this._groups[groupsKeyType] = group;
            };
            this.clearGroup = ()=>{
                this._groups = {};
            };
            this.getAnonymousId = ()=>this._userInfo.anonymousId;
            this.setUIViewedAttributes = (uiViewedAttributes)=>{
                if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
                if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
                this._uiViewedAttributes = {
                    ...uiViewedAttributes
                };
            };
            this.getUIViewedAttributes = ()=>{
                return this._uiViewedAttributes;
            };
            this.clearUIViewedAttributes = ()=>{
                this._uiViewedAttributes = {};
            };
            this.sendIdentifyEvent = (userIdType, userId, callback)=>{
                this.setUserInfo(userIdType, userId);
                const builtEvent = {
                    userIdType: userIdType,
                    eventType: (0, (0, parcelRequire("bpIMA")).eventType).IDENTIFY
                };
                return this._processEvent(userId, builtEvent, this._context, callback);
            };
            this.sendPageEvent = (name, callback)=>{
                return this.sendScreenEvent(name, callback);
            };
            this.sendScreenEvent = (event, callback, attributes)=>{
                let screenName;
                let screenAttributes;
                let screenContainers;
                let screenTags;
                if (typeof event === 'object') {
                    screenName = event.name;
                    screenAttributes = event.attributes;
                    screenContainers = event.containers;
                    screenTags = event.tags;
                } else {
                    screenName = event;
                    screenAttributes = attributes;
                }
                (0, (0, parcelRequire("k0HOQ")).validateScreenEvent)(screenName);
                (0, (0, parcelRequire("k0HOQ")).validateContainers)(screenContainers);
                const builtEvent = (0, (0, parcelRequire("c3RJk")).buildScreenEvent)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
                const builtEventWithName = {
                    name: screenName,
                    ...builtEvent
                };
                this._setLastScreenEvent(builtEventWithName);
                return this._processEvent(screenName, builtEventWithName, this._context, (0, (0, parcelRequire("ef7xh")).default)(callback, builtEventWithName));
            };
            this.sendTrackEvent = (event, callback)=>{
                (0, (0, parcelRequire("k0HOQ")).validateTrackEvent)(event);
                const builtEvent = (0, (0, parcelRequire("c3RJk")).buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, (0, parcelRequire("bpIMA")).eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
                return this._processEvent((0, (0, parcelRequire("c3RJk")).buildActionName)(event), builtEvent, this._context, (0, (0, parcelRequire("ef7xh")).default)(callback, builtEvent));
            };
            this.sendUIEvent = (event, callback)=>{
                (0, (0, parcelRequire("k0HOQ")).validateUIEvent)(event);
                const builtEvent = (0, (0, parcelRequire("c3RJk")).buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, (0, parcelRequire("bpIMA")).eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
                return this._processEvent((0, (0, parcelRequire("c3RJk")).buildActionName)(event), builtEvent, this._context, (0, (0, parcelRequire("ef7xh")).default)(callback, builtEvent));
            };
            this.sendOperationalEvent = (event, callback)=>{
                (0, (0, parcelRequire("k0HOQ")).validateOperationalEvent)(event);
                const builtEvent = (0, (0, parcelRequire("c3RJk")).buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, (0, parcelRequire("bpIMA")).eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
                return this._processEvent((0, (0, parcelRequire("c3RJk")).buildActionName)(event), builtEvent, this._context, (0, (0, parcelRequire("ef7xh")).default)(callback, builtEvent));
            };
            this.startUIViewedEvent = (callback)=>{
                this.stopUIViewedEvent();
                this._uiViewedEvent = new (0, (0, parcelRequire("aR61w")).default)(this._productInfo, ()=>({
                        embeddedProduct: this._productInfo.embeddedProduct(),
                        subproduct: this._productInfo.subproduct(),
                        tenantIdType: this._tenantInfo.tenantIdType,
                        tenantId: this._tenantInfo.tenantId,
                        userId: this._userInfo.userId,
                        lastScreenEvent: this._getLastScreenEvent(),
                        attributes: this._uiViewedAttributes
                    }), (event)=>this.sendUIEvent(event, callback));
                this._uiViewedEvent.start();
            };
            this.stopUIViewedEvent = ()=>{
                if (this._uiViewedEvent) {
                    this._uiViewedEvent.stop();
                    this._uiViewedEvent = null;
                }
            };
            this.resetUIViewedTimers = ()=>{
                if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
            };
            this.startApdexEvent = (apdexEvent)=>{
                this._apdexEvent.start(apdexEvent);
            };
            this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
            this.stopApdexEvent = (apdexEvent, callback)=>{
                this._apdexEvent.stop(apdexEvent, callback);
            };
            this.startLowPriorityEventDelay = (timeout, callback)=>{
                this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
            };
            this.stopLowPriorityEventDelay = ()=>{
                this.eventDelayQueue.stopLowPriorityEventDelay();
            };
            this.onEvent = (_analyticsId, analyticsData)=>{
                if (!analyticsData) throw new Error('Missing analyticsData');
                if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
                if (analyticsData.eventType === (0, (0, parcelRequire("bpIMA")).eventType).TRACK) return this.sendTrackEvent(analyticsData);
                else if (analyticsData.eventType === (0, (0, parcelRequire("bpIMA")).eventType).UI) return this.sendUIEvent(analyticsData);
                else if (analyticsData.eventType === (0, (0, parcelRequire("bpIMA")).eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
                else if (analyticsData.eventType === (0, (0, parcelRequire("bpIMA")).eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
                else if (analyticsData.eventType === (0, (0, parcelRequire("bpIMA")).eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
                throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, (0, parcelRequire("bpIMA")).objectValues)((0, (0, parcelRequire("bpIMA")).eventType))}]`);
            };
            if (!productInfo) throw new Error('Missing productInfo');
            if (!productInfo.env) throw new Error('Missing productInfo.env');
            if (!productInfo.product) throw new Error('Missing productInfo.product');
            if (!(0, (0, parcelRequire("bpIMA")).isType)((0, (0, parcelRequire("bpIMA")).envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, (0, parcelRequire("bpIMA")).objectValues)((0, (0, parcelRequire("bpIMA")).envType))}]`);
            if (productInfo.perimeter && !(0, (0, parcelRequire("bpIMA")).isType)((0, (0, parcelRequire("bpIMA")).perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, (0, parcelRequire("bpIMA")).objectValues)((0, (0, parcelRequire("bpIMA")).perimeterType))}]`);
            if (!productInfo.origin) productInfo.origin = (0, (0, parcelRequire("bpIMA")).originType).WEB;
            else if (!(0, (0, parcelRequire("bpIMA")).isType)((0, (0, parcelRequire("bpIMA")).originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, (0, parcelRequire("bpIMA")).objectValues)((0, (0, parcelRequire("bpIMA")).originType))}]`);
            if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, (0, parcelRequire("bpIMA")).originType).WEB ? (0, (0, parcelRequire("bpIMA")).platformType).WEB : (0, (0, parcelRequire("bpIMA")).platformType).DESKTOP;
            else (0, (0, parcelRequire("k0HOQ")).validatePlatform)(productInfo);
            this.logger = settings.logger || console;
            this._productInfo = {
                ...productInfo,
                subproduct: this._createSubproductGetter(productInfo.subproduct),
                embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
            };
            this._tenantInfo = {};
            this._orgInfo = {};
            this._uiViewedAttributes = {};
            this._context = (0, (0, parcelRequire("c3RJk")).buildContext)(this._productInfo);
            this._safeSessionStorage = new (0, (0, parcelRequire("ikdCB")).default)();
            const useStargate = this._useStargate(settings.useStargate);
            const apiHost = settings.apiHost || (0, (0, parcelRequire("gYXWu")).selectHost)({
                useStargate: useStargate,
                env: productInfo.env,
                useLegacyUrl: settings.useLegacyUrl,
                perimeter: productInfo.perimeter,
                envOverride: productInfo.envOverride
            });
            const apiHostProtocol = settings.apiHostProtocol || 'https';
            const minRetryDelay = settings.minRetryDelay || 1000;
            const retryQueueOptions = {
                maxRetryDelay: 60000,
                minRetryDelay: minRetryDelay,
                backoffFactor: 2,
                flushWaitMs: settings.flushWaitInterval,
                flushBeforeUnload: settings.flushBeforeUnload
            };
            const retryQueuePrefix = `awc-${productInfo.env}`;
            const xidPromiseGetter = ()=>(0, (0, parcelRequire("bE87f")).XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
            const disableCookiePersistence = settings.disableCookiePersistence || false;
            this.eventProcessor = new (0, (0, parcelRequire("kjpfP")).default)({
                apiHost: apiHost,
                apiHostProtocol: apiHostProtocol,
                product: productInfo.product,
                retryQueuePrefix: retryQueuePrefix,
                retryQueueOptions: retryQueueOptions,
                xidPromiseGetter: xidPromiseGetter,
                logger: this.logger,
                disableCookiePersistence: disableCookiePersistence
            });
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
            };
            this._pageVisibility = new (0, (0, parcelRequire("6P9bw")).default)();
            this._tabTracking = new (0, (0, parcelRequire("aycns")).default)();
            this._sessionTracking = new (0, (0, parcelRequire("2jDOS")).default)({
                sessionExpiryTime: settings.sessionExpiryTime,
                onNewSessionStarted: settings.onNewSessionStarted
            });
            this.task = new (0, (0, parcelRequire("6fgea")).default)();
            this.originTracing = new (0, (0, parcelRequire("9E64n")).default)();
            this._apdexEvent = new (0, (0, parcelRequire("fYTlD")).default)(this.sendOperationalEvent, this._pageVisibility);
            this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, (0, parcelRequire("f8lVk")).defaultHistoryReplaceFn);
            this.eventDelayQueue = new (0, (0, parcelRequire("gk4Et")).default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
            this._testingCache = new (0, (0, parcelRequire("evS6W")).default)();
            this._pageLoadId = (0, ($parcel$interopDefault($bXrHm)))();
            this._workspaceInfo = {};
            this._aliases = {};
            this._groups = {};
        }
    }
});
parcelRegister("bpIMA", function(module, exports) {
    $parcel$export(module.exports, "envType", ()=>$7f55b2a607c9d895$export$56ac8ebc9870b1b9);
    $parcel$export(module.exports, "eventType", ()=>$7f55b2a607c9d895$export$4c045e605d532c98);
    $parcel$export(module.exports, "platformType", ()=>$7f55b2a607c9d895$export$6b4f396210e539f3);
    $parcel$export(module.exports, "originType", ()=>$7f55b2a607c9d895$export$f73e9fcd368bb695);
    $parcel$export(module.exports, "tenantType", ()=>$7f55b2a607c9d895$export$496f06ac2a964da2);
    $parcel$export(module.exports, "userType", ()=>$7f55b2a607c9d895$export$1827adfd178b4870);
    $parcel$export(module.exports, "apdexType", ()=>$7f55b2a607c9d895$export$99b37380a464d794);
    $parcel$export(module.exports, "desktopPlatforms", ()=>$7f55b2a607c9d895$export$809831be6c4c6227);
    $parcel$export(module.exports, "webPlatforms", ()=>$7f55b2a607c9d895$export$19c579398ad213e7);
    $parcel$export(module.exports, "originTracingType", ()=>$7f55b2a607c9d895$export$62a500c02dc63ee);
    $parcel$export(module.exports, "objectValues", ()=>$7f55b2a607c9d895$export$ad1854f4a08c15f8);
    $parcel$export(module.exports, "isType", ()=>$7f55b2a607c9d895$export$26b9f946b448f23e);
    $parcel$export(module.exports, "perimeterType", ()=>$7f55b2a607c9d895$export$bdd41749d2096e4b);
    $parcel$export(module.exports, "aliasType", ()=>$7f55b2a607c9d895$export$a8c99e46b781d936);
    $parcel$export(module.exports, "groupType", ()=>$7f55b2a607c9d895$export$e73680b18d9b7c6e);
    var $7f55b2a607c9d895$export$56ac8ebc9870b1b9;
    (function(envType) {
        envType["LOCAL"] = "local";
        envType["DEV"] = "dev";
        envType["STAGING"] = "staging";
        envType["PROD"] = "prod";
    })($7f55b2a607c9d895$export$56ac8ebc9870b1b9 || ($7f55b2a607c9d895$export$56ac8ebc9870b1b9 = {}));
    var $7f55b2a607c9d895$export$4c045e605d532c98;
    (function(eventType) {
        eventType["TRACK"] = "track";
        eventType["UI"] = "ui";
        eventType["OPERATIONAL"] = "operational";
        eventType["SCREEN"] = "screen";
        eventType["IDENTIFY"] = "identify";
    })($7f55b2a607c9d895$export$4c045e605d532c98 || ($7f55b2a607c9d895$export$4c045e605d532c98 = {}));
    var $7f55b2a607c9d895$export$6b4f396210e539f3;
    (function(platformType) {
        platformType["MAC"] = "mac";
        platformType["LINUX"] = "linux";
        platformType["WINDOWS"] = "windows";
        platformType["DESKTOP"] = "desktop";
        platformType["WEB"] = "web";
        platformType["MOBILE_WEB"] = "mobileWeb";
    })($7f55b2a607c9d895$export$6b4f396210e539f3 || ($7f55b2a607c9d895$export$6b4f396210e539f3 = {}));
    var $7f55b2a607c9d895$export$f73e9fcd368bb695;
    (function(originType) {
        originType["DESKTOP"] = "desktop";
        originType["WEB"] = "web";
    })($7f55b2a607c9d895$export$f73e9fcd368bb695 || ($7f55b2a607c9d895$export$f73e9fcd368bb695 = {}));
    var $7f55b2a607c9d895$export$496f06ac2a964da2;
    (function(tenantType) {
        tenantType["CLOUD_ID"] = "cloudId";
        tenantType["ORG_ID"] = "orgId";
        tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
        tenantType["HALP_TEAM_ID"] = "halpTeamId";
        tenantType["LOOM_ORG_ID"] = "loomOrgId";
        tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
        tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
        tenantType["NONE"] = "none";
    })($7f55b2a607c9d895$export$496f06ac2a964da2 || ($7f55b2a607c9d895$export$496f06ac2a964da2 = {}));
    var $7f55b2a607c9d895$export$1827adfd178b4870;
    (function(userType) {
        userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
        userType["HASHED_EMAIL"] = "hashedEmail";
        userType["LOOM"] = "loom";
        userType["TRELLO"] = "trello";
        userType["OPSGENIE"] = "opsgenie";
        userType["HALP"] = "halp";
    })($7f55b2a607c9d895$export$1827adfd178b4870 || ($7f55b2a607c9d895$export$1827adfd178b4870 = {}));
    var $7f55b2a607c9d895$export$99b37380a464d794;
    (function(apdexType) {
        apdexType["TRANSITION"] = "transition";
        apdexType["INITIAL_LOAD"] = "initialLoad";
    })($7f55b2a607c9d895$export$99b37380a464d794 || ($7f55b2a607c9d895$export$99b37380a464d794 = {}));
    const $7f55b2a607c9d895$export$809831be6c4c6227 = Object.freeze([
        "desktop",
        "mac",
        "linux",
        "windows"
    ]);
    const $7f55b2a607c9d895$export$19c579398ad213e7 = Object.freeze([
        "web",
        "mobileWeb"
    ]);
    var $7f55b2a607c9d895$export$62a500c02dc63ee;
    (function(originTracingType) {
        originTracingType["ATL_ORIGIN"] = "atlOrigin";
    })($7f55b2a607c9d895$export$62a500c02dc63ee || ($7f55b2a607c9d895$export$62a500c02dc63ee = {}));
    function $7f55b2a607c9d895$export$ad1854f4a08c15f8(object) {
        return Object.values(object);
    }
    function $7f55b2a607c9d895$export$26b9f946b448f23e(type, value) {
        return Object.values(type).indexOf(value) > -1;
    }
    var $7f55b2a607c9d895$export$bdd41749d2096e4b;
    (function(perimeterType) {
        perimeterType["C5"] = "c5";
        perimeterType["COMMERCIAL"] = "commercial";
        perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
        perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    })($7f55b2a607c9d895$export$bdd41749d2096e4b || ($7f55b2a607c9d895$export$bdd41749d2096e4b = {}));
    var $7f55b2a607c9d895$export$a8c99e46b781d936;
    $7f55b2a607c9d895$export$a8c99e46b781d936 || ($7f55b2a607c9d895$export$a8c99e46b781d936 = {});
    var $7f55b2a607c9d895$export$e73680b18d9b7c6e;
    (function(groupType) {
        groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    })($7f55b2a607c9d895$export$e73680b18d9b7c6e || ($7f55b2a607c9d895$export$e73680b18d9b7c6e = {}));
    var $7f55b2a607c9d895$export$12b75c708da5a04b;
    $7f55b2a607c9d895$export$12b75c708da5a04b || ($7f55b2a607c9d895$export$12b75c708da5a04b = {});
});
parcelRegister("fYTlD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebd9ea63d5002e79$export$2e2bcd8739ae039);
    var $bpIMA;
    var $6P9bw;
    var $bn0vY;
    class $ebd9ea63d5002e79$export$2e2bcd8739ae039 {
        constructor(onEvent, pageVisibility){
            this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
            this._getEventTimingByName = (name)=>{
                const eventTimings = this._performance.getEntriesByName(name);
                const eventTiming = eventTimings[eventTimings.length - 1];
                return eventTiming;
            };
            this._getApdexFields = (event)=>{
                const apdexTimings = this._getApdexTimings(event);
                const apdexScore = this._calculateApdex({
                    duration: apdexTimings.duration,
                    threshold: event.threshold
                });
                return {
                    ...apdexTimings,
                    apdex: apdexScore
                };
            };
            this._getApdexTimings = (event)=>{
                const eventKey = this._getEventKey(event);
                const eventStartName = `${eventKey}-start`;
                const startTime = event.startTime || this._getStartTime(event, eventStartName);
                const stopTime = event.stopTime || this._getStopTime();
                this._cleanApdexState(eventKey);
                return {
                    startTime: startTime,
                    stopTime: stopTime,
                    duration: stopTime - startTime
                };
            };
            this._getStartTime = (event, eventName)=>{
                let startTime;
                const timeOrigin = this._performance.getTimeOrigin();
                if (event.type === (0, (0, parcelRequire("bpIMA")).apdexType).INITIAL_LOAD) startTime = timeOrigin;
                else {
                    const eventTiming = this._getEventTimingByName(eventName);
                    startTime = timeOrigin + eventTiming.startTime;
                }
                return startTime;
            };
            this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
            this._cleanApdexState = (eventKey)=>{
                this._performance.clearMarks(`${eventKey}-start`);
                this._performance.clearMarks(`${eventKey}-stop`);
                this._startedEvents.delete(eventKey);
            };
            this._getVisibilityFields = (event)=>{
                let isActiveTab;
                if (event.type === (0, (0, parcelRequire("bpIMA")).apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
                else if (event.type === (0, (0, parcelRequire("bpIMA")).apdexType).TRANSITION) {
                    const eventKey = this._getEventKey(event);
                    isActiveTab = this._isActiveEvents.get(eventKey);
                }
                if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
                return {
                    isActiveTab: isActiveTab
                };
            };
            this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
                let apdex;
                const satisfiedThreshold = threshold;
                const tolerableThreshold = threshold * 4;
                if (duration <= satisfiedThreshold) apdex = 1;
                else if (duration <= tolerableThreshold) apdex = 0.5;
                else apdex = 0;
                return apdex;
            };
            this._validateStartEvent = (event)=>{
                if (!event) throw new Error('Missing "event" in Apdex start event');
                if (!event.task) throw new Error('Missing "task" in Apdex start event');
                if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
                if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
            };
            this._validateStopEvent = (event)=>{
                if (!event) throw new Error('Missing "event" in Apdex stop event');
                if (!event.task) throw new Error('Missing "task" in Apdex stop event');
                if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
                if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
                if (!event.type) throw new Error('Missing "type" in Apdex stop event');
                if (event.type && !(0, (0, parcelRequire("bpIMA")).isType)((0, (0, parcelRequire("bpIMA")).apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
                if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
                if (!event.startTime && event.type === (0, (0, parcelRequire("bpIMA")).apdexType).TRANSITION) {
                    const eventKey = this._getEventKey(event);
                    if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
                }
                if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
                if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
                if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
            };
            this._shouldSendEvent = (event)=>{
                if (!event) return false;
                if (typeof event.apdex !== 'number') return false;
                return true;
            };
            this._sendEvent = (event, callback)=>{
                if (this._shouldSendEvent(event)) this._onEvent({
                    source: 'ui',
                    action: 'readyForUser',
                    actionSubject: 'ui',
                    attributes: {
                        ...event.additionalAttributes,
                        task: event.task,
                        taskId: event.taskId,
                        type: event.type,
                        threshold: event.threshold || this._threshold,
                        apdex: event.apdex,
                        startTime: event.startTime,
                        stopTime: event.stopTime,
                        duration: event.duration,
                        isActiveTab: event.isActiveTab
                    }
                }, callback);
            };
            if (!onEvent) throw new Error('Missing onEvent callback');
            if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
            if (!(pageVisibility instanceof (0, (0, parcelRequire("6P9bw")).default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
            this._startedEvents = new Map();
            this._performance = new (0, (0, parcelRequire("bn0vY")).default)();
            this._onEvent = onEvent;
            this._threshold = 1000;
            this._wasPreviouslyHidden = pageVisibility.getIsHidden();
            this._isActiveEvents = new Map();
            this._pageVisibility = pageVisibility;
            this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
                this.onVisibilityChange(!isHidden);
            });
        }
        start(event) {
            this._validateStartEvent(event);
            if (!this._performance.isAvailable()) return;
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            this._startedEvents.set(eventKey, true);
            this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
            this._performance.clearMarks(eventStartName);
            this._performance.mark(eventStartName);
        }
        getStart(event) {
            this._validateStartEvent(event);
            if (!this._performance.isAvailable()) return undefined;
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            return this._getEventTimingByName(eventStartName);
        }
        stop(event, callback) {
            this._validateStopEvent(event);
            if (!this._performance.isAvailable()) return;
            const apdexFields = this._getApdexFields(event);
            const visibilityFields = this._getVisibilityFields(event);
            this._sendEvent({
                ...event,
                ...apdexFields,
                ...visibilityFields
            }, callback);
        }
        onVisibilityChange(isActive) {
            if (!isActive) {
                this._wasPreviouslyHidden = true;
                Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
            }
        }
    }
});
parcelRegister("6P9bw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c56340b63e1862a$export$2e2bcd8739ae039);
    class $2c56340b63e1862a$export$2e2bcd8739ae039 {
        constructor(){
            this._bindEventListeners = ()=>{
                document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
            };
            this._handleVisibilityChange = ()=>{
                const isHidden = document[this._hidden];
                this._isHidden = isHidden;
                this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
            };
            this._isHidden = false;
            this._callbacks = new Map();
            this._hidden = undefined;
            this._visibilityChange = undefined;
            if (typeof document !== 'undefined') {
                if (typeof document.hidden !== 'undefined') {
                    this._isHidden = document.hidden;
                    this._hidden = 'hidden';
                    this._visibilityChange = 'visibilitychange';
                } else if (typeof document.msHidden !== 'undefined') {
                    this._isHidden = document.msHidden;
                    this._hidden = 'msHidden';
                    this._visibilityChange = 'msvisibilitychange';
                } else if (typeof document.webkitHidden !== 'undefined') {
                    this._isHidden = document.webkitHidden;
                    this._hidden = 'webkitHidden';
                    this._visibilityChange = 'webkitvisibilitychange';
                }
                if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
            }
        }
        addCallback(name, fn) {
            if (typeof name !== 'string') throw new Error('Invalid name, must be string');
            if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
            this._callbacks.set(name, fn);
        }
        removeCallback(name) {
            if (this._callbacks.has(name)) this._callbacks.delete(name);
        }
        getIsHidden() {
            return this._isHidden;
        }
    }
});
parcelRegister("bn0vY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ddee47f94546626$export$2e2bcd8739ae039);
    class $4ddee47f94546626$export$2e2bcd8739ae039 {
        constructor(){
            this._performance = window.performance;
        }
        clearMarks(...args) {
            if (!this._performance || !this._performance.clearMarks) return;
            this._performance.clearMarks(...args);
        }
        mark(...args) {
            if (!this._performance || !this._performance.mark) return;
            this._performance.mark(...args);
        }
        getEntriesByName(...args) {
            if (!this._performance || !this._performance.getEntriesByName) return [];
            return this._performance.getEntriesByName(...args);
        }
        getTimeOrigin() {
            if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
            return this._performance.timeOrigin || this._performance.timing.navigationStart;
        }
        now() {
            if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
            return this._performance.now();
        }
        isAvailable() {
            return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
        }
    }
});
parcelRegister("92uUR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$be7eb084c17fdacd$export$2e2bcd8739ae039);
    const $be7eb084c17fdacd$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
    var $be7eb084c17fdacd$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
        return ()=>{
            if ($be7eb084c17fdacd$var$isFunction(possibleFn)) try {
                return possibleFn();
            } catch (e) {
                console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
                return undefined;
            }
            return possibleFn;
        };
    };
});
parcelRegister("c3RJk", function(module, exports) {
    $parcel$export(module.exports, "buildActionFields", ()=>$7e1dd294790eae6e$export$655ecf7241feac42);
    $parcel$export(module.exports, "buildScreenEvent", ()=>$7e1dd294790eae6e$export$c7d9a5f56acc4b19);
    $parcel$export(module.exports, "buildActionName", ()=>$7e1dd294790eae6e$export$9c5623a792efc9b0);
    $parcel$export(module.exports, "buildContext", ()=>$7e1dd294790eae6e$export$3a7fe28f9bf4f3d9);
    $parcel$export(module.exports, "buildActionEvent", ()=>$7e1dd294790eae6e$export$7bf451af4a8e3dd9);
    var $bpIMA;
    var $jMpLN;
    const $7e1dd294790eae6e$var$libraryVersion = "0.0.0-use.local";
    function $7e1dd294790eae6e$var$buildTenantFields(tenantInfo) {
        return {
            tenantIdType: tenantInfo.tenantIdType,
            tenantId: tenantInfo.tenantId
        };
    }
    function $7e1dd294790eae6e$var$buildUserFields(userInfo) {
        return {
            userIdType: userInfo.userIdType
        };
    }
    function $7e1dd294790eae6e$var$buildOrgFields(orgInfo) {
        return {
            orgId: orgInfo.orgId
        };
    }
    function $7e1dd294790eae6e$var$buildWorkspaceFields(workspaceInfo) {
        return {
            workspaceId: workspaceInfo.workspaceId
        };
    }
    function $7e1dd294790eae6e$var$buildAliases(aliases) {
        if ($7e1dd294790eae6e$var$isNotEmptyObject(aliases)) return {
            aliases: aliases
        };
        return undefined;
    }
    function $7e1dd294790eae6e$var$buildGroups(groups) {
        if ($7e1dd294790eae6e$var$isNotEmptyObject(groups)) return {
            groups: groups
        };
        return undefined;
    }
    function $7e1dd294790eae6e$var$buildEventOverrides(event) {
        if (event.anonymousId) return {
            anonymousId: event.anonymousId
        };
        return {};
    }
    function $7e1dd294790eae6e$var$getProductField(field, override) {
        return override === undefined ? field : override;
    }
    function $7e1dd294790eae6e$var$buildProductFields(productInfo, productOverrides) {
        const overrides = productOverrides || {};
        const env = $7e1dd294790eae6e$var$getProductField(productInfo.env, overrides.env);
        const product = $7e1dd294790eae6e$var$getProductField(productInfo.product, overrides.product);
        const subproduct = $7e1dd294790eae6e$var$getProductField(productInfo.subproduct(), overrides.subproduct);
        const version = $7e1dd294790eae6e$var$getProductField(productInfo.version, overrides.version);
        const origin = $7e1dd294790eae6e$var$getProductField(productInfo.origin, overrides.origin);
        const platform = $7e1dd294790eae6e$var$getProductField(productInfo.platform, overrides.platform);
        return {
            env: env,
            product: product,
            subproduct: subproduct,
            version: version,
            origin: origin,
            platform: platform
        };
    }
    function $7e1dd294790eae6e$var$isNotEmptyObject(obj) {
        return (0, (0, parcelRequire("jMpLN")).isPlainObject)(obj) && Object.keys(obj).length > 0;
    }
    function $7e1dd294790eae6e$var$buildAttributesWithName(name, attrObject) {
        return $7e1dd294790eae6e$var$isNotEmptyObject(attrObject) ? {
            [name]: attrObject
        } : undefined;
    }
    function $7e1dd294790eae6e$var$buildAttributes(attributes) {
        return $7e1dd294790eae6e$var$buildAttributesWithName('attributes', attributes);
    }
    function $7e1dd294790eae6e$export$3f5115a568819c1a(containers) {
        const validContainers = {};
        Object.keys(containers).forEach((key)=>{
            const value = containers[key];
            validContainers[key] = {
                id: value.id,
                type: value.type
            };
        });
        return validContainers;
    }
    function $7e1dd294790eae6e$export$f045f238d77c002a(containers) {
        if ($7e1dd294790eae6e$var$isNotEmptyObject(containers)) {
            const validContainers = $7e1dd294790eae6e$export$3f5115a568819c1a(containers);
            return $7e1dd294790eae6e$var$buildAttributesWithName('containers', validContainers);
        }
        return undefined;
    }
    function $7e1dd294790eae6e$export$655ecf7241feac42(event, actionEventType) {
        return {
            containerType: event.containerType,
            containerId: event.containerId,
            source: event.source,
            objectType: event.objectType,
            objectId: event.objectId,
            actionSubject: event.actionSubject,
            action: event.action,
            actionSubjectId: event.actionSubjectId,
            attributes: event.attributes,
            nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
            tags: event.tags,
            highPriority: event.highPriority,
            eventType: actionEventType,
            ...$7e1dd294790eae6e$export$f045f238d77c002a(event.containers)
        };
    }
    function $7e1dd294790eae6e$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
        return $7e1dd294790eae6e$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
    }
    function $7e1dd294790eae6e$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
        const productFields = $7e1dd294790eae6e$var$buildProductFields(productInfo);
        const tenantFields = $7e1dd294790eae6e$var$buildTenantFields(tenantInfo);
        const userFields = $7e1dd294790eae6e$var$buildUserFields(userInfo);
        const orgFields = $7e1dd294790eae6e$var$buildOrgFields(orgInfo);
        const workspaceFields = $7e1dd294790eae6e$var$buildWorkspaceFields(workspaceInfo);
        const overrides = {
            title: '',
            path: '',
            url: '',
            referrer: '',
            search: '',
            eventType: (0, (0, parcelRequire("bpIMA")).eventType).SCREEN
        };
        return {
            ...productFields,
            ...tenantFields,
            ...userFields,
            ...orgFields,
            ...overrides,
            ...$7e1dd294790eae6e$var$buildAttributes(attributes),
            ...$7e1dd294790eae6e$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
            ...$7e1dd294790eae6e$export$f045f238d77c002a(containers),
            ...$7e1dd294790eae6e$var$buildEventOverrides(event),
            tags: tags,
            tabId: tabId,
            sessionId: sessionId,
            taskSessions: taskSessions,
            pageLoadId: pageLoadId,
            ...workspaceFields,
            ...$7e1dd294790eae6e$var$buildAliases(aliases),
            ...$7e1dd294790eae6e$var$buildGroups(groups)
        };
    }
    function $7e1dd294790eae6e$export$9c5623a792efc9b0(event) {
        return `${event.actionSubject} ${event.action}`;
    }
    function $7e1dd294790eae6e$export$3a7fe28f9bf4f3d9(productInfo) {
        const screen = window.screen || {};
        return {
            context: {
                locale: productInfo.locale,
                screen: {
                    width: screen.width,
                    height: screen.height,
                    density: window.devicePixelRatio
                },
                library: {
                    name: 'analytics.js',
                    version: $7e1dd294790eae6e$var$libraryVersion
                }
            }
        };
    }
    function $7e1dd294790eae6e$export$e3d99b4bfec06f6e(event) {
        const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
        return {
            env: env,
            product: product,
            subproduct: subproduct,
            version: version,
            origin: origin,
            platform: platform
        };
    }
    function $7e1dd294790eae6e$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
        const productFields = $7e1dd294790eae6e$var$buildProductFields(productInfo, $7e1dd294790eae6e$export$e3d99b4bfec06f6e(event));
        const tenantFields = $7e1dd294790eae6e$var$buildTenantFields(tenantInfo);
        const orgFields = $7e1dd294790eae6e$var$buildOrgFields(orgInfo);
        const workspaceFields = $7e1dd294790eae6e$var$buildWorkspaceFields(workspaceInfo);
        const userFields = $7e1dd294790eae6e$var$buildUserFields(userInfo);
        const actionFields = $7e1dd294790eae6e$export$655ecf7241feac42(event, actionEventType);
        return {
            ...productFields,
            ...tenantFields,
            ...orgFields,
            ...userFields,
            ...actionFields,
            ...$7e1dd294790eae6e$var$buildEventOverrides(event),
            tabId: tabId,
            sessionId: sessionId,
            taskSessions: taskSessions,
            pageLoadId: pageLoadId,
            ...workspaceFields,
            ...$7e1dd294790eae6e$var$buildAliases(aliases),
            ...$7e1dd294790eae6e$var$buildGroups(groups)
        };
    }
});
parcelRegister("jMpLN", function(module, exports) {
    $parcel$export(module.exports, "isPlainObject", ()=>$b15bde09c82f1e9c$export$53b83ca8eaab0383);
    function $b15bde09c82f1e9c$var$isObject(val) {
        return val !== null && typeof val === 'object' && Array.isArray(val) === false;
    }
    function $b15bde09c82f1e9c$var$isObjectObject(o) {
        return $b15bde09c82f1e9c$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
    }
    function $b15bde09c82f1e9c$export$53b83ca8eaab0383(o) {
        if ($b15bde09c82f1e9c$var$isObjectObject(o) === false) return false;
        const ctor = o.constructor;
        if (typeof ctor !== 'function') return false;
        const prot = ctor.prototype;
        if ($b15bde09c82f1e9c$var$isObjectObject(prot) === false) return false;
        if (!('isPrototypeOf' in prot)) return false;
        return true;
    }
});
parcelRegister("gk4Et", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de367b2ac3f46917$export$2e2bcd8739ae039);
    var $4K0jj;
    var $lzWTs;
    class $de367b2ac3f46917$export$2e2bcd8739ae039 {
        constructor(fireDelayedEvent, compressors){
            this.push = (identifier, builtEvent, context, userInfo)=>{
                this.delayQueue.push(identifier, builtEvent, context, userInfo);
            };
            this.startLowPriorityEventDelay = (timeout = (0, $835d34a7c9fd1af2$export$cf090d5281b5ae06), callback)=>{
                if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
                if (this.delayTimeout) clearTimeout(this.delayTimeout);
                const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $835d34a7c9fd1af2$export$8575e30be0feb909)) : (0, $835d34a7c9fd1af2$export$8575e30be0feb909);
                this.delayCallback = callback;
                this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, (0, parcelRequire("lzWTs")).StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
                this.delayQueue.cancelFlush();
                this.isDelaying = true;
            };
            this.stopLowPriorityEventDelay = (reason = (0, (0, parcelRequire("lzWTs")).StopLowPriorityEventDelayReason).MANUAL)=>{
                if (this.delayTimeout) {
                    clearTimeout(this.delayTimeout);
                    this.delayTimeout = undefined;
                }
                this.delayQueue.startFlush();
                this.isDelaying = false;
                this.delayCallback?.(reason);
                this.delayCallback = undefined;
            };
            this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
            this.isDelaying = false;
            this.delayQueue = new (0, (0, parcelRequire("4K0jj")).default)(fireDelayedEvent, compressors);
        }
    }
});
const $835d34a7c9fd1af2$export$cf090d5281b5ae06 = 10000;
const $835d34a7c9fd1af2$export$8575e30be0feb909 = 30000;
parcelRegister("4K0jj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0aae0b78a9a7519f$export$2e2bcd8739ae039);
    var $c3RJk;
    var $d603q;
    var $bZNRB;
    const $0aae0b78a9a7519f$var$FLUSH_BATCH_SIZE = 7;
    const $0aae0b78a9a7519f$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
    class $0aae0b78a9a7519f$export$2e2bcd8739ae039 {
        constructor(processFn, compressionRules){
            this.push = (identifier, builtEvent, context, userInfo)=>{
                this.eventArgs.push({
                    identifier: identifier,
                    builtEvent: builtEvent,
                    context: context,
                    userInfo: userInfo
                });
            };
            this.size = ()=>this.eventArgs.length;
            this.startFlush = ()=>{
                try {
                    this.eventArgs = this.compressEventArgs(this.eventArgs);
                } catch (e) {
                    console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
                }
                this.flushNextBatch();
            };
            this.cancelFlush = ()=>{
                if (this.flushBatchTimeout) {
                    clearTimeout(this.flushBatchTimeout);
                    this.flushBatchTimeout = null;
                }
            };
            this.flushNextBatch = ()=>{
                const batch = this.eventArgs.splice(0, $0aae0b78a9a7519f$var$FLUSH_BATCH_SIZE);
                batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
                if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $0aae0b78a9a7519f$var$FLUSH_BATCH_BACKOFF_PERIOD);
                else this.flushBatchTimeout = null;
            };
            this.compressEventArgs = (eventArgs)=>{
                const [compressibleEventArgs, incompressibleEventArgs] = (0, (0, parcelRequire("d603q")).partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
                const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                    const matchingGroup = groups.find((group)=>(0, (0, parcelRequire("d603q")).equals)(group.userInfo, args.userInfo) && (0, (0, parcelRequire("d603q")).equals)(group.context, args.context));
                    if (matchingGroup) matchingGroup.eventArgs.push(args);
                    else groups.push({
                        userInfo: args.userInfo,
                        context: args.context,
                        eventArgs: [
                            args
                        ]
                    });
                    return groups;
                }, []);
                const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                    try {
                        const events = group.eventArgs.map((args)=>args.builtEvent);
                        const compressedEvents = this.compressor.compress(events);
                        const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                                identifier: (0, (0, parcelRequire("c3RJk")).buildActionName)(compressedEvent),
                                builtEvent: compressedEvent,
                                userInfo: group.userInfo,
                                context: group.context
                            }));
                        return acc.concat(compressedEventArgs);
                    } catch (e) {
                        console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                        return group.eventArgs;
                    }
                }, []);
                incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
                return allCompressedEventArgs;
            };
            this.processFn = processFn;
            this.flushBatchTimeout = null;
            this.eventArgs = [];
            this.compressor = new (0, (0, parcelRequire("bZNRB")).default)(compressionRules);
        }
    }
});
parcelRegister("d603q", function(module, exports) {
    $parcel$export(module.exports, "mapKeys", ()=>$165457ca3fa7a755$export$781522908e4e76a1);
    $parcel$export(module.exports, "pick", ()=>$165457ca3fa7a755$export$357523c63a2253b9);
    $parcel$export(module.exports, "omitBy", ()=>$165457ca3fa7a755$export$d7a617dda645b4e3);
    $parcel$export(module.exports, "pickBy", ()=>$165457ca3fa7a755$export$b460b275d6c6aa0);
    $parcel$export(module.exports, "omit", ()=>$165457ca3fa7a755$export$30a06c8d3562193f);
    $parcel$export(module.exports, "equals", ()=>$165457ca3fa7a755$export$e9bab7fafb253603);
    $parcel$export(module.exports, "partition", ()=>$165457ca3fa7a755$export$b29f828819edca8d);
    const $165457ca3fa7a755$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
            const key = fn(obj[k], k, obj);
            acc[key] = obj[k];
            return acc;
        }, {});
    const $165457ca3fa7a755$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
    const $165457ca3fa7a755$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
    const $165457ca3fa7a755$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
    const $165457ca3fa7a755$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
    const $165457ca3fa7a755$export$e9bab7fafb253603 = (a, b)=>{
        if (a === b) return true;
        if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
        if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
        if (a.prototype !== b.prototype) return false;
        const keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length) return false;
        return keys.every((k)=>$165457ca3fa7a755$export$e9bab7fafb253603(a[k], b[k]));
    };
    const $165457ca3fa7a755$export$b29f828819edca8d = (arr, fn)=>arr.reduce((acc, val, i, arr)=>{
            acc[fn(val, i, arr) ? 0 : 1].push(val);
            return acc;
        }, [
            [],
            []
        ]);
});
parcelRegister("bZNRB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e88f0c1c99181a4c$export$2e2bcd8739ae039);
    var $c3RJk;
    var $d603q;
    var $4vGXg;
    class $e88f0c1c99181a4c$export$2e2bcd8739ae039 {
        constructor(compressionRules = []){
            this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
            this.compress = (events)=>{
                const groups = this.createGroups(events);
                return groups.reduce((allCompressedEvents, group)=>{
                    const groupCompressedEvents = this.compressGroup(group);
                    return allCompressedEvents.concat(groupCompressedEvents);
                }, []);
            };
            this.createGroups = (events)=>events.reduce((groups, event)=>{
                    const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                    let contextFields;
                    if (matchingCompressor) {
                        const actionFields = (0, (0, parcelRequire("c3RJk")).buildActionFields)(event, event.eventType);
                        contextFields = (0, (0, parcelRequire("d603q")).omit)(event, Object.keys(actionFields));
                    }
                    const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, (0, parcelRequire("d603q")).equals)(contextFields, group.contextFields));
                    if (matchingGroup) matchingGroup.events.push(event);
                    else groups.push({
                        contextFields: contextFields,
                        compressor: matchingCompressor,
                        events: [
                            event
                        ]
                    });
                    return groups;
                }, []);
            this.compressGroup = (group)=>{
                if (!group.compressor) return group.events;
                try {
                    const compressedEventActionFields = group.compressor.compress(group.events);
                    return compressedEventActionFields.map((actionFields)=>({
                            ...actionFields,
                            ...group.contextFields
                        }));
                } catch (e) {
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                    return group.events;
                }
            };
            if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
            if (!compressionRules.every((rule)=>rule instanceof (0, (0, parcelRequire("4vGXg")).CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
            this.compressionRules = compressionRules;
        }
    }
});
parcelRegister("4vGXg", function(module, exports) {
    $parcel$export(module.exports, "CompressionRule", ()=>$e0803ecbd7047a75$export$89b3253ddfd2e6e8);
    var $k0HOQ;
    var $d603q;
    class $e0803ecbd7047a75$export$89b3253ddfd2e6e8 {
        constructor(predicate, compressFn){
            this.canCompress = (event)=>{
                try {
                    return event && (0, (0, parcelRequire("k0HOQ")).isActionEventType)(event.eventType) && this.predicate(event);
                } catch (e) {
                    return false;
                }
            };
            this.compress = (events)=>{
                const [compatibleEvents, incompatibleEvents] = (0, (0, parcelRequire("d603q")).partition)(events, (event)=>this.canCompress(event));
                const compressedEvents = this.compressFn(compatibleEvents);
                if (!compressedEvents) throw new Error('No events were returned from the compression function');
                compressedEvents.forEach((event)=>{
                    (0, (0, parcelRequire("k0HOQ")).validateActionEventType)(event.eventType);
                    (0, (0, parcelRequire("k0HOQ")).validateActionEvent)(event);
                });
                return compressedEvents.concat(incompatibleEvents);
            };
            if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
            if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
            this.predicate = predicate;
            this.compressFn = compressFn;
        }
    }
});
parcelRegister("k0HOQ", function(module, exports) {
    $parcel$export(module.exports, "validateContainers", ()=>$26c721e12b3274ca$export$e63ea5d8477971d3);
    $parcel$export(module.exports, "isActionEventType", ()=>$26c721e12b3274ca$export$d19cebda16f7579a);
    $parcel$export(module.exports, "validateActionEventType", ()=>$26c721e12b3274ca$export$4a8d7476662aebcc);
    $parcel$export(module.exports, "validateActionEvent", ()=>$26c721e12b3274ca$export$e0c121325c66ed4c);
    $parcel$export(module.exports, "validateScreenEvent", ()=>$26c721e12b3274ca$export$dc993432a592dc27);
    $parcel$export(module.exports, "validateTrackEvent", ()=>$26c721e12b3274ca$export$8c014fd74b0c8b99);
    $parcel$export(module.exports, "validateDwellBaseEvent", ()=>$26c721e12b3274ca$export$39d6334da9a44984);
    $parcel$export(module.exports, "validateUIEvent", ()=>$26c721e12b3274ca$export$e5bac0930c812e90);
    $parcel$export(module.exports, "validateOperationalEvent", ()=>$26c721e12b3274ca$export$1e561554275607ef);
    $parcel$export(module.exports, "validateIdentifyEvent", ()=>$26c721e12b3274ca$export$c16a4e16aa4026c0);
    $parcel$export(module.exports, "validatePlatform", ()=>$26c721e12b3274ca$export$801b46c35394d316);
    var $bpIMA;
    var $jMpLN;
    const $26c721e12b3274ca$var$actionEventTypes = Object.freeze([
        (0, (0, parcelRequire("bpIMA")).eventType).OPERATIONAL,
        (0, (0, parcelRequire("bpIMA")).eventType).TRACK,
        (0, (0, parcelRequire("bpIMA")).eventType).UI
    ]);
    function $26c721e12b3274ca$export$df8ff30e3c960006(container) {
        if (!(0, (0, parcelRequire("jMpLN")).isPlainObject)(container)) throw new Error('properties.containers must be an Object');
        if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
        if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
        if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
    }
    function $26c721e12b3274ca$export$e63ea5d8477971d3(containers) {
        if (!containers) return;
        if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
        Object.values(containers).forEach((container)=>$26c721e12b3274ca$export$df8ff30e3c960006(container));
    }
    function $26c721e12b3274ca$export$d19cebda16f7579a(type) {
        switch(type){
            case (0, (0, parcelRequire("bpIMA")).eventType).OPERATIONAL:
            case (0, (0, parcelRequire("bpIMA")).eventType).TRACK:
            case (0, (0, parcelRequire("bpIMA")).eventType).UI:
                return true;
            default:
                return false;
        }
    }
    function $26c721e12b3274ca$export$4a8d7476662aebcc(type) {
        if (!$26c721e12b3274ca$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$26c721e12b3274ca$var$actionEventTypes}]`);
        return true;
    }
    function $26c721e12b3274ca$export$e0c121325c66ed4c(event) {
        if (!event) throw new Error('Missing event');
        if (!event.source) throw new Error('Missing event.source');
        if (!event.actionSubject) throw new Error('Missing event.actionSubject');
        if (!event.action) throw new Error('Missing event.action');
        $26c721e12b3274ca$export$e63ea5d8477971d3(event.containers);
    }
    function $26c721e12b3274ca$export$dc993432a592dc27(name) {
        if (!name) throw new Error('Missing name');
    }
    function $26c721e12b3274ca$export$8c014fd74b0c8b99(event) {
        $26c721e12b3274ca$export$e0c121325c66ed4c(event);
    }
    function $26c721e12b3274ca$export$39d6334da9a44984(event) {
        if (!event) throw new Error('Missing event');
        if (!event.source) throw new Error('Missing event.source');
        if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    }
    function $26c721e12b3274ca$export$e5bac0930c812e90(event) {
        $26c721e12b3274ca$export$e0c121325c66ed4c(event);
    }
    function $26c721e12b3274ca$export$1e561554275607ef(event) {
        $26c721e12b3274ca$export$e0c121325c66ed4c(event);
    }
    function $26c721e12b3274ca$export$c16a4e16aa4026c0(userIdType, userId) {
        if (!userIdType) throw new Error('Missing userIdType');
        if (!userId) throw new Error('Missing userId');
        if (!(0, (0, parcelRequire("bpIMA")).isType)((0, (0, parcelRequire("bpIMA")).userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, (0, parcelRequire("bpIMA")).objectValues)((0, (0, parcelRequire("bpIMA")).userType))}]`);
    }
    function $26c721e12b3274ca$export$801b46c35394d316(productInfo) {
        if (!(0, (0, parcelRequire("bpIMA")).isType)((0, (0, parcelRequire("bpIMA")).platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, (0, parcelRequire("bpIMA")).objectValues)((0, (0, parcelRequire("bpIMA")).platformType))}]`);
        if (productInfo.origin === (0, (0, parcelRequire("bpIMA")).originType).DESKTOP && !(0, (0, parcelRequire("bpIMA")).isType)((0, (0, parcelRequire("bpIMA")).desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
        if (productInfo.origin === (0, (0, parcelRequire("bpIMA")).originType).WEB && !(0, (0, parcelRequire("bpIMA")).isType)((0, (0, parcelRequire("bpIMA")).webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
    }
});
parcelRegister("lzWTs", function(module, exports) {
    $parcel$export(module.exports, "StopLowPriorityEventDelayReason", ()=>$aed06690e6ef85f2$export$fa6e3729c21cb8f);
    var $aed06690e6ef85f2$export$fa6e3729c21cb8f;
    (function(StopLowPriorityEventDelayReason) {
        StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
        StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    })($aed06690e6ef85f2$export$fa6e3729c21cb8f || ($aed06690e6ef85f2$export$fa6e3729c21cb8f = {}));
});
parcelRegister("kjpfP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56202ccd073ac79a$export$2e2bcd8739ae039);
    var $bXrHm = parcelRequire("bXrHm");
    var $dqusS;
    var $khrXz;
    var $t1wQK;
    var $4qhwE;
    var $3g17q;
    var $laGea;
    var $hv0EA;
    var $1lxBC;
    class $56202ccd073ac79a$export$2e2bcd8739ae039 {
        constructor(options){
            this.sendEvents = async (items, callback)=>{
                const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
                const metricsPayload = this.metrics.getMetricsPayload();
                const metadata = {
                    ...metricsPayload,
                    httpRetryCount: httpRetryCount
                };
                for(let key in metadata)if (metadata[key] === 0) delete metadata[key];
                const eventsWithXID = await this.attachXIDs(items);
                const sentAt = new Date().toISOString();
                const unpackagedEvents = eventsWithXID.map((item)=>{
                    item.msg.sentAt = sentAt;
                    return item.msg;
                });
                const batchBody = {
                    batch: unpackagedEvents,
                    sentAt: sentAt,
                    metadata: metadata
                };
                try {
                    const response = await (0, (0, parcelRequire("3g17q")).sendEvents)({
                        url: this.gasv3BatchUrl,
                        batch: batchBody,
                        timeout: this.options.requestTimeout
                    });
                    this.metrics.subtractFromMetrics(metricsPayload);
                    callback(null, response);
                } catch (error) {
                    callback(error, null);
                }
            };
            this.options = {
                ...options,
                requestTimeout: options.requestTimeout || (0, (0, parcelRequire("4qhwE")).DEFAULT_REQUEST_TIMEOUT),
                retryQueueOptions: options.retryQueueOptions || {},
                logger: options.logger || console,
                disableCookiePersistence: options.disableCookiePersistence || false
            };
            this.user = new (0, (0, parcelRequire("hv0EA")).default)(this.options?.disableCookiePersistence);
            this.xidPromiseCallback = options.xidPromiseGetter();
            this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
            this.metrics = (0, (0, parcelRequire("khrXz")).default)();
            this.resilienceQueue = (0, (0, parcelRequire("dqusS")).default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
            this.resilienceQueue.start(this.sendEvents);
        }
        getUser() {
            return this.user;
        }
        async track(eventName, builtEvent, context, callback) {
            const baseEvent = this.buildBaseEvent(context, (0, (0, parcelRequire("laGea")).SegmentEventTypes).TRACK, builtEvent);
            const eventWithoutMessageId = {
                ...baseEvent,
                type: (0, (0, parcelRequire("laGea")).SegmentEventTypes).TRACK,
                properties: (0, (0, parcelRequire("1lxBC")).prepareEventProperties)(builtEvent),
                event: eventName
            };
            const event = {
                ...eventWithoutMessageId,
                messageId: this.createMessageId()
            };
            const packagedEvent = this.packageEvent(event);
            await this.resilienceQueue.addItem(packagedEvent);
            if (callback) callback();
        }
        async page(eventName, builtEvent, context, callback) {
            const baseEvent = this.buildBaseEvent(context, (0, (0, parcelRequire("laGea")).SegmentEventTypes).PAGE, builtEvent);
            const eventWithoutMessageId = {
                ...baseEvent,
                type: (0, (0, parcelRequire("laGea")).SegmentEventTypes).PAGE,
                properties: (0, (0, parcelRequire("1lxBC")).prepareEventProperties)(builtEvent),
                name: eventName
            };
            const event = {
                ...eventWithoutMessageId,
                messageId: this.createMessageId()
            };
            const packagedEvent = this.packageEvent(event);
            await this.resilienceQueue.addItem(packagedEvent);
            if (callback) callback();
        }
        async identify(_identifier, builtEvent, context, callback) {
            const baseEvent = this.buildBaseEvent(context, (0, (0, parcelRequire("laGea")).SegmentEventTypes).IDENTIFY, builtEvent);
            const eventWithoutMessageId = {
                ...baseEvent,
                type: (0, (0, parcelRequire("laGea")).SegmentEventTypes).IDENTIFY,
                traits: (0, (0, parcelRequire("1lxBC")).prepareEventProperties)(builtEvent)
            };
            const event = {
                ...eventWithoutMessageId,
                messageId: this.createMessageId()
            };
            const packagedEvent = this.packageEvent(event);
            await this.resilienceQueue.addItem(packagedEvent);
            if (callback) callback();
        }
        buildBaseEvent(context, type, overrides) {
            const clonedContext = (0, (0, parcelRequire("1lxBC")).prepareEventProperties)(context);
            const segmentContext = (0, (0, parcelRequire("1lxBC")).buildContext)(clonedContext);
            return {
                context: segmentContext,
                timestamp: new Date().toISOString(),
                type: type,
                userId: this.user.getUserId(),
                anonymousId: overrides.anonymousId || this.user.getAnonymousId()
            };
        }
        createMessageId() {
            return `ajs-${(0, ($parcel$interopDefault($bXrHm)))()}`;
        }
        packageEvent(event) {
            const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
            return {
                headers: {
                    'Content-Type': 'text/plain'
                },
                msg: event,
                url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
            };
        }
        async attachXIDs(items) {
            if (this.xidPromiseCallback) return (0, (0, parcelRequire("t1wQK")).attachXidToMultipleEvents)(items, this.xidPromiseCallback);
            return Promise.resolve(items);
        }
    }
});
parcelRegister("dqusS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1d46274717c35b70$export$2e2bcd8739ae039);
    var $2FeoI;
    var $1d46274717c35b70$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
        return new (0, (0, parcelRequire("2FeoI")).default)(retryQueuePrefix, product, options || {}, logger);
    };
});
parcelRegister("2FeoI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32fdb4508a83a2ba$export$2e2bcd8739ae039);
    var $98PhW;
    var $3BOar;
    var $beO5C;
    var $jbPN9;
    var $7FNEu;
    var $khrXz;
    var $HgOyT;
    var $8Kw4t;
    var $hRp5m;
    var $6Xkkj;
    const $32fdb4508a83a2ba$var$ONE_MINUTE = 60000;
    const $32fdb4508a83a2ba$var$LONG_POLLING_OPTIONS = {
        backoffFactor: 0,
        backoffJitterPercentage: 0,
        flushWaitMs: $32fdb4508a83a2ba$var$ONE_MINUTE,
        minRetryDelay: $32fdb4508a83a2ba$var$ONE_MINUTE,
        maxRetryDelay: $32fdb4508a83a2ba$var$ONE_MINUTE
    };
    const $32fdb4508a83a2ba$export$d219df4fe04c04a7 = {
        backoffFactor: 2,
        backoffJitterPercentage: 0.2,
        batchFlushSize: 7,
        flushBeforeUnload: false,
        flushWaitMs: 500,
        maxAttempts: 10,
        maxItems: 1000,
        maxRetryDelay: 30000,
        minRetryDelay: 1000
    };
    class $32fdb4508a83a2ba$export$2e2bcd8739ae039 {
        constructor(queuePrefix, product, options, logger){
            this.queuePrefix = queuePrefix;
            this.resilience = new (0, (0, parcelRequire("jbPN9")).default)(product, {
                logger: logger,
                maxAttempts: options?.maxAttempts,
                maxEventLimit: options?.maxItems
            });
            this.options = this.buildOptions(options);
            this.scheduler = new (0, (0, parcelRequire("8Kw4t")).default)({
                ...this.options,
                waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
            }, this.scheduleCallback.bind(this));
            this.longPollingScheduler = new (0, (0, parcelRequire("8Kw4t")).default)({
                ...$32fdb4508a83a2ba$var$LONG_POLLING_OPTIONS,
                waitInterval: $32fdb4508a83a2ba$var$LONG_POLLING_OPTIONS.flushWaitMs
            }, this.scheduleLongCallBack.bind(this));
            this.metricsCollector = (0, (0, parcelRequire("khrXz")).default)();
            this.networkStatus = new (0, (0, parcelRequire("HgOyT")).default)((status)=>{
                if (status === (0, (0, parcelRequire("6Xkkj")).NetworkStatusEnum).OFFLINE) this.scheduler.stop();
                else this.checkEventCountAndReschedule();
            });
        }
        start(flushCallback) {
            this.batchFlushCallback = flushCallback;
            this.longPollingScheduler.schedule();
        }
        stop() {
            this.scheduler.stop();
            this.longPollingScheduler.stop();
        }
        async addItem(item) {
            const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
            const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, (0, parcelRequire("7FNEu")).GuardPolicy).EVICT);
            this.scheduler.schedule();
            this.metricsCollector.addToEventCount();
            if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
        }
        getGlobalRetryCount() {
            return this.scheduler.getFailureCount();
        }
        async scheduleCallback(done) {
            if (this.networkStatus.getNetworkStatus() === (0, (0, parcelRequire("6Xkkj")).NetworkStatusEnum).OFFLINE) {
                done((0, (0, parcelRequire("hRp5m")).DoneState).NOOP);
                return;
            }
            try {
                const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
                done(result);
            } catch (error) {
                if (error.name === (0, (0, parcelRequire("beO5C")).CallbackProcessingErrorName)) {
                    done((0, (0, parcelRequire("hRp5m")).DoneState).ERROR);
                    return;
                }
            } finally{
                await this.checkEventCountAndReschedule();
            }
        }
        async checkEventCountAndReschedule() {
            const eventWaitingCount = await this.resilience.getItemCount();
            if (eventWaitingCount > 0) this.scheduler.schedule({
                immediate: eventWaitingCount >= this.options.batchFlushSize
            });
        }
        async scheduleLongCallBack(done) {
            const numberOfQueuesPurged = (0, (0, parcelRequire("98PhW")).default)(this.queuePrefix);
            this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
            const reclaimMetrics = await (0, (0, parcelRequire("3BOar")).default)(this.queuePrefix, async (localStorageItems)=>{
                const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                        item: localStorageItem.item,
                        retryAttempts: localStorageItem.attemptNumber,
                        id: localStorageItem.id
                    }));
                const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, (0, parcelRequire("7FNEu")).GuardPolicy).IGNORE);
                if (addedEvents.length === itemsToAdd.length) return {
                    status: 'successful'
                };
                else return {
                    status: 'partial',
                    acceptedItemIds: addedEvents.map((event)=>event.id)
                };
            });
            this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
            await this.checkEventCountAndReschedule();
            done((0, (0, parcelRequire("hRp5m")).DoneState).SUCCESS);
            this.longPollingScheduler.schedule();
        }
        flush(wrappedItems, otherMetadata) {
            this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
            const { batchFlushCallback: batchFlushCallback } = this;
            if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
            return new Promise((resolve, reject)=>{
                if (wrappedItems.length <= 0) {
                    resolve((0, (0, parcelRequire("hRp5m")).DoneState).NOOP);
                    return;
                }
                const items = wrappedItems.map((wrappedItem)=>{
                    const item = wrappedItem.item;
                    if (wrappedItem.retryAttempts > 0 && item.msg) {
                        if (!item.msg._metadata) item.msg._metadata = {};
                        item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                    }
                    return item;
                });
                batchFlushCallback(items, (error)=>{
                    if (error) {
                        if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                        reject(error);
                    } else resolve((0, (0, parcelRequire("hRp5m")).DoneState).SUCCESS);
                });
            });
        }
        buildOptions(options) {
            return {
                backoffFactor: options?.backoffFactor || $32fdb4508a83a2ba$export$d219df4fe04c04a7.backoffFactor,
                backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $32fdb4508a83a2ba$export$d219df4fe04c04a7.backoffJitterPercentage,
                batchFlushSize: options?.batchFlushSize || $32fdb4508a83a2ba$export$d219df4fe04c04a7.batchFlushSize,
                flushBeforeUnload: options?.flushBeforeUnload || $32fdb4508a83a2ba$export$d219df4fe04c04a7.flushBeforeUnload,
                flushWaitMs: options?.flushWaitMs || $32fdb4508a83a2ba$export$d219df4fe04c04a7.flushWaitMs,
                maxItems: options?.maxItems || $32fdb4508a83a2ba$export$d219df4fe04c04a7.maxItems,
                maxAttempts: options?.maxAttempts || $32fdb4508a83a2ba$export$d219df4fe04c04a7.maxAttempts,
                maxRetryDelay: options?.maxRetryDelay || $32fdb4508a83a2ba$export$d219df4fe04c04a7.maxRetryDelay,
                minRetryDelay: options?.minRetryDelay || $32fdb4508a83a2ba$export$d219df4fe04c04a7.minRetryDelay
            };
        }
    }
});
parcelRegister("98PhW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb0b4c6e292b46a5$export$2e2bcd8739ae039);
    var $cg80p;
    var $izgmw;
    const $bb0b4c6e292b46a5$var$validSuffixs = Object.values((0, (0, parcelRequire("cg80p")).LocalStorageKeySuffix));
    var $bb0b4c6e292b46a5$export$2e2bcd8739ae039 = (prefix)=>{
        if (typeof prefix !== 'string' || prefix.length === 0) return 0;
        try {
            const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $bb0b4c6e292b46a5$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
                const [, id, suffix] = currentKeys;
                if (accumulator[id] === undefined) accumulator[id] = {};
                accumulator[id][suffix] = true;
                return accumulator;
            }, {});
            const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, (0, parcelRequire("cg80p")).LocalStorageKeySuffix).ACK] !== true);
            queuesToPurge.forEach((id)=>{
                const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, (0, parcelRequire("izgmw")).createLocalStorageKeys)(prefix, id);
                localStorage.removeItem(inProgress);
                localStorage.removeItem(queue);
                localStorage.removeItem(reclaimStart);
                localStorage.removeItem(reclaimEnd);
            });
            return queuesToPurge.length;
        } catch (_error) {}
        return 0;
    };
});
parcelRegister("cg80p", function(module, exports) {
    $parcel$export(module.exports, "LocalStorageKeySuffix", ()=>$9358dbe55b50a442$export$ecfa71cbc9b28241);
    $parcel$export(module.exports, "Timers", ()=>$9358dbe55b50a442$export$8bb2c1fb2b1765a9);
    var $9358dbe55b50a442$export$ecfa71cbc9b28241;
    (function(LocalStorageKeySuffix) {
        LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
        LocalStorageKeySuffix["QUEUE"] = "queue";
        LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
        LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
        LocalStorageKeySuffix["ACK"] = "ack";
    })($9358dbe55b50a442$export$ecfa71cbc9b28241 || ($9358dbe55b50a442$export$ecfa71cbc9b28241 = {}));
    var $9358dbe55b50a442$export$8bb2c1fb2b1765a9;
    (function(Timers) {
        Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
        Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
        Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    })($9358dbe55b50a442$export$8bb2c1fb2b1765a9 || ($9358dbe55b50a442$export$8bb2c1fb2b1765a9 = {}));
});
parcelRegister("izgmw", function(module, exports) {
    $parcel$export(module.exports, "createLocalStorageKeys", ()=>$fc20957a3e5c4087$export$8433d54f767cbec5);
    var $cg80p;
    const $fc20957a3e5c4087$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
            [(0, (0, parcelRequire("cg80p")).LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, (0, parcelRequire("cg80p")).LocalStorageKeySuffix).ACK}`,
            [(0, (0, parcelRequire("cg80p")).LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, (0, parcelRequire("cg80p")).LocalStorageKeySuffix).QUEUE}`,
            [(0, (0, parcelRequire("cg80p")).LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, (0, parcelRequire("cg80p")).LocalStorageKeySuffix).IN_PROGRESS}`,
            [(0, (0, parcelRequire("cg80p")).LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, (0, parcelRequire("cg80p")).LocalStorageKeySuffix).RECLAIM_START}`,
            [(0, (0, parcelRequire("cg80p")).LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, (0, parcelRequire("cg80p")).LocalStorageKeySuffix).RECLAIM_END}`
        });
});
parcelRegister("3BOar", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7c2eb593c177ebc$export$2e2bcd8739ae039);
    var $bXrHm = parcelRequire("bXrHm");
    var $cg80p;
    var $izgmw;
    const $e7c2eb593c177ebc$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
            setTimeout(resolve, msToWait);
        });
    const $e7c2eb593c177ebc$var$findOtherQueues = (queuePrefix)=>{
        try {
            return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
                if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, (0, parcelRequire("cg80p")).LocalStorageKeySuffix).ACK) try {
                    const ackTimestamp = localStorage.getItem(split.join('.'));
                    if (ackTimestamp) {
                        const ackTimestampNumber = parseInt(ackTimestamp);
                        return (0, (0, parcelRequire("cg80p")).Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                    }
                } catch (error) {}
                return false;
            }).map((split)=>split[1]);
        } catch (_error) {}
        return [];
    };
    const $e7c2eb593c177ebc$var$tryReclaim = async (options, callback)=>{
        const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
        const start = Date.now();
        localStorage.setItem(reclaimStart, options.reclaimProcessId);
        localStorage.setItem(ack, start.toString());
        await $e7c2eb593c177ebc$var$promisedSetTimeout((0, (0, parcelRequire("cg80p")).Timers).RECLAIM_WAIT);
        if (Date.now() > start + (0, (0, parcelRequire("cg80p")).Timers).RECLAIM_WAIT_THRESHOLD || localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
        localStorage.setItem(reclaimEnd, options.reclaimProcessId);
        await $e7c2eb593c177ebc$var$promisedSetTimeout((0, (0, parcelRequire("cg80p")).Timers).RECLAIM_WAIT);
        if (Date.now() > start + (0, (0, parcelRequire("cg80p")).Timers).RECLAIM_WAIT_THRESHOLD || localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
        return $e7c2eb593c177ebc$var$reclaim(options, callback);
    };
    const $e7c2eb593c177ebc$var$reclaim = async (options, callback)=>{
        const { queue: queue, inProgress: inProgress } = options.storageKeys;
        const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
        const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
        const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
            const itemWithId = {
                ...item,
                attemptNumber: item.attemptNumber + 1,
                id: key
            };
            return itemWithId;
        });
        const eventsToProcess = [
            ...eventsInQueue,
            ...arrayOfEventsInProgress
        ];
        if (eventsToProcess.length > 0) {
            const result = await callback(eventsToProcess);
            if (result.status === 'successful') $e7c2eb593c177ebc$var$clearLocalStorageKeys(options.storageKeys);
            else if (result.status === 'partial') {
                const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
                localStorage.removeItem(inProgress);
                localStorage.setItem(queue, JSON.stringify(leftover));
                return {
                    fullReclaim: false
                };
            }
        } else $e7c2eb593c177ebc$var$clearLocalStorageKeys(options.storageKeys);
        return {
            fullReclaim: true
        };
    };
    const $e7c2eb593c177ebc$var$clearLocalStorageKeys = (keys)=>{
        localStorage.removeItem(keys.queue);
        localStorage.removeItem(keys.inProgress);
        localStorage.removeItem(keys.reclaimEnd);
        localStorage.removeItem(keys.reclaimStart);
        localStorage.removeItem(keys.ack);
    };
    var $e7c2eb593c177ebc$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
        if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) return {
            fullReclaims: 0,
            partialReclaims: 0,
            failedReclaims: 0
        };
        const reclaimProcessId = (0, ($parcel$interopDefault($bXrHm)))();
        const queuesToReclaim = $e7c2eb593c177ebc$var$findOtherQueues(queuePrefix);
        const claims = queuesToReclaim.map((id)=>$e7c2eb593c177ebc$var$tryReclaim({
                queuePrefix: queuePrefix,
                reclaimProcessId: reclaimProcessId,
                storageKeys: (0, (0, parcelRequire("izgmw")).createLocalStorageKeys)(queuePrefix, id)
            }, callback));
        const settledClaims = await Promise.allSettled(claims);
        const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
        const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
        const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
        const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
        return {
            failedReclaims: failedReclaims.length,
            partialReclaims: partialReclaims.length,
            fullReclaims: fullReclaims.length
        };
    };
});
parcelRegister("beO5C", function(module, exports) {
    $parcel$export(module.exports, "CallbackProcessingErrorName", ()=>$6cf5321a3cb481af$export$a409c8de90e11e14);
    $parcel$export(module.exports, "default", ()=>$6cf5321a3cb481af$export$2e2bcd8739ae039);
    const $6cf5321a3cb481af$export$a409c8de90e11e14 = 'CallbackProcessingError';
    class $6cf5321a3cb481af$export$2e2bcd8739ae039 extends Error {
        constructor(error){
            const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
            const messageFromString = typeof error === 'string' && error;
            const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
            super(`Error thrown while processing events in callback: ${message}`);
            Object.setPrototypeOf(this, $6cf5321a3cb481af$export$2e2bcd8739ae039.prototype);
            this.name = $6cf5321a3cb481af$export$a409c8de90e11e14;
        }
    }
});
parcelRegister("jbPN9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d281296ab2b6cd8$export$2e2bcd8739ae039);
    var $3NnrI;
    var $7FNEu;
    var $beO5C;
    var $7d281296ab2b6cd8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3NnrI")).default);
});
parcelRegister("3NnrI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1fb27e17d7078ef$export$2e2bcd8739ae039);
    var $7FNEu;
    var $4yASA;
    var $8qeDu;
    var $8VTHs;
    var $9oMZy;
    var $Owykq;
    class $e1fb27e17d7078ef$export$2e2bcd8739ae039 {
        constructor(namespace, options = {}){
            this.namespace = namespace;
            this.options = (0, (0, parcelRequire("Owykq")).createOptionsWithDefaults)(options);
            if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
            this.resilience = this.getResilienceMechanism(namespace, options);
        }
        getResilienceMechanism(namespace, options) {
            if (!options.useMemory) try {
                return new (0, (0, parcelRequire("8VTHs")).default)(namespace, options);
            } catch (error) {
                if (!(error instanceof (0, (0, parcelRequire("4yASA")).default))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
            return new (0, (0, parcelRequire("9oMZy")).default)(this.namespace, options);
        }
        addItem(item, options, policy = (0, (0, parcelRequire("7FNEu")).GuardPolicy).ABANDON) {
            return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
        }
        bulkAddItem(itemOptions, policy = (0, (0, parcelRequire("7FNEu")).GuardPolicy).ABANDON) {
            return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
        }
        getItems(count) {
            return this.runOrFailOver(()=>this.resilience.getItems(count));
        }
        deleteItems(itemIds) {
            return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
        }
        getItemCount() {
            return this.runOrFailOver(()=>this.resilience.getItemCount());
        }
        processItems(processFn, count) {
            return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
        }
        storeType() {
            return this.resilience.storeType();
        }
        async runOrFailOver(runnable) {
            try {
                return await runnable();
            } catch (error) {
                if ((0, (0, parcelRequire("8qeDu")).shouldIgnoreResilienceDbError)(error)) throw error;
                else if (this.resilience.storeType() === (0, (0, parcelRequire("7FNEu")).StoreType).INDEXEDDB) await this.failOver();
                return runnable();
            }
        }
        async failOver() {
            const oldResilience = this.resilience;
            const newResilience = new (0, (0, parcelRequire("9oMZy")).default)(this.namespace, this.options);
            this.resilience = newResilience;
            try {
                const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
                if (items.length > 0) {
                    const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, (0, parcelRequire("7FNEu")).GuardPolicy).IGNORE);
                    const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                    await oldResilience.deleteItems(addedItemIds);
                }
            } catch (error) {
                this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
            }
        }
    }
});
parcelRegister("7FNEu", function(module, exports) {
    $parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", ()=>$d3392066da267861$export$d21fbb25eb37b5bf);
    $parcel$export(module.exports, "RESILIENCE_DB_NAME", ()=>$d3392066da267861$export$8cad224051643259);
    $parcel$export(module.exports, "RESILIENCE_STORE_NAME", ()=>$d3392066da267861$export$3d8420be07b276ab);
    $parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", ()=>$d3392066da267861$export$a512a65455fce2a6);
    $parcel$export(module.exports, "TIME_ADDED_INDEX", ()=>$d3392066da267861$export$89d9c1ff8ac91862);
    $parcel$export(module.exports, "RETRY_INDEX", ()=>$d3392066da267861$export$a37d385bcd713809);
    $parcel$export(module.exports, "INDEXEDDB_TIMEOUT", ()=>$d3392066da267861$export$6d8635fed0e4b14d);
    $parcel$export(module.exports, "StoreType", ()=>$d3392066da267861$export$39337ab5872e9457);
    $parcel$export(module.exports, "GuardPolicy", ()=>$d3392066da267861$export$7710d69e6f450f20);
    const $d3392066da267861$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
    const $d3392066da267861$export$8cad224051643259 = 'analytics-web-client';
    const $d3392066da267861$export$3d8420be07b276ab = 'analytics-resilience';
    const $d3392066da267861$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
    const $d3392066da267861$export$89d9c1ff8ac91862 = 'timeAdded';
    const $d3392066da267861$export$a37d385bcd713809 = 'retryAttempts';
    const $d3392066da267861$export$6d8635fed0e4b14d = 15000;
    var $d3392066da267861$export$39337ab5872e9457;
    (function(StoreType) {
        StoreType["INDEXEDDB"] = "indexeddb";
        StoreType["MEMORY"] = "memory";
    })($d3392066da267861$export$39337ab5872e9457 || ($d3392066da267861$export$39337ab5872e9457 = {}));
    var $d3392066da267861$export$7710d69e6f450f20;
    (function(GuardPolicy) {
        GuardPolicy["IGNORE"] = "ignore";
        GuardPolicy["ABANDON"] = "abandon";
        GuardPolicy["EVICT"] = "evict";
    })($d3392066da267861$export$7710d69e6f450f20 || ($d3392066da267861$export$7710d69e6f450f20 = {}));
});
parcelRegister("4yASA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b84c328e1efc90ad$export$2e2bcd8739ae039);
    const $b84c328e1efc90ad$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
    class $b84c328e1efc90ad$export$2e2bcd8739ae039 extends Error {
        constructor(){
            super('window.indexeddb is undefined.');
            Object.setPrototypeOf(this, $b84c328e1efc90ad$export$2e2bcd8739ae039.prototype);
            this.name = $b84c328e1efc90ad$export$fc14cf6dcea0f8ed;
        }
    }
});
parcelRegister("8qeDu", function(module, exports) {
    $parcel$export(module.exports, "shouldIgnoreResilienceDbError", ()=>$da0743621a80dd75$export$74101021e0969375);
    var $5QWWB;
    var $beO5C;
    var $4uxxC;
    const $da0743621a80dd75$export$74101021e0969375 = (error)=>{
        if (error && typeof error === 'object' && 'name' in error) {
            const errorWithName = error;
            return typeof errorWithName.name === 'string' && (errorWithName.name === (0, (0, parcelRequire("5QWWB")).AbandonWriteErrorName) || errorWithName.name === (0, (0, parcelRequire("beO5C")).CallbackProcessingErrorName) || errorWithName.name === (0, (0, parcelRequire("4uxxC")).InvalidPolicyErrorName));
        }
        return false;
    };
});
parcelRegister("5QWWB", function(module, exports) {
    $parcel$export(module.exports, "AbandonWriteErrorName", ()=>$948064ae43bb6495$export$ba95206613c96b28);
    $parcel$export(module.exports, "default", ()=>$948064ae43bb6495$export$2e2bcd8739ae039);
    const $948064ae43bb6495$export$ba95206613c96b28 = 'AbandonWriteError';
    class $948064ae43bb6495$export$2e2bcd8739ae039 extends Error {
        constructor(source){
            super(`Event Limit reached. Abandoning write to: ${source}`);
            Object.setPrototypeOf(this, $948064ae43bb6495$export$2e2bcd8739ae039.prototype);
            this.name = $948064ae43bb6495$export$ba95206613c96b28;
        }
    }
});
parcelRegister("4uxxC", function(module, exports) {
    $parcel$export(module.exports, "InvalidPolicyErrorName", ()=>$4ae8708b11d4dfcd$export$7e7aee9a953465ec);
    $parcel$export(module.exports, "default", ()=>$4ae8708b11d4dfcd$export$2e2bcd8739ae039);
    const $4ae8708b11d4dfcd$export$7e7aee9a953465ec = 'InvalidPolicyError';
    class $4ae8708b11d4dfcd$export$2e2bcd8739ae039 extends Error {
        constructor(policy, method){
            super(`Method '${method}' cannot be called with policy '${policy}'.`);
            this.name = $4ae8708b11d4dfcd$export$7e7aee9a953465ec;
        }
    }
});
parcelRegister("8VTHs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$513f3047f2c2fc19$export$2e2bcd8739ae039);
    var $7FNEu;
    var $i2WnZ;
    var $beO5C;
    var $4uxxC;
    var $4yASA;
    var $8qeDu;
    var $jNQDS;
    var $Owykq;
    class $513f3047f2c2fc19$export$2e2bcd8739ae039 {
        constructor(namespace, options = {}){
            this.startDB = async ()=>{
                return new Promise(async (resolve, reject)=>{
                    if (typeof window !== 'undefined') {
                        const dbTimeout = window.setTimeout(()=>{
                            this.logger.warn('IndexedDB timed out.');
                            reject(new (0, (0, parcelRequire("4yASA")).default)());
                        }, (0, (0, parcelRequire("7FNEu")).INDEXEDDB_TIMEOUT));
                        const request = window.indexedDB.open((0, (0, parcelRequire("7FNEu")).RESILIENCE_DB_NAME), 1);
                        request.onupgradeneeded = (event)=>{
                            if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                            const db = request.result;
                            const store = db.createObjectStore((0, (0, parcelRequire("7FNEu")).RESILIENCE_STORE_NAME), {
                                keyPath: 'id'
                            });
                            store.createIndex((0, (0, parcelRequire("7FNEu")).TIME_TO_PROCESS_AFTER_INDEX), (0, (0, parcelRequire("7FNEu")).TIME_TO_PROCESS_AFTER_INDEX), {
                                unique: false
                            });
                            store.createIndex((0, (0, parcelRequire("7FNEu")).RETRY_INDEX), (0, (0, parcelRequire("7FNEu")).RETRY_INDEX), {
                                unique: false
                            });
                            store.createIndex((0, (0, parcelRequire("7FNEu")).TIME_ADDED_INDEX), (0, (0, parcelRequire("7FNEu")).TIME_ADDED_INDEX), {
                                unique: false
                            });
                            store.createIndex((0, (0, parcelRequire("7FNEu")).NAMESPACE_AND_TIME_ADDED_INDEX), [
                                'namespace',
                                'timeAdded'
                            ], {
                                unique: false
                            });
                        };
                        request.onerror = function() {
                            reject(new (0, (0, parcelRequire("4yASA")).default)());
                        };
                        try {
                            await (0, (0, parcelRequire("Owykq")).requestToPromise)(request);
                            return resolve(request.result);
                        } catch (error) {
                            this.logger.warn('IndexedDB failed to initialise.', error);
                            reject(new (0, (0, parcelRequire("4yASA")).default)());
                        } finally{
                            window.clearTimeout(dbTimeout);
                        }
                    } else {
                        this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                        reject(new (0, (0, parcelRequire("4yASA")).default)());
                    }
                });
            };
            this.addItem = async (item, options = {}, policy = (0, (0, parcelRequire("7FNEu")).GuardPolicy).ABANDON)=>{
                const { logger: logger, namespace: namespace } = this;
                const value = (0, (0, parcelRequire("Owykq")).convertToItemWrapper)(item, namespace, options);
                const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
                if (policy === (0, (0, parcelRequire("7FNEu")).GuardPolicy).IGNORE) throw new (0, (0, parcelRequire("4uxxC")).default)(policy, 'IndexedDbConnector#addItem');
                try {
                    if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                    const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                        value
                    ], policy);
                    if (bulkAddResult.items.length === 1) return {
                        item: bulkAddResult.items[0],
                        numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                    };
                    throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
                } catch (error) {
                    if ((0, (0, parcelRequire("8qeDu")).shouldIgnoreResilienceDbError)(error)) throw error;
                    logger.log('Failed to add item to table', error);
                    throw new Error('Request to add item to table failed');
                }
            };
            this.bulkAddItem = async (itemOptions, policy = (0, (0, parcelRequire("7FNEu")).GuardPolicy).ABANDON)=>{
                const { logger: logger, namespace: namespace } = this;
                const items = itemOptions.map(({ item: item, ...options })=>(0, (0, parcelRequire("Owykq")).convertToItemWrapper)(item, namespace, options));
                const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
                try {
                    return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
                } catch (error) {
                    if ((0, (0, parcelRequire("8qeDu")).shouldIgnoreResilienceDbError)(error)) throw error;
                    logger.log('Failed to add item to table', error);
                    throw new Error('Request to add item to table failed');
                }
            };
            this.getItems = async (count = (0, (0, parcelRequire("i2WnZ")).GET_ITEM_COUNT))=>{
                const fixedCount = count > 0 ? count : (0, (0, parcelRequire("i2WnZ")).GET_ITEM_COUNT);
                const { logger: logger } = this;
                const maxAttempts = this.options.maxAttempts;
                const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
                const timeIndex = objectStore.index((0, (0, parcelRequire("7FNEu")).TIME_TO_PROCESS_AFTER_INDEX));
                const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
                const request = timeIndex.openCursor(upperBoundOpenKeyRange);
                const getResult = await new Promise(async (resolve, reject)=>{
                    const items = [];
                    let numberOfDeletedItems = 0;
                    request.onerror = (error)=>{
                        logger.error('Failed to open cursor:', error);
                        reject('Failed to open cursor');
                    };
                    request.onsuccess = (event)=>{
                        const cursor = event.target.result;
                        if (cursor) {
                            const value = {
                                ...cursor.value
                            };
                            items.push(value);
                            const updatedValue = cursor.value;
                            updatedValue.retryAttempts += 1;
                            updatedValue.timeToBeProcessedAfter = Date.now() + (0, (0, parcelRequire("i2WnZ")).VISIBILITY_TIMEOUT);
                            if (updatedValue.retryAttempts >= maxAttempts) {
                                ++numberOfDeletedItems;
                                const request = cursor.delete();
                                (0, (0, parcelRequire("Owykq")).monitorErrorsOnRequest)(request, logger);
                            } else {
                                const request = cursor.update(updatedValue);
                                (0, (0, parcelRequire("Owykq")).monitorErrorsOnRequest)(request, logger);
                            }
                            if (items.length < fixedCount) cursor.continue();
                            else resolve({
                                items: items,
                                numberOfDeletedItems: numberOfDeletedItems
                            });
                        } else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    };
                });
                await (0, (0, parcelRequire("Owykq")).commitTransaction)(transaction, this.logger);
                return getResult;
            };
            this.deleteItems = async (itemIds)=>{
                const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
                try {
                    const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                    await (0, (0, parcelRequire("Owykq")).commitTransaction)(transaction, this.logger);
                    await Promise.all(deletePromises);
                } catch (error) {
                    this.logger.warn('Failed to delete items from indexeddb.', error);
                    throw error;
                }
            };
            this.getItemCount = async ()=>{
                const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
                const timeIndex = objectStore.index((0, (0, parcelRequire("7FNEu")).TIME_TO_PROCESS_AFTER_INDEX));
                const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
                const request = timeIndex.count(upperBoundOpenKeyRange);
                const event = await (0, (0, parcelRequire("Owykq")).requestToPromise)(request);
                await (0, (0, parcelRequire("Owykq")).commitTransaction)(transaction, this.logger);
                return event.target.result;
            };
            this.processItems = async (processFn, count = (0, (0, parcelRequire("i2WnZ")).GET_ITEM_COUNT))=>{
                const { items: items, ...partialResult } = await this.getItems(count);
                try {
                    const result = await processFn(items, partialResult);
                    const itemIds = items.map((item)=>item.id);
                    await this.deleteItems(itemIds);
                    return result;
                } catch (error) {
                    throw new (0, (0, parcelRequire("beO5C")).default)(error);
                }
            };
            this.deleteItem = async (objectStore, id)=>{
                const { logger: logger } = this;
                try {
                    await (0, (0, parcelRequire("Owykq")).requestToPromise)(objectStore.delete(id));
                } catch (error) {
                    logger.error('Failed to delete item:', id, error);
                    throw error;
                }
            };
            this.getObjectStoreAndTransaction = async (mode)=>{
                const transaction = (await this.db).transaction((0, (0, parcelRequire("7FNEu")).RESILIENCE_STORE_NAME), mode);
                const objectStore = transaction.objectStore((0, (0, parcelRequire("7FNEu")).RESILIENCE_STORE_NAME));
                return {
                    transaction: transaction,
                    objectStore: objectStore
                };
            };
            this.options = (0, (0, parcelRequire("Owykq")).createOptionsWithDefaults)(options);
            this.namespace = namespace;
            this.logger = this.options.logger;
            if (!window.indexedDB) throw new (0, (0, parcelRequire("4yASA")).default)();
            this.db = this.startDB();
            this.db.catch(()=>{});
            this.globalEventLimitGuard = new (0, (0, parcelRequire("jNQDS")).default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
        }
        storeType() {
            return (0, (0, parcelRequire("7FNEu")).StoreType).INDEXEDDB;
        }
    }
});
parcelRegister("i2WnZ", function(module, exports) {
    $parcel$export(module.exports, "GET_ITEM_COUNT", ()=>$09bd1eed79b6b201$export$b6df3d334cec060f);
    $parcel$export(module.exports, "VISIBILITY_TIMEOUT", ()=>$09bd1eed79b6b201$export$14ef152a03a4b6ee);
    $parcel$export(module.exports, "MAX_ATTEMPTS", ()=>$09bd1eed79b6b201$export$da9ab7b2fd5998e8);
    $parcel$export(module.exports, "EVENT_COUNT_LIMIT", ()=>$09bd1eed79b6b201$export$1188664dfff364c8);
    const $09bd1eed79b6b201$export$b6df3d334cec060f = 7;
    const $09bd1eed79b6b201$export$14ef152a03a4b6ee = 60000;
    const $09bd1eed79b6b201$export$da9ab7b2fd5998e8 = 10;
    const $09bd1eed79b6b201$export$1188664dfff364c8 = 5000;
});
parcelRegister("jNQDS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2007c04ff1dfdd50$export$2e2bcd8739ae039);
    var $7FNEu;
    var $5QWWB;
    var $Owykq;
    class $2007c04ff1dfdd50$export$2e2bcd8739ae039 {
        constructor(eventLimit, namespace, logger, deleteItemHandler){
            this.deleteOldestNEvents = async (objectStore, count)=>{
                const productTimeAddedIndex = objectStore.index((0, (0, parcelRequire("7FNEu")).NAMESPACE_AND_TIME_ADDED_INDEX));
                const keyRangeValues = IDBKeyRange.bound([
                    this.namespace,
                    0
                ], [
                    this.namespace,
                    Date.now()
                ]);
                const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
                const event = await (0, (0, parcelRequire("Owykq")).requestToPromise)(getAllRequest);
                const result = event?.target?.result;
                if (result && Array.isArray(result) && result.length > 0) try {
                    const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                    await Promise.all(deletePromises);
                } catch (error) {
                    this.logger.warn('Failed to delete items from indexeddb.', error);
                    throw error;
                }
            };
            if (eventLimit > 0) this.eventLimit = eventLimit;
            else throw Error('Event Limit has to be set higher than 1');
            this.namespace = namespace;
            this.logger = logger;
            this.deleteItemHandler = deleteItemHandler;
        }
        async insertItems(objectStore, items, policy = (0, (0, parcelRequire("7FNEu")).GuardPolicy).ABANDON) {
            const itemsToAdd = [
                ...items
            ];
            let numberOfEvictedItems = 0;
            switch(policy){
                case (0, (0, parcelRequire("7FNEu")).GuardPolicy).ABANDON:
                    await this.throwIfNotEnoughSpace(objectStore, items.length);
                    break;
                case (0, (0, parcelRequire("7FNEu")).GuardPolicy).EVICT:
                    numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                    break;
                case (0, (0, parcelRequire("7FNEu")).GuardPolicy).IGNORE:
                    await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                    break;
            }
            const promises = itemsToAdd.map((item)=>(0, (0, parcelRequire("Owykq")).requestToPromise)(objectStore.add(item)));
            await Promise.all(promises);
            await (0, (0, parcelRequire("Owykq")).commitTransaction)(objectStore.transaction, this.logger);
            return {
                items: itemsToAdd,
                numberOfEvictedItems: numberOfEvictedItems
            };
        }
        async throwIfNotEnoughSpace(objectStore, requiredSpace) {
            const freeSpace = await this.calculateFreeSpace(objectStore);
            if (freeSpace < requiredSpace) throw new (0, (0, parcelRequire("5QWWB")).default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
        }
        async evictIfNotEnoughSpace(objectStore, requiredSpace) {
            const freeSpace = await this.calculateFreeSpace(objectStore);
            if (freeSpace < requiredSpace) {
                const extraSpace = requiredSpace - freeSpace;
                await this.deleteOldestNEvents(objectStore, extraSpace);
                return extraSpace;
            }
            return 0;
        }
        async calculateHowManyEventsWeCanAdd(objectStore, items) {
            const freeSpace = await this.calculateFreeSpace(objectStore);
            if (freeSpace < items.length) {
                const numberOfItemsToRemove = items.length - freeSpace;
                const start = items.length - numberOfItemsToRemove;
                items.splice(start, numberOfItemsToRemove);
            }
        }
        async calculateFreeSpace(objectStore) {
            const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
            return this.eventLimit - numberOfEventsInDb;
        }
        async getCountofEventsInObjectStore(objectStore) {
            const productTimeAddedIndex = objectStore.index((0, (0, parcelRequire("7FNEu")).NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const request = productTimeAddedIndex.count(keyRangeValues);
            const event = await (0, (0, parcelRequire("Owykq")).requestToPromise)(request);
            return event.target.result;
        }
    }
});
parcelRegister("Owykq", function(module, exports) {
    $parcel$export(module.exports, "convertToItemWrapper", ()=>$be9e573ff7ca18b4$export$aec476f33d77be11);
    $parcel$export(module.exports, "createOptionsWithDefaults", ()=>$be9e573ff7ca18b4$export$ddc6718318090f71);
    $parcel$export(module.exports, "requestToPromise", ()=>$be9e573ff7ca18b4$export$85ceed0783e42041);
    $parcel$export(module.exports, "commitTransaction", ()=>$be9e573ff7ca18b4$export$feab8418f018df89);
    $parcel$export(module.exports, "monitorErrorsOnRequest", ()=>$be9e573ff7ca18b4$export$342d941b6f724995);
    var $bXrHm = parcelRequire("bXrHm");
    var $i2WnZ;
    const $be9e573ff7ca18b4$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
            item: item,
            id: id || (0, ($parcel$interopDefault($bXrHm)))(),
            retryAttempts: retryAttempts || 0,
            timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
            namespace: namespace,
            timeAdded: Date.now()
        });
    const $be9e573ff7ca18b4$export$ddc6718318090f71 = (options)=>({
            logger: options.logger || console,
            useMemory: options.useMemory || false,
            maxAttempts: options.maxAttempts || (0, (0, parcelRequire("i2WnZ")).MAX_ATTEMPTS),
            maxEventLimit: options.maxEventLimit || (0, (0, parcelRequire("i2WnZ")).EVENT_COUNT_LIMIT)
        });
    const $be9e573ff7ca18b4$export$85ceed0783e42041 = (request)=>{
        return new Promise((resolve, reject)=>{
            request.onsuccess = (event)=>{
                resolve(event);
            };
            request.onerror = (event)=>{
                reject(event);
            };
        });
    };
    const $be9e573ff7ca18b4$export$2a5213bce1720b42 = (transaction)=>{
        return new Promise((resolve, reject)=>{
            transaction.oncomplete = ()=>{
                resolve();
            };
            transaction.onerror = (event)=>{
                reject(event);
            };
            transaction.onabort = (event)=>{
                reject(event);
            };
        });
    };
    const $be9e573ff7ca18b4$export$feab8418f018df89 = (transaction, logger)=>{
        try {
            if (typeof transaction.commit === 'function') transaction.commit();
        } catch (error) {
            logger.error('Failed to force commit transaction:', error);
            throw error;
        }
        return $be9e573ff7ca18b4$export$2a5213bce1720b42(transaction);
    };
    const $be9e573ff7ca18b4$export$342d941b6f724995 = (request, logger)=>{
        request.onerror = (event)=>{
            logger.warn('Error thrown from request:', event);
        };
    };
});
parcelRegister("9oMZy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$231befcb3e8aedb2$export$2e2bcd8739ae039);
    var $7FNEu;
    var $i2WnZ;
    var $beO5C;
    var $4uxxC;
    var $5mvug;
    var $Owykq;
    class $231befcb3e8aedb2$export$2e2bcd8739ae039 {
        constructor(namespace, options = {}){
            this.namespace = namespace;
            this.memoryStore = [];
            this.options = (0, (0, parcelRequire("Owykq")).createOptionsWithDefaults)(options);
            this.globalEventLimitGuard = new (0, (0, parcelRequire("5mvug")).default)(this.options.maxEventLimit, {
                addItems: this.addItems.bind(this),
                getItemCount: this.getItemCount.bind(this),
                evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
            });
        }
        async addItem(item, options = {}, policy = (0, (0, parcelRequire("7FNEu")).GuardPolicy).ABANDON) {
            if (policy === (0, (0, parcelRequire("7FNEu")).GuardPolicy).IGNORE) throw new (0, (0, parcelRequire("4uxxC")).default)(policy, 'IndexedDbConnector#addItem');
            const storedValue = (0, (0, parcelRequire("Owykq")).convertToItemWrapper)(item, this.namespace, options);
            const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
                storedValue
            ], policy);
            return Promise.resolve({
                item: bulkAddItemsResult.items[0],
                numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
            });
        }
        bulkAddItem(itemOptions, policy = (0, (0, parcelRequire("7FNEu")).GuardPolicy).ABANDON) {
            const items = itemOptions.map(({ item: item, ...addOptions })=>(0, (0, parcelRequire("Owykq")).convertToItemWrapper)(item, this.namespace, addOptions));
            return this.bulkAddItemWrapperType(items, policy);
        }
        bulkAddItemWrapperType(items, policy = (0, (0, parcelRequire("7FNEu")).GuardPolicy).ABANDON) {
            return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
        }
        getItems(count = (0, (0, parcelRequire("i2WnZ")).GET_ITEM_COUNT)) {
            return Promise.resolve(this.synchronousGetItems(count));
        }
        synchronousGetItems(count = (0, (0, parcelRequire("i2WnZ")).GET_ITEM_COUNT)) {
            const fixedCount = count > 0 ? count : (0, (0, parcelRequire("i2WnZ")).GET_ITEM_COUNT);
            const now = Date.now();
            const wrappedItems = [];
            const itemsToRemove = [];
            for (let wrappedItem of this.memoryStore){
                if (wrappedItem.timeToBeProcessedAfter <= now) {
                    wrappedItems.push({
                        ...wrappedItem
                    });
                    wrappedItem.timeToBeProcessedAfter += (0, (0, parcelRequire("i2WnZ")).VISIBILITY_TIMEOUT);
                    wrappedItem.retryAttempts += 1;
                    if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
                }
                if (wrappedItems.length >= fixedCount) break;
            }
            itemsToRemove.forEach((item)=>{
                const index = this.memoryStore.indexOf(item);
                this.memoryStore.splice(index, 1);
            });
            return {
                items: wrappedItems,
                numberOfDeletedItems: itemsToRemove.length
            };
        }
        deleteItems(itemIds) {
            this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
            return Promise.resolve(void 0);
        }
        getItemCount() {
            const now = Date.now();
            const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
            return Promise.resolve(count);
        }
        async processItems(processFn, count) {
            const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
            const itemIds = items.map((i)=>i.id);
            try {
                const result = await processFn(items, partialGetResult);
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                throw new (0, (0, parcelRequire("beO5C")).default)(error);
            }
        }
        storeType() {
            return (0, (0, parcelRequire("7FNEu")).StoreType).MEMORY;
        }
        addItems(itemsToAdd) {
            this.memoryStore.push(...itemsToAdd);
            this.memoryStore.sort(function(a, b) {
                return a.timeAdded - b.timeAdded;
            });
        }
        evictEventsIfNeeded(eventLimit) {
            const numberOfEventsInDb = this.memoryStore.length;
            if (numberOfEventsInDb > eventLimit) {
                const m = numberOfEventsInDb - eventLimit;
                this.memoryStore.splice(0, m);
                return m;
            }
            return 0;
        }
    }
});
parcelRegister("5mvug", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dde1de34b73d4ad4$export$2e2bcd8739ae039);
    var $7FNEu;
    var $5QWWB;
    class $dde1de34b73d4ad4$export$2e2bcd8739ae039 {
        constructor(eventLimit, memoryItemHandlers){
            this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
                switch(policy){
                    case (0, (0, parcelRequire("7FNEu")).GuardPolicy).ABANDON:
                        return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                    case (0, (0, parcelRequire("7FNEu")).GuardPolicy).EVICT:
                        return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                    case (0, (0, parcelRequire("7FNEu")).GuardPolicy).IGNORE:
                        return this.handleAddAsManyAsPossible(itemsToAdd);
                }
            };
            if (eventLimit > 0) this.eventLimit = eventLimit;
            else throw Error('Event Limit has to be set higher than 1');
            this.memoryItemHandlers = memoryItemHandlers;
        }
        async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
            const itemCount = await this.memoryItemHandlers.getItemCount();
            if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, (0, parcelRequire("5QWWB")).default)((0, (0, parcelRequire("7FNEu")).StoreType).MEMORY);
            this.memoryItemHandlers.addItems(itemsToAdd);
            return {
                items: itemsToAdd,
                numberOfEvictedItems: 0
            };
        }
        handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
            this.memoryItemHandlers.addItems(itemsToAdd);
            const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
            return {
                items: itemsToAdd,
                numberOfEvictedItems: numberOfEvictedItems
            };
        }
        async handleAddAsManyAsPossible(itemsToAdd) {
            const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
            const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
            this.memoryItemHandlers.addItems(partialEventsToAdd);
            return {
                items: partialEventsToAdd,
                numberOfEvictedItems: 0
            };
        }
    }
});
parcelRegister("khrXz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5bd1fa444a09692b$export$2e2bcd8739ae039);
    var $6Xkkj;
    class $5bd1fa444a09692b$export$4b62ee5120ab50a8 {
        addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
            this.itemsDiscardedByRetry += numberOfDeletedEvents;
        }
        addToEventCount() {
            this.eventCount++;
        }
        addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
            this.itemsDiscardedByOverflow += numberOfDeletedEvents;
        }
        setResilienceMechanism(mechanism) {
            this.resilienceMechanism = mechanism;
        }
        addToReclaimMetrics(reclaimMetrics) {
            this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
            this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
            this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
        }
        addToPurgedQueuesMetrics(numberOfQueuesPurged) {
            this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
        }
        subtractFromMetrics(sentMetrics) {
            this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
            this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
            this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
            this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
            this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
            this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
            this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
        }
        subtractFromCount(count, subtract) {
            return Math.max(count - (subtract || 0), 0);
        }
        getMetricsPayload() {
            return {
                itemsDiscardedByRetry: this.itemsDiscardedByRetry,
                eventCount: this.eventCount,
                itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
                resilienceMechanism: this.resilienceMechanism,
                localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
                fullReclaims: this.localstorageNumberOfFullReclaims,
                partialReclaims: this.localstorageNumberOfPartialReclaims,
                failedReclaims: this.localstorageNumberOfFailedReclaims
            };
        }
        constructor(){
            this.itemsDiscardedByRetry = 0;
            this.eventCount = 0;
            this.itemsDiscardedByOverflow = 0;
            this.resilienceMechanism = (0, (0, parcelRequire("6Xkkj")).ResilienceMechanism).INDEXEDDB;
            this.localstorageNumberOfQueuesPurged = 0;
            this.localstorageNumberOfFullReclaims = 0;
            this.localstorageNumberOfPartialReclaims = 0;
            this.localstorageNumberOfFailedReclaims = 0;
        }
    }
    let $5bd1fa444a09692b$var$cachedMetricsClient = null;
    var $5bd1fa444a09692b$export$2e2bcd8739ae039 = ()=>{
        if (!$5bd1fa444a09692b$var$cachedMetricsClient) $5bd1fa444a09692b$var$cachedMetricsClient = new $5bd1fa444a09692b$export$4b62ee5120ab50a8();
        return $5bd1fa444a09692b$var$cachedMetricsClient;
    };
});
parcelRegister("6Xkkj", function(module, exports) {
    $parcel$export(module.exports, "ResilienceMechanism", ()=>$d2536d77cd1031ce$export$c75161629e3ec34e);
    $parcel$export(module.exports, "NetworkStatusEnum", ()=>$d2536d77cd1031ce$export$ee138fa712d11b84);
    var $d2536d77cd1031ce$export$c75161629e3ec34e;
    (function(ResilienceMechanism) {
        ResilienceMechanism["INDEXEDDB"] = "indexeddb";
        ResilienceMechanism["MEMORY"] = "memory";
    })($d2536d77cd1031ce$export$c75161629e3ec34e || ($d2536d77cd1031ce$export$c75161629e3ec34e = {}));
    var $d2536d77cd1031ce$export$ee138fa712d11b84;
    (function(NetworkStatusEnum) {
        NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
        NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    })($d2536d77cd1031ce$export$ee138fa712d11b84 || ($d2536d77cd1031ce$export$ee138fa712d11b84 = {}));
});
parcelRegister("HgOyT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$484291cf064eb94b$export$2e2bcd8739ae039);
    var $6Xkkj;
    class $484291cf064eb94b$export$2e2bcd8739ae039 {
        constructor(networkChangeCallback){
            if (typeof window !== 'undefined') {
                window.addEventListener('offline', ()=>networkChangeCallback((0, (0, parcelRequire("6Xkkj")).NetworkStatusEnum).OFFLINE));
                window.addEventListener('online', ()=>networkChangeCallback((0, (0, parcelRequire("6Xkkj")).NetworkStatusEnum).ONLINE));
            }
        }
        getNetworkStatus() {
            if (window.navigator.onLine) return (0, (0, parcelRequire("6Xkkj")).NetworkStatusEnum).ONLINE;
            return (0, (0, parcelRequire("6Xkkj")).NetworkStatusEnum).OFFLINE;
        }
    }
});
parcelRegister("8Kw4t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$347c5ce8e3a1f173$export$2e2bcd8739ae039);
    var $aUXPf;
    var $hRp5m;
    const $347c5ce8e3a1f173$var$SCHEDULER_OPTIONS_DEFAULT = {
        minRetryDelay: 1000,
        maxRetryDelay: 30000,
        backoffFactor: 2,
        backoffJitterPercentage: 0,
        waitInterval: 500,
        callbackTimeoutPeriod: 5000
    };
    var $347c5ce8e3a1f173$export$8bb92baee001fc60;
    (function(QueuedScheduleTypes) {
        QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
        QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
        QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    })($347c5ce8e3a1f173$export$8bb92baee001fc60 || ($347c5ce8e3a1f173$export$8bb92baee001fc60 = {}));
    class $347c5ce8e3a1f173$export$2e2bcd8739ae039 {
        constructor(retryOptions, callback){
            this.schedule = ({ immediate: immediate } = {
                immediate: false
            })=>{
                if (typeof window === 'undefined') return;
                if (this.operationInFlight) {
                    if (immediate) this.queuedSchedule = 1;
                    else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
                } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                    this.clearTimeout();
                    this.run();
                } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
                else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
            };
            this.stop = ()=>{
                this.clearTimeout();
                this.queuedSchedule = 0;
            };
            this.getFailureCount = ()=>this.failureCount;
            this.getCallbackStatus = ()=>{
                return this.callbackTimer.getCallbackStatus();
            };
            this.clearTimeout = ()=>{
                if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                    window.clearTimeout(this.scheduledTimeout);
                    this.scheduledTimeout = null;
                }
            };
            this.run = ()=>{
                this.operationInFlight = true;
                this.clearTimeout();
                try {
                    this.callbackTimer.executeCallbackWithTimeout(this.callback, this.done, ()=>this.done((0, (0, parcelRequire("hRp5m")).DoneState).ERROR));
                } catch (err) {
                    this.done(err);
                }
            };
            this.done = (state)=>{
                this.operationInFlight = false;
                if (state === (0, (0, parcelRequire("hRp5m")).DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, (0, parcelRequire("aUXPf")).CallbackStatus).TIMED_OUT) {
                    this.failureCount++;
                    this.clearTimeout();
                } else if (state === (0, (0, parcelRequire("hRp5m")).DoneState).SUCCESS) this.failureCount = 0;
                this.processQueuedSchedule();
            };
            this.processQueuedSchedule = ()=>{
                if (this.queuedSchedule !== 0) {
                    const immediate = this.queuedSchedule === 1;
                    this.queuedSchedule = 0;
                    this.schedule({
                        immediate: immediate
                    });
                } else if (this.failureCount > 0) this.schedule();
            };
            this.calculateBackoff = ()=>{
                const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
                let ms = minRetryDelay * backoffFactor ** this.failureCount;
                if (backoffJitterPercentage) {
                    const rand = Math.random();
                    const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                    if (Math.floor(rand * 10) < 5) ms -= deviation;
                    else ms += deviation;
                }
                return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
            };
            this.options = {
                minRetryDelay: retryOptions.minRetryDelay || $347c5ce8e3a1f173$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
                maxRetryDelay: retryOptions.maxRetryDelay || $347c5ce8e3a1f173$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
                backoffFactor: retryOptions.backoffFactor || $347c5ce8e3a1f173$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
                backoffJitterPercentage: retryOptions.backoffJitterPercentage || $347c5ce8e3a1f173$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
                waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $347c5ce8e3a1f173$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
                callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $347c5ce8e3a1f173$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
            };
            this.scheduledTimeout = null;
            this.failureCount = 0;
            this.callback = callback;
            this.operationInFlight = false;
            this.queuedSchedule = 0;
            this.callbackTimer = new (0, (0, parcelRequire("aUXPf")).CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
        }
    }
});
parcelRegister("aUXPf", function(module, exports) {
    $parcel$export(module.exports, "CallbackStatus", ()=>$74e605ca5f83ca91$export$ef3353088fca369c);
    $parcel$export(module.exports, "CallbackWithTimeout", ()=>$74e605ca5f83ca91$export$590a718599f8f8b3);
    var $74e605ca5f83ca91$export$ef3353088fca369c;
    (function(CallbackStatus) {
        CallbackStatus["IDLE"] = "idle";
        CallbackStatus["RUNNING"] = "running";
        CallbackStatus["COMPLETED"] = "completed";
        CallbackStatus["TIMED_OUT"] = "timedOut";
    })($74e605ca5f83ca91$export$ef3353088fca369c || ($74e605ca5f83ca91$export$ef3353088fca369c = {}));
    var $74e605ca5f83ca91$export$def7d978353eaa0;
    (function(CallbackEvent) {
        CallbackEvent["EXECUTE"] = "execute";
        CallbackEvent["COMPLETE"] = "complete";
        CallbackEvent["TIMEOUT"] = "timeout";
    })($74e605ca5f83ca91$export$def7d978353eaa0 || ($74e605ca5f83ca91$export$def7d978353eaa0 = {}));
    class $74e605ca5f83ca91$export$590a718599f8f8b3 {
        constructor(timeoutPeriod){
            this.timeoutHandle = undefined;
            this.callbackStatus = "idle";
            if (timeoutPeriod > 0) {
                this.timeoutPeriod = timeoutPeriod;
                return;
            }
            throw new Error('CallbackWithTimeout requires timeout period higher than 0');
        }
        transitionCallbackStatus(currentStatus, event) {
            switch(currentStatus){
                case "idle":
                case "timedOut":
                case "completed":
                    if (event === "execute") this.callbackStatus = "running";
                    break;
                case "running":
                    switch(event){
                        case "complete":
                            this.callbackStatus = "completed";
                            break;
                        case "timeout":
                            this.callbackStatus = "timedOut";
                            break;
                    }
                    break;
                default:
                    this.callbackStatus = currentStatus;
            }
        }
        executeCallbackWithTimeout(callback, onDone, onTimeout) {
            if (typeof window === 'undefined') return;
            this.transitionCallbackStatus(this.callbackStatus, "execute");
            this.timeoutHandle = window.setTimeout(()=>{
                this.transitionCallbackStatus(this.callbackStatus, "timeout");
                onTimeout();
            }, this.timeoutPeriod);
            callback((state)=>{
                this.cancelTimeout();
                if (this.getCallbackStatus() !== "timedOut") {
                    this.transitionCallbackStatus(this.callbackStatus, "complete");
                    onDone(state);
                }
            });
        }
        getCallbackStatus() {
            return this.callbackStatus;
        }
        cancelTimeout() {
            if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
                window.clearTimeout(this.timeoutHandle);
                this.timeoutHandle = undefined;
            }
        }
    }
});
parcelRegister("hRp5m", function(module, exports) {
    $parcel$export(module.exports, "DoneState", ()=>$bc10456d1870788a$export$f93c40fda808dd0c);
    var $bc10456d1870788a$export$f93c40fda808dd0c;
    (function(DoneState) {
        DoneState[DoneState["NOOP"] = 0] = "NOOP";
        DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
        DoneState[DoneState["ERROR"] = 2] = "ERROR";
    })($bc10456d1870788a$export$f93c40fda808dd0c || ($bc10456d1870788a$export$f93c40fda808dd0c = {}));
});
parcelRegister("t1wQK", function(module, exports) {
    $parcel$export(module.exports, "attachXidToMultipleEvents", ()=>$5c79bff0dce26885$export$c21270cab66ab290);
    var $laGea;
    function $5c79bff0dce26885$export$c9c3aaf655d6f275(item, xidCallback) {
        if (!(xidCallback && xidCallback instanceof Function)) return item;
        if (item.msg.type === (0, (0, parcelRequire("laGea")).SegmentEventTypes).PAGE || item.msg.type === (0, (0, parcelRequire("laGea")).SegmentEventTypes).TRACK) {
            const xid = xidCallback();
            if (xid && Array.isArray(xid)) item.msg.properties = {
                ...item.msg.properties,
                xid: xid
            };
        } else if (item.msg.traits && item.msg.type === (0, (0, parcelRequire("laGea")).SegmentEventTypes).IDENTIFY) {
            const xid = xidCallback();
            if (xid && Array.isArray(xid)) item.msg.traits = {
                ...item.msg.traits,
                xid: xid
            };
        }
        return item;
    }
    async function $5c79bff0dce26885$export$c21270cab66ab290(items, xidItemPromiseCallback) {
        try {
            const xidCallback = await xidItemPromiseCallback;
            return items.map((item)=>$5c79bff0dce26885$export$c9c3aaf655d6f275(item, xidCallback));
        } catch (error) {
            return items;
        }
    }
});
parcelRegister("laGea", function(module, exports) {
    $parcel$export(module.exports, "SegmentEventTypes", ()=>$96d45f553fc08ee8$export$ddf929981dc6feb3);
    var $96d45f553fc08ee8$export$ddf929981dc6feb3;
    (function(SegmentEventTypes) {
        SegmentEventTypes["IDENTIFY"] = "identify";
        SegmentEventTypes["PAGE"] = "page";
        SegmentEventTypes["TRACK"] = "track";
    })($96d45f553fc08ee8$export$ddf929981dc6feb3 || ($96d45f553fc08ee8$export$ddf929981dc6feb3 = {}));
    var $96d45f553fc08ee8$export$8d8db47b9b0efb63;
    (function(CrossDomainIdentifierType) {
        CrossDomainIdentifierType["XC"] = "xc";
        CrossDomainIdentifierType["UID"] = "uid";
    })($96d45f553fc08ee8$export$8d8db47b9b0efb63 || ($96d45f553fc08ee8$export$8d8db47b9b0efb63 = {}));
    var $96d45f553fc08ee8$export$2140495465f9e528;
    (function(CrossDomainIdentifierState) {
        CrossDomainIdentifierState["NEW"] = "NEW";
        CrossDomainIdentifierState["CHANGED"] = "CHANGED";
        CrossDomainIdentifierState["EXISTING"] = "EXISTING";
        CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
        CrossDomainIdentifierState["ERROR"] = "ERROR";
        CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
        CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
        CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    })($96d45f553fc08ee8$export$2140495465f9e528 || ($96d45f553fc08ee8$export$2140495465f9e528 = {}));
});
parcelRegister("4qhwE", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", ()=>$7e096f28c9f749ac$export$9175ce0e1c95daf2);
    const $7e096f28c9f749ac$export$9175ce0e1c95daf2 = 10000;
});
parcelRegister("3g17q", function(module, exports) {
    $parcel$export(module.exports, "sendEvents", ()=>$d6420d6d106e20b5$export$8e8f0180c1b41fad);
    var $8QpSo;
    const $d6420d6d106e20b5$export$8e8f0180c1b41fad = async (options)=>{
        const signal = $d6420d6d106e20b5$var$createOrGetAbortController(options)?.signal;
        const corsOptions = $d6420d6d106e20b5$var$getCorsForUrl(options.url);
        const response = await fetch(options.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'text/plain'
            },
            body: JSON.stringify(options.batch),
            signal: signal,
            ...corsOptions
        });
        if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
        return response;
    };
    const $d6420d6d106e20b5$var$createOrGetAbortController = (options)=>{
        if (options.abortController) return options.abortController;
        else if (options.timeout) {
            const abortController = new AbortController();
            setTimeout(()=>{
                abortController.abort();
            }, options.timeout);
            return abortController;
        }
    };
    const $d6420d6d106e20b5$var$getCorsForUrl = (0, (0, parcelRequire("8QpSo")).default)((url)=>{
        const origin = new URL(url).origin;
        if (origin === location.origin) return {};
        else return {
            mode: 'cors',
            credentials: 'include'
        };
    });
});
parcelRegister("hv0EA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1e49d1581249817$export$2e2bcd8739ae039);
    var $4mBKK;
    var $bXrHm = parcelRequire("bXrHm");
    var $8FQiz;
    var $aXOp8;
    var $jdVRE;
    const $d1e49d1581249817$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
    const $d1e49d1581249817$var$SAFE = 'SAFE';
    const $d1e49d1581249817$var$UNSAFE = 'UNSAFE';
    const $d1e49d1581249817$var$NOT_FOUND = 'NOT_FOUND';
    const $d1e49d1581249817$var$COOKIE = 'COOKIE';
    const $d1e49d1581249817$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
    class $d1e49d1581249817$export$2e2bcd8739ae039 {
        constructor(disableCookiePersistence){
            this.store = new (0, (0, parcelRequire("jdVRE")).default)({
                useStoragePrefix: false
            });
            this.cookie = new (0, (0, parcelRequire("aXOp8")).default)(disableCookiePersistence);
        }
        getUserId() {
            return this.userId || null;
        }
        setUserId(userId) {
            this.userId = userId;
        }
        getAnonymousId(customAnonymousIdGenerator) {
            return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
        }
        setAnonymousId(anonymousId) {
            const stringifyAnonymosId = JSON.stringify(anonymousId);
            this.cookie.set((0, (0, parcelRequire("8FQiz")).AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
            this.lastAnonymousIdCookieUpdate = Date.now();
            return this.store.setItem((0, (0, parcelRequire("8FQiz")).AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
        }
        getAnonymousIdFromStorage(source) {
            const rawStorageAnonidValue = source === $d1e49d1581249817$var$LOCAL_STORAGE ? this.store.getItem((0, (0, parcelRequire("8FQiz")).AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, (0, parcelRequire("8FQiz")).AWCCookiesKeys).AJS_ANONYMOUS_ID);
            if (rawStorageAnonidValue) {
                const unsafeValue = {
                    type: $d1e49d1581249817$var$UNSAFE,
                    anonymousId: rawStorageAnonidValue
                };
                try {
                    const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                    if (parsedAnonId && typeof parsedAnonId === 'string') return {
                        type: $d1e49d1581249817$var$SAFE,
                        anonymousId: parsedAnonId
                    };
                    return unsafeValue;
                } catch (err) {
                    return unsafeValue;
                }
            }
            return {
                type: $d1e49d1581249817$var$NOT_FOUND
            };
        }
        getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
            const localStorageValue = this.getAnonymousIdFromStorage($d1e49d1581249817$var$LOCAL_STORAGE);
            let shouldUpdateCookie = false;
            if (!this.lastAnonymousIdCookieUpdate || (0, (0, parcelRequire("4mBKK")).default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $d1e49d1581249817$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
            switch(localStorageValue.type){
                case $d1e49d1581249817$var$SAFE:
                    if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                    return localStorageValue.anonymousId;
                case $d1e49d1581249817$var$UNSAFE:
                    return localStorageValue.anonymousId;
                case $d1e49d1581249817$var$NOT_FOUND:
                default:
                    return null;
            }
        }
        getAnonymousIdFromCookieAndUpdateLocalStorage() {
            const cookieValue = this.getAnonymousIdFromStorage($d1e49d1581249817$var$COOKIE);
            switch(cookieValue.type){
                case $d1e49d1581249817$var$SAFE:
                case $d1e49d1581249817$var$UNSAFE:
                    this.store.setItem((0, (0, parcelRequire("8FQiz")).AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                    return cookieValue.anonymousId;
                case $d1e49d1581249817$var$NOT_FOUND:
                default:
                    return null;
            }
        }
        generateNewAnonymousId(customAnonymousIdGenerator = (0, ($parcel$interopDefault($bXrHm)))) {
            const newAnonId = customAnonymousIdGenerator();
            this.setAnonymousId(newAnonId);
            return newAnonId;
        }
    }
});
parcelRegister("8FQiz", function(module, exports) {
    $parcel$export(module.exports, "AWCCookiesKeys", ()=>$321b25390bd739cd$export$202d555a5dbfd90c);
    $parcel$export(module.exports, "AllAnalyticsCookies", ()=>$321b25390bd739cd$export$d4cb17942ea57c95);
    var $321b25390bd739cd$export$202d555a5dbfd90c;
    (function(AWCCookiesKeys) {
        AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
        AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
        AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    })($321b25390bd739cd$export$202d555a5dbfd90c || ($321b25390bd739cd$export$202d555a5dbfd90c = {}));
    class $321b25390bd739cd$var$CookieSchema {
        constructor(key, options){
            this.key = key;
            this.options = options;
        }
        getAttributes() {
            return this.options;
        }
        getKey() {
            return this.key;
        }
    }
    const $321b25390bd739cd$var$isSecure = ()=>{
        try {
            return window && window.location && window.location.protocol === 'https:';
        } catch (err) {
            return false;
        }
    };
    const $321b25390bd739cd$export$d4cb17942ea57c95 = {
        ["AWC_TLD_TEST"]: new $321b25390bd739cd$var$CookieSchema('__awc_tld_test__', {
            expires: 365,
            secure: $321b25390bd739cd$var$isSecure(),
            path: '/'
        }),
        ["AWC_ANALYTICS_DEBUG"]: new $321b25390bd739cd$var$CookieSchema('atlassian_analytics_debug', {
            expires: 365,
            secure: $321b25390bd739cd$var$isSecure(),
            path: '/'
        }),
        ["AJS_ANONYMOUS_ID"]: new $321b25390bd739cd$var$CookieSchema('ajs_anonymous_id', {
            expires: 365,
            secure: $321b25390bd739cd$var$isSecure(),
            path: '/'
        })
    };
});
parcelRegister("aXOp8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1d9afa2015604b5$export$2e2bcd8739ae039);
    var $eYli8 = parcelRequire("eYli8");
    var $8FQiz;
    var $c1Dzx;
    var $1pINp;
    class $b1d9afa2015604b5$export$2e2bcd8739ae039 {
        constructor(disableCookiePersistence){
            this.cookieLike = (0, (0, parcelRequire("1pINp")).canUseCookie)(disableCookiePersistence) ? (0, ($parcel$interopDefault($eYli8))) : new (0, (0, parcelRequire("c1Dzx")).default)();
        }
        set(name, value, options) {
            if (!(0, (0, parcelRequire("8FQiz")).AllAnalyticsCookies)[name]) {
                console.warn(`Unknown cookie key ${name} provided, not set.`);
                return;
            }
            return this.cookieLike.set((0, (0, parcelRequire("8FQiz")).AllAnalyticsCookies)[name].getKey(), value, {
                ...(0, (0, parcelRequire("8FQiz")).AllAnalyticsCookies)[name].getAttributes(),
                domain: (0, (0, parcelRequire("1pINp")).getTld)(),
                ...options
            });
        }
        get(name) {
            if (!(0, (0, parcelRequire("8FQiz")).AllAnalyticsCookies)[name]) {
                console.warn(`Unknown cookie key ${name} provided, not fetched.`);
                return;
            }
            return this.cookieLike.get((0, (0, parcelRequire("8FQiz")).AllAnalyticsCookies)[name].getKey());
        }
        remove(name, options) {
            if (!(0, (0, parcelRequire("8FQiz")).AllAnalyticsCookies)[name]) {
                console.warn(`Unknown cookie key ${name} provided, not removed.`);
                return;
            }
            this.cookieLike.remove((0, (0, parcelRequire("8FQiz")).AllAnalyticsCookies)[name].getKey(), {
                ...options
            });
        }
    }
});
parcelRegister("c1Dzx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f83d4aaefc5696b5$export$2e2bcd8739ae039);
    var $jdVRE;
    class $f83d4aaefc5696b5$export$2e2bcd8739ae039 {
        constructor(){
            this.safeStorage = new (0, (0, parcelRequire("jdVRE")).default)({
                useStoragePrefix: false
            });
        }
        set(name, value) {
            this.safeStorage.setItem(name, value);
            return value;
        }
        get(name) {
            const value = this.safeStorage.getItem(name);
            return value || undefined;
        }
        remove(name) {
            this.safeStorage.removeItem(name);
        }
    }
});
parcelRegister("jdVRE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$972dafae9bfa5727$export$2e2bcd8739ae039);
    var $eLJDL;
    var $8rOMP;
    class $972dafae9bfa5727$export$2e2bcd8739ae039 extends (0, (0, parcelRequire("8rOMP")).default) {
        constructor(options){
            let storageToUse;
            try {
                storageToUse = window.localStorage || (0, (0, parcelRequire("eLJDL")).default);
            } catch (err) {
                storageToUse = (0, (0, parcelRequire("eLJDL")).default);
            }
            super(storageToUse, options);
        }
    }
});
parcelRegister("eLJDL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$368bfa039c1261db$export$2e2bcd8739ae039);
    class $368bfa039c1261db$export$90e3e001bcac59c7 {
        constructor(){
            this._data = {};
            this.length = 0;
            this.setItem = (key, value)=>{
                this._data[key] = value;
                this.length = Object.keys(this._data).length;
                return value;
            };
            this.getItem = (key)=>{
                if (key in this._data) return this._data[key];
                return null;
            };
            this.removeItem = (key)=>{
                if (key in this._data) delete this._data[key];
                this.length = Object.keys(this._data).length;
                return null;
            };
            this.clear = ()=>{
                this._data = {};
                this.length = 0;
            };
            this.key = (index)=>Object.keys(this._data)[index];
        }
    }
    var $368bfa039c1261db$export$2e2bcd8739ae039 = new $368bfa039c1261db$export$90e3e001bcac59c7();
});
parcelRegister("8rOMP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4598e0c6cebed22d$export$2e2bcd8739ae039);
    var $bpIMA;
    var $eLJDL;
    const $4598e0c6cebed22d$export$41c06fdd37b7e9a5 = 'awc';
    const $4598e0c6cebed22d$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
    function $4598e0c6cebed22d$export$48c17662a6902497(store) {
        const TEST_VALUE = 'test_value';
        if (!store) return false;
        try {
            const key = 'awc.storage.support';
            store.setItem(key, TEST_VALUE);
            const value = store.getItem(key);
            store.removeItem(key);
            return value === TEST_VALUE;
        } catch (e) {
            return false;
        }
    }
    function $4598e0c6cebed22d$export$6325979d1c67607f(e) {
        let quotaExceeded = false;
        if (e.code) switch(e.code){
            case 22:
                quotaExceeded = true;
                break;
            case 1014:
                if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
                break;
            default:
                break;
        }
        else if (e.number === -2147024882) quotaExceeded = true;
        return quotaExceeded;
    }
    class $4598e0c6cebed22d$export$2e2bcd8739ae039 {
        constructor(storageToUse, options = {}){
            this.getStore = ()=>this._store;
            this.getItem = (key)=>this._store.getItem(this.createKey(key));
            this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
            this.setItem = (key, value)=>{
                try {
                    this._store.setItem(this.createKey(key), value);
                } catch (err) {
                    if ($4598e0c6cebed22d$export$6325979d1c67607f(err)) {
                        this.swapToInMemory();
                        this._store.setItem(this.createKey(key), value);
                    }
                }
            };
            this.swapToInMemory = ()=>{
                if (this._store === (0, (0, parcelRequire("eLJDL")).default) || typeof window === 'undefined') return;
                const keys = Object.keys(this._store || {});
                let inMemoryStorage;
                if ($4598e0c6cebed22d$export$48c17662a6902497(window[$4598e0c6cebed22d$export$770aa8bc07b3de03])) inMemoryStorage = window[$4598e0c6cebed22d$export$770aa8bc07b3de03];
                else {
                    inMemoryStorage = (0, (0, parcelRequire("eLJDL")).default);
                    if (!window[$4598e0c6cebed22d$export$770aa8bc07b3de03]) window[$4598e0c6cebed22d$export$770aa8bc07b3de03] = (0, (0, parcelRequire("eLJDL")).default);
                }
                keys.forEach((key)=>{
                    if (key.indexOf(this.getPrefix()) === 0) {
                        const value = this._store.getItem(key);
                        if (value) inMemoryStorage.setItem(key, value);
                    }
                });
                this._store = inMemoryStorage;
            };
            this.clear = ()=>this._store.clear();
            this.key = (index)=>this._store.key(index);
            this.getPrefix = ()=>this._prefix;
            this.createKey = (key)=>{
                if (this._prefix) return `${this.getPrefix()}.${key}`;
                return key;
            };
            this.options = options;
            const prefixes = [];
            if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($4598e0c6cebed22d$export$41c06fdd37b7e9a5);
            if (options.envPrefix && options.envPrefix !== (0, (0, parcelRequire("bpIMA")).envType).PROD) prefixes.push(options.envPrefix);
            this._prefix = prefixes.join('-');
            if ($4598e0c6cebed22d$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
            else this.swapToInMemory();
        }
    }
});
parcelRegister("1pINp", function(module, exports) {
    $parcel$export(module.exports, "canUseCookie", ()=>$5c790dbe34735a27$export$a9330601ee8f4d95);
    $parcel$export(module.exports, "getTld", ()=>$5c790dbe34735a27$export$de6821eed3d5f32d);
    var $eYli8 = parcelRequire("eYli8");
    var $8QpSo;
    var $8FQiz;
    const $5c790dbe34735a27$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
        if (disableCookiePersistence) return false;
        return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
    };
    const $5c790dbe34735a27$export$eb80e1beaa8dacf8 = (0, (0, parcelRequire("8FQiz")).AllAnalyticsCookies).AWC_TLD_TEST.getKey();
    const $5c790dbe34735a27$export$19164982d36535d8 = 'tld_test';
    const $5c790dbe34735a27$export$de6821eed3d5f32d = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        if (typeof location === 'undefined') return '';
        const { hostname: hostname } = location;
        const splitHostname = hostname.split('.');
        for(let i = 1; i <= splitHostname.length; i++){
            const domainParts = splitHostname.slice(i * -1);
            const domain = `.${domainParts.join('.')}`;
            (0, ($parcel$interopDefault($eYli8))).set($5c790dbe34735a27$export$eb80e1beaa8dacf8, $5c790dbe34735a27$export$19164982d36535d8, {
                domain: domain
            });
            if ((0, ($parcel$interopDefault($eYli8))).get($5c790dbe34735a27$export$eb80e1beaa8dacf8) === $5c790dbe34735a27$export$19164982d36535d8) {
                (0, ($parcel$interopDefault($eYli8))).remove($5c790dbe34735a27$export$eb80e1beaa8dacf8, {
                    domain: domain
                });
                return domain;
            }
        }
        return hostname;
    });
});
parcelRegister("1lxBC", function(module, exports) {
    $parcel$export(module.exports, "buildContext", ()=>$bd8c839754f17cd3$export$3a7fe28f9bf4f3d9);
    $parcel$export(module.exports, "prepareEventProperties", ()=>$bd8c839754f17cd3$export$44d22e5fb02cc68e);
    var $1m0iJ = parcelRequire("1m0iJ");
    const $bd8c839754f17cd3$export$3a7fe28f9bf4f3d9 = (context)=>{
        return {
            ...context.context,
            userAgent: navigator.userAgent
        };
    };
    const $bd8c839754f17cd3$export$44d22e5fb02cc68e = (properties)=>{
        const propertiesWithoutUndefined = $bd8c839754f17cd3$export$2250ccecd1e040fd(properties);
        return (0, ($parcel$interopDefault($1m0iJ)))(propertiesWithoutUndefined);
    };
    const $bd8c839754f17cd3$export$2250ccecd1e040fd = (obj)=>{
        if (obj === null || typeof obj !== 'object') return obj;
        const clone = {};
        Object.keys(obj).forEach((key)=>{
            const value = $bd8c839754f17cd3$var$getValueOfObject(obj, key);
            if (value !== undefined) {
                if (Array.isArray(value)) clone[key] = value.map((i)=>$bd8c839754f17cd3$export$2250ccecd1e040fd(i));
                else if (typeof value === 'object' && value !== null) clone[key] = $bd8c839754f17cd3$export$2250ccecd1e040fd(value);
                else clone[key] = value;
            }
        });
        return clone;
    };
    const $bd8c839754f17cd3$var$getValueOfObject = (obj, key)=>{
        return obj[key];
    };
});
parcelRegister("9E64n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31692341e656ca1b$export$2e2bcd8739ae039);
    var $bpIMA;
    var $f8lVk;
    class $31692341e656ca1b$export$2e2bcd8739ae039 {
        constructor(){
            this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
                const originParamLabelList = Object.keys(originParamHandlerMapping);
                if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
                const invalidParams = originParamLabelList.filter((x)=>Object.values((0, (0, parcelRequire("bpIMA")).originTracingType)).indexOf(x) < 0);
                if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
                const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
                const capturedURLParams = (0, (0, parcelRequire("f8lVk")).default)(isCaptureParam, historyReplaceFn);
                const applyHandlerFunction = (key)=>{
                    const x = originParamHandlerMapping[key](capturedURLParams[key]);
                    return {
                        [key]: x
                    };
                };
                const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
                return extractedOriginID;
            };
            this._originStore = {};
        }
    }
});
parcelRegister("f8lVk", function(module, exports) {
    $parcel$export(module.exports, "defaultHistoryReplaceFn", ()=>$454b267270e3d633$export$600dd5bf1b049f11);
    $parcel$export(module.exports, "default", ()=>$454b267270e3d633$export$2e2bcd8739ae039);
    var $3Hqb2 = parcelRequire("3Hqb2");
    var $d603q;
    const $454b267270e3d633$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
    const $454b267270e3d633$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $454b267270e3d633$export$600dd5bf1b049f11)=>{
        const originalUrl = window.location.href;
        const fragmentHash = window.location.hash;
        const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
        const { url: url, query: query } = (0, $3Hqb2.parseUrl)(removedFragmentURL);
        const captureParams = (0, (0, parcelRequire("d603q")).pickBy)(query, isCaptureParam);
        if (Object.keys(captureParams).length > 0) {
            const queryWithoutCaptureParams = (0, (0, parcelRequire("d603q")).omitBy)(query, isCaptureParam);
            if (Object.keys(queryWithoutCaptureParams).length > 0) {
                const newUrl = `${url}?${(0, $3Hqb2.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
                historyReplaceFn(newUrl);
            } else historyReplaceFn(`${url}${fragmentHash}`);
        }
        return captureParams;
    };
    var $454b267270e3d633$export$2e2bcd8739ae039 = $454b267270e3d633$var$urlParamExtractor;
});
parcelRegister("3Hqb2", function(module, exports) {
    $parcel$export(module.exports, "extract", ()=>$2b19b177bf070152$export$f9380c9a627682d3, (v)=>$2b19b177bf070152$export$f9380c9a627682d3 = v);
    $parcel$export(module.exports, "parse", ()=>$2b19b177bf070152$export$98e6a39c04603d36, (v)=>$2b19b177bf070152$export$98e6a39c04603d36 = v);
    $parcel$export(module.exports, "stringify", ()=>$2b19b177bf070152$export$fac44ee5b035f737, (v)=>$2b19b177bf070152$export$fac44ee5b035f737 = v);
    $parcel$export(module.exports, "parseUrl", ()=>$2b19b177bf070152$export$7a5253c0f62e0150, (v)=>$2b19b177bf070152$export$7a5253c0f62e0150 = v);
    $parcel$export(module.exports, "stringifyUrl", ()=>$2b19b177bf070152$export$a8c1621ea79325d3, (v)=>$2b19b177bf070152$export$a8c1621ea79325d3 = v);
    $parcel$export(module.exports, "pick", ()=>$2b19b177bf070152$export$357523c63a2253b9, (v)=>$2b19b177bf070152$export$357523c63a2253b9 = v);
    var $2b19b177bf070152$export$f9380c9a627682d3;
    var $2b19b177bf070152$export$98e6a39c04603d36;
    var $2b19b177bf070152$export$fac44ee5b035f737;
    var $2b19b177bf070152$export$7a5253c0f62e0150;
    var $2b19b177bf070152$export$a8c1621ea79325d3;
    var $2b19b177bf070152$export$357523c63a2253b9;
    var $2b19b177bf070152$export$44c361b8ec72ef7f;
    'use strict';
    var $hlggt = parcelRequire("hlggt");
    var $aCrRe = parcelRequire("aCrRe");
    var $gjKya = parcelRequire("gjKya");
    var $cNVkY = parcelRequire("cNVkY");
    const $2b19b177bf070152$var$isNullOrUndefined = (value)=>value === null || value === undefined;
    const $2b19b177bf070152$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
    function $2b19b177bf070152$var$encoderForArrayFormat(options) {
        switch(options.arrayFormat){
            case 'index':
                return (key)=>(result, value)=>{
                        const index = result.length;
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        if (value === null) return [
                            ...result,
                            [
                                $2b19b177bf070152$var$encode(key, options),
                                '[',
                                index,
                                ']'
                            ].join('')
                        ];
                        return [
                            ...result,
                            [
                                $2b19b177bf070152$var$encode(key, options),
                                '[',
                                $2b19b177bf070152$var$encode(index, options),
                                ']=',
                                $2b19b177bf070152$var$encode(value, options)
                            ].join('')
                        ];
                    };
            case 'bracket':
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        if (value === null) return [
                            ...result,
                            [
                                $2b19b177bf070152$var$encode(key, options),
                                '[]'
                            ].join('')
                        ];
                        return [
                            ...result,
                            [
                                $2b19b177bf070152$var$encode(key, options),
                                '[]=',
                                $2b19b177bf070152$var$encode(value, options)
                            ].join('')
                        ];
                    };
            case 'colon-list-separator':
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        if (value === null) return [
                            ...result,
                            [
                                $2b19b177bf070152$var$encode(key, options),
                                ':list='
                            ].join('')
                        ];
                        return [
                            ...result,
                            [
                                $2b19b177bf070152$var$encode(key, options),
                                ':list=',
                                $2b19b177bf070152$var$encode(value, options)
                            ].join('')
                        ];
                    };
            case 'comma':
            case 'separator':
            case 'bracket-separator':
                {
                    const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                    return (key)=>(result, value)=>{
                            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                            value = value === null ? '' : value;
                            if (result.length === 0) return [
                                [
                                    $2b19b177bf070152$var$encode(key, options),
                                    keyValueSep,
                                    $2b19b177bf070152$var$encode(value, options)
                                ].join('')
                            ];
                            return [
                                [
                                    result,
                                    $2b19b177bf070152$var$encode(value, options)
                                ].join(options.arrayFormatSeparator)
                            ];
                        };
                }
            default:
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        if (value === null) return [
                            ...result,
                            $2b19b177bf070152$var$encode(key, options)
                        ];
                        return [
                            ...result,
                            [
                                $2b19b177bf070152$var$encode(key, options),
                                '=',
                                $2b19b177bf070152$var$encode(value, options)
                            ].join('')
                        ];
                    };
        }
    }
    function $2b19b177bf070152$var$parserForArrayFormat(options) {
        let result;
        switch(options.arrayFormat){
            case 'index':
                return (key, value, accumulator)=>{
                    result = /\[(\d*)\]$/.exec(key);
                    key = key.replace(/\[\d*\]$/, '');
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) accumulator[key] = {};
                    accumulator[key][result[1]] = value;
                };
            case 'bracket':
                return (key, value, accumulator)=>{
                    result = /(\[\])$/.exec(key);
                    key = key.replace(/\[\]$/, '');
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value);
                };
            case 'colon-list-separator':
                return (key, value, accumulator)=>{
                    result = /(:list)$/.exec(key);
                    key = key.replace(/:list$/, '');
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value);
                };
            case 'comma':
            case 'separator':
                return (key, value, accumulator)=>{
                    const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                    const isEncodedArray = typeof value === 'string' && !isArray && $2b19b177bf070152$var$decode(value, options).includes(options.arrayFormatSeparator);
                    value = isEncodedArray ? $2b19b177bf070152$var$decode(value, options) : value;
                    const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$2b19b177bf070152$var$decode(item, options)) : value === null ? value : $2b19b177bf070152$var$decode(value, options);
                    accumulator[key] = newValue;
                };
            case 'bracket-separator':
                return (key, value, accumulator)=>{
                    const isArray = /(\[\])$/.test(key);
                    key = key.replace(/\[\]$/, '');
                    if (!isArray) {
                        accumulator[key] = value ? $2b19b177bf070152$var$decode(value, options) : value;
                        return;
                    }
                    const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$2b19b177bf070152$var$decode(item, options));
                    if (accumulator[key] === undefined) {
                        accumulator[key] = arrayValue;
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], arrayValue);
                };
            default:
                return (key, value, accumulator)=>{
                    if (accumulator[key] === undefined) {
                        accumulator[key] = value;
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value);
                };
        }
    }
    function $2b19b177bf070152$var$validateArrayFormatSeparator(value) {
        if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
    }
    function $2b19b177bf070152$var$encode(value, options) {
        if (options.encode) return options.strict ? $hlggt(value) : encodeURIComponent(value);
        return value;
    }
    function $2b19b177bf070152$var$decode(value, options) {
        if (options.decode) return $aCrRe(value);
        return value;
    }
    function $2b19b177bf070152$var$keysSorter(input) {
        if (Array.isArray(input)) return input.sort();
        if (typeof input === 'object') return $2b19b177bf070152$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
        return input;
    }
    function $2b19b177bf070152$var$removeHash(input) {
        const hashStart = input.indexOf('#');
        if (hashStart !== -1) input = input.slice(0, hashStart);
        return input;
    }
    function $2b19b177bf070152$var$getHash(url) {
        let hash = '';
        const hashStart = url.indexOf('#');
        if (hashStart !== -1) hash = url.slice(hashStart);
        return hash;
    }
    function $2b19b177bf070152$var$extract(input) {
        input = $2b19b177bf070152$var$removeHash(input);
        const queryStart = input.indexOf('?');
        if (queryStart === -1) return '';
        return input.slice(queryStart + 1);
    }
    function $2b19b177bf070152$var$parseValue(value, options) {
        if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
        else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
        return value;
    }
    function $2b19b177bf070152$var$parse(query, options) {
        options = Object.assign({
            decode: true,
            sort: true,
            arrayFormat: 'none',
            arrayFormatSeparator: ',',
            parseNumbers: false,
            parseBooleans: false
        }, options);
        $2b19b177bf070152$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
        const formatter = $2b19b177bf070152$var$parserForArrayFormat(options);
        const ret = Object.create(null);
        if (typeof query !== 'string') return ret;
        query = query.trim().replace(/^[?#&]/, '');
        if (!query) return ret;
        for (const param of query.split('&')){
            if (param === '') continue;
            let [key, value] = $gjKya(options.decode ? param.replace(/\+/g, ' ') : param, '=');
            value = value === undefined ? null : [
                'comma',
                'separator',
                'bracket-separator'
            ].includes(options.arrayFormat) ? value : $2b19b177bf070152$var$decode(value, options);
            formatter($2b19b177bf070152$var$decode(key, options), value, ret);
        }
        for (const key of Object.keys(ret)){
            const value = ret[key];
            if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $2b19b177bf070152$var$parseValue(value[k], options);
            else ret[key] = $2b19b177bf070152$var$parseValue(value, options);
        }
        if (options.sort === false) return ret;
        return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
            const value = ret[key];
            if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) result[key] = $2b19b177bf070152$var$keysSorter(value);
            else result[key] = value;
            return result;
        }, Object.create(null));
    }
    $2b19b177bf070152$export$f9380c9a627682d3 = $2b19b177bf070152$var$extract;
    $2b19b177bf070152$export$98e6a39c04603d36 = $2b19b177bf070152$var$parse;
    $2b19b177bf070152$export$fac44ee5b035f737 = (object, options)=>{
        if (!object) return '';
        options = Object.assign({
            encode: true,
            strict: true,
            arrayFormat: 'none',
            arrayFormatSeparator: ','
        }, options);
        $2b19b177bf070152$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
        const shouldFilter = (key)=>options.skipNull && $2b19b177bf070152$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
        const formatter = $2b19b177bf070152$var$encoderForArrayFormat(options);
        const objectCopy = {};
        for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
        const keys = Object.keys(objectCopy);
        if (options.sort !== false) keys.sort(options.sort);
        return keys.map((key)=>{
            const value = object[key];
            if (value === undefined) return '';
            if (value === null) return $2b19b177bf070152$var$encode(key, options);
            if (Array.isArray(value)) {
                if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $2b19b177bf070152$var$encode(key, options) + '[]';
                return value.reduce(formatter(key), []).join('&');
            }
            return $2b19b177bf070152$var$encode(key, options) + '=' + $2b19b177bf070152$var$encode(value, options);
        }).filter((x)=>x.length > 0).join('&');
    };
    $2b19b177bf070152$export$7a5253c0f62e0150 = (url, options)=>{
        options = Object.assign({
            decode: true
        }, options);
        const [url_, hash] = $gjKya(url, '#');
        return Object.assign({
            url: url_.split('?')[0] || '',
            query: $2b19b177bf070152$var$parse($2b19b177bf070152$var$extract(url), options)
        }, options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $2b19b177bf070152$var$decode(hash, options)
        } : {});
    };
    $2b19b177bf070152$export$a8c1621ea79325d3 = (object, options)=>{
        options = Object.assign({
            encode: true,
            strict: true,
            [$2b19b177bf070152$var$encodeFragmentIdentifier]: true
        }, options);
        const url = $2b19b177bf070152$var$removeHash(object.url).split('?')[0] || '';
        const queryFromUrl = $2b19b177bf070152$export$f9380c9a627682d3(object.url);
        const parsedQueryFromUrl = $2b19b177bf070152$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        });
        const query = Object.assign(parsedQueryFromUrl, object.query);
        let queryString = $2b19b177bf070152$export$fac44ee5b035f737(query, options);
        if (queryString) queryString = `?${queryString}`;
        let hash = $2b19b177bf070152$var$getHash(object.url);
        if (object.fragmentIdentifier) hash = `#${options[$2b19b177bf070152$var$encodeFragmentIdentifier] ? $2b19b177bf070152$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
        return `${url}${queryString}${hash}`;
    };
    $2b19b177bf070152$export$357523c63a2253b9 = (input, filter, options)=>{
        options = Object.assign({
            parseFragmentIdentifier: true,
            [$2b19b177bf070152$var$encodeFragmentIdentifier]: false
        }, options);
        const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $2b19b177bf070152$export$7a5253c0f62e0150(input, options);
        return $2b19b177bf070152$export$a8c1621ea79325d3({
            url: url,
            query: $cNVkY(query, filter),
            fragmentIdentifier: fragmentIdentifier
        }, options);
    };
    $2b19b177bf070152$export$44c361b8ec72ef7f = (input, filter, options)=>{
        const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
        return $2b19b177bf070152$export$357523c63a2253b9(input, exclusionFilter, options);
    };
});
parcelRegister("gYXWu", function(module, exports) {
    $parcel$export(module.exports, "selectHost", ()=>$7111763dbc1551bd$export$18c0b81944902eae);
    var $bpIMA;
    const $7111763dbc1551bd$var$PROD_HOST = 'as.atlassian.com/api/v1';
    const $7111763dbc1551bd$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
    const $7111763dbc1551bd$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
    const $7111763dbc1551bd$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
    const $7111763dbc1551bd$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
    const $7111763dbc1551bd$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
    const $7111763dbc1551bd$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
    const $7111763dbc1551bd$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
    const $7111763dbc1551bd$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
    const $7111763dbc1551bd$var$handleFedRampStagingDirect = ()=>{
        return $7111763dbc1551bd$var$FEDRAMP_STAGING_HOST;
    };
    const $7111763dbc1551bd$var$handleFedRampStagingStargate = ()=>{
        return $7111763dbc1551bd$var$STARGATE_FEDRAMP_STAGING_HOST;
    };
    const $7111763dbc1551bd$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
        if (env === (0, (0, parcelRequire("bpIMA")).envType).LOCAL || env === (0, (0, parcelRequire("bpIMA")).envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
        if (env === (0, (0, parcelRequire("bpIMA")).envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
        if (!useStargate) return env === (0, (0, parcelRequire("bpIMA")).envType).PROD ? $7111763dbc1551bd$var$FEDRAMP_PROD_HOST : $7111763dbc1551bd$var$handleFedRampStagingDirect();
        if (useLegacyUrl) return env === (0, (0, parcelRequire("bpIMA")).envType).PROD ? $7111763dbc1551bd$var$STARGATE_FEDRAMP_PROD_HOST : $7111763dbc1551bd$var$handleFedRampStagingStargate();
        return window.location.host + $7111763dbc1551bd$var$STARGATE_PROXY_PATH;
    };
    const $7111763dbc1551bd$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
        if (!useStargate) return env === (0, (0, parcelRequire("bpIMA")).envType).PROD ? $7111763dbc1551bd$var$PROD_HOST : $7111763dbc1551bd$var$STAGING_HOST;
        if (useLegacyUrl) return env === (0, (0, parcelRequire("bpIMA")).envType).PROD ? $7111763dbc1551bd$var$STARGATE_PROD_HOST : $7111763dbc1551bd$var$STARGATE_STAGING_HOST;
        return window.location.host + $7111763dbc1551bd$var$STARGATE_PROXY_PATH;
    };
    function $7111763dbc1551bd$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
        if (perimeter === (0, (0, parcelRequire("bpIMA")).perimeterType).FEDRAMP_MODERATE) return $7111763dbc1551bd$var$handleFedRampModerate({
            useStargate: useStargate,
            env: env,
            useLegacyUrl: useLegacyUrl,
            envOverride: envOverride
        });
        return $7111763dbc1551bd$var$handleCommercial({
            useStargate: useStargate,
            env: env,
            useLegacyUrl: useLegacyUrl
        });
    }
});
parcelRegister("2jDOS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab94c86daa56c4b8$export$2e2bcd8739ae039);
    var $jdVRE;
    const $ab94c86daa56c4b8$var$SESSION_ID_STORAGE_KEY = 'session.id';
    const $ab94c86daa56c4b8$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
    const $ab94c86daa56c4b8$var$ONLY_NUMBERS_REGEX = /^\d+$/;
    const $ab94c86daa56c4b8$export$285f6bddd927a06d = 1800000;
    const $ab94c86daa56c4b8$export$a92e915d70316eb2 = 5000;
    const $ab94c86daa56c4b8$export$de43760b2dc10c19 = 0.9;
    const $ab94c86daa56c4b8$export$5702a91a6f42969f = ()=>{};
    class $ab94c86daa56c4b8$export$2e2bcd8739ae039 {
        constructor(options = {}){
            this._generateNewSessionId = ()=>{
                const newSessionId = Date.now().toString();
                this._safeLocalStorage.setItem($ab94c86daa56c4b8$var$SESSION_ID_STORAGE_KEY, newSessionId);
                this._onNewSessionStarted && this._onNewSessionStarted();
                return newSessionId;
            };
            this._updateSessionExpiry = ()=>{
                const expiry = Date.now() + this._sessionExpiryTime;
                this._safeLocalStorage.setItem($ab94c86daa56c4b8$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
                return expiry;
            };
            this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
                const { _updateSessionExpiry: _updateSessionExpiry } = this;
                if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
                else {
                    if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                    this._sessionExpiryDebounceTimer = setTimeout(()=>{
                        _updateSessionExpiry();
                    }, this._sessionExpiryDebounce);
                }
            };
            this._sessionExpiryTime = options.sessionExpiryTime || $ab94c86daa56c4b8$export$285f6bddd927a06d;
            this._sessionExpiryDebounce = options.sessionExpiryDebounce || $ab94c86daa56c4b8$export$a92e915d70316eb2;
            this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $ab94c86daa56c4b8$export$de43760b2dc10c19;
            this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $ab94c86daa56c4b8$export$5702a91a6f42969f;
            this._safeLocalStorage = new (0, (0, parcelRequire("jdVRE")).default)();
        }
        getCurrentSessionId() {
            const sessionId = this._safeLocalStorage.getItem($ab94c86daa56c4b8$var$SESSION_ID_STORAGE_KEY);
            const sessionExpiry = parseInt(this._safeLocalStorage.getItem($ab94c86daa56c4b8$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
            this._debouncedUpdateSessionExpiry(sessionExpiry);
            if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
            if (!$ab94c86daa56c4b8$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
            return sessionId;
        }
    }
});
parcelRegister("ikdCB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$316ec249ab10b293$export$2e2bcd8739ae039);
    var $eLJDL;
    var $8rOMP;
    class $316ec249ab10b293$export$2e2bcd8739ae039 extends (0, (0, parcelRequire("8rOMP")).default) {
        constructor(options){
            let storageToUse;
            try {
                storageToUse = window.sessionStorage || (0, (0, parcelRequire("eLJDL")).default);
            } catch (err) {
                storageToUse = (0, (0, parcelRequire("eLJDL")).default);
            }
            super(storageToUse, options);
        }
    }
});
parcelRegister("aycns", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b69f1e110650e92$export$2e2bcd8739ae039);
    var $bXrHm = parcelRequire("bXrHm");
    var $ikdCB;
    const $9b69f1e110650e92$var$STORAGE_KEY = 'tab.id';
    class $9b69f1e110650e92$export$2e2bcd8739ae039 {
        constructor(){
            this._generateNewTabId = ()=>{
                const newTabId = (0, ($parcel$interopDefault($bXrHm)))();
                this._safeSessionStorage.setItem($9b69f1e110650e92$var$STORAGE_KEY, newTabId);
                return newTabId;
            };
            this._safeSessionStorage = new (0, (0, parcelRequire("ikdCB")).default)();
        }
        getCurrentTabId() {
            let tabId = this._safeSessionStorage.getItem($9b69f1e110650e92$var$STORAGE_KEY);
            if (!tabId) tabId = this._generateNewTabId();
            return tabId;
        }
    }
});
parcelRegister("6fgea", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1fdfde92a88309eb$export$2e2bcd8739ae039);
    var $3Hqb2 = parcelRequire("3Hqb2");
    var $bXrHm = parcelRequire("bXrHm");
    var $bpIMA;
    var $d603q;
    var $ikdCB;
    var $f8lVk;
    const $1fdfde92a88309eb$var$STORAGE_KEY = 'taskSessions';
    const $1fdfde92a88309eb$var$INIT_KEY = 'taskSessionsInit';
    const $1fdfde92a88309eb$var$AWC_PARAM_PREFIX = 'awc.';
    const $1fdfde92a88309eb$var$TASK_SESSION_RELOAD_TIME = 3000;
    class $1fdfde92a88309eb$export$2e2bcd8739ae039 {
        constructor(){
            this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($1fdfde92a88309eb$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($1fdfde92a88309eb$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($1fdfde92a88309eb$var$INIT_KEY) || '0', 10) < currentTimestamp - $1fdfde92a88309eb$var$TASK_SESSION_RELOAD_TIME;
            this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($1fdfde92a88309eb$var$AWC_PARAM_PREFIX)[1];
            this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($1fdfde92a88309eb$var$AWC_PARAM_PREFIX);
            this.getAllTaskSessions = ()=>{
                try {
                    return JSON.parse(this._safeSessionStorage.getItem($1fdfde92a88309eb$var$STORAGE_KEY) || '');
                } catch (e) {
                    return {};
                }
            };
            this._writeToSessionStorage = (taskSessions)=>{
                try {
                    this._safeSessionStorage.setItem($1fdfde92a88309eb$var$STORAGE_KEY, JSON.stringify(taskSessions));
                } catch (e) {}
            };
            this._appendTaskSessions = (newTaskSessions)=>{
                const currentState = this.getAllTaskSessions();
                const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
                this._writeToSessionStorage(newState);
            };
            this._safelyRemoveKey = (currentState, taskSessionName)=>{
                if (currentState === null) return {};
                delete currentState[taskSessionName];
                return currentState;
            };
            this.createTaskSession = (taskSessionName)=>{
                const taskSessionId = (0, ($parcel$interopDefault($bXrHm)))();
                const newTaskSessions = {};
                newTaskSessions[taskSessionName] = taskSessionId;
                this._appendTaskSessions(newTaskSessions);
                return taskSessionId;
            };
            this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
                if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
                const newTaskSessions = {};
                newTaskSessions[taskSessionName] = taskSessionId;
                this._appendTaskSessions(newTaskSessions);
            };
            this.completeTaskSession = (taskSessionName)=>{
                const currentState = this.getAllTaskSessions();
                const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
                this._writeToSessionStorage(updatedState);
            };
            this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
                const { url: url, query: query } = (0, $3Hqb2.parseUrl)(uri);
                const currentState = this.getAllTaskSessions();
                const filteredTaskSessions = includedTaskSessions ? (0, (0, parcelRequire("d603q")).pick)(currentState, includedTaskSessions) : (0, (0, parcelRequire("d603q")).omit)(currentState, Object.values((0, (0, parcelRequire("bpIMA")).originTracingType)));
                if (Object.keys(filteredTaskSessions).length === 0) return uri;
                const queryWithTaskSessions = {
                    ...(0, (0, parcelRequire("d603q")).mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$1fdfde92a88309eb$var$AWC_PARAM_PREFIX + taskSessionName),
                    ...query
                };
                return `${url}?${(0, $3Hqb2.stringify)(queryWithTaskSessions)}`;
            };
            this.stripQueryParameters = ()=>{
                const extractedTaskSessions = (0, (0, parcelRequire("d603q")).mapKeys)((0, (0, parcelRequire("f8lVk")).default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
                this._appendTaskSessions(extractedTaskSessions);
            };
            const currentTimestamp = Date.now();
            this._safeSessionStorage = new (0, (0, parcelRequire("ikdCB")).default)();
            try {
                if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                    this._writeToSessionStorage({});
                    this._safeSessionStorage.setItem($1fdfde92a88309eb$var$INIT_KEY, currentTimestamp.toString());
                }
            } catch (e) {}
        }
    }
});
parcelRegister("evS6W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e1a69a659d3e605$export$2e2bcd8739ae039);
    var $eYli8 = parcelRequire("eYli8");
    var $8FQiz;
    const $0e1a69a659d3e605$var$MAX_CACHE_SIZE = 100;
    const $0e1a69a659d3e605$var$COOKIE_NAME = (0, (0, parcelRequire("8FQiz")).AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
    const $0e1a69a659d3e605$var$DEBUG_TAG = 'synthetic';
    const $0e1a69a659d3e605$var$getDebugCookie = ()=>{
        try {
            return JSON.parse((0, ($parcel$interopDefault($eYli8))).get($0e1a69a659d3e605$var$COOKIE_NAME) || 'false');
        } catch (error) {
            (0, ($parcel$interopDefault($eYli8))).remove($0e1a69a659d3e605$var$COOKIE_NAME);
        }
        return false;
    };
    class $0e1a69a659d3e605$var$TestingCache {
        constructor(){
            this._bind = ()=>{
                if (typeof window === 'undefined' || window.testAnalytics) return;
                window.testAnalytics = {
                    eventCache: [],
                    events: ()=>window.testAnalytics.eventCache,
                    clear: ()=>{
                        window.testAnalytics.eventCache = [];
                        try {
                            localStorage.removeItem('awc.ui.viewed.last.sent');
                            localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                            localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                            localStorage.removeItem('awc-local.ui.viewed.last.sent');
                        } catch (_error) {}
                    }
                };
            };
            this._cache = (event)=>{
                if (typeof window === 'undefined') return;
                if (window.testAnalytics.eventCache.length >= $0e1a69a659d3e605$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
                window.testAnalytics.eventCache.push(event);
            };
            this._shouldCacheEvent = ()=>this._isDebugCookieEnabled;
            this.saveEvent = (event)=>{
                if (event && this._shouldCacheEvent()) {
                    if (!window.testAnalytics) this._bind();
                    if (event.tags instanceof Array) event.tags.push($0e1a69a659d3e605$var$DEBUG_TAG);
                    else event.tags = [
                        $0e1a69a659d3e605$var$DEBUG_TAG
                    ];
                    this._cache(event);
                }
            };
            this._isDebugCookieEnabled = $0e1a69a659d3e605$var$getDebugCookie();
            if (this._isDebugCookieEnabled) this._bind();
        }
    }
    var $0e1a69a659d3e605$export$2e2bcd8739ae039 = $0e1a69a659d3e605$var$TestingCache;
});
parcelRegister("aR61w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f78ba0d3d9f07e7f$export$2e2bcd8739ae039);
    var $bpIMA;
    var $jdVRE;
    const $f78ba0d3d9f07e7f$var$DEFAULT_DELAY = 2000;
    const $f78ba0d3d9f07e7f$var$DEFAULT_THROTTLE = 3600000;
    const $f78ba0d3d9f07e7f$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
    class $f78ba0d3d9f07e7f$export$2e2bcd8739ae039 {
        constructor(productInfo, getContext, onEvent, settings = {}){
            this.start = ()=>{
                this._startInterval();
                this._bindEventListeners();
            };
            this.stop = ()=>{
                this._stopInterval();
                this._unbindEventListeners();
            };
            this.resetTimers = ()=>{
                if (this._intervalId) {
                    this.stop();
                    this.start();
                }
            };
            this._bindEventListeners = ()=>{
                if (typeof window !== 'undefined') {
                    window.addEventListener('focus', this._focusListener);
                    window.addEventListener('blur', this._blurListener);
                }
            };
            this._unbindEventListeners = ()=>{
                if (typeof window !== 'undefined') {
                    window.removeEventListener('focus', this._focusListener);
                    window.removeEventListener('blur', this._blurListener);
                }
            };
            this._startInterval = ()=>{
                clearInterval(this._intervalId);
                this._intervalId = setInterval(this._handleInterval, this._delay);
            };
            this._stopInterval = ()=>{
                if (this._intervalId) {
                    clearInterval(this._intervalId);
                    this._intervalId = null;
                }
            };
            this._getProductKey = (product, subproduct)=>{
                let productKey = product;
                if (subproduct) productKey += `-${subproduct}`;
                return productKey;
            };
            this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
                const json = this._parseLocalStorageData() || {};
                const u = json[userId] || {};
                const t = u[tenantId] || {};
                const p = t[productKey] || null;
                return p;
            };
            this._parseLocalStorageData = ()=>{
                const data = this._safeLocalStorage.getItem(this._storageKey);
                try {
                    return JSON.parse(data || '');
                } catch (error) {
                    this._safeLocalStorage.removeItem(this._storageKey);
                    return null;
                }
            };
            this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
                const json = this._parseLocalStorageData() || {};
                const u = json[userId] || {};
                const t = u[tenantId] || {};
                t[productKey] = Date.now();
                u[tenantId] = t;
                json[userId] = u;
                this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
            };
            this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
                if (!document.hasFocus()) return false;
                if (tenantIdType !== (0, (0, parcelRequire("bpIMA")).tenantType).NONE && !tenantId || !userId) return false;
                const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
                return sinceLastSent > this._throttle;
            };
            this._handleInterval = ()=>{
                const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
                this._sendEvent(this._product, context);
                if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
            };
            this._sendEvent = (product, context, isEmbeddedProduct = false)=>{
                const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
                const productKey = this._getProductKey(product, subproduct);
                if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                    this._onEvent(event);
                }
            };
            this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
                const event = {
                    product: product,
                    source: 'ui',
                    action: 'viewed',
                    actionSubject: 'ui',
                    attributes: extraAttributes
                };
                if (isEmbeddedProduct) {
                    event.subproduct = null;
                    event.version = null;
                    event.attributes = {
                        ...event.attributes,
                        embeddedInEnv: this._productInfo.env,
                        embeddedInProduct: this._productInfo.product,
                        embeddedInSubproduct: subproduct,
                        embeddedInVersion: this._productInfo.version,
                        embeddedInOrigin: this._productInfo.origin,
                        embeddedInPlatform: this._productInfo.platform
                    };
                }
                if (lastScreenEvent) event.attributes = {
                    ...event.attributes,
                    lastScreenEvent: {
                        name: lastScreenEvent.name,
                        attributes: lastScreenEvent.attributes
                    }
                };
                return event;
            };
            if (!productInfo) throw new Error('Missing productInfo');
            if (!productInfo.product) throw new Error('Missing productInfo.product');
            if (!getContext) throw new Error('Missing getContext callback');
            if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
            if (!onEvent) throw new Error('Missing onEvent callback');
            if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
            this._productInfo = productInfo;
            this._product = productInfo.product;
            this._getContext = getContext;
            this._onEvent = onEvent;
            this._delay = settings.delay || $f78ba0d3d9f07e7f$var$DEFAULT_DELAY;
            this._throttle = settings.throttle || $f78ba0d3d9f07e7f$var$DEFAULT_THROTTLE;
            this._storageKey = settings.storageKey || $f78ba0d3d9f07e7f$var$DEFAULT_STORAGE_KEY;
            this._safeLocalStorage = new (0, (0, parcelRequire("jdVRE")).default)({
                envPrefix: this._productInfo.env
            });
            this._focusListener = ()=>{
                this._startInterval();
            };
            this._blurListener = ()=>{
                this._stopInterval();
            };
        }
    }
});
parcelRegister("ef7xh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9f967559626837d$export$2e2bcd8739ae039);
    function $e9f967559626837d$export$2e2bcd8739ae039(callback, event) {
        if (!callback || typeof callback !== 'function') return null;
        return ()=>{
            callback(event);
        };
    }
});
parcelRegister("bE87f", function(module, exports) {
    $parcel$export(module.exports, "XIDPromise", ()=>$cd3be339e1d5d2ef$export$fbe53bbbe682bcdd);
    var $60rIW;
    const $cd3be339e1d5d2ef$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
        if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
            const timeoutPromise = ()=>{
                return new Promise((resolve)=>{
                    setTimeout(()=>resolve(()=>(0, (0, parcelRequire("60rIW")).createTimeoutXid)()), (0, (0, parcelRequire("60rIW")).XID_TIMEOUT));
                });
            };
            const xidPromise = ()=>{
                return xidPromiseFn().catch(()=>()=>(0, (0, parcelRequire("60rIW")).createUnknownXid)());
            };
            return Promise.race([
                xidPromise(),
                timeoutPromise()
            ]);
        }
        return undefined;
    };
});
parcelRegister("60rIW", function(module, exports) {
    $parcel$export(module.exports, "XID_TIMEOUT", ()=>$7741cf8efd4cb8a4$export$545bcbd53afabfa3);
    $parcel$export(module.exports, "createTimeoutXid", ()=>$7741cf8efd4cb8a4$export$af4087e36d63846);
    $parcel$export(module.exports, "createUnknownXid", ()=>$7741cf8efd4cb8a4$export$fa341d0c750d705b);
    var $4tMKS;
    const $7741cf8efd4cb8a4$export$545bcbd53afabfa3 = 5000;
    const $7741cf8efd4cb8a4$export$af4087e36d63846 = ()=>[
            {
                type: (0, (0, parcelRequire("4tMKS")).XIDItemType).XC,
                state: 'TIMEOUT'
            },
            {
                type: (0, (0, parcelRequire("4tMKS")).XIDItemType).UID,
                state: 'TIMEOUT'
            }
        ];
    const $7741cf8efd4cb8a4$export$fa341d0c750d705b = ()=>[
            {
                type: (0, (0, parcelRequire("4tMKS")).XIDItemType).XC,
                state: 'UNKNOWN'
            },
            {
                type: (0, (0, parcelRequire("4tMKS")).XIDItemType).UID,
                state: 'UNKNOWN'
            }
        ];
});
parcelRegister("4tMKS", function(module, exports) {
    $parcel$export(module.exports, "XIDItemType", ()=>$662d01d04a212b43$export$92ca0438bcb0d396);
    var $662d01d04a212b43$export$92ca0438bcb0d396;
    (function(XIDItemType) {
        XIDItemType["XC"] = "xc";
        XIDItemType["UID"] = "uid";
    })($662d01d04a212b43$export$92ca0438bcb0d396 || ($662d01d04a212b43$export$92ca0438bcb0d396 = {}));
    var $662d01d04a212b43$export$c9079017d1f5aab9;
    (function(XIDState) {
        XIDState["NEW"] = "NEW";
        XIDState["CHANGED"] = "CHANGED";
        XIDState["EXISTING"] = "EXISTING";
        XIDState["TIMEOUT"] = "TIMEOUT";
        XIDState["ERROR"] = "ERROR";
        XIDState["UNAVAILABLE"] = "UNAVAILABLE";
        XIDState["MALFORMED"] = "MALFORMED";
        XIDState["UNKNOWN"] = "UNKNOWN";
    })($662d01d04a212b43$export$c9079017d1f5aab9 || ($662d01d04a212b43$export$c9079017d1f5aab9 = {}));
});
parcelRegister("70qxv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$351022eecb95f10a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "FeatureGateEnvironment", ()=>(parcelRequire("86Qvr")).FeatureGateEnvironment);
    var $1doJz = parcelRequire("1doJz");
    var $1WqFo;
    var $bNypW;
    var $bygye;
    var $86Qvr;
    var $hRhhD;
    const $351022eecb95f10a$var$DEFAULT_CLIENT_KEY = 'client-default-key';
    const $351022eecb95f10a$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/';
    class $351022eecb95f10a$var$FeatureGates {
        static{
            this.initPromise = null;
        }
        static{
            this.initCompleted = false;
        }
        static{
            this.initWithDefaults = false;
        }
        static{
            this.hasGetExperimentErrorOccurred = false;
        }
        static{
            this.hasGetExperimentValueErrorOccurred = false;
        }
        static{
            this.hasGetLayerErrorOccurred = false;
        }
        static{
            this.hasGetLayerValueErrorOccurred = false;
        }
        static{
            this.hasCheckGateErrorOccurred = false;
        }
        static{
            this.subscriptions = new (0, (0, parcelRequire("bNypW")).default)();
        }
        static async initialize(clientOptions, identifiers, customAttributes) {
            const clientOptionsWithDefaults = this.getOptionsWithDefaults(clientOptions);
            if ($351022eecb95f10a$var$FeatureGates.initPromise) {
                if (!$351022eecb95f10a$var$FeatureGates.shallowEquals(clientOptionsWithDefaults, $351022eecb95f10a$var$FeatureGates.initOptions)) console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                return $351022eecb95f10a$var$FeatureGates.initPromise;
            }
            const startTime = performance.now();
            $351022eecb95f10a$var$FeatureGates.initOptions = clientOptionsWithDefaults;
            $351022eecb95f10a$var$FeatureGates.initPromise = $351022eecb95f10a$var$FeatureGates.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
                $351022eecb95f10a$var$FeatureGates.initCompleted = true;
                $351022eecb95f10a$var$FeatureGates.initWithDefaults = true;
            }).finally(()=>{
                const endTime = performance.now();
                const totalTime = endTime - startTime;
                $351022eecb95f10a$var$FeatureGates.fireClientEvent(startTime, totalTime, 'initialize', $351022eecb95f10a$var$FeatureGates.initCompleted, clientOptionsWithDefaults.apiKey);
            });
            return $351022eecb95f10a$var$FeatureGates.initPromise;
        }
        static async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
            const clientOptionsWithDefaults = this.getOptionsWithDefaults(clientOptions);
            if ($351022eecb95f10a$var$FeatureGates.initPromise) {
                if (!$351022eecb95f10a$var$FeatureGates.shallowEquals(clientOptionsWithDefaults, $351022eecb95f10a$var$FeatureGates.initOptions)) console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                return $351022eecb95f10a$var$FeatureGates.initPromise;
            }
            const startTime = performance.now();
            $351022eecb95f10a$var$FeatureGates.initOptions = clientOptionsWithDefaults;
            $351022eecb95f10a$var$FeatureGates.provider = provider;
            $351022eecb95f10a$var$FeatureGates.provider.setClientVersion((0, (0, parcelRequire("hRhhD")).CLIENT_VERSION));
            if ($351022eecb95f10a$var$FeatureGates.provider.setApplyUpdateCallback) $351022eecb95f10a$var$FeatureGates.provider.setApplyUpdateCallback(this.applyUpdateCallback);
            $351022eecb95f10a$var$FeatureGates.initPromise = $351022eecb95f10a$var$FeatureGates.initWithProvider(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
                $351022eecb95f10a$var$FeatureGates.initCompleted = true;
                $351022eecb95f10a$var$FeatureGates.initWithDefaults = true;
            }).finally(()=>{
                const endTime = performance.now();
                const totalTime = endTime - startTime;
                $351022eecb95f10a$var$FeatureGates.fireClientEvent(startTime, totalTime, 'initializeWithProvider', $351022eecb95f10a$var$FeatureGates.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
            });
            return $351022eecb95f10a$var$FeatureGates.initPromise;
        }
        static applyUpdateCallback(experimentsResult) {
            try {
                if ($351022eecb95f10a$var$FeatureGates.initCompleted || $351022eecb95f10a$var$FeatureGates.initWithDefaults) {
                    (0, ($parcel$interopDefault($1doJz))).setInitializeValues(experimentsResult.experimentValues);
                    $351022eecb95f10a$var$FeatureGates.subscriptions.anyUpdated();
                }
            } catch (error) {
                console.warn('Error when attempting to apply update', error);
            }
        }
        static fireClientEvent(startTime, totalTime, action, success, apiKey) {
            $351022eecb95f10a$var$FeatureGates.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
                const attributes = {
                    targetApp: $351022eecb95f10a$var$FeatureGates.initOptions.targetApp,
                    clientVersion: (0, (0, parcelRequire("hRhhD")).CLIENT_VERSION),
                    success: success,
                    startTime: startTime,
                    totalTime: totalTime,
                    ...apiKey && {
                        apiKey: apiKey
                    }
                };
                analyticsWebClient.sendOperationalEvent({
                    action: action,
                    actionSubject: 'featureGatesClient',
                    attributes: attributes,
                    tags: [
                        'measurement'
                    ],
                    source: '@atlaskit/feature-gate-js-client'
                });
            }).catch((err)=>{
                if ($351022eecb95f10a$var$FeatureGates.initOptions.environment !== (0, (0, parcelRequire("86Qvr")).FeatureGateEnvironment).Production) console.error('Analytics web client promise did not resolve', err);
            });
        }
        static async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
            const clientOptionsWithDefaults = this.getOptionsWithDefaults(clientOptions);
            if ($351022eecb95f10a$var$FeatureGates.initPromise) {
                if (!$351022eecb95f10a$var$FeatureGates.shallowEquals(clientOptionsWithDefaults, $351022eecb95f10a$var$FeatureGates.initOptions)) console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                return $351022eecb95f10a$var$FeatureGates.initPromise;
            }
            const startTime = performance.now();
            $351022eecb95f10a$var$FeatureGates.initOptions = clientOptionsWithDefaults;
            $351022eecb95f10a$var$FeatureGates.initPromise = $351022eecb95f10a$var$FeatureGates.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
                $351022eecb95f10a$var$FeatureGates.initCompleted = true;
                $351022eecb95f10a$var$FeatureGates.initWithDefaults = true;
            }).finally(()=>{
                const endTime = performance.now();
                const totalTime = endTime - startTime;
                $351022eecb95f10a$var$FeatureGates.fireClientEvent(startTime, totalTime, 'initializeFromValues', $351022eecb95f10a$var$FeatureGates.initCompleted);
            });
            return $351022eecb95f10a$var$FeatureGates.initPromise;
        }
        static async updateUser(fetchOptions, identifiers, customAttributes) {
            const fetchOptionsWithDefaults = this.getOptionsWithDefaults(fetchOptions);
            const initializeValuesProducer = ()=>(0, (0, parcelRequire("bygye")).default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                        experimentValues: experimentValues,
                        customAttributesFromFetch: customAttributes
                    }));
            await $351022eecb95f10a$var$FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
        }
        static async updateUserWithProvider(identifiers, customAttributes) {
            if (!$351022eecb95f10a$var$FeatureGates.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
            await $351022eecb95f10a$var$FeatureGates.provider.setProfile($351022eecb95f10a$var$FeatureGates.initOptions, identifiers, customAttributes);
            await $351022eecb95f10a$var$FeatureGates.updateUserUsingInitializeValuesProducer(()=>$351022eecb95f10a$var$FeatureGates.provider.getExperimentValues(), identifiers, customAttributes);
        }
        static async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
            const initializeValuesProducer = ()=>Promise.resolve({
                    experimentValues: initializeValues,
                    customAttributesFromFetch: customAttributes
                });
            await $351022eecb95f10a$var$FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
        }
        static initializeCalled() {
            return $351022eecb95f10a$var$FeatureGates.initPromise != null;
        }
        static initializeCompleted() {
            return $351022eecb95f10a$var$FeatureGates.initCompleted;
        }
        static checkGate(gateName, options = {}) {
            try {
                if (window && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
                    const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                    if (overrideValue !== undefined) return overrideValue;
                }
                const { fireGateExposure: fireGateExposure = true } = options;
                const evalMethod = fireGateExposure ? (0, ($parcel$interopDefault($1doJz))).checkGate.bind((0, ($parcel$interopDefault($1doJz)))) : (0, ($parcel$interopDefault($1doJz))).checkGateWithExposureLoggingDisabled.bind((0, ($parcel$interopDefault($1doJz))));
                return evalMethod(gateName);
            } catch (error) {
                if (!$351022eecb95f10a$var$FeatureGates.hasCheckGateErrorOccurred) {
                    console.warn({
                        msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                        gateName: gateName,
                        error: error
                    });
                    $351022eecb95f10a$var$FeatureGates.hasCheckGateErrorOccurred = true;
                }
                return false;
            }
        }
        static manuallyLogGateExposure(gateName) {
            (0, ($parcel$interopDefault($1doJz))).manuallyLogGateExposure(gateName);
        }
        static getExperiment(experimentName, options = {}) {
            try {
                const { fireExperimentExposure: fireExperimentExposure = true } = options;
                const evalMethod = fireExperimentExposure ? (0, ($parcel$interopDefault($1doJz))).getExperiment.bind((0, ($parcel$interopDefault($1doJz)))) : (0, ($parcel$interopDefault($1doJz))).getExperimentWithExposureLoggingDisabled.bind((0, ($parcel$interopDefault($1doJz))));
                return evalMethod(experimentName);
            } catch (error) {
                if (!$351022eecb95f10a$var$FeatureGates.hasGetExperimentErrorOccurred) {
                    console.warn({
                        msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                        experimentName: experimentName,
                        error: error
                    });
                    $351022eecb95f10a$var$FeatureGates.hasGetExperimentErrorOccurred = true;
                }
                return new (0, $1doJz.DynamicConfig)(experimentName, {}, '', {
                    time: Date.now(),
                    reason: (0, $1doJz.EvaluationReason).Error
                });
            }
        }
        static getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
            if (window && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
                const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
            }
            const experiment = $351022eecb95f10a$var$FeatureGates.getExperiment(experimentName, options);
            try {
                const { typeGuard: typeGuard } = options;
                return experiment.get(parameterName, defaultValue, typeGuard);
            } catch (error) {
                if (!$351022eecb95f10a$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                    console.warn({
                        msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                        experimentName: experimentName,
                        defaultValue: defaultValue,
                        options: options,
                        error: error
                    });
                    $351022eecb95f10a$var$FeatureGates.hasGetExperimentValueErrorOccurred = true;
                }
                return defaultValue;
            }
        }
        static manuallyLogExperimentExposure(experimentName) {
            (0, ($parcel$interopDefault($1doJz))).manuallyLogExperimentExposure(experimentName);
        }
        static manuallyLogLayerExposure(layerName, parameterName) {
            (0, ($parcel$interopDefault($1doJz))).manuallyLogLayerParameterExposure(layerName, parameterName);
        }
        static shutdownStatsig() {
            (0, ($parcel$interopDefault($1doJz))).shutdown();
        }
        static overrideGate(gateName, value) {
            (0, ($parcel$interopDefault($1doJz))).overrideGate(gateName, value);
            $351022eecb95f10a$var$FeatureGates.subscriptions.anyUpdated();
        }
        static clearGateOverride(gateName) {
            (0, ($parcel$interopDefault($1doJz))).overrideGate(gateName, null);
            $351022eecb95f10a$var$FeatureGates.subscriptions.anyUpdated();
        }
        static overrideConfig(experimentName, values) {
            (0, ($parcel$interopDefault($1doJz))).overrideConfig(experimentName, values);
            $351022eecb95f10a$var$FeatureGates.subscriptions.anyUpdated();
        }
        static clearConfigOverride(experimentName) {
            (0, ($parcel$interopDefault($1doJz))).overrideConfig(experimentName, null);
            $351022eecb95f10a$var$FeatureGates.subscriptions.anyUpdated();
        }
        static setOverrides(overrides) {
            (0, ($parcel$interopDefault($1doJz))).setOverrides({
                gates: {},
                configs: {},
                layers: {},
                ...overrides
            });
            $351022eecb95f10a$var$FeatureGates.subscriptions.anyUpdated();
        }
        static getOverrides() {
            return (0, ($parcel$interopDefault($1doJz))).getOverrides();
        }
        static clearAllOverrides() {
            (0, ($parcel$interopDefault($1doJz))).setOverrides(null);
            $351022eecb95f10a$var$FeatureGates.subscriptions.anyUpdated();
        }
        static isCurrentUser(identifiers, customAttributes) {
            return $351022eecb95f10a$var$FeatureGates.shallowEquals($351022eecb95f10a$var$FeatureGates.currentIdentifiers, identifiers) && $351022eecb95f10a$var$FeatureGates.shallowEquals($351022eecb95f10a$var$FeatureGates.currentAttributes, customAttributes);
        }
        static onGateUpdated(gateName, callback, options = {}) {
            const wrapCallback = (value)=>{
                const { fireGateExposure: fireGateExposure = true } = options;
                if (fireGateExposure) $351022eecb95f10a$var$FeatureGates.manuallyLogGateExposure(gateName);
                try {
                    callback(value);
                } catch (error) {
                    console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
                }
            };
            return $351022eecb95f10a$var$FeatureGates.subscriptions.onGateUpdated(gateName, wrapCallback, $351022eecb95f10a$var$FeatureGates.checkGate, options);
        }
        static onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
            const wrapCallback = (value)=>{
                const { fireExperimentExposure: fireExperimentExposure = true } = options;
                if (fireExperimentExposure) $351022eecb95f10a$var$FeatureGates.manuallyLogExperimentExposure(experimentName);
                try {
                    callback(value);
                } catch (error) {
                    console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
                }
            };
            return $351022eecb95f10a$var$FeatureGates.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, $351022eecb95f10a$var$FeatureGates.getExperimentValue, options);
        }
        static onAnyUpdated(callback) {
            return $351022eecb95f10a$var$FeatureGates.subscriptions?.onAnyUpdated(callback);
        }
        static async init(clientOptions, identifiers, customAttributes) {
            const fromValuesClientOptions = {
                ...clientOptions
            };
            let experimentValues;
            let customAttributesFromResult;
            try {
                const clientSdkKeyPromise = (0, (0, parcelRequire("bygye")).default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
                const experimentValuesPromise = (0, (0, parcelRequire("bygye")).default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
                const [, experimentValuesResult] = await Promise.all([
                    clientSdkKeyPromise,
                    experimentValuesPromise
                ]);
                experimentValues = experimentValuesResult.experimentValues;
                customAttributesFromResult = experimentValuesResult.customAttributes;
            } catch (error) {
                if (error instanceof Error) console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
                console.warn(`Initialising Statsig client without values`);
                await $351022eecb95f10a$var$FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                throw error;
            }
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
        }
        static async initWithProvider(baseClientOptions, identifiers, customAttributes) {
            const fromValuesClientOptions = {
                ...baseClientOptions,
                disableCurrentPageLogging: true
            };
            let experimentValues;
            let customAttributesFromResult;
            try {
                await $351022eecb95f10a$var$FeatureGates.provider.setProfile(baseClientOptions, identifiers, customAttributes);
                const clientSdkKeyPromise = $351022eecb95f10a$var$FeatureGates.provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
                const experimentValuesPromise = $351022eecb95f10a$var$FeatureGates.provider.getExperimentValues();
                const [, experimentValuesResult] = await Promise.all([
                    clientSdkKeyPromise,
                    experimentValuesPromise
                ]);
                experimentValues = experimentValuesResult.experimentValues;
                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
            } catch (error) {
                if (error instanceof Error) console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
                console.warn(`Initialising Statsig client without values`);
                await $351022eecb95f10a$var$FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                throw error;
            }
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
        }
        static async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
            const user = this.toStatsigUser(identifiers, customAttributes);
            $351022eecb95f10a$var$FeatureGates.currentIdentifiers = identifiers;
            $351022eecb95f10a$var$FeatureGates.currentAttributes = customAttributes;
            if (!clientOptions.sdkKey) clientOptions.sdkKey = $351022eecb95f10a$var$DEFAULT_CLIENT_KEY;
            if (!clientOptions.eventLoggingApi) clientOptions.eventLoggingApi = $351022eecb95f10a$var$DEFAULT_EVENT_LOGGING_API;
            if (clientOptions.perimeter === (0, (0, parcelRequire("86Qvr")).PerimeterType).FEDRAMP_MODERATE) clientOptions.disableAllLogging = true;
            const { sdkKey: sdkKey } = clientOptions;
            const statsigOptions = this.toStatsigOptions(clientOptions, initializeValues);
            try {
                await (0, ($parcel$interopDefault($1doJz))).initialize(sdkKey, user, statsigOptions);
            } catch (error) {
                if (error instanceof Error) console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
                console.warn(`Initialising Statsig client with default sdk key and without values`);
                await (0, ($parcel$interopDefault($1doJz))).initialize($351022eecb95f10a$var$DEFAULT_CLIENT_KEY, user, {
                    ...statsigOptions,
                    initializeValues: {}
                });
                $351022eecb95f10a$var$FeatureGates.initWithDefaults = true;
                throw error;
            }
        }
        static toStatsigUser(identifiers, customAttributes) {
            const user = {
                customIDs: identifiers,
                custom: customAttributes
            };
            if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
            return user;
        }
        static async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
            if (!$351022eecb95f10a$var$FeatureGates.initPromise) throw new Error('The FeatureGates client must be initialized before you can update the user.');
            if ($351022eecb95f10a$var$FeatureGates.isCurrentUser(identifiers, customAttributes)) return $351022eecb95f10a$var$FeatureGates.initPromise;
            const originalInitPromise = $351022eecb95f10a$var$FeatureGates.initPromise;
            try {
                await $351022eecb95f10a$var$FeatureGates.initPromise;
            } catch (err) {}
            const initializeValuesPromise = getInitializeValues();
            const updateUserPromise = $351022eecb95f10a$var$FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
            $351022eecb95f10a$var$FeatureGates.initPromise = updateUserPromise.catch(async ()=>{
                $351022eecb95f10a$var$FeatureGates.initPromise = originalInitPromise;
                if ($351022eecb95f10a$var$FeatureGates.provider) await $351022eecb95f10a$var$FeatureGates.provider.setProfile($351022eecb95f10a$var$FeatureGates.initOptions, $351022eecb95f10a$var$FeatureGates.currentIdentifiers, $351022eecb95f10a$var$FeatureGates.currentAttributes);
            });
            return updateUserPromise;
        }
        static async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
            let initializeValues, user;
            try {
                initializeValues = await initializeValuesPromise;
                user = $351022eecb95f10a$var$FeatureGates.toStatsigUser(identifiers, initializeValues.customAttributesFromFetch);
            } catch (err) {
                const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
                $351022eecb95f10a$var$FeatureGates.initOptions.updateUserCompletionCallback?.(false, errMsg);
                throw err;
            }
            const success = (0, ($parcel$interopDefault($1doJz))).updateUserWithValues(user, initializeValues.experimentValues);
            if (success) {
                $351022eecb95f10a$var$FeatureGates.currentIdentifiers = identifiers;
                $351022eecb95f10a$var$FeatureGates.currentAttributes = customAttributes;
                $351022eecb95f10a$var$FeatureGates.subscriptions.anyUpdated();
            } else throw new Error('Failed to update user. An unexpected error occured.');
        }
        static toStatsigOptions(options, initializeValues) {
            const { sdkKey: sdkKey, updateUserCompletionCallback: updateUserCompletionCallback, perimeter: perimeter, ...restClientOptions } = options;
            return {
                ...restClientOptions,
                initializeValues: initializeValues,
                environment: {
                    tier: options.environment
                },
                disableCurrentPageLogging: true,
                ...options.updateUserCompletionCallback && {
                    updateUserCompletionCallback: $351022eecb95f10a$var$FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
                }
            };
        }
        static toStatsigUpdateUserCompletionCallback(callback) {
            return (_duration, success, message)=>{
                callback(success, message);
            };
        }
        static shallowEquals(objectA, objectB) {
            if (!objectA && !objectB) return true;
            if (!objectA || !objectB) return false;
            const aEntries = Object.entries(objectA);
            const bEntries = Object.entries(objectB);
            if (aEntries.length !== bEntries.length) return false;
            const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
            aEntries.sort(ascendingKeyOrder);
            bEntries.sort(ascendingKeyOrder);
            for(let i = 0; i < aEntries.length; i++){
                const [, aValue] = aEntries[i];
                const [, bValue] = bEntries[i];
                if (aValue !== bValue) return false;
            }
            return true;
        }
        static getPackageVersion() {
            return 0, (0, parcelRequire("hRhhD")).CLIENT_VERSION;
        }
        static getLayer(layerName, options = {}) {
            try {
                const { fireLayerExposure: fireLayerExposure = true } = options;
                const evalMethod = fireLayerExposure ? (0, ($parcel$interopDefault($1doJz))).getLayer.bind((0, ($parcel$interopDefault($1doJz)))) : (0, ($parcel$interopDefault($1doJz))).getLayerWithExposureLoggingDisabled.bind((0, ($parcel$interopDefault($1doJz))));
                return evalMethod(layerName);
            } catch (error) {
                if (!$351022eecb95f10a$var$FeatureGates.hasGetLayerErrorOccurred) {
                    console.warn({
                        msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                        layerName: layerName,
                        error: error
                    });
                    $351022eecb95f10a$var$FeatureGates.hasGetLayerErrorOccurred = true;
                }
                return (0, $1doJz.Layer)._create(layerName, {}, '', {
                    time: Date.now(),
                    reason: (0, $1doJz.EvaluationReason).Error
                });
            }
        }
        static getLayerValue(layerName, parameterName, defaultValue, options = {}) {
            const layer = $351022eecb95f10a$var$FeatureGates.getLayer(layerName, options);
            try {
                const { typeGuard: typeGuard } = options;
                return layer.get(parameterName, defaultValue, typeGuard);
            } catch (error) {
                if (!$351022eecb95f10a$var$FeatureGates.hasGetLayerValueErrorOccurred) {
                    console.warn({
                        msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                        layerName: layerName,
                        defaultValue: defaultValue,
                        options: options,
                        error: error
                    });
                    $351022eecb95f10a$var$FeatureGates.hasGetLayerValueErrorOccurred = true;
                }
                return defaultValue;
            }
        }
        static getOptionsWithDefaults(options) {
            return {
                perimeter: $351022eecb95f10a$var$FeatureGates.getDefaultPerimeter(),
                ...options
            };
        }
        static getDefaultPerimeter() {
            return (0, (0, parcelRequire("1WqFo")).isFedRamp)() ? (0, (0, parcelRequire("86Qvr")).PerimeterType).FEDRAMP_MODERATE : (0, (0, parcelRequire("86Qvr")).PerimeterType).COMMERCIAL;
        }
    }
    let $351022eecb95f10a$var$boundFGJS = $351022eecb95f10a$var$FeatureGates;
    if (typeof window !== 'undefined') {
        if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $351022eecb95f10a$var$FeatureGates;
        else {
            $351022eecb95f10a$var$boundFGJS = window.__FEATUREGATES_JS__;
            const boundVersion = $351022eecb95f10a$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
            if (boundVersion !== (0, (0, parcelRequire("hRhhD")).CLIENT_VERSION)) {
                const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, (0, parcelRequire("hRhhD")).CLIENT_VERSION)} was loading.`;
                console.warn(message);
            }
        }
    }
    var $351022eecb95f10a$export$2e2bcd8739ae039 = $351022eecb95f10a$var$boundFGJS;
});
parcelRegister("bNypW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33734c40a1b5f682$export$2e2bcd8739ae039);
    var $7n9mn = parcelRequire("7n9mn");
    const $33734c40a1b5f682$export$a66cbd9b2289cd78 = '@all-features';
    class $33734c40a1b5f682$export$2e2bcd8739ae039 {
        constructor(){
            this.eventToValue = new Map();
            this.emitter = new (0, $7n9mn.EventEmitter2)();
        }
        onGateUpdated(gateName, callback, checkGate, options) {
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
            const wrapCallback = ()=>{
                const value = checkGate(gateName, {
                    ...options,
                    fireGateExposure: false
                });
                const existingValue = this.eventToValue.get(callback);
                if (existingValue !== value) {
                    this.eventToValue.set(callback, value);
                    callback(value);
                }
            };
            this.emitter.on(gateName, wrapCallback);
            return ()=>{
                this.emitter.off(gateName, wrapCallback);
            };
        }
        onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
            const experimentEventName = `${experimentName}.${parameterName}`;
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
            const wrapCallback = ()=>{
                const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                    ...options,
                    fireExperimentExposure: false
                });
                const existingValue = this.eventToValue.get(callback);
                if (existingValue !== value) {
                    this.eventToValue.set(callback, value);
                    callback(value);
                }
            };
            this.emitter.on(experimentEventName, wrapCallback);
            return ()=>{
                this.emitter.off(experimentEventName, wrapCallback);
            };
        }
        onAnyUpdated(callback) {
            this.emitter.on($33734c40a1b5f682$export$a66cbd9b2289cd78, callback);
            return ()=>{
                this.emitter.off($33734c40a1b5f682$export$a66cbd9b2289cd78, callback);
            };
        }
        anyUpdated() {
            this.emitter.emit($33734c40a1b5f682$export$a66cbd9b2289cd78);
            this.emitter.eventNames().filter((name)=>name !== $33734c40a1b5f682$export$a66cbd9b2289cd78).forEach((event)=>{
                this.emitter.emit(event);
            });
        }
    }
});
parcelRegister("bygye", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a0fd7b02d5cb037$export$2e2bcd8739ae039);
    var $86Qvr;
    var $hRhhD;
    var $9OeqF;
    const $0a0fd7b02d5cb037$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
    const $0a0fd7b02d5cb037$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
    const $0a0fd7b02d5cb037$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
    const $0a0fd7b02d5cb037$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
    const $0a0fd7b02d5cb037$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
    const $0a0fd7b02d5cb037$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
    const $0a0fd7b02d5cb037$export$450bd8fb2a6d7ace = '/gateway/api/flags';
    class $0a0fd7b02d5cb037$export$2e2bcd8739ae039 {
        static async fetchClientSdk(fetcherOptions) {
            const { targetApp: targetApp } = fetcherOptions;
            const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
            try {
                return await this.fetchRequest(url, 'GET', fetcherOptions);
            } catch (error) {
                if (error instanceof Error) throw error;
                throw Error('Failed to retrieve client sdk key');
            }
        }
        static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
            const requestBody = {
                identifiers: identifiers,
                customAttributes: customAttributes,
                targetApp: fetcherOptions.targetApp
            };
            try {
                return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
            } catch (error) {
                if (error instanceof Error) throw error;
                throw Error('Failed to retrieve experiment values');
            }
        }
        static async handleResponseError(response) {
            if (!response.ok) {
                const body = await response.text();
                throw new (0, (0, parcelRequire("9OeqF")).ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
            }
            if (response.status === 204) throw new (0, (0, parcelRequire("9OeqF")).ResponseError)('Unexpected 204 response');
        }
        static async extractResponseBody(response) {
            const value = await response.text();
            return JSON.parse(value);
        }
        static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter) {
            if (useGatewayUrl) return $0a0fd7b02d5cb037$export$450bd8fb2a6d7ace;
            if (perimeter === (0, (0, parcelRequire("86Qvr")).PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                case (0, (0, parcelRequire("86Qvr")).FeatureGateEnvironment).Production:
                    return $0a0fd7b02d5cb037$export$18c93900db9358a4;
                case (0, (0, parcelRequire("86Qvr")).FeatureGateEnvironment).Staging:
                    return $0a0fd7b02d5cb037$export$1a401a0da8da3565;
                default:
                    throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
            }
            else if (perimeter === (0, (0, parcelRequire("86Qvr")).PerimeterType).COMMERCIAL) switch(serviceEnv){
                case (0, (0, parcelRequire("86Qvr")).FeatureGateEnvironment).Development:
                    return $0a0fd7b02d5cb037$export$f058dbf75c3bc647;
                case (0, (0, parcelRequire("86Qvr")).FeatureGateEnvironment).Staging:
                    return $0a0fd7b02d5cb037$export$942ba04389b0d5a2;
                default:
                    return $0a0fd7b02d5cb037$export$250a58ecde616daa;
            }
            else throw new Error(`Invalid perimeter "${perimeter}"`);
        }
        static async fetchRequest(path, method, fetcherOptions, body) {
            const baseUrl = $0a0fd7b02d5cb037$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
            const fetchTimeout = fetcherOptions.fetchTimeoutMs || $0a0fd7b02d5cb037$var$DEFAULT_REQUEST_TIMEOUT_MS;
            let abortSignal;
            if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
            else if (AbortController) {
                const abortController = new AbortController();
                abortSignal = abortController.signal;
                setTimeout(()=>abortController.abort(), fetchTimeout);
            }
            const response = await fetch(`${baseUrl}${path}`, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    'X-Client-Name': 'feature-gate-js-client',
                    'X-Client-Version': (0, (0, parcelRequire("hRhhD")).CLIENT_VERSION),
                    'X-API-KEY': fetcherOptions.apiKey
                },
                signal: abortSignal,
                ...body && {
                    body: JSON.stringify(body)
                }
            });
            await this.handleResponseError(response);
            return await this.extractResponseBody(response);
        }
    }
});
parcelRegister("86Qvr", function(module, exports) {
    $parcel$export(module.exports, "FeatureGateEnvironment", ()=>$773fe4e85e5ab6ae$export$479e7351a733299);
    $parcel$export(module.exports, "PerimeterType", ()=>$773fe4e85e5ab6ae$export$c42b7bbc5e7ba555);
    var $773fe4e85e5ab6ae$export$479e7351a733299;
    (function(FeatureGateEnvironment) {
        FeatureGateEnvironment["Development"] = "development";
        FeatureGateEnvironment["Staging"] = "staging";
        FeatureGateEnvironment["Production"] = "production";
    })($773fe4e85e5ab6ae$export$479e7351a733299 || ($773fe4e85e5ab6ae$export$479e7351a733299 = {}));
    var $773fe4e85e5ab6ae$export$c42b7bbc5e7ba555;
    (function(PerimeterType) {
        PerimeterType["COMMERCIAL"] = "commercial";
        PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    })($773fe4e85e5ab6ae$export$c42b7bbc5e7ba555 || ($773fe4e85e5ab6ae$export$c42b7bbc5e7ba555 = {}));
    const $773fe4e85e5ab6ae$export$42f4885608027d0c = 'non_boolean';
});
parcelRegister("hRhhD", function(module, exports) {
    $parcel$export(module.exports, "CLIENT_VERSION", ()=>$bd2813427759585e$export$a59f8d67326bd1cb);
    const $bd2813427759585e$export$a59f8d67326bd1cb = "0.0.0-use.local";
});
parcelRegister("9OeqF", function(module, exports) {
    $parcel$export(module.exports, "ResponseError", ()=>$750f54f2d6dcae81$export$286baf652d0b1206);
    class $750f54f2d6dcae81$export$286baf652d0b1206 extends Error {
        constructor(message){
            super(message);
        }
    }
});
parcelRegister("20wDi", function(module, exports) {
    $parcel$export(module.exports, "DefaultInteractionID", ()=>$132b2354a7dd3df1$export$3109542b68df9ba1);
    $parcel$export(module.exports, "default", ()=>$132b2354a7dd3df1$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "getInteractionId", ()=>$132b2354a7dd3df1$export$37bca3107733ac1e);
    var $5uXOq = parcelRequire("5uXOq");
    const $132b2354a7dd3df1$export$3109542b68df9ba1 = {
        current: null
    };
    var $132b2354a7dd3df1$export$2e2bcd8739ae039 = (0, $5uXOq.createContext)($132b2354a7dd3df1$export$3109542b68df9ba1);
    const $132b2354a7dd3df1$export$37bca3107733ac1e = ()=>$132b2354a7dd3df1$export$3109542b68df9ba1;
    const $132b2354a7dd3df1$export$9f6000531b78127e = ()=>$132b2354a7dd3df1$export$3109542b68df9ba1;
});
parcelRegister("iNl9c", function(module, exports) {
    $parcel$export(module.exports, "postInteractionLog", ()=>$8e6eb157b6a4f37c$export$d8f52e8f804021e8);
    $parcel$export(module.exports, "getActiveInteraction", ()=>$8e6eb157b6a4f37c$export$2b3954d2e8509985);
    $parcel$export(module.exports, "updatePageLoadInteractionName", ()=>$8e6eb157b6a4f37c$export$f6f1cf5bedf83c71);
    $parcel$export(module.exports, "addMetadata", ()=>$8e6eb157b6a4f37c$export$12f2b6cb85d59904);
    $parcel$export(module.exports, "addCustomData", ()=>$8e6eb157b6a4f37c$export$e4380431c2bdabee);
    $parcel$export(module.exports, "addCustomTiming", ()=>$8e6eb157b6a4f37c$export$27cacb7d7f3fe20a);
    $parcel$export(module.exports, "addMark", ()=>$8e6eb157b6a4f37c$export$728e28c22a0fba4);
    $parcel$export(module.exports, "addSpan", ()=>$8e6eb157b6a4f37c$export$2c1d6e17cfa9bbc7);
    $parcel$export(module.exports, "addSpanToAll", ()=>$8e6eb157b6a4f37c$export$943a8b2b5d6b1809);
    $parcel$export(module.exports, "extractModuleName", ()=>$8e6eb157b6a4f37c$export$f5a8f10de74904da);
    $parcel$export(module.exports, "addHold", ()=>$8e6eb157b6a4f37c$export$7606887303596f82);
    $parcel$export(module.exports, "addHoldByID", ()=>$8e6eb157b6a4f37c$export$10582acd678c213);
    $parcel$export(module.exports, "removeHoldByID", ()=>$8e6eb157b6a4f37c$export$4983dfbbb996f7ae);
    $parcel$export(module.exports, "getCurrentInteractionType", ()=>$8e6eb157b6a4f37c$export$2df109852219d16e);
    $parcel$export(module.exports, "ModuleLoadingProfiler", ()=>$8e6eb157b6a4f37c$export$9591b52b33ccc510);
    $parcel$export(module.exports, "addError", ()=>$8e6eb157b6a4f37c$export$239c33984d9b1367);
    $parcel$export(module.exports, "addErrorToAll", ()=>$8e6eb157b6a4f37c$export$7379c15afd3840fa);
    $parcel$export(module.exports, "addProfilerTimings", ()=>$8e6eb157b6a4f37c$export$53d6f611de951a13);
    $parcel$export(module.exports, "sinkInteractionHandler", ()=>$8e6eb157b6a4f37c$export$9e614a29a1ac213e);
    $parcel$export(module.exports, "sinkPostInteractionLogHandler", ()=>$8e6eb157b6a4f37c$export$8a1ba7bef607358a);
    $parcel$export(module.exports, "tryComplete", ()=>$8e6eb157b6a4f37c$export$673be905888f8839);
    $parcel$export(module.exports, "abort", ()=>$8e6eb157b6a4f37c$export$5def58af4fd46132);
    $parcel$export(module.exports, "abortByNewInteraction", ()=>$8e6eb157b6a4f37c$export$c4a545284f55edf2);
    $parcel$export(module.exports, "abortAll", ()=>$8e6eb157b6a4f37c$export$614a7af2affc5dff);
    $parcel$export(module.exports, "addOnCancelCallback", ()=>$8e6eb157b6a4f37c$export$7b9261a96cfe427b);
    $parcel$export(module.exports, "addNewInteraction", ()=>$8e6eb157b6a4f37c$export$1a1ed1e1fdb2006b);
    $parcel$export(module.exports, "addBrowserMetricEvent", ()=>$8e6eb157b6a4f37c$export$4a759336b50e86e3);
    $parcel$export(module.exports, "addApdexToAll", ()=>$8e6eb157b6a4f37c$export$ad216cc25852d44b);
    $parcel$export(module.exports, "addApdex", ()=>$8e6eb157b6a4f37c$export$35220fd6cdd1b731);
    $parcel$export(module.exports, "addRequestInfo", ()=>$8e6eb157b6a4f37c$export$57d55b4569823d8f);
    $parcel$export(module.exports, "addSegment", ()=>$8e6eb157b6a4f37c$export$1c43f9ac826b6462);
    $parcel$export(module.exports, "removeSegment", ()=>$8e6eb157b6a4f37c$export$d0365e48b58231c3);
    $parcel$export(module.exports, "addRedirect", ()=>$8e6eb157b6a4f37c$export$bbf14d79614d9818);
    $parcel$export(module.exports, "interactionSpans", ()=>$8e6eb157b6a4f37c$export$6ce04c7ca6810a7e);
    $parcel$export(module.exports, "addCustomSpans", ()=>$8e6eb157b6a4f37c$export$5342dcad19138a1c);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $fseZC;
    var $9HC2N;
    var $6ui18;
    var $aiwW2;
    var $20wDi;
    var $8luMn;
    var $8RRQy;
    var $ciQm5;
    const $8e6eb157b6a4f37c$var$PreviousInteractionLog = {
        name: undefined,
        isAborted: undefined
    };
    const $8e6eb157b6a4f37c$export$d8f52e8f804021e8 = new (0, (0, parcelRequire("ciQm5")).default)();
    const $8e6eb157b6a4f37c$var$interactionQueue = [];
    const $8e6eb157b6a4f37c$var$segmentCache = new Map();
    const $8e6eb157b6a4f37c$var$CLEANUP_TIMEOUT = 60000;
    const $8e6eb157b6a4f37c$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
    const $8e6eb157b6a4f37c$var$segmentObservers = [];
    function $8e6eb157b6a4f37c$export$2b3954d2e8509985() {
        const interactionId = (0, (0, parcelRequire("20wDi")).getInteractionId)();
        if (!interactionId.current) return;
        return (0, (0, parcelRequire("8RRQy")).default).get(interactionId.current);
    }
    function $8e6eb157b6a4f37c$var$isPerformanceTracingEnabled() {
        return (0, (0, parcelRequire("9HC2N")).getConfig)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
    }
    function $8e6eb157b6a4f37c$var$labelStackToString(labelStack, name) {
        const stack = [
            ...labelStack ?? []
        ];
        if (name) stack.push({
            name: name
        });
        return stack.map((l)=>l.name)?.join('/');
    }
    function $8e6eb157b6a4f37c$var$labelStackToIdString(labelStack) {
        return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
    }
    function $8e6eb157b6a4f37c$var$addSegmentObserver(observer) {
        $8e6eb157b6a4f37c$var$segmentObservers.push(observer);
        for (const segmentInfo of $8e6eb157b6a4f37c$var$segmentCache.values())observer.onAdd(segmentInfo);
    }
    function $8e6eb157b6a4f37c$var$removeSegmentObserver(observer) {
        const index = $8e6eb157b6a4f37c$var$segmentObservers.findIndex((obs)=>obs === observer);
        if (index !== -1) $8e6eb157b6a4f37c$var$segmentObservers.splice(index, 1);
    }
    function $8e6eb157b6a4f37c$export$cd7f480d6b8286c3(interactionId) {
        (0, (0, parcelRequire("8RRQy")).default).delete(interactionId);
    }
    function $8e6eb157b6a4f37c$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
        const interaction = $8e6eb157b6a4f37c$export$2b3954d2e8509985();
        if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
        interaction.ufoName = ufoName;
        interaction.routeName = routeName;
    }
    function $8e6eb157b6a4f37c$export$12f2b6cb85d59904(interactionId, data) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) Object.keys(data).forEach((key)=>{
            interaction.metaData[key] = data[key];
        });
    }
    function $8e6eb157b6a4f37c$export$e4380431c2bdabee(interactionId, labelStack, data) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) Object.keys(data).forEach((i)=>{
            interaction.customData.push({
                labelStack: labelStack,
                data: {
                    [i]: data[i]
                }
            });
        });
    }
    function $8e6eb157b6a4f37c$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) {
            interaction.customTimings.push({
                labelStack: labelStack,
                data: data
            });
            if ($8e6eb157b6a4f37c$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(data)){
                const { startTime: startTime, endTime: endTime } = timingData;
                try {
                    performance.measure(`\u{1F6F8} ${$8e6eb157b6a4f37c$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                        start: startTime,
                        end: endTime
                    });
                } catch (e) {}
            }
        }
    }
    function $8e6eb157b6a4f37c$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
        if ($8e6eb157b6a4f37c$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$8e6eb157b6a4f37c$var$labelStackToString(labelStack, name)} [${type}]`, {
            startTime: time
        });
    }
    function $8e6eb157b6a4f37c$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
        (0, (0, parcelRequire("8RRQy")).default).forEach((interaction)=>{
            interaction.marks.push({
                type: type,
                name: name,
                labelStack: labelStack,
                time: time
            });
        });
        if ($8e6eb157b6a4f37c$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$8e6eb157b6a4f37c$var$labelStackToString(labelStack, name)} [${type}]`, {
            startTime: time
        });
    }
    function $8e6eb157b6a4f37c$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) {
            interaction.spans.push({
                type: type,
                name: name,
                labelStack: labelStack,
                start: start,
                end: end,
                size: size
            });
            if ($8e6eb157b6a4f37c$var$isPerformanceTracingEnabled()) try {
                performance.measure(`\u{1F6F8} ${$8e6eb157b6a4f37c$var$labelStackToString(labelStack, name)} [${type}]`, {
                    start: start,
                    end: end
                });
            } catch (e) {}
        }
    }
    function $8e6eb157b6a4f37c$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
        (0, (0, parcelRequire("8RRQy")).default).forEach((interaction)=>{
            interaction.spans.push({
                type: type,
                name: name,
                labelStack: labelStack,
                start: start,
                end: end,
                size: size
            });
        });
        if ($8e6eb157b6a4f37c$var$isPerformanceTracingEnabled()) try {
            performance.measure(`\u{1F6F8} ${$8e6eb157b6a4f37c$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end
            });
        } catch (e) {}
    }
    function $8e6eb157b6a4f37c$export$9e04fe1a58571ec(moduleId, timestamp) {
        $8e6eb157b6a4f37c$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
    }
    function $8e6eb157b6a4f37c$export$6f228d1fdc911d7(identifier, start, end) {
        $8e6eb157b6a4f37c$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
    }
    const $8e6eb157b6a4f37c$var$moduleLoadingRequests = {};
    function $8e6eb157b6a4f37c$export$f5a8f10de74904da(input) {
        let result = input ?? '';
        result = result.replace(/^\.\/src\/packages\//, '');
        result = result.replace(/^\.\/node_modules\//, '');
        result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
        return result;
    }
    function $8e6eb157b6a4f37c$var$addHoldCriterion(id, labelStack, name, startTime) {
        if (!window.__CRITERION__?.addUFOHold) return;
        window.__CRITERION__.addUFOHold(id, $8e6eb157b6a4f37c$var$labelStackToString(labelStack), name, startTime);
    }
    function $8e6eb157b6a4f37c$var$removeHoldCriterion(id) {
        if (!window.__CRITERION__?.removeUFOHold) return;
        window.__CRITERION__.removeUFOHold(id);
    }
    function $8e6eb157b6a4f37c$export$7606887303596f82(interactionId, labelStack, name) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        const id = (0, $7Jxgt.v4)();
        if (interaction != null) {
            const start = performance.now();
            interaction.holdActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start
            });
            $8e6eb157b6a4f37c$var$addHoldCriterion(id, labelStack, name, start);
            return ()=>{
                const end = performance.now();
                if ($8e6eb157b6a4f37c$var$isPerformanceTracingEnabled()) try {
                    performance.measure(`\u{1F6F8} ${$8e6eb157b6a4f37c$var$labelStackToString(labelStack, name)} [hold]`, {
                        start: start,
                        end: end
                    });
                } catch (e) {}
                $8e6eb157b6a4f37c$var$removeHoldCriterion(id);
                const currentInteraction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
                const currentHold = interaction.holdActive.get(id);
                if (currentInteraction != null && currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
            };
        }
        return ()=>{};
    }
    function $8e6eb157b6a4f37c$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) {
            const start = performance.now();
            interaction.holdActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
            $8e6eb157b6a4f37c$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{};
    }
    function $8e6eb157b6a4f37c$export$4983dfbbb996f7ae(interactionId, id) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) {
            const end = performance.now();
            const currentInteraction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null && currentHold != null) {
                currentInteraction.holdInfo.push({
                    ...currentHold,
                    end: end
                });
                interaction.holdActive.delete(id);
                $8e6eb157b6a4f37c$var$removeHoldCriterion(id);
            }
        }
    }
    function $8e6eb157b6a4f37c$export$2df109852219d16e(interactionId) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction) return interaction.type;
        return null;
    }
    const $8e6eb157b6a4f37c$export$9591b52b33ccc510 = {
        onPreload (moduleId, _priority) {
            $8e6eb157b6a4f37c$export$9e04fe1a58571ec($8e6eb157b6a4f37c$export$f5a8f10de74904da(moduleId), performance.now());
        },
        onLoadStart (info) {
            const timeoutId = setTimeout(()=>{
                delete $8e6eb157b6a4f37c$var$moduleLoadingRequests[info.identifier];
            }, 30000);
            const request = {
                start: performance.now(),
                timeoutId: timeoutId
            };
            $8e6eb157b6a4f37c$var$moduleLoadingRequests[info.identifier] = request;
        },
        onLoadComplete (info) {
            const request = $8e6eb157b6a4f37c$var$moduleLoadingRequests[info.identifier];
            if (request) {
                clearTimeout(request.timeoutId);
                delete $8e6eb157b6a4f37c$var$moduleLoadingRequests[info.identifier];
                $8e6eb157b6a4f37c$export$6f228d1fdc911d7($8e6eb157b6a4f37c$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
            }
        },
        placeholderFallBackMounted (id, moduleId) {
            const interactionId = (0, (0, parcelRequire("20wDi")).getInteractionId)();
            const currentInteractionId = interactionId.current;
            $8e6eb157b6a4f37c$export$10582acd678c213(currentInteractionId, [], moduleId, id);
        },
        placeholderFallBackUnmounted (id) {
            const interactionId = (0, (0, parcelRequire("20wDi")).getInteractionId)();
            const currentInteractionId = interactionId.current;
            $8e6eb157b6a4f37c$export$4983dfbbb996f7ae(currentInteractionId, id);
        }
    };
    function $8e6eb157b6a4f37c$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            forcedError: forcedError
        });
    }
    function $8e6eb157b6a4f37c$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
        (0, (0, parcelRequire("8RRQy")).default).forEach((interaction)=>{
            interaction.errors.push({
                name: name,
                labelStack: labelStack,
                errorType: errorType,
                errorMessage: errorMessage,
                errorStack: errorStack
            });
        });
    }
    const $8e6eb157b6a4f37c$export$53d6f611de951a13 = (interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime)=>{
        if ($8e6eb157b6a4f37c$var$isPerformanceTracingEnabled()) try {
            performance.measure(`\u{1F6F8} ${$8e6eb157b6a4f37c$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
                start: startTime,
                duration: actualDuration
            });
        } catch (e) {}
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) interaction.reactProfilerTimings.push({
            labelStack: labelStack,
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime
        });
        else if ((0, (0, parcelRequire("9HC2N")).getConfig)()?.postInteractionLog?.enabled) $8e6eb157b6a4f37c$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
    };
    const $8e6eb157b6a4f37c$var$pushToQueue = (id, data)=>{
        $8e6eb157b6a4f37c$var$interactionQueue.push({
            id: id,
            data: data
        });
    };
    let $8e6eb157b6a4f37c$var$handleInteraction = $8e6eb157b6a4f37c$var$pushToQueue;
    function $8e6eb157b6a4f37c$var$callCleanUpCallbacks(interaction) {
        interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
            cleanUpCallback();
        });
    }
    const $8e6eb157b6a4f37c$var$finishInteraction = (id, data, endTime = performance.now())=>{
        data.end = endTime;
        try {
            performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
                start: data.start,
                end: data.end
            });
        } catch (e) {}
        if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, (0, parcelRequire("aiwW2")).currentFeatureFlagsAccessed));
        (0, (0, parcelRequire("6ui18")).clearActiveTrace)();
        $8e6eb157b6a4f37c$var$callCleanUpCallbacks(data);
        if ((0, (0, parcelRequire("9HC2N")).getConfig)()?.vc?.stopVCAtInteractionFinish) data.vc = (0, (0, parcelRequire("8luMn")).getVCObserver)().getVCRawData();
        $8e6eb157b6a4f37c$export$cd7f480d6b8286c3(id);
        $8e6eb157b6a4f37c$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
        $8e6eb157b6a4f37c$var$PreviousInteractionLog.isAborted = data.abortReason != null;
        if (data.ufoName) $8e6eb157b6a4f37c$var$handleInteraction(id, data);
        if ($8e6eb157b6a4f37c$var$isPerformanceTracingEnabled()) {
            const profilerTimingMap = new Map();
            data.reactProfilerTimings.forEach((profilerTiming)=>{
                const labelStackId = $8e6eb157b6a4f37c$var$labelStackToIdString(profilerTiming.labelStack);
                if (labelStackId) {
                    const timing = profilerTimingMap.get(labelStackId) ?? {
                        labelStack: profilerTiming.labelStack
                    };
                    timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                    timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                    profilerTimingMap.set(labelStackId, timing);
                }
            });
            try {
                for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$8e6eb157b6a4f37c$var$labelStackToString(labelStack)} [segment_ttai]`, {
                    start: start,
                    end: end
                });
            } catch (e) {}
        }
        try {
            window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
                detail: data
            }));
        } catch (error) {}
    };
    const $8e6eb157b6a4f37c$export$9e614a29a1ac213e = (sinkFn)=>{
        if ($8e6eb157b6a4f37c$var$handleInteraction === $8e6eb157b6a4f37c$var$pushToQueue) {
            $8e6eb157b6a4f37c$var$handleInteraction = sinkFn;
            $8e6eb157b6a4f37c$var$interactionQueue.forEach((interaction)=>{
                sinkFn(interaction.id, interaction.data);
            });
            $8e6eb157b6a4f37c$var$interactionQueue.length = 0;
        }
    };
    const $8e6eb157b6a4f37c$export$8a1ba7bef607358a = (sinkFn)=>{
        $8e6eb157b6a4f37c$export$d8f52e8f804021e8.sinkHandler(sinkFn);
    };
    function $8e6eb157b6a4f37c$export$673be905888f8839(interactionId, endTime) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) {
            const noMoreHolds = interaction.holdActive.size === 0;
            if (noMoreHolds) {
                $8e6eb157b6a4f37c$var$finishInteraction(interactionId, interaction, endTime);
                if ((0, (0, parcelRequire("9HC2N")).getConfig)()?.postInteractionLog?.enabled) $8e6eb157b6a4f37c$export$d8f52e8f804021e8.onInteractionComplete(interaction);
            }
        }
    }
    function $8e6eb157b6a4f37c$var$callCancelCallbacks(interaction) {
        interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
            cancelCallback();
        });
    }
    function $8e6eb157b6a4f37c$export$5def58af4fd46132(interactionId, abortReason) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) {
            $8e6eb157b6a4f37c$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            $8e6eb157b6a4f37c$var$finishInteraction(interactionId, interaction);
        }
    }
    function $8e6eb157b6a4f37c$export$c4a545284f55edf2(interactionId, interactionName) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) {
            $8e6eb157b6a4f37c$var$callCancelCallbacks(interaction);
            interaction.abortReason = 'new_interaction';
            interaction.abortedByInteractionName = interactionName;
            $8e6eb157b6a4f37c$var$finishInteraction(interactionId, interaction);
        }
    }
    function $8e6eb157b6a4f37c$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
        (0, (0, parcelRequire("8RRQy")).default).forEach((interaction, interactionId)=>{
            const noMoreHolds = interaction.holdActive.size === 0;
            if (!noMoreHolds) {
                $8e6eb157b6a4f37c$var$callCancelCallbacks(interaction);
                interaction.abortReason = abortReason;
                if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            }
            $8e6eb157b6a4f37c$var$finishInteraction(interactionId, interaction);
        });
    }
    function $8e6eb157b6a4f37c$export$7b9261a96cfe427b(id, cancelCallback) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(id);
        interaction?.cancelCallbacks.push(cancelCallback);
    }
    function $8e6eb157b6a4f37c$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
        if ((0, (0, parcelRequire("9HC2N")).getConfig)()?.postInteractionLog?.enabled) $8e6eb157b6a4f37c$export$d8f52e8f804021e8.reset();
        let previousTime = startTime;
        let timeoutTime = $8e6eb157b6a4f37c$var$CLEANUP_TIMEOUT;
        const timerID = setTimeout(()=>{
            $8e6eb157b6a4f37c$export$5def58af4fd46132(interactionId, 'timeout');
        }, $8e6eb157b6a4f37c$var$CLEANUP_TIMEOUT);
        function changeTimeout(newTime) {
            const currentTime = performance.now();
            const timeLeft = timeoutTime - (currentTime - previousTime);
            if (timeLeft < newTime) return;
            clearTimeout(this.timerID);
            const newTimerID = setTimeout(()=>{
                $8e6eb157b6a4f37c$export$5def58af4fd46132(interactionId, 'timeout');
            }, newTime);
            timeoutTime = newTime;
            previousTime = currentTime;
            this.timerID = newTimerID;
        }
        const addFeatureFlagsToInteraction = (0, (0, parcelRequire("fseZC")).default)((0, (0, parcelRequire("9HC2N")).getCapabilityRate)('feature_flag_access'));
        const metrics = {
            id: interactionId,
            start: startTime,
            end: 0,
            ufoName: ufoName,
            type: type,
            previousInteractionName: $8e6eb157b6a4f37c$var$PreviousInteractionLog.name,
            isPreviousInteractionAborted: $8e6eb157b6a4f37c$var$PreviousInteractionLog.isAborted === true,
            marks: [],
            customData: [],
            customTimings: [],
            spans: [],
            requestInfo: [],
            reactProfilerTimings: [],
            holdInfo: [],
            holdActive: new Map(),
            measureStart: performance.now(),
            rate: rate,
            cancelCallbacks: [],
            metaData: {},
            errors: [],
            apdex: [],
            labelStack: labelStack,
            routeName: routeName ?? ufoName,
            featureFlags: addFeatureFlagsToInteraction ? {
                prior: Object.fromEntries((0, (0, parcelRequire("aiwW2")).allFeatureFlagsAccessed)),
                during: {}
            } : undefined,
            knownSegments: [],
            cleanupCallbacks: [],
            awaitReactProfilerCount: 0,
            redirects: [],
            timerID: timerID,
            changeTimeout: changeTimeout,
            trace: trace
        };
        if (addFeatureFlagsToInteraction) (0, (0, parcelRequire("aiwW2")).currentFeatureFlagsAccessed).clear();
        (0, (0, parcelRequire("8RRQy")).default).set(interactionId, metrics);
        const segmentObserver = {
            onAdd (segment) {
                metrics.knownSegments.push(segment);
            },
            onRemove () {}
        };
        $8e6eb157b6a4f37c$var$addSegmentObserver(segmentObserver);
        metrics.cleanupCallbacks.push(()=>{
            $8e6eb157b6a4f37c$var$removeSegmentObserver(segmentObserver);
        });
        metrics.cleanupCallbacks.push(()=>{
            clearTimeout(metrics.timerID);
        });
        const awaitBM3TTIList = (0, (0, parcelRequire("9HC2N")).getAwaitBM3TTIList)();
        if (awaitBM3TTIList.includes(ufoName)) $8e6eb157b6a4f37c$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
        if (type === 'transition') {
            (0, (0, parcelRequire("8luMn")).getVCObserver)().start({
                startTime: startTime
            });
            $8e6eb157b6a4f37c$export$d8f52e8f804021e8.startVCObserver({
                startTime: startTime
            });
        }
    }
    function $8e6eb157b6a4f37c$export$4a759336b50e86e3(event) {
        const interaction = $8e6eb157b6a4f37c$export$2b3954d2e8509985();
        if (interaction) {
            interaction.legacyMetrics = interaction.legacyMetrics || [];
            interaction.legacyMetrics.push(event);
            if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') {
                interaction.changeTimeout($8e6eb157b6a4f37c$var$CLEANUP_TIMEOUT_AFTER_APDEX);
                $8e6eb157b6a4f37c$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
            }
        }
    }
    function $8e6eb157b6a4f37c$export$ad216cc25852d44b(apdex) {
        (0, (0, parcelRequire("8RRQy")).default).forEach((interaction, key)=>{
            interaction.apdex.push(apdex);
            try {
                performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                    start: apdex.startTime ?? interaction.start,
                    end: apdex.stopTime
                });
            } catch (e) {}
            if (interaction.type === 'page_load' || interaction.type === 'transition') {
                interaction.changeTimeout($8e6eb157b6a4f37c$var$CLEANUP_TIMEOUT_AFTER_APDEX);
                $8e6eb157b6a4f37c$export$4983dfbbb996f7ae(key, interaction.ufoName);
            }
        });
    }
    function $8e6eb157b6a4f37c$export$35220fd6cdd1b731(interactionId, apdexInfo) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) {
            interaction.apdex.push(apdexInfo);
            try {
                performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                    start: apdexInfo.startTime ?? interaction.start,
                    end: apdexInfo.stopTime
                });
            } catch (e) {}
            if (interaction.type === 'page_load' || interaction.type === 'transition') {
                interaction.changeTimeout($8e6eb157b6a4f37c$var$CLEANUP_TIMEOUT_AFTER_APDEX);
                $8e6eb157b6a4f37c$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
            }
        }
    }
    function $8e6eb157b6a4f37c$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) interaction.requestInfo.push({
            labelStack: labelStack,
            ...requestInfo
        });
    }
    function $8e6eb157b6a4f37c$var$isSegmentLabel(obj) {
        return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
    }
    function $8e6eb157b6a4f37c$var$getSegmentCacheKey(labelStack) {
        return labelStack.map((l)=>{
            if ($8e6eb157b6a4f37c$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
            return l.name;
        }).join('|');
    }
    function $8e6eb157b6a4f37c$export$1c43f9ac826b6462(labelStack) {
        const key = $8e6eb157b6a4f37c$var$getSegmentCacheKey(labelStack);
        const existingSegment = $8e6eb157b6a4f37c$var$segmentCache.get(key);
        if (!existingSegment) {
            const segmentInfo = {
                labelStack: labelStack
            };
            $8e6eb157b6a4f37c$var$segmentCache.set(key, segmentInfo);
            $8e6eb157b6a4f37c$var$segmentObservers.forEach((observer)=>{
                observer.onAdd(segmentInfo);
            });
        }
    }
    function $8e6eb157b6a4f37c$export$d0365e48b58231c3(labelStack) {
        const key = $8e6eb157b6a4f37c$var$getSegmentCacheKey(labelStack);
        const segmentInfo = $8e6eb157b6a4f37c$var$segmentCache.get(key);
        if (segmentInfo) {
            $8e6eb157b6a4f37c$var$segmentCache.delete(JSON.stringify(labelStack));
            $8e6eb157b6a4f37c$var$segmentObservers.forEach((observer)=>{
                observer.onRemove(segmentInfo);
            });
        }
    }
    function $8e6eb157b6a4f37c$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
        const interaction = (0, (0, parcelRequire("8RRQy")).default).get(interactionId);
        if (interaction != null) {
            interaction.ufoName = nextUfoName;
            interaction.routeName = nextRouteName;
            interaction.redirects.push({
                fromInteractionName: fromUfoName,
                time: time
            });
            if ($8e6eb157b6a4f37c$var$isPerformanceTracingEnabled()) {
                const prevRedirect = interaction.redirects.at(-2);
                try {
                    performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                        start: prevRedirect?.time ?? interaction.start,
                        end: time
                    });
                } catch (e) {}
            }
        }
    }
    const $8e6eb157b6a4f37c$export$6ce04c7ca6810a7e = [];
    const $8e6eb157b6a4f37c$var$defaultLabelStack = [
        {
            name: 'custom'
        }
    ];
    function $8e6eb157b6a4f37c$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $8e6eb157b6a4f37c$var$defaultLabelStack) {
        const customSpan = {
            type: 'custom',
            name: name,
            start: start,
            end: end,
            labelStack: labelStack,
            size: size
        };
        $8e6eb157b6a4f37c$export$6ce04c7ca6810a7e.push(customSpan);
    }
});
parcelRegister("fseZC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a80a9dbb107bc6ef$export$2e2bcd8739ae039);
    function $a80a9dbb107bc6ef$export$2e2bcd8739ae039(rate) {
        if (rate === 0) return false;
        else if (rate === 1) return true;
        else return Math.random() * rate <= 1;
    }
});
parcelRegister("9HC2N", function(module, exports) {
    $parcel$export(module.exports, "setUFOConfig", ()=>$2ff0c8fe5421f070$export$10d6139a8fb42158);
    $parcel$export(module.exports, "getConfig", ()=>$2ff0c8fe5421f070$export$44487a86467333c3);
    $parcel$export(module.exports, "getInteractionRate", ()=>$2ff0c8fe5421f070$export$9466a8f085fa7d4e);
    $parcel$export(module.exports, "getPostInteractionRate", ()=>$2ff0c8fe5421f070$export$1d459f020c06ae34);
    $parcel$export(module.exports, "getCapabilityRate", ()=>$2ff0c8fe5421f070$export$29b9ffb14861a1d);
    $parcel$export(module.exports, "getTypingPerformanceTracingMethod", ()=>$2ff0c8fe5421f070$export$7e32aae12bf9b50f);
    $parcel$export(module.exports, "getAwaitBM3TTIList", ()=>$2ff0c8fe5421f070$export$2d311b3fd18dcab1);
    $parcel$export(module.exports, "getUfoNameOverrides", ()=>$2ff0c8fe5421f070$export$4f4649ef27b6f5d6);
    $parcel$export(module.exports, "getDoNotAbortActivePressInteraction", ()=>$2ff0c8fe5421f070$export$3c170167645a0eff);
    $parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", ()=>$2ff0c8fe5421f070$export$d6dc9444bd15f70f);
    let $2ff0c8fe5421f070$var$config;
    function $2ff0c8fe5421f070$export$10d6139a8fb42158(newConfig) {
        $2ff0c8fe5421f070$var$config = newConfig;
    }
    function $2ff0c8fe5421f070$export$44487a86467333c3() {
        return $2ff0c8fe5421f070$var$config;
    }
    function $2ff0c8fe5421f070$export$9466a8f085fa7d4e(name, interactionKind) {
        try {
            if (!$2ff0c8fe5421f070$var$config) return 0;
            const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $2ff0c8fe5421f070$var$config;
            if (killswitch != null) {
                if (killswitch.includes(name)) return 0;
            }
            if (rates != null) {
                if (rates[name] != null) return rates[name];
            }
            if (rules != null) for(let i = 0; i < rules.length; i++){
                const rule = rules[i];
                const { test: test, rate: rate } = rule;
                if (test != null && rate != null) {
                    const regexp = new RegExp(test, 'ig');
                    if (regexp.test(name)) return rate;
                }
            }
            const isAutogenerated = name?.startsWith('auto-generated');
            if (isAutogenerated) {
                const rate = autoGeneratedRate;
                if (rate != null) return rate;
            }
            if (kind != null) {
                const rate = kind[interactionKind];
                if (rate != null) return rate;
            }
            return 0;
        } catch (e) {
            return 0;
        }
    }
    function $2ff0c8fe5421f070$export$1d459f020c06ae34(name, interactionType) {
        try {
            if (!$2ff0c8fe5421f070$var$config) return 0;
            const { postInteractionLog: postInteractionLog } = $2ff0c8fe5421f070$var$config;
            if (!postInteractionLog?.enabled) return 0;
            if (postInteractionLog.rates && typeof postInteractionLog.rates[name] === 'number') return postInteractionLog.rates[name];
            if (postInteractionLog.kind && typeof postInteractionLog.kind[interactionType] === 'number') return postInteractionLog.kind[interactionType];
            return 0;
        } catch (e) {
            return 0;
        }
    }
    function $2ff0c8fe5421f070$export$29b9ffb14861a1d(capability) {
        try {
            if (!$2ff0c8fe5421f070$var$config) return 0;
            const { capability: capabilityRate } = $2ff0c8fe5421f070$var$config;
            if (capabilityRate != null) {
                const rate = capabilityRate[capability];
                if (rate != null) return rate;
            }
            return 0;
        } catch  {
            return 0;
        }
    }
    const $2ff0c8fe5421f070$var$validTypingMethods = [
        'timeout',
        'timeoutNoAlloc',
        'mutationObserver'
    ];
    function $2ff0c8fe5421f070$export$7e32aae12bf9b50f() {
        const defaultMethod = 'timeout';
        try {
            if (!$2ff0c8fe5421f070$var$config) return defaultMethod;
            const { typingMethod: typingMethod } = $2ff0c8fe5421f070$var$config;
            if (typingMethod != null && $2ff0c8fe5421f070$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
            else return defaultMethod;
        } catch (e) {
            return defaultMethod;
        }
    }
    function $2ff0c8fe5421f070$export$2d311b3fd18dcab1() {
        try {
            if (!$2ff0c8fe5421f070$var$config) return [];
            const { awaitBM3TTI: awaitBM3TTI } = $2ff0c8fe5421f070$var$config;
            if (awaitBM3TTI != null) return awaitBM3TTI;
            else return [];
        } catch (e) {
            return [];
        }
    }
    function $2ff0c8fe5421f070$export$e2ea675800536898() {
        try {
            if (!$2ff0c8fe5421f070$var$config) return false;
            const { removePageSegmentsUFOPrefixes: removePageSegmentsUFOPrefixes } = $2ff0c8fe5421f070$var$config;
            if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
            else return false;
        } catch (e) {
            return false;
        }
    }
    function $2ff0c8fe5421f070$export$525ba53ca98e9db() {
        try {
            if (!$2ff0c8fe5421f070$var$config) return false;
            const { removeInteractionsUFOPrefixes: removeInteractionsUFOPrefixes } = $2ff0c8fe5421f070$var$config;
            if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
            else return false;
        } catch (e) {
            return false;
        }
    }
    function $2ff0c8fe5421f070$export$4f4649ef27b6f5d6() {
        try {
            if (!$2ff0c8fe5421f070$var$config) return undefined;
            const { ufoNameOverrides: ufoNameOverrides } = $2ff0c8fe5421f070$var$config;
            if (ufoNameOverrides != null) return ufoNameOverrides;
            return undefined;
        } catch (e) {
            return undefined;
        }
    }
    function $2ff0c8fe5421f070$export$3c170167645a0eff() {
        try {
            if (!$2ff0c8fe5421f070$var$config) return undefined;
            const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $2ff0c8fe5421f070$var$config;
            return doNotAbortActivePressInteraction;
        } catch (e) {
            return undefined;
        }
    }
    function $2ff0c8fe5421f070$export$d6dc9444bd15f70f() {
        try {
            if (!$2ff0c8fe5421f070$var$config) return undefined;
            const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $2ff0c8fe5421f070$var$config;
            return doNotAbortActivePressInteractionOnTransition;
        } catch (e) {
            return undefined;
        }
    }
});
parcelRegister("8luMn", function(module, exports) {
    $parcel$export(module.exports, "getVCObserver", ()=>$306dbd87d8042dbb$export$b3bc47985717b49e);
    var $jztB7;
    let $306dbd87d8042dbb$var$instance = null;
    const $306dbd87d8042dbb$export$b3bc47985717b49e = (opts = {})=>{
        if ($306dbd87d8042dbb$var$instance === null) $306dbd87d8042dbb$var$instance = new (0, (0, parcelRequire("jztB7")).VCObserver)(opts);
        return $306dbd87d8042dbb$var$instance;
    };
});
parcelRegister("jztB7", function(module, exports) {
    $parcel$export(module.exports, "VCObserver", ()=>$336f76290519985e$export$1f70d263701b1d01);
    var $chZM6;
    var $112a7;
    var $4L4Do;
    const $336f76290519985e$var$abortReason = {
        scroll: 'scroll',
        keypress: 'keypress',
        resize: 'resize',
        error: 'error'
    };
    const $336f76290519985e$var$UNUSED_SECTOR = 0;
    function $336f76290519985e$var$filterComponentsLog(log) {
        return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
                Number(timestamp),
                entries.map((entry)=>{
                    const { __debug__element: __debug__element, ...rest } = entry;
                    return rest;
                })
            ]));
    }
    class $336f76290519985e$export$1f70d263701b1d01 {
        static{
            this.VCParts = [
                '25',
                '50',
                '75',
                '80',
                '85',
                '90',
                '95',
                '98',
                '99'
            ];
        }
        constructor(options){
            this.abortReason = {
                reason: null,
                info: '',
                timestamp: -1,
                blocking: false
            };
            this.outOfBoundaryInfo = '';
            this.viewport = {
                w: 0,
                h: 0
            };
            this.arraySize = 0;
            this.componentsLog = {};
            this.vcRatios = {};
            this.active = false;
            this.totalTime = 0;
            this.startTime = 0;
            this._startMeasureTimestamp = -1;
            this.ssr = {
                reactRendered: -1
            };
            this.unbind = [];
            this.getAbortReasonInfo = ()=>{
                if (this.abortReason.reason === null) return null;
                const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
                return `${this.abortReason.reason}${info}`;
            };
            this.getVCRawData = ()=>{
                this.measureStart();
                if (!this.active) {
                    this.measureStop();
                    return null;
                }
                this.stop();
                const abortReasonInfo = this.getAbortReasonInfo();
                this.measureStop();
                return {
                    abortReasonInfo: abortReasonInfo,
                    abortReason: {
                        ...this.abortReason
                    },
                    heatmap: this.heatmap,
                    heatmapNext: this.heatmapNext,
                    outOfBoundaryInfo: this.outOfBoundaryInfo,
                    totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                    componentsLog: {
                        ...this.componentsLog
                    },
                    viewport: {
                        ...this.viewport
                    },
                    oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                    devToolsEnabled: this.devToolsEnabled,
                    ratios: this.vcRatios
                };
            };
            this.getVCResult = ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc })=>{
                const startTime = performance.now();
                const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
                const rawData = vc !== undefined ? vc : this.getVCRawData();
                if (rawData === null) return {};
                const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
                if (abortReasonInfo !== null && abortReason.blocking) {
                    try {
                        if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                    } catch (e) {}
                    return {
                        [`${fullPrefix}vc:state`]: false,
                        [`${fullPrefix}vc:abort:reason`]: abortReasonInfo,
                        [`${fullPrefix}vc:abort:timestamp`]: abortReason.timestamp
                    };
                }
                const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = $336f76290519985e$export$1f70d263701b1d01.calculateVC({
                    heatmap: heatmap,
                    ssr: ssr,
                    componentsLog: {
                        ...componentsLog
                    },
                    viewport: viewport
                });
                try {
                    if (!this.isPostInteraction) $336f76290519985e$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                        const duration = VC[key];
                        if (duration !== null && duration !== undefined) performance.measure(`VC${key}`, {
                            start: start,
                            duration: duration
                        });
                    });
                } catch (e) {}
                const vcNext = $336f76290519985e$export$1f70d263701b1d01.calculateVC({
                    heatmap: heatmapNext,
                    ssr: ssr,
                    componentsLog: {
                        ...componentsLog
                    },
                    viewport: viewport
                });
                const outOfBoundary = outOfBoundaryInfo ? {
                    [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
                } : {};
                const stopTime = performance.now();
                try {
                    if (!this.isPostInteraction && devToolsEnabled) {
                        window.__vc = {
                            entries: VCEntries.rel,
                            log: componentsLog,
                            metrics: {
                                '75': VC['75'],
                                '80': VC['80'],
                                '85': VC['85'],
                                '90': VC['90'],
                                '95': VC['95'],
                                '98': VC['98'],
                                '99': VC['99'],
                                tti: tti,
                                ttai: stop - start
                            },
                            heatmap: heatmap,
                            ratios: ratios
                        };
                        window.dispatchEvent(new CustomEvent('vcReady', {
                            detail: {
                                log: $336f76290519985e$var$filterComponentsLog(componentsLog),
                                entries: VCEntries.rel
                            }
                        }));
                    }
                } catch (e) {}
                return {
                    'metrics:vc': VC,
                    [`${fullPrefix}vc:state`]: true,
                    [`${fullPrefix}vc:clean`]: !abortReasonInfo,
                    [`${fullPrefix}vc:dom`]: VCBox,
                    [`${fullPrefix}vc:updates`]: VCEntries.rel.slice(0, 50),
                    [`${fullPrefix}vc:size`]: viewport,
                    [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                    [`${fullPrefix}vc:total`]: totalPainted,
                    [`${fullPrefix}vc:ratios`]: ratios,
                    ...outOfBoundary,
                    [`${fullPrefix}vc:next`]: vcNext.VC,
                    [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog)
                };
            };
            this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason)=>{
                this.measureStart();
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    const time = Math.round(rawTime - this.startTime);
                    const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                    this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                    if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                    if ((!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                    if (!this.componentsLog[time]) this.componentsLog[time] = [];
                    this.componentsLog[time].push({
                        __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                        intersectionRect: intersectionRect,
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    });
                }
                this.measureStop();
            };
            this.mapPixelsToHeatmap = (left, top, width, height)=>{
                const { w: w, h: h } = this.viewport;
                const l = Math.floor(left / w * this.arraySize);
                const t = Math.floor(top / h * this.arraySize);
                const r = Math.ceil((left + width) / w * this.arraySize);
                const b = Math.ceil((top + height) / h * this.arraySize);
                if (this.outOfBoundaryInfo === '') {
                    let outOfBoundaryInfo = '';
                    if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                    if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                    this.outOfBoundaryInfo = outOfBoundaryInfo;
                }
                const result = {
                    l: Math.max(0, l),
                    t: Math.max(0, t),
                    r: Math.min(this.arraySize, r),
                    b: Math.min(this.arraySize, b)
                };
                return result;
            };
            this.getElementRatio = (mappedValues)=>{
                const { r: r, l: l, b: b, t: t } = mappedValues;
                return (r - l) * (b - t) / (this.arraySize * this.arraySize);
            };
            this.abortReasonCallback = (key, time)=>{
                switch(key){
                    case 'wheel':
                        this.setAbortReason($336f76290519985e$var$abortReason.scroll, time);
                        break;
                    case 'keydown':
                        this.setAbortReason($336f76290519985e$var$abortReason.keypress, time);
                        break;
                    case 'resize':
                        this.setAbortReason($336f76290519985e$var$abortReason.resize, time);
                        break;
                }
            };
            this.attachAbortListeners = ()=>{
                this.detachAbortListeners();
                let unbinds = (0, (0, parcelRequire("chZM6")).attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
                if (window?.__SSR_ABORT_LISTENERS__) {
                    Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                        if (time) this.abortReasonCallback(key, time);
                    });
                    unbinds = unbinds.concat(window.__SSR_ABORT_LISTENERS__.unbinds);
                    delete window?.__SSR_ABORT_LISTENERS__;
                }
                this.unbind = unbinds;
            };
            this.arraySize = options.heatmapSize || 200;
            this.devToolsEnabled = options.devToolsEnabled || false;
            this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
            this.observers = new (0, (0, parcelRequire("4L4Do")).Observers)({
                selectorConfig: options.selectorConfig || {
                    id: false,
                    testId: false,
                    role: false,
                    className: true,
                    dataVC: true
                }
            });
            this.heatmap = this.getCleanHeatmap();
            this.heatmapNext = this.getCleanHeatmap();
            this.isPostInteraction = options.isPostInteraction || false;
        }
        start({ startTime: startTime }) {
            this.active = true;
            if (this.observers.isBrowserSupported()) {
                this.setViewportSize();
                this.resetState();
                this.startTime = startTime;
                this.attachAbortListeners();
                this.observers.subscribeResults(this.handleUpdate);
                this.observers.observe();
            } else this.setAbortReason('not-supported', startTime);
        }
        stop() {
            this.observers.disconnect();
            this.detachAbortListeners();
        }
        getIgnoredElements(componentsLog) {
            return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                    targetName: targetName,
                    ignoreReason: ignoreReason
                }));
        }
        static calculateVC({ heatmap: heatmap, ssr: ssr = $336f76290519985e$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport }) {
            const lastUpdate = {};
            let totalPainted = 0;
            if (ssr !== $336f76290519985e$var$UNUSED_SECTOR) {
                const element = {
                    __debug__element: new WeakRef(window.document?.body),
                    intersectionRect: {
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        x: 0,
                        y: 0,
                        width: viewport.w,
                        height: viewport.h,
                        toJSON () {
                            return {};
                        }
                    },
                    targetName: 'SSR'
                };
                if (!componentsLog[ssr]) componentsLog[ssr] = [];
                componentsLog[ssr].push(element);
            }
            heatmap.forEach((line)=>{
                line.forEach((entry)=>{
                    const rounded = Math.floor(entry === $336f76290519985e$var$UNUSED_SECTOR && ssr !== $336f76290519985e$var$UNUSED_SECTOR ? ssr : entry);
                    totalPainted += rounded !== $336f76290519985e$var$UNUSED_SECTOR ? 1 : 0;
                    if (rounded !== $336f76290519985e$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                });
            });
            const entries = Object.entries(lastUpdate).map((a)=>[
                    parseInt(a[0], 10),
                    a[1]
                ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
            const VC = $336f76290519985e$export$1f70d263701b1d01.makeVCReturnObj();
            const VCBox = $336f76290519985e$export$1f70d263701b1d01.makeVCReturnObj();
            entries.reduce((acc = 0, v)=>{
                const VCRatio = v[1] / totalPainted + acc;
                const time = v[0];
                $336f76290519985e$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                    const value = parseInt(key, 10);
                    if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                        VC[key] = time;
                        VCBox[key] = componentsLog[time]?.map((v)=>v.targetName);
                    }
                });
                return VCRatio;
            }, 0);
            const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
                const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
                const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                const logEntry = componentsLog[timestamp]?.map((v)=>v.targetName);
                acc.abs.push([
                    timestamp,
                    currentlyPainted
                ]);
                acc.rel.push({
                    time: timestamp,
                    vc: currentlyPaintedRatio,
                    elements: logEntry
                });
                return acc;
            }, {
                abs: [],
                rel: []
            });
            return {
                VC: VC,
                VCBox: VCBox,
                VCEntries: VCEntries,
                totalPainted: totalPainted
            };
        }
        setSSRElement(element) {
            this.observers.setReactRootElement(element);
        }
        setReactRootRenderStart(startTime = performance.now()) {
            this.observers.setReactRootRenderStart(startTime);
        }
        setReactRootRenderStop(stopTime = performance.now()) {
            this.observers.setReactRootRenderStop(stopTime);
        }
        setAbortReason(abort, timestamp, info = '') {
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                this.abortReason.reason = abort;
                this.abortReason.info = info;
                this.abortReason.timestamp = timestamp;
                this.abortReason.blocking = abort !== $336f76290519985e$var$abortReason.scroll;
                if (this.abortReason.blocking) this.detachAbortListeners();
            }
        }
        resetState() {
            this.abortReason = {
                reason: null,
                info: '',
                timestamp: -1,
                blocking: false
            };
            this.detachAbortListeners();
            this.heatmap = this.getCleanHeatmap();
            this.heatmapNext = this.getCleanHeatmap();
            this.totalTime = 0;
            this.componentsLog = {};
            this.vcRatios = {};
        }
        getCleanHeatmap() {
            return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($336f76290519985e$var$UNUSED_SECTOR));
        }
        setViewportSize() {
            this.viewport.w = (0, (0, parcelRequire("112a7")).getViewportWidth)();
            this.viewport.h = (0, (0, parcelRequire("112a7")).getViewportHeight)();
        }
        applyChangesToHeatMap(a, time, heatmap) {
            const { l: l, t: t, r: r, b: b } = a;
            const localHeatmap = heatmap;
            for(let row = t; row < b; row++){
                for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                    try {
                        this.setAbortReason($336f76290519985e$var$abortReason.error, time, `index - ${row}`);
                    } catch (e) {
                        this.setAbortReason($336f76290519985e$var$abortReason.error, time, 'row error');
                    }
                    return;
                } else localHeatmap[row][col] = time;
            }
        }
        static makeVCReturnObj() {
            const vc = {};
            $336f76290519985e$export$1f70d263701b1d01.VCParts.forEach((v)=>{
                vc[v] = null;
            });
            return vc;
        }
        detachAbortListeners() {
            this.unbind.forEach((fn)=>fn());
            this.unbind = [];
        }
        measureStart() {
            this._startMeasureTimestamp = performance.now();
        }
        measureStop() {
            if (this._startMeasureTimestamp === -1) return;
            this.totalTime += performance.now() - this._startMeasureTimestamp;
            this._startMeasureTimestamp = -1;
        }
    }
});
parcelRegister("chZM6", function(module, exports) {
    $parcel$export(module.exports, "attachAbortListeners", ()=>$f6e0157d6f483651$export$9010aa71841a6887);
    var $cBeZP;
    var $9jRau;
    var $112a7;
    const $f6e0157d6f483651$export$9010aa71841a6887 = (window, initialViewPort, callback)=>{
        const unbindWheel = (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: (0, (0, parcelRequire("9jRau")).AbortEvent).wheel,
            listener: (e)=>{
                callback((0, (0, parcelRequire("9jRau")).AbortEvent).wheel, e.timeStamp);
            },
            options: {
                passive: true,
                once: true
            }
        });
        const unbindKeydown = (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: (0, (0, parcelRequire("9jRau")).AbortEvent).keydown,
            listener: (e)=>{
                callback((0, (0, parcelRequire("9jRau")).AbortEvent).keydown, e.timeStamp);
            },
            options: {
                once: true
            }
        });
        const unbindResize = (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: (0, (0, parcelRequire("9jRau")).AbortEvent).resize,
            listener: (e)=>{
                if ((0, (0, parcelRequire("112a7")).getViewportWidth)() !== initialViewPort.w || (0, (0, parcelRequire("112a7")).getViewportHeight)() !== initialViewPort.h) {
                    callback((0, (0, parcelRequire("9jRau")).AbortEvent).resize, e.timeStamp);
                    unbindResize();
                }
            }
        });
        return [
            unbindWheel,
            unbindKeydown,
            unbindResize
        ];
    };
});
parcelRegister("9jRau", function(module, exports) {
    $parcel$export(module.exports, "AbortEvent", ()=>$e07a20e7466cdcdc$export$199edc0307b5587f);
    const $e07a20e7466cdcdc$export$199edc0307b5587f = {
        wheel: 'wheel',
        keydown: 'keydown',
        resize: 'resize'
    };
});
parcelRegister("112a7", function(module, exports) {
    $parcel$export(module.exports, "getViewportWidth", ()=>$0cc333a46c001328$export$a497a1dcb4408212);
    $parcel$export(module.exports, "getViewportHeight", ()=>$0cc333a46c001328$export$4f01c15d21ef9cc6);
    function $0cc333a46c001328$export$a497a1dcb4408212(document = window.document) {
        let documentWidth;
        try {
            documentWidth = document.documentElement.clientWidth || 0;
        } catch (e) {
            documentWidth = 0;
        }
        return Math.max(documentWidth, window.innerWidth || 0);
    }
    function $0cc333a46c001328$export$4f01c15d21ef9cc6(document = window.document) {
        let documentHeight;
        try {
            documentHeight = document.documentElement.clientHeight || 0;
        } catch (e) {
            documentHeight = 0;
        }
        return Math.max(documentHeight, window.innerHeight || 0);
    }
});
parcelRegister("4L4Do", function(module, exports) {
    $parcel$export(module.exports, "Observers", ()=>$ede9d1679d74ec8d$export$b65d046240060e78);
    var $294ns;
    var $hIR0E;
    var $iQ5zY;
    var $4e4AN;
    const $ede9d1679d74ec8d$var$state = {
        normal: 1,
        waitingForFirstRender: 2,
        ignoring: 3
    };
    class $ede9d1679d74ec8d$export$b65d046240060e78 {
        constructor(opts){
            this.observedMutations = new WeakMap();
            this.elementsInView = new Set();
            this.callbacks = new Set();
            this.totalTime = 0;
            this._startMeasureTimestamp = -1;
            this.ssr = {
                state: $ede9d1679d74ec8d$var$state.normal,
                reactRootElement: null,
                renderStart: -1,
                renderStop: -1
            };
            this.selectorConfig = {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            };
            this.subscribeResults = (cb)=>{
                this.callbacks.add(cb);
            };
            this.observeElement = (node, mutation, type, ignoreReason)=>{
                this.intersectionObserver?.observe(node);
                this.observedMutations.set(node, {
                    mutation: mutation,
                    ignoreReason: ignoreReason,
                    type: type
                });
            };
            this.selectorConfig = {
                ...this.selectorConfig,
                ...opts.selectorConfig
            };
            this.intersectionObserver = this.getIntersectionObserver();
            this.mutationObserver = this.getMutationObserver();
            this.ssrPlaceholderHandler = new (0, (0, parcelRequire("4e4AN")).SSRPlaceholderHandlers)();
            this.editorLnvHandler = new (0, (0, parcelRequire("iQ5zY")).EditorLnvHandler)();
        }
        isBrowserSupported() {
            return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
        }
        observe() {
            this.totalTime = 0;
            this.ssr = {
                state: $ede9d1679d74ec8d$var$state.normal,
                reactRootElement: null,
                renderStart: -1,
                renderStop: -1
            };
            this.mutationObserver?.observe(document.body, {
                attributeFilter: [
                    'hidden',
                    'style',
                    'src'
                ],
                attributeOldValue: true,
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        disconnect() {
            this.mutationObserver?.disconnect();
            this.intersectionObserver?.disconnect();
            this.observedMutations = new WeakMap();
            this.elementsInView = new Set();
            this.callbacks = new Set();
            this.ssr.reactRootElement = null;
            this.ssrPlaceholderHandler.clear();
            this.editorLnvHandler.clear();
        }
        getTotalTime() {
            return this.totalTime;
        }
        setReactRootElement(element) {
            this.ssr.reactRootElement = element;
        }
        setReactRootRenderStart(startTime = performance.now()) {
            this.ssr.renderStart = startTime;
            this.ssr.state = $ede9d1679d74ec8d$var$state.waitingForFirstRender;
        }
        setReactRootRenderStop(stopTime = performance.now()) {
            this.ssr.renderStop = stopTime;
        }
        getMutationObserver() {
            return this.isBrowserSupported() ? new MutationObserver((mutations)=>{
                this.measureStart();
                mutations.forEach((mutation)=>{
                    mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                    let ignoreReason = '';
                    if (this.ssr.state === $ede9d1679d74ec8d$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                        this.ssr.state = $ede9d1679d74ec8d$var$state.ignoring;
                        if (this.ssr.renderStop === -1) this.ssr.renderStop = mutation.timestamp + 500;
                        ignoreReason = 'ssr-hydration';
                    }
                    if (this.ssr.state === $ede9d1679d74ec8d$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                        if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                        else this.ssr.state = $ede9d1679d74ec8d$var$state.normal;
                    }
                    if (mutation.type === 'childList') {
                        mutation.addedNodes.forEach((node)=>{
                            if ((0, (0, parcelRequire("hIR0E")).isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                            if (node instanceof HTMLElement) {
                                if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                    this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                        if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                    });
                                    return;
                                }
                                if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                    this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                        if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                    });
                                    return;
                                }
                                if ((0, (0, parcelRequire("294ns")).fg)('platform_editor_ed-25557_lnv_add_ssr_placeholder')) {
                                    if (this.editorLnvHandler.shouldHandleAddedNode(node)) {
                                        this.editorLnvHandler.handleAddedNode(node).then(({ shouldIgnore: shouldIgnore })=>{
                                            this.observeElement(node, mutation, 'html', shouldIgnore ? 'editor-lazy-node-view' : ignoreReason);
                                        });
                                        return;
                                    }
                                }
                                this.observeElement(node, mutation, 'html', ignoreReason);
                            }
                            if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                        });
                        mutation.removedNodes.forEach((node)=>{
                            if (node instanceof Element) {
                                this.elementsInView.delete(node);
                                this.intersectionObserver?.unobserve(node);
                            }
                        });
                    } else if (mutation.type === 'attributes') {
                        if (mutation.target instanceof HTMLElement) {
                            if (mutation.attributeName === 'style' && this.getStyleDisplay(mutation.target.getAttribute('style')) !== this.getStyleDisplay(mutation.oldValue)) this.observeElement(mutation.target, mutation, 'attr', ignoreReason);
                        }
                    }
                });
                this.measureStop();
            }) : null;
        }
        getStyleDisplay(styleAttributeValue) {
            if (!styleAttributeValue) return undefined;
            const declarations = styleAttributeValue.split(';');
            for (const declaration of declarations){
                const [property, value] = declaration.split(':').map((part)=>part.trim());
                if (property && property.toLowerCase() === 'display') return value;
            }
            return undefined;
        }
        getElementName(element) {
            try {
                const tagName = element.localName;
                const dataVCAttr = element.getAttribute('data-vc');
                const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
                const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
                let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
                testId = testId ? `[testid=${testId}]` : '';
                let role = this.selectorConfig.role ? element.getAttribute('role') : '';
                role = role ? `[role=${role}]` : '';
                let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
                classList = classList === '' ? '' : `.${classList}`;
                const attrs = dataVC ? dataVC : [
                    id,
                    testId,
                    role
                ].join('');
                let idString = '';
                if (attrs === '' && classList === '') {
                    const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                    idString = `${parent} > ${tagName}`;
                } else idString = [
                    tagName,
                    attrs || classList
                ].join('');
                return idString;
            } catch (e) {
                return 'error';
            }
        }
        getIntersectionObserver() {
            return this.isBrowserSupported() ? new IntersectionObserver((entries)=>{
                this.measureStart();
                entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                    const data = this.observedMutations.get(target);
                    this.observedMutations.delete(target);
                    if (isIntersecting && ir.width > 0 && ir.height > 0) {
                        if (!(target instanceof HTMLElement)) return;
                        if (!data?.mutation) return;
                        if ((0, (0, parcelRequire("294ns")).fg)('platform-ufo-invisible-element-vc-calculations')) {
                            const isVisible = target.checkVisibility({
                                contentVisibilityAuto: true,
                                opacityProperty: true,
                                visibilityProperty: true
                            });
                            if (!isVisible) data.ignoreReason = 'not-visible';
                        }
                        this.callbacks.forEach((callback)=>{
                            let elementName;
                            try {
                                elementName = this.getElementName(target);
                            } catch (e) {
                                elementName = 'error';
                            }
                            callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason);
                        });
                        this.elementsInView.add(target);
                    } else this.elementsInView.delete(target);
                });
                this.measureStop();
            }) : null;
        }
        measureStart() {
            this._startMeasureTimestamp = performance.now();
        }
        measureStop() {
            if (this._startMeasureTimestamp === -1) return;
            this.totalTime += performance.now() - this._startMeasureTimestamp;
            this._startMeasureTimestamp = -1;
        }
    }
});
parcelRegister("hIR0E", function(module, exports) {
    $parcel$export(module.exports, "isContainedWithinMediaWrapper", ()=>$fcaf54f2ce3c921d$export$f61fbc3b9c4a9019);
    var $kNoDc;
    const $fcaf54f2ce3c921d$export$f61fbc3b9c4a9019 = (node)=>{
        while(node){
            if (node instanceof Element && node.hasAttribute((0, (0, parcelRequire("kNoDc")).MEDIA_WRAPPER_TAG))) return true;
            node = node.parentNode;
        }
        return false;
    };
});
parcelRegister("kNoDc", function(module, exports) {
    $parcel$export(module.exports, "MEDIA_WRAPPER_TAG", ()=>$f3372f8fbdb2b0a4$export$7674290405cc25b0);
    $parcel$export(module.exports, "VcMediaWrapperProps", ()=>$f3372f8fbdb2b0a4$export$7028e9efe569888c);
    var $5uXOq = parcelRequire("5uXOq");
    const $f3372f8fbdb2b0a4$export$7674290405cc25b0 = 'data-media-vc-wrapper';
    const $f3372f8fbdb2b0a4$export$7028e9efe569888c = {
        [$f3372f8fbdb2b0a4$export$7674290405cc25b0]: true
    };
    function $f3372f8fbdb2b0a4$export$2e2bcd8739ae039({ children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", $f3372f8fbdb2b0a4$export$7028e9efe569888c, children);
    }
});
parcelRegister("iQ5zY", function(module, exports) {
    $parcel$export(module.exports, "EditorLnvHandler", ()=>$2f0d9de1e316b9e0$export$569bcb41b9a84ec8);
    const $2f0d9de1e316b9e0$var$placeholderDataKey = 'editorLnvPlaceholder';
    const $2f0d9de1e316b9e0$var$replaceDataKey = 'editorLnvPlaceholderReplace';
    class $2f0d9de1e316b9e0$export$569bcb41b9a84ec8 {
        constructor(){
            this.placeholders = new Map();
            this.getSizeCallbacks = new Map();
            this.isAddedPlaceholderMatchingSizeCallbacks = new Map();
            this.isAddedReplaceMatchingSizeCallbacks = new Map();
            this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
                this.intersectionObserver.unobserve(target);
                if (!(target instanceof HTMLElement)) return;
                const placeholderId = target.dataset?.[$2f0d9de1e316b9e0$var$placeholderDataKey];
                if (placeholderId && this.getSizeCallbacks.has(placeholderId)) {
                    const resolve = this.getSizeCallbacks.get(placeholderId);
                    this.getSizeCallbacks.delete(placeholderId);
                    if (!resolve) return;
                    resolve({
                        x: boundingClientRect.x,
                        y: boundingClientRect.y,
                        width: boundingClientRect.width,
                        height: boundingClientRect.height
                    });
                    return;
                }
                if (placeholderId && this.isAddedPlaceholderMatchingSizeCallbacks.has(placeholderId)) {
                    const resolve = this.isAddedPlaceholderMatchingSizeCallbacks.get(placeholderId);
                    this.isAddedPlaceholderMatchingSizeCallbacks.delete(placeholderId);
                    if (!resolve) return;
                    const placeholder = this.placeholders.get(placeholderId);
                    if (!placeholder) {
                        resolve(false);
                        return;
                    }
                    resolve(this.areRectsSameSize(placeholder, boundingClientRect));
                    return;
                }
                const replaceId = target.dataset?.[$2f0d9de1e316b9e0$var$replaceDataKey];
                if (replaceId && this.isAddedReplaceMatchingSizeCallbacks.has(replaceId)) {
                    const resolve = this.isAddedReplaceMatchingSizeCallbacks.get(replaceId);
                    this.isAddedReplaceMatchingSizeCallbacks.delete(replaceId);
                    if (!resolve) return;
                    const placeholder = this.placeholders.get(replaceId);
                    if (!placeholder) {
                        resolve(false);
                        return;
                    }
                    this.placeholders.delete(replaceId);
                    resolve(this.areRectsSameSize(placeholder, boundingClientRect));
                    return;
                }
            };
            this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        }
        shouldHandleAddedNode(el) {
            return el.dataset?.[$2f0d9de1e316b9e0$var$placeholderDataKey] || el.dataset?.[$2f0d9de1e316b9e0$var$replaceDataKey];
        }
        handleAddedNode(el) {
            const placeholderId = el.dataset?.[$2f0d9de1e316b9e0$var$placeholderDataKey];
            if (placeholderId) return this.handleAddedPlaceholderNode(el, placeholderId);
            const replaceId = el.dataset?.[$2f0d9de1e316b9e0$var$replaceDataKey];
            if (replaceId) return this.handleAddedReplaceNode(el, replaceId);
            return Promise.resolve({
                shouldIgnore: false
            });
        }
        clear() {
            this.placeholders.clear();
            this.intersectionObserver.disconnect();
        }
        handleAddedPlaceholderNode(el, placeholderId) {
            if (this.isExistingPlaceholder(placeholderId)) return this.isAddedPlaceholderMatchingSize(el, placeholderId).then((isMatching)=>({
                    shouldIgnore: isMatching
                }));
            return this.registerPlaceholder(el, placeholderId).then(()=>({
                    shouldIgnore: false
                }));
        }
        handleAddedReplaceNode(el, placeholderId) {
            if (this.isExistingPlaceholder(placeholderId)) return this.isAddedReplaceMatchingSize(el, placeholderId).then((isMatching)=>({
                    shouldIgnore: isMatching
                }));
            return Promise.resolve({
                shouldIgnore: false
            });
        }
        isExistingPlaceholder(placeholderId) {
            return this.placeholders.has(placeholderId);
        }
        registerPlaceholder(el, placeholderId) {
            return this.getSize(el, placeholderId).then((size)=>{
                this.placeholders.set(placeholderId, size);
            });
        }
        getSize(el, placeholderId) {
            return new Promise((resolve)=>{
                this.getSizeCallbacks.set(placeholderId, resolve);
                this.intersectionObserver.observe(el);
            });
        }
        isAddedPlaceholderMatchingSize(el, placeholderId) {
            return new Promise((resolve)=>{
                this.isAddedPlaceholderMatchingSizeCallbacks.set(placeholderId, resolve);
                this.intersectionObserver.observe(el);
            });
        }
        isAddedReplaceMatchingSize(el, placeholderId) {
            return new Promise((resolve)=>{
                this.isAddedReplaceMatchingSizeCallbacks.set(placeholderId, resolve);
                this.intersectionObserver.observe(el);
            });
        }
        areRectsSameSize(a, b) {
            return Math.abs(a.width - b.width) < 1 && Math.abs(a.height - b.height) < 1;
        }
    }
});
parcelRegister("4e4AN", function(module, exports) {
    $parcel$export(module.exports, "SSRPlaceholderHandlers", ()=>$010f6199a8487d86$export$c0102f1a1198d10f);
    const $010f6199a8487d86$var$EQUALITY_THRESHOLD = 0.1;
    const $010f6199a8487d86$var$ANCESTOR_LOOKUP_LIMIT = 10;
    class $010f6199a8487d86$export$c0102f1a1198d10f {
        constructor(){
            this.staticPlaceholders = new Map();
            this.callbacks = new Map();
            this.getSizeCallbacks = new Map();
            this.reactValidateCallbacks = new Map();
            this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
                this.intersectionObserver.unobserve(target);
                if (!(target instanceof HTMLElement)) return;
                const staticKey = target.dataset.ssrPlaceholder || '';
                if (staticKey) {
                    if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                        const resolve = this.callbacks.get(staticKey);
                        if (!resolve) return;
                        const rect = this.staticPlaceholders.get(staticKey);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                        resolve(hasSameSizePosition);
                        this.callbacks.delete(staticKey);
                    }
                } else {
                    const key = target.dataset.ssrPlaceholderReplace || '';
                    const resolve = this.reactValidateCallbacks.get(key);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(key);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    resolve(hasSameSizePosition);
                    this.staticPlaceholders.delete(staticKey);
                    this.reactValidateCallbacks.delete(staticKey);
                }
            };
            this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
            if (window.document) try {
                const existingElements = document.querySelectorAll('[data-ssr-placeholder]');
                existingElements.forEach((el)=>{
                    if (el instanceof HTMLElement && el?.dataset?.ssrPlaceholder) {
                        let width = -1;
                        let height = -1;
                        let x = -1;
                        let y = -1;
                        const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[el.dataset.ssrPlaceholder];
                        if (boundingClientRect) {
                            width = boundingClientRect.width;
                            height = boundingClientRect.height;
                            x = boundingClientRect.x;
                            y = boundingClientRect.y;
                        }
                        this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
                            width: width,
                            height: height,
                            x: x,
                            y: y
                        });
                        this.intersectionObserver.observe(el);
                    }
                });
            } catch (e) {} finally{
                delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
            }
        }
        clear() {
            this.staticPlaceholders = new Map();
            this.callbacks = new Map();
            this.getSizeCallbacks = new Map();
            this.reactValidateCallbacks = new Map();
        }
        isPlaceholder(element) {
            return Boolean(element.dataset.ssrPlaceholder);
        }
        isPlaceholderReplacement(element) {
            return Boolean(element.dataset.ssrPlaceholderReplace);
        }
        isPlaceholderIgnored(element) {
            return 'ssrPlaceholderIgnored' in element.dataset;
        }
        findNearestPlaceholderContainerIfIgnored(element) {
            if (!this.isPlaceholderIgnored(element)) return element;
            let ancestor = element.parentElement;
            let i = 0;
            while(ancestor && i < $010f6199a8487d86$var$ANCESTOR_LOOKUP_LIMIT){
                if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                ancestor = ancestor.parentElement;
                i++;
            }
            return element;
        }
        checkIfExistedAndSizeMatching(el) {
            el = this.findNearestPlaceholderContainerIfIgnored(el);
            const id = el.dataset.ssrPlaceholder || '';
            return new Promise((resolve)=>{
                if (!this.staticPlaceholders.has(id)) {
                    resolve(false);
                    return;
                } else {
                    this.callbacks.set(id, resolve);
                    this.intersectionObserver.observe(el);
                }
            });
        }
        getSize(el) {
            return new Promise((resolve)=>{
                this.getSizeCallbacks.set(el.dataset.ssrPlaceholder || '', resolve);
                this.intersectionObserver.observe(el);
            });
        }
        validateReactComponentMatchToPlaceholder(el) {
            el = this.findNearestPlaceholderContainerIfIgnored(el);
            const id = el.dataset.ssrPlaceholderReplace || '';
            return new Promise((resolve)=>{
                if (!this.staticPlaceholders.has(id)) {
                    resolve(false);
                    return;
                } else {
                    this.reactValidateCallbacks.set(id, resolve);
                    this.intersectionObserver.observe(el);
                }
            });
        }
        hasSameSizePosition(rect, boundingClientRect) {
            return rect && Math.abs(rect.x - boundingClientRect.x) < $010f6199a8487d86$var$EQUALITY_THRESHOLD && Math.abs(rect.y - boundingClientRect.y) < $010f6199a8487d86$var$EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < $010f6199a8487d86$var$EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < $010f6199a8487d86$var$EQUALITY_THRESHOLD || false;
        }
    }
});
parcelRegister("8RRQy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98964913c265eba9$export$2e2bcd8739ae039);
    const $98964913c265eba9$var$interactions = new Map();
    var $98964913c265eba9$export$2e2bcd8739ae039 = $98964913c265eba9$var$interactions;
});
parcelRegister("ciQm5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc9ffb63570ef533$export$2e2bcd8739ae039);
    var $9HC2N;
    var $jztB7;
    const $cc9ffb63570ef533$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
    class $cc9ffb63570ef533$export$2e2bcd8739ae039 {
        initializeVCObserver(options) {
            if (this.vcObserver === null) this.vcObserver = new (0, (0, parcelRequire("jztB7")).VCObserver)({
                ...options,
                isPostInteraction: true
            });
        }
        startVCObserver({ startTime: startTime }) {
            this.vcObserver?.start({
                startTime: startTime
            });
        }
        setVCObserverSSRConfig(vcObserverSSRConfig) {
            this.vcObserverSSRConfig = vcObserverSSRConfig;
        }
        setLastInteractionFinishVCResult(result) {
            this.lastInteractionFinishVCResult = result;
        }
        sinkHandler(sinkHandlerFn) {
            this.sinkHandlerFn = sinkHandlerFn;
        }
        reset() {
            this.lastInteractionFinish = null;
            this.reactProfilerTimings = [];
            if (this.sinkTimeoutId != null) {
                clearTimeout(this.sinkTimeoutId);
                this.sinkTimeoutId = null;
            }
            this.setVCObserverSSRConfig(null);
        }
        hasData() {
            return this.reactProfilerTimings?.length > 0;
        }
        sendPostInteractionLog() {
            if (!this.hasData() || !this.lastInteractionFinish || !this.sinkHandlerFn) {
                this.reset();
                return;
            }
            this.sinkHandlerFn({
                lastInteractionFinish: this.lastInteractionFinish,
                reactProfilerTimings: this.reactProfilerTimings,
                postInteractionFinishVCResult: this.vcObserver?.getVCResult({
                    start: this.lastInteractionFinish.start,
                    stop: performance.now(),
                    tti: -1,
                    prefix: 'ufo',
                    ...this.vcObserverSSRConfig
                }),
                lastInteractionFinishVCResult: this.lastInteractionFinishVCResult
            });
            this.reset();
        }
        onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type }) {
            this.lastInteractionFinish = {
                ufoName: ufoName,
                start: start,
                end: end,
                id: id,
                abortReason: abortReason,
                abortedByInteractionName: abortedByInteractionName,
                routeName: routeName,
                type: type
            };
            const timeout = (0, (0, parcelRequire("9HC2N")).getConfig)()?.timeWindowForLateMutationsInMilliseconds || $cc9ffb63570ef533$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
            this.sinkTimeoutId = window.setTimeout(()=>{
                this.sendPostInteractionLog();
            }, timeout);
        }
        addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
            if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                type: type,
                actualDuration: actualDuration,
                baseDuration: baseDuration,
                startTime: startTime,
                commitTime: commitTime,
                labelStack: labelStack
            });
        }
        constructor(){
            this.lastInteractionFinish = null;
            this.reactProfilerTimings = [];
            this.sinkTimeoutId = null;
            this.vcObserver = null;
            this.vcObserverSSRConfig = null;
            this.sinkHandlerFn = ()=>{};
        }
    }
});
parcelRegister("5o4Qk", function(module, exports) {
    $parcel$export(module.exports, "addTimingFromPerformanceMark", ()=>$af546d393af357b0$export$758b9a33800fa436);
    $parcel$export(module.exports, "getTimings", ()=>$af546d393af357b0$export$6d488733a547304);
    const $af546d393af357b0$var$timings = [];
    function $af546d393af357b0$export$758b9a33800fa436(name, startMark, stopMark, cleanStart = false, cleanStop = false) {
        $af546d393af357b0$var$timings.push({
            name: name,
            startMark: startMark,
            stopMark: stopMark,
            cleanStart: cleanStart,
            cleanStop: cleanStop
        });
    }
    function $af546d393af357b0$export$6d488733a547304() {
        const reportedTimingsObj = {};
        $af546d393af357b0$var$timings.forEach(({ name: name, startMark: startMark, stopMark: stopMark, cleanStart: cleanStart, cleanStop: cleanStop })=>{
            const startEntryList = performance.getEntriesByName(startMark);
            const stopEntryList = performance.getEntriesByName(stopMark);
            if (startEntryList?.length > 0 && stopEntryList?.length > 0) {
                const startEntry = startEntryList[startEntryList.length - 1];
                const stopEntry = stopEntryList[stopEntryList.length - 1];
                const { startTime: startTime } = startEntry;
                const duration = stopEntry.startTime - startTime;
                const timing = {
                    startTime: Math.round(startTime),
                    duration: Math.round(duration)
                };
                reportedTimingsObj[name] = timing;
            }
            if (cleanStart) performance.clearMarks(startMark);
            if (cleanStop) performance.clearMarks(stopMark);
        });
        return reportedTimingsObj;
    }
});
parcelRegister("19hl5", function(module, exports) {
    $parcel$export(module.exports, "browserMetrics", ()=>$205910301d06aff8$export$c08e7affcf78b064);
    var $jMYZH;
    var $9s5ra;
    var $9QLE7;
    var $5X7fp;
    var $hHWTZ;
    var $8bDkf;
    var $37Ee8;
    var $7vk4a;
    const $205910301d06aff8$var$makeBrowserMetrics = ()=>{
        const bm = {
            init (config) {
                (0, (0, parcelRequire("5X7fp")).visibilityChangeObserver).start();
                if (config.events[(0, (0, parcelRequire("7vk4a")).BMEventsType).WEB_VITALS]?.enabled) (0, (0, parcelRequire("hHWTZ")).webVitalsObserver).start();
                if (config.debug) {
                    (0, (0, parcelRequire("9s5ra")).logger).enable();
                    (0, (0, parcelRequire("37Ee8")).submitter).setDebug(true);
                    (0, (0, parcelRequire("9QLE7")).pageLoadMetaMetric).setDebug(true);
                }
                (0, (0, parcelRequire("37Ee8")).submitter).configure(config);
                if (config.ssr?.getDoneMark) (0, (0, parcelRequire("jMYZH")).SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
            },
            setRoute (newRoute) {
                (0, (0, parcelRequire("8bDkf")).Route).setRoute(newRoute);
            },
            startPageLoad (params) {
                (0, (0, parcelRequire("9QLE7")).pageLoadMetaMetric).startPageLoad({
                    isInitial: false,
                    cancelStarted: true,
                    ...params
                });
            },
            getPageLoadMetric () {
                return 0, (0, parcelRequire("9QLE7")).pageLoadMetaMetric;
            },
            experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
                if (initialOnly && !(0, (0, parcelRequire("9QLE7")).pageLoadMetaMetric).isInitialLoad()) return;
                const start = performance.getEntriesByName(startMark);
                const stop = performance.getEntriesByName(stopMark);
                if (start.length > 0 && stop.length > 0) {
                    if ((0, (0, parcelRequire("9QLE7")).pageLoadMetaMetric).isDebugMode()) try {
                        performance.measure(name, startMark, stopMark);
                    } catch (e) {}
                    const pageLoadData = (0, (0, parcelRequire("9QLE7")).pageLoadMetaMetric).getData();
                    if (pageLoadData.start !== null) {
                        const startMark = start[start.length - 1];
                        const timing = {
                            startTime: Math.round(startMark.startTime - pageLoadData.start),
                            duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                        };
                        (0, (0, parcelRequire("9QLE7")).pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                    }
                }
            }
        };
        return bm;
    };
    const $205910301d06aff8$export$c08e7affcf78b064 = $205910301d06aff8$var$makeBrowserMetrics();
});
parcelRegister("jMYZH", function(module, exports) {
    $parcel$export(module.exports, "SSRGetDoneMark", ()=>$c588b7c4a7e2d84b$export$9e87a201397ac0a9);
    const $c588b7c4a7e2d84b$export$9e87a201397ac0a9 = {
        getDoneMark: ()=>null,
        setGetDoneMark: (fn)=>{
            $c588b7c4a7e2d84b$export$9e87a201397ac0a9.getDoneMark = fn;
        }
    };
});
parcelRegister("9s5ra", function(module, exports) {
    $parcel$export(module.exports, "logger", ()=>$30f8b99f1e758218$export$af88d00dbe7f521);
    const $30f8b99f1e758218$export$af88d00dbe7f521 = {
        enabled: false,
        enable () {
            this.enabled = true;
        },
        log (...args) {
            if (this.enabled) console.log('BM log: ', ...args);
        },
        logCond (condition, ...args) {
            if (this.enabled && condition && args.length > 1) this.log(...args);
        }
    };
});
parcelRegister("9QLE7", function(module, exports) {
    $parcel$export(module.exports, "pageLoadMetaMetric", ()=>$18c368a57a806aed$export$24b7a1a311eb05dc);
    var $7vk4a;
    var $dSGYO;
    var $abxLD;
    class $18c368a57a806aed$export$9609608c00ea5077 extends (0, (0, parcelRequire("abxLD")).BasePageLoadMetric) {
        startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
            isInitial: false,
            cancelStarted: false
        }) {
            if (cancelStarted || this.state !== (0, (0, parcelRequire("dSGYO")).MetricState).STARTED) super.startPageLoad(startPageLoadParams);
        }
        setActive(metric) {
            this.activePageLoadMetric = metric;
        }
        setDebug(debug) {
            this.config.debug = debug;
        }
        isDebugMode() {
            return this.config.debug;
        }
        isInitialLoad() {
            return this.isInitial;
        }
        clear() {
            this.activePageLoadMetric && this.activePageLoadMetric.cancel();
            super.clear();
        }
        include(metric) {
            if (!this.config.include) this.config.include = [
                metric
            ];
            else this.config.include.push(metric);
        }
        experimental__addExplicitTiming(name, timing) {
            if (this.explicitTimings === null) this.explicitTimings = {};
            this.explicitTimings[name] = timing;
        }
        constructor(...args){
            super(...args), this.activePageLoadMetric = null;
        }
    }
    const $18c368a57a806aed$export$24b7a1a311eb05dc = new $18c368a57a806aed$export$9609608c00ea5077({
        type: (0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_LOAD,
        key: 'page_load_meta_metric'
    });
});
parcelRegister("7vk4a", function(module, exports) {
    $parcel$export(module.exports, "BMEventsType", ()=>$614a89dd4006becb$export$9c73e297d4be9159);
    $parcel$export(module.exports, "StorableBMEventsType", ()=>$614a89dd4006becb$export$9b7037ec30489597);
    $parcel$export(module.exports, "BMPageLoadMetrics", ()=>$614a89dd4006becb$export$74c1fb0997d51e2a);
    $parcel$export(module.exports, "BMPageSegmentLoadMetrics", ()=>$614a89dd4006becb$export$88195ac8200d03a6);
    $parcel$export(module.exports, "BMInteractionMetrics", ()=>$614a89dd4006becb$export$6e28252a002afdb2);
    $parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", ()=>$614a89dd4006becb$export$474154836bfd8dd9);
    $parcel$export(module.exports, "PageVisibleFields", ()=>$614a89dd4006becb$export$e89802082dab5633);
    $parcel$export(module.exports, "PageVisibleValueOrigin", ()=>$614a89dd4006becb$export$983b017156c2aee2);
    $parcel$export(module.exports, "isDetailedPageLoadSlo", ()=>$614a89dd4006becb$export$5866f95702a15142);
    $parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", ()=>$614a89dd4006becb$export$f087a59bd717e49d);
    $parcel$export(module.exports, "isInteractionMetricsSlo", ()=>$614a89dd4006becb$export$b10c1d9a7db7765b);
    $parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", ()=>$614a89dd4006becb$export$60c0193054fc3040);
    var $dSGYO;
    var $614a89dd4006becb$export$9c73e297d4be9159;
    (function(BMEventsType) {
        BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
        BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
        BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
        BMEventsType["CUSTOM"] = "CUSTOM";
        BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    })($614a89dd4006becb$export$9c73e297d4be9159 || ($614a89dd4006becb$export$9c73e297d4be9159 = {}));
    var $614a89dd4006becb$export$9b7037ec30489597;
    (function(StorableBMEventsType) {
        StorableBMEventsType["PAGE_LOAD"] = "page-load";
        StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
        StorableBMEventsType["INLINE_RESULT"] = "inline-result";
        StorableBMEventsType["CUSTOM"] = "custom";
        StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    })($614a89dd4006becb$export$9b7037ec30489597 || ($614a89dd4006becb$export$9b7037ec30489597 = {}));
    var $614a89dd4006becb$export$74c1fb0997d51e2a;
    (function(BMPageLoadMetrics) {
        BMPageLoadMetrics["fmp"] = "fmp";
        BMPageLoadMetrics["tti"] = "tti";
    })($614a89dd4006becb$export$74c1fb0997d51e2a || ($614a89dd4006becb$export$74c1fb0997d51e2a = {}));
    var $614a89dd4006becb$export$88195ac8200d03a6;
    (function(BMPageSegmentLoadMetrics) {
        BMPageSegmentLoadMetrics["fmp"] = "fmp";
        BMPageSegmentLoadMetrics["tti"] = "tti";
    })($614a89dd4006becb$export$88195ac8200d03a6 || ($614a89dd4006becb$export$88195ac8200d03a6 = {}));
    var $614a89dd4006becb$export$6e28252a002afdb2;
    (function(BMInteractionMetrics) {
        BMInteractionMetrics["response"] = "response";
        BMInteractionMetrics["result"] = "result";
    })($614a89dd4006becb$export$6e28252a002afdb2 || ($614a89dd4006becb$export$6e28252a002afdb2 = {}));
    var $614a89dd4006becb$export$474154836bfd8dd9;
    (function(PageSegmentPageLoadMetricsOptions) {
        PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
        PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
        PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    })($614a89dd4006becb$export$474154836bfd8dd9 || ($614a89dd4006becb$export$474154836bfd8dd9 = {}));
    var $614a89dd4006becb$export$e89802082dab5633;
    (function(PageVisibleFields) {
        PageVisibleFields["pageVisibleState"] = "page-visible-state";
        PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    })($614a89dd4006becb$export$e89802082dab5633 || ($614a89dd4006becb$export$e89802082dab5633 = {}));
    var $614a89dd4006becb$export$983b017156c2aee2;
    (function(PageVisibleValueOrigin) {
        PageVisibleValueOrigin["documentHidden"] = "document-hidden";
        PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    })($614a89dd4006becb$export$983b017156c2aee2 || ($614a89dd4006becb$export$983b017156c2aee2 = {}));
    const $614a89dd4006becb$export$5866f95702a15142 = (data)=>{
        return Boolean(data.initial);
    };
    const $614a89dd4006becb$export$f087a59bd717e49d = (data)=>{
        return Boolean(data.initial);
    };
    const $614a89dd4006becb$export$153c4c72fa5eeece = (data)=>{
        const obj = data;
        return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
    };
    const $614a89dd4006becb$export$b10c1d9a7db7765b = (data)=>{
        const obj = data;
        return Boolean(obj.result !== undefined || obj.response !== undefined);
    };
    var $614a89dd4006becb$export$60c0193054fc3040;
    (function(IncludeSSRFeatureFlagsConfig) {
        IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
        IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
        IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    })($614a89dd4006becb$export$60c0193054fc3040 || ($614a89dd4006becb$export$60c0193054fc3040 = {}));
});
parcelRegister("dSGYO", function(module, exports) {
    $parcel$export(module.exports, "MetricState", ()=>$84d8596d631cceba$export$1e458f18c0c7bfe3);
    $parcel$export(module.exports, "PageVisibleState", ()=>$84d8596d631cceba$export$a12c67b37a306b13);
    $parcel$export(module.exports, "BaseMetric", ()=>$84d8596d631cceba$export$2bce4ffdd840e878);
    var $bvZfX;
    var $9s5ra;
    var $5X7fp;
    var $9t3P8;
    var $84d8596d631cceba$export$1e458f18c0c7bfe3;
    (function(MetricState) {
        MetricState["NOT_STARTED"] = "not-started";
        MetricState["STARTED"] = "started";
        MetricState["FINISHED"] = "finished";
        MetricState["CANCELLED"] = "cancelled";
    })($84d8596d631cceba$export$1e458f18c0c7bfe3 || ($84d8596d631cceba$export$1e458f18c0c7bfe3 = {}));
    var $84d8596d631cceba$export$a12c67b37a306b13;
    (function(PageVisibleState) {
        PageVisibleState["VISIBLE"] = "visible";
        PageVisibleState["MIXED"] = "mixed";
        PageVisibleState["HIDDEN"] = "hidden";
    })($84d8596d631cceba$export$a12c67b37a306b13 || ($84d8596d631cceba$export$a12c67b37a306b13 = {}));
    function $84d8596d631cceba$var$getPageVisibleState() {
        return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
    }
    class $84d8596d631cceba$export$2bce4ffdd840e878 {
        static{
            this.FMP = 'fmp';
        }
        constructor(config){
            this.state = "not-started";
            this.startTime = null;
            this.stopTime = null;
            this.marks = {};
            this.onStopCallbacks = [];
            this.custom = null;
            this.submetrics = [];
            this.route = null;
            this.untilOnStopCallback = null;
            this.pageVisibleState = $84d8596d631cceba$var$getPageVisibleState();
            this.setPageVisibleStateToMixed = ()=>{
                this.pageVisibleState = "mixed";
            };
            this.config = config;
            this.key = config.key.replace(/ /gi, '-');
            this.type = config.type;
            this.config.timings?.forEach((entry)=>{
                if ((0, (0, parcelRequire("bvZfX")).restrictedTimingKeys).includes(entry.key)) {
                    console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                    entry.key = `custom__${entry.key}`;
                }
            });
        }
        get untilMetrics() {
            const { until: until } = this.config;
            if (!until) return [];
            else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
            return this.getConfiguredUntilMetricArray([
                until
            ]);
        }
        start({ startTime: startTime = window.performance.now() } = {}) {
            this.clear();
            (0, (0, parcelRequire("9s5ra")).logger).logCond(!!this.config.debug, this.key, startTime);
            this.state = "started";
            this.startTime = startTime;
            this.pageVisibleState = $84d8596d631cceba$var$getPageVisibleState();
            (0, (0, parcelRequire("5X7fp")).visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            this.watchUntil();
        }
        stop(stopArguments = {}) {
            const { stopTime: stopTime = window.performance.now() } = stopArguments;
            if (this.state !== "started" || this.startTime === null) {
                (0, (0, parcelRequire("9s5ra")).logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
                return false;
            }
            if (stopTime < this.startTime) {
                (0, (0, parcelRequire("9s5ra")).logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
                return false;
            }
            this.stopTime = stopTime;
            this.state = "finished";
            this.handleStop(stopArguments);
            (0, (0, parcelRequire("5X7fp")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            return true;
        }
        handleStop(stopArguments) {
            const { customData: customData = null } = stopArguments;
            if (customData) this.custom = {
                ...this.custom,
                ...customData
            };
            this.config.include && this.config.include.forEach((metric)=>{
                const included = metric.getData();
                if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
            });
            this.onStopCallbacks.forEach(([success])=>{
                success(stopArguments);
            });
            this.onStopCallbacks = [];
            (0, (0, parcelRequire("9s5ra")).logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
        }
        mark(mark, timestamp = window.performance.now()) {
            this.marks[mark] = timestamp;
        }
        cancel() {
            if (this.state !== "started") return;
            this.state = "cancelled";
            this.cancelUntil();
            this.onStopCallbacks.forEach(([, cancel])=>{
                cancel();
            });
            this.onStopCallbacks = [];
            (0, (0, parcelRequire("5X7fp")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        }
        merge(mergeData) {
            this.state = mergeData.state;
            this.pageVisibleState = mergeData.pageVisibleState;
            this.startTime = mergeData.start;
            this.stopTime = mergeData.stop;
            this.marks = {
                ...this.marks,
                ...mergeData.marks
            };
            this.submetrics = [
                ...this.submetrics,
                ...mergeData.submetrics
            ];
            this.onStopCallbacks = [
                ...this.onStopCallbacks,
                ...mergeData.onStopCallbacks
            ];
        }
        onStop(success, cancel) {
            this.onStopCallbacks.push([
                success,
                cancel
            ]);
        }
        removeOnStopCallback(success) {
            const index = this.onStopCallbacks.findIndex(([successCallback])=>{
                return success === successCallback;
            });
            if (index > -1) this.onStopCallbacks.splice(index, 1);
        }
        getData() {
            return {
                key: this.key,
                state: this.state,
                start: this.startTime,
                stop: this.stopTime,
                marks: this.marks,
                custom: this.custom,
                submetrics: this.submetrics,
                config: this.config,
                route: this.route,
                pageVisibleState: this.pageVisibleState,
                type: this.config.type
            };
        }
        getDataToMerge() {
            return {
                ...this.getData(),
                onStopCallbacks: this.onStopCallbacks
            };
        }
        addSubMetric(data) {
            this.submetrics.push(data);
        }
        getConfiguredUntilMetric(metricOrConfig) {
            return metricOrConfig instanceof $84d8596d631cceba$export$2bce4ffdd840e878 ? (0, (0, parcelRequire("9t3P8")).UntilExperience).fromMetric(metricOrConfig) : (0, (0, parcelRequire("9t3P8")).UntilExperience).fromConfig(metricOrConfig);
        }
        getConfiguredUntilMetricArray(metricArray) {
            if (!metricArray.length) return [];
            return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
        }
        isUntilFinished() {
            return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
        }
        handleAllUntilFinished() {
            const sorted = [
                ...this.untilMetrics
            ].sort((m1, m2)=>{
                return m1.getDependencyStopTime() - m2.getDependencyStopTime();
            });
            const latestFullyInteractiveSegment = [
                ...this.untilMetrics
            ].reduce((currentLatestSegment, metric)=>{
                const currentLatestStopTime = currentLatestSegment?.getFullyInteractiveStopTime() ?? 0;
                const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
                return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
            }, undefined);
            const accumulatedCustomData = {};
            sorted.forEach((metric)=>{
                Object.assign(accumulatedCustomData, metric.experience.getData().custom);
            });
            const latestSegment = sorted[sorted.length - 1];
            const latestFullyInteractiveStopTime = latestFullyInteractiveSegment?.getFullyInteractiveStopTime();
            this.stop({
                stopTime: latestSegment.getDependencyStopTime(),
                customData: {
                    ...accumulatedCustomData,
                    segment: latestSegment.getKey(),
                    segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                    ...latestFullyInteractiveStopTime ? {
                        latestFullyInteractiveSegment: latestFullyInteractiveSegment?.getKey(),
                        latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                    } : {}
                }
            });
        }
        watchUntil() {
            if (!this.untilMetrics.length) return;
            if (this.isUntilFinished()) {
                this.handleAllUntilFinished();
                return;
            }
            this.untilOnStopCallback = ()=>{
                if (this.isUntilFinished()) this.handleAllUntilFinished();
            };
            this.untilMetrics.forEach((metric)=>{
                if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
            });
        }
        cancelUntil() {
            this.untilMetrics.forEach((metric)=>{
                if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
            });
        }
        clear() {
            this.cancelUntil();
            this.state = "not-started";
            this.startTime = null;
            this.stopTime = null;
            this.marks = {};
            this.custom = null;
            this.submetrics = [];
            this.route = null;
            this.pageVisibleState = $84d8596d631cceba$var$getPageVisibleState();
        }
    }
});
parcelRegister("bvZfX", function(module, exports) {
    $parcel$export(module.exports, "restrictedTimingKeys", ()=>$02e2eb46e160fa80$export$1d17377365286b00);
    $parcel$export(module.exports, "clsWaitTimeMs", ()=>$02e2eb46e160fa80$export$df21d285cfcda81e);
    const $02e2eb46e160fa80$export$1d17377365286b00 = [
        'ssr'
    ];
    const $02e2eb46e160fa80$export$df21d285cfcda81e = 7500;
});
parcelRegister("5X7fp", function(module, exports) {
    $parcel$export(module.exports, "visibilityChangeObserver", ()=>$abeb3715b87aebd6$export$13e680397ec8f3eb);
    class $abeb3715b87aebd6$var$VisibilityChangeObserver {
        start() {
            document.addEventListener('visibilitychange', this.broadcast);
            window.addEventListener('pagehide', this.broadcast);
        }
        subscribe(callback) {
            this.observers.push(callback);
        }
        unsubscribe(callback) {
            this.observers = this.observers.filter((fn)=>fn !== callback);
        }
        constructor(){
            this.observers = [];
            this.broadcast = ()=>{
                this.observers.forEach((fn)=>fn());
                this.observers = [];
            };
        }
    }
    const $abeb3715b87aebd6$export$13e680397ec8f3eb = new $abeb3715b87aebd6$var$VisibilityChangeObserver();
});
parcelRegister("9t3P8", function(module, exports) {
    $parcel$export(module.exports, "UntilExperience", ()=>$3617950edd41435c$export$3fcc0936ee2cc852);
    class $3617950edd41435c$export$3fcc0936ee2cc852 {
        static{
            this.FMP = 'fmp';
        }
        static fromConfig(config) {
            return new $3617950edd41435c$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
        }
        static fromMetric(metric) {
            return new $3617950edd41435c$export$3fcc0936ee2cc852(metric);
        }
        constructor(experience, useFmpAsUntilStopTime){
            this.experience = experience;
            this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
        }
        getFmp() {
            const { marks: marks, stop: stop } = this.experience.getData();
            return marks[$3617950edd41435c$export$3fcc0936ee2cc852.FMP] ?? stop;
        }
        getDependencyStopTime() {
            if (this.useFmpAsUntilStopTime) return this.getFmp();
            return this.experience.getData().stop;
        }
        getFullyInteractiveStopTime() {
            return this.experience.getData().stop;
        }
        getIsSegmentLoadOverrided() {
            if (this.useFmpAsUntilStopTime) {
                const { marks: marks } = this.experience.getData();
                return marks[$3617950edd41435c$export$3fcc0936ee2cc852.FMP] ? true : false;
            }
            return false;
        }
        getKey() {
            return this.experience.getData().key;
        }
    }
});
parcelRegister("abxLD", function(module, exports) {
    $parcel$export(module.exports, "BasePageLoadMetric", ()=>$bad5255a2704f7ee$export$fd1447b187f590fe);
    var $9s5ra;
    var $dSGYO;
    class $bad5255a2704f7ee$export$fd1447b187f590fe extends (0, (0, parcelRequire("dSGYO")).BaseMetric) {
        static{
            this.FMP = 'fmp';
        }
        constructor(args){
            super(args), this.isInitial = true, this.explicitTimings = null;
            this.config = args;
        }
        start({} = {}) {
            return;
        }
        startPageLoad(params = {
            isInitial: false
        }) {
            this.isInitial = params.isInitial;
            if (params.isInitial) super.start({
                startTime: 0
            });
            else super.start(params);
            (0, (0, parcelRequire("9s5ra")).logger).logCond(!!this.config.debug, this.key, this.startTime);
        }
        stopPageLoad(pageLoadMetaMetricData, stopArguments = {
            stopTime: window.performance.now()
        }) {
            if (pageLoadMetaMetricData.state !== (0, (0, parcelRequire("dSGYO")).MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
                (0, (0, parcelRequire("9s5ra")).logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
                return false;
            }
            if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
                (0, (0, parcelRequire("9s5ra")).logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
                return false;
            }
            this.merge(pageLoadMetaMetricData);
            this.stopTime = stopArguments.stopTime;
            this.state = (0, (0, parcelRequire("dSGYO")).MetricState).FINISHED;
            this.handleStop(stopArguments);
            return true;
        }
        handleStop(stopArguments) {
            const { until: until } = this.config;
            const fmpWasMarked = $bad5255a2704f7ee$export$fd1447b187f590fe.FMP in this.marks;
            if (!fmpWasMarked && until) {
                const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                    until
                ]);
                const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
                if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
            }
            super.handleStop(stopArguments);
        }
        mark(mark, timestamp = window.performance.now()) {
            if (mark === $bad5255a2704f7ee$export$fd1447b187f590fe.FMP) return;
            super.mark(mark, timestamp);
        }
        merge(mergeData) {
            super.merge(mergeData);
            this.isInitial = mergeData.isInitial;
            this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
                ...mergeData.explicitTimings,
                ...this.explicitTimings
            } : null;
        }
        markFMP(timestamp) {
            super.mark($bad5255a2704f7ee$export$fd1447b187f590fe.FMP, timestamp);
        }
        getPageLoadData() {
            return {
                isInitial: this.isInitial,
                explicitTimings: this.explicitTimings
            };
        }
        getData() {
            return {
                ...super.getData(),
                ...this.getPageLoadData()
            };
        }
        getDataToMerge() {
            return {
                ...super.getDataToMerge(),
                ...this.getPageLoadData()
            };
        }
        clear() {
            this.explicitTimings = null;
            super.clear();
        }
    }
});
parcelRegister("hHWTZ", function(module, exports) {
    $parcel$export(module.exports, "webVitalsObserver", ()=>$d6a09b2d981438d5$export$253d38dccbb37615);
    class $d6a09b2d981438d5$var$WebVitalsObserver {
        start() {
            this.ttciDetermined = this.registerTTCI();
            this.webVitalsDetermined = this.registerWebVitals();
        }
        async registerWebVitals() {
            try {
                const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("ahp0n"));
                await Promise.all([
                    getTTFB,
                    getFID,
                    getFCP,
                    getLCP,
                    getCLS
                ].map((fx)=>new Promise((resolve)=>{
                        fx(({ name: name, value: value })=>{
                            const metricName = name.toLowerCase();
                            const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                            this.data[`metric:${metricName}`] = metricValue;
                            resolve();
                        });
                    })));
            } catch (e) {}
        }
        async registerTTCI() {
            try {
                const ttiPolyfill = await (parcelRequire("7XmIb"));
                await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                    this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                    return true;
                });
            } catch (e) {}
        }
        constructor(){
            this.data = {
                'metric:ttci': null,
                'metric:ttfb': null,
                'metric:fid': null,
                'metric:fcp': null,
                'metric:lcp': null,
                'metric:cls': null
            };
        }
    }
    const $d6a09b2d981438d5$export$253d38dccbb37615 = new $d6a09b2d981438d5$var$WebVitalsObserver();
});
parcelRegister("ahp0n", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gceFf").then(()=>parcelRequire('gDSxx'));
});
parcelRegister("6fhBS", function(module, exports) {
    "use strict";
    function $48c1cdc5229a6006$var$load(id) {
        return import((parcelRequire("dy9lH")).resolve(id));
    }
    module.exports = $48c1cdc5229a6006$var$load;
});
parcelRegister("dy9lH", function(module, exports) {
    $parcel$export(module.exports, "register", ()=>$9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v)=>$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
    $parcel$export(module.exports, "resolve", ()=>$9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v)=>$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
    var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
    var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
    "use strict";
    var $9dd5b3e06d7b5702$var$mapping = new Map();
    function $9dd5b3e06d7b5702$var$register(baseUrl, manifest) {
        for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
            baseUrl: baseUrl,
            path: manifest[i + 1]
        });
    }
    function $9dd5b3e06d7b5702$var$resolve(id) {
        var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
        if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
        return new URL(resolved.path, resolved.baseUrl).toString();
    }
    $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
    $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;
});
parcelRegister("7XmIb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8qy0v").then(()=>parcelRequire('8yzun'));
});
parcelRegister("8bDkf", function(module, exports) {
    $parcel$export(module.exports, "Route", ()=>$c1aac0b8c8531c5b$export$e7b0ac011bb776c6);
    const $c1aac0b8c8531c5b$export$e7b0ac011bb776c6 = {
        route: '',
        setRoute (newRoute) {
            this.route = newRoute;
        },
        getRoute () {
            return this.route;
        }
    };
});
parcelRegister("37Ee8", function(module, exports) {
    $parcel$export(module.exports, "submitter", ()=>$f623e61be670fadd$export$c21a25872e3f5a2b);
    var $iNl9c;
    var $7vk4a;
    var $58jWV;
    var $1YAnF;
    const $f623e61be670fadd$export$c21a25872e3f5a2b = {
        debug: false,
        config: {
            gasv3: undefined,
            configChunk: null,
            useVisibleState: false,
            histogram: {},
            enableReactUFOTracker: false
        },
        configure (config) {
            this.config.gasv3 = config.endpoints.eventPipelineClient;
            this.config.enableReactUFOTracker = config.enableReactUFOTracker;
            this.config.configChunk = (0, (0, parcelRequire("1YAnF")).makeShareableGlobalConfig)(config);
            if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, (0, parcelRequire("7vk4a")).PageVisibleFields).pageVisibleState;
        },
        setDebug (debug) {
            this.debug = debug;
        },
        async queue (data) {
            if (this.config.enableReactUFOTracker) (0, (0, parcelRequire("iNl9c")).addBrowserMetricEvent)(data);
            if (!this.config.configChunk) {
                this.debug && console.warn('Submitter is not configured');
                return null;
            }
            const chunk = await this.config.configChunk;
            const payload = await (0, (0, parcelRequire("58jWV")).eventDataProcessor)(chunk[data.config.type], data);
            if (payload === null) return;
            if (this.config.gasv3 !== undefined) {
                const client = await this.config.gasv3;
                const attributes = {
                    task: payload['event:key'],
                    properties: payload
                };
                client && client.sendOperationalEvent({
                    actionSubject: 'performance',
                    attributes: attributes,
                    source: 'performance',
                    action: 'measured'
                });
            }
        }
    };
});
parcelRegister("58jWV", function(module, exports) {
    $parcel$export(module.exports, "eventDataProcessor", ()=>$ba3b7103dab6ddc2$export$896b6e121bbaec25);
    var $bvZfX;
    var $9s5ra;
    var $fGNE2;
    var $b24Xk;
    var $aTMI7;
    var $jTgB4;
    var $2XUVj;
    var $5eIVN;
    var $2sWrQ;
    var $6MGt5;
    var $6pV4v;
    var $8QKki;
    var $fRqTS;
    var $4OdcW;
    var $a9PiQ;
    var $s2RB5;
    var $4J39k;
    var $hLBIK;
    var $eVisQ;
    var $27Bxr;
    var $eD0le;
    var $c5WqZ;
    var $8yRnE;
    var $cV4Dr;
    var $lt03s;
    var $bfBZT;
    var $a38a5;
    var $kVwwi;
    var $ghQYo;
    var $3c7WV;
    var $6DkJU;
    var $9vhvF;
    var $1Jc9p;
    var $cSRv5;
    var $iOCAc;
    var $joKrc;
    var $7vk4a;
    const $ba3b7103dab6ddc2$var$defaultSet = [
        (0, (0, parcelRequire("6MGt5")).eventKey),
        (0, (0, parcelRequire("a9PiQ")).eventType),
        (0, (0, parcelRequire("8QKki")).eventProduct),
        (0, (0, parcelRequire("4OdcW")).eventRoute),
        (0, (0, parcelRequire("5eIVN")).eventId),
        (0, (0, parcelRequire("6pV4v")).eventLocalTime),
        (0, (0, parcelRequire("fRqTS")).eventRegion),
        (0, (0, parcelRequire("b24Xk")).appFramework),
        (0, (0, parcelRequire("aTMI7")).appVersion),
        (0, (0, parcelRequire("jTgB4")).bmVersion),
        (0, (0, parcelRequire("3c7WV")).telemetryBrowser),
        (0, (0, parcelRequire("6DkJU")).telemetryCpu),
        (0, (0, parcelRequire("9vhvF")).telemetryMemory),
        (0, (0, parcelRequire("1Jc9p")).telemetryNetwork),
        (0, (0, parcelRequire("2XUVj")).customData),
        (0, (0, parcelRequire("s2RB5")).featureFlags),
        (0, (0, parcelRequire("4J39k")).hostname),
        (0, (0, parcelRequire("a38a5")).productCustomData),
        (0, (0, parcelRequire("cSRv5")).appTimings),
        (0, (0, parcelRequire("joKrc")).resourceTimings)
    ];
    const $ba3b7103dab6ddc2$var$pageLoadCommon = [
        ...$ba3b7103dab6ddc2$var$defaultSet,
        (0, (0, parcelRequire("lt03s")).pageVisibleState),
        (0, (0, parcelRequire("bfBZT")).pageVisibleValue),
        (0, (0, parcelRequire("2sWrQ")).eventInitial),
        (0, (0, parcelRequire("c5WqZ")).pageLoadMetrics),
        (0, (0, parcelRequire("iOCAc")).bundleEvalTimings)
    ];
    const $ba3b7103dab6ddc2$var$initialPageLoadSet = [
        ...$ba3b7103dab6ddc2$var$pageLoadCommon,
        (0, (0, parcelRequire("eVisQ")).initialPageLoadMetrics),
        (0, (0, parcelRequire("eD0le")).navigationMetrics),
        (0, (0, parcelRequire("ghQYo")).ssrSuccess),
        (0, (0, parcelRequire("kVwwi")).ssrFeatureFlags)
    ];
    const $ba3b7103dab6ddc2$var$spaTransitionSet = [
        ...$ba3b7103dab6ddc2$var$pageLoadCommon
    ];
    const $ba3b7103dab6ddc2$var$pageSegmentLoadSet = [
        ...$ba3b7103dab6ddc2$var$defaultSet,
        (0, (0, parcelRequire("8yRnE")).pageSegmentLoadMetrics),
        (0, (0, parcelRequire("lt03s")).pageVisibleState),
        (0, (0, parcelRequire("bfBZT")).pageVisibleValue),
        (0, (0, parcelRequire("2sWrQ")).eventInitial),
        (0, (0, parcelRequire("iOCAc")).bundleEvalTimings)
    ];
    const $ba3b7103dab6ddc2$var$interactionSet = [
        ...$ba3b7103dab6ddc2$var$defaultSet,
        (0, (0, parcelRequire("lt03s")).pageVisibleState),
        (0, (0, parcelRequire("bfBZT")).pageVisibleValue),
        (0, (0, parcelRequire("27Bxr")).interactionMetrics)
    ];
    const $ba3b7103dab6ddc2$var$customMetricSet = [
        ...$ba3b7103dab6ddc2$var$defaultSet,
        (0, (0, parcelRequire("lt03s")).pageVisibleState),
        (0, (0, parcelRequire("bfBZT")).pageVisibleValue),
        (0, (0, parcelRequire("hLBIK")).customEventMetrics)
    ];
    const $ba3b7103dab6ddc2$var$webVitalsMetricSet = [
        ...$ba3b7103dab6ddc2$var$defaultSet,
        (0, (0, parcelRequire("cV4Dr")).webVitalsMetrics)
    ];
    const $ba3b7103dab6ddc2$var$waitForCLS = (delay = (0, (0, parcelRequire("bvZfX")).clsWaitTimeMs) + 500)=>{
        return new Promise((resolve)=>setTimeout(resolve, delay));
    };
    const $ba3b7103dab6ddc2$export$896b6e121bbaec25 = async (globalConfig, data)=>{
        if (data.start === null || data.stop === null) {
            (0, (0, parcelRequire("9s5ra")).logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
            return null;
        }
        let set = [];
        if (data.config.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_LOAD && (0, (0, parcelRequire("fGNE2")).isPageLoadMetricData)(data) && data.isInitial) set = $ba3b7103dab6ddc2$var$initialPageLoadSet;
        if (data.config.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_LOAD && (0, (0, parcelRequire("fGNE2")).isPageLoadMetricData)(data) && !data.isInitial) set = $ba3b7103dab6ddc2$var$spaTransitionSet;
        if (data.config.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_SEGMENT_LOAD && (0, (0, parcelRequire("fGNE2")).isPageSegmentLoadMetricData)(data)) set = $ba3b7103dab6ddc2$var$pageSegmentLoadSet;
        if (data.config.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).INLINE_RESULT) set = $ba3b7103dab6ddc2$var$interactionSet;
        if (data.config.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).CUSTOM) set = $ba3b7103dab6ddc2$var$customMetricSet;
        if (data.config.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).WEB_VITALS) {
            set = $ba3b7103dab6ddc2$var$webVitalsMetricSet;
            await $ba3b7103dab6ddc2$var$waitForCLS();
        }
        const plugins = [];
        for (const plugin of set){
            const result = await plugin(data.config, data, globalConfig);
            if (result) plugins.push(result);
        }
        const pluginResults = await Promise.all(plugins);
        const generated = {};
        pluginResults.forEach((pluginResult)=>{
            if (pluginResult === null) return;
            Object.keys(pluginResult).forEach((key)=>{
                const keyResult = pluginResult[key];
                if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
            });
        });
        return generated;
    };
});
parcelRegister("fGNE2", function(module, exports) {
    $parcel$export(module.exports, "isPageLoadMetricData", ()=>$ace35ad448528c37$export$b0e12e7abb0bff11);
    $parcel$export(module.exports, "isPageSegmentLoadMetricData", ()=>$ace35ad448528c37$export$83d0099ee6dbb5b0);
    $parcel$export(module.exports, "isPageLoadConfig", ()=>$ace35ad448528c37$export$8672fa27ba8bba88);
    $parcel$export(module.exports, "isPageSegmentLoadConfig", ()=>$ace35ad448528c37$export$abe063537ef4987b);
    $parcel$export(module.exports, "isInteractionConfig", ()=>$ace35ad448528c37$export$ae68674b6a9353be);
    $parcel$export(module.exports, "isCustomConfig", ()=>$ace35ad448528c37$export$b493eb8b2ba87421);
    var $7vk4a;
    const $ace35ad448528c37$export$b0e12e7abb0bff11 = (data)=>{
        return data.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_LOAD;
    };
    const $ace35ad448528c37$export$83d0099ee6dbb5b0 = (data)=>{
        return data.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_SEGMENT_LOAD;
    };
    const $ace35ad448528c37$export$8672fa27ba8bba88 = (data)=>{
        return data.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_LOAD;
    };
    const $ace35ad448528c37$export$abe063537ef4987b = (data)=>{
        return data.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_SEGMENT_LOAD;
    };
    const $ace35ad448528c37$export$ae68674b6a9353be = (data)=>{
        return data.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).INLINE_RESULT;
    };
    const $ace35ad448528c37$export$b493eb8b2ba87421 = (data)=>{
        return data.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).CUSTOM;
    };
});
parcelRegister("b24Xk", function(module, exports) {
    $parcel$export(module.exports, "appFramework", ()=>$cfa2d6a45ae71bcc$export$e34e4529b979f74c);
    const $cfa2d6a45ae71bcc$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
        if (!globalConfig.app.framework) return null;
        return {
            'app:framework:name': globalConfig.app.framework.name,
            'app:framework:version': globalConfig.app.framework.version
        };
    };
});
parcelRegister("aTMI7", function(module, exports) {
    $parcel$export(module.exports, "appVersion", ()=>$d19a23c1321794b0$export$82ae485178b37419);
    const $d19a23c1321794b0$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
        const pluginData = {
            'app:web:version': globalConfig.app.version.web
        };
        if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
        return pluginData;
    };
});
parcelRegister("jTgB4", function(module, exports) {
    $parcel$export(module.exports, "bmVersion", ()=>$f2026e5b463110a7$export$5cafa465fc876895);
    const $f2026e5b463110a7$export$5cafa465fc876895 = ()=>{
        return {
            'bm:version': 3
        };
    };
});
parcelRegister("2XUVj", function(module, exports) {
    $parcel$export(module.exports, "customData", ()=>$8c8484017f19936e$export$f7e743c7db162193);
    const $8c8484017f19936e$export$f7e743c7db162193 = (_config, data)=>{
        const custom = {};
        let changed = false;
        if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
            changed = true;
            custom[`custom:${key}`] = value;
        });
        return changed ? custom : null;
    };
});
parcelRegister("5eIVN", function(module, exports) {
    $parcel$export(module.exports, "eventId", ()=>$6f9ba767e1ac3105$export$aed28df7ac07d79a);
    const $6f9ba767e1ac3105$export$aed28df7ac07d79a = (config)=>{
        return {
            'event:id': config.key
        };
    };
});
parcelRegister("2sWrQ", function(module, exports) {
    $parcel$export(module.exports, "eventInitial", ()=>$8d56bdff90373c26$export$fa8e91d436b3ef8b);
    var $fGNE2;
    const $8d56bdff90373c26$export$fa8e91d436b3ef8b = (_config, data)=>{
        if (!(0, (0, parcelRequire("fGNE2")).isPageLoadMetricData)(data) && !(0, (0, parcelRequire("fGNE2")).isPageSegmentLoadMetricData)(data)) return null;
        return {
            'event:initial': data.isInitial
        };
    };
});
parcelRegister("6MGt5", function(module, exports) {
    $parcel$export(module.exports, "eventKey", ()=>$b69cc1480653dad9$export$10be2d3a558d3f88);
    var $58ihi;
    const $b69cc1480653dad9$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
        return {
            'event:key': `${globalConfig.product}.fe.${(0, (0, parcelRequire("58ihi")).mapEventType)(config.type)}.${config.key}`
        };
    };
});
parcelRegister("58ihi", function(module, exports) {
    $parcel$export(module.exports, "mapEventType", ()=>$07cf14d36a21c06b$export$b334d07f11140768);
    var $7vk4a;
    const $07cf14d36a21c06b$export$b334d07f11140768 = (type)=>{
        switch(type){
            case (0, (0, parcelRequire("7vk4a")).BMEventsType).CUSTOM:
                return (0, (0, parcelRequire("7vk4a")).StorableBMEventsType).CUSTOM;
            case (0, (0, parcelRequire("7vk4a")).BMEventsType).INLINE_RESULT:
                return (0, (0, parcelRequire("7vk4a")).StorableBMEventsType).INLINE_RESULT;
            case (0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_LOAD:
                return (0, (0, parcelRequire("7vk4a")).StorableBMEventsType).PAGE_LOAD;
            case (0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_SEGMENT_LOAD:
                return (0, (0, parcelRequire("7vk4a")).StorableBMEventsType).PAGE_SEGMENT_LOAD;
            case (0, (0, parcelRequire("7vk4a")).BMEventsType).WEB_VITALS:
                return (0, (0, parcelRequire("7vk4a")).StorableBMEventsType).WEB_VITALS;
            default:
                return 'unknown';
        }
    };
});
parcelRegister("6pV4v", function(module, exports) {
    $parcel$export(module.exports, "eventLocalTime", ()=>$1a794be8e9fc3d55$export$5219854ae7ec45da);
    var $k7m40;
    const $1a794be8e9fc3d55$export$5219854ae7ec45da = ()=>({
            'event:localHour': parseInt((0, (0, parcelRequire("k7m40")).default)(new Date(), 'H'), 10),
            'event:localDayOfWeek': parseInt((0, (0, parcelRequire("k7m40")).default)(new Date(), 'i'), 10)
        });
});
parcelRegister("8QKki", function(module, exports) {
    $parcel$export(module.exports, "eventProduct", ()=>$9bf27e335f9a35b4$export$a7df4e8088db8843);
    const $9bf27e335f9a35b4$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
        return {
            'event:product': `${globalConfig.product}`
        };
    };
});
parcelRegister("fRqTS", function(module, exports) {
    $parcel$export(module.exports, "eventRegion", ()=>$8b5e360194edc619$export$d0117b71adcdebc0);
    const $8b5e360194edc619$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
        return {
            'event:region': `${globalConfig.region}`
        };
    };
});
parcelRegister("4OdcW", function(module, exports) {
    $parcel$export(module.exports, "eventRoute", ()=>$547b7d5d14a7893c$export$44d3627af289ca16);
    const $547b7d5d14a7893c$export$44d3627af289ca16 = (_config, data)=>{
        if (!data.route) return null;
        return {
            'event:route': data.route
        };
    };
});
parcelRegister("a9PiQ", function(module, exports) {
    $parcel$export(module.exports, "eventType", ()=>$2367a49fc39a86fc$export$4c045e605d532c98);
    var $58ihi;
    const $2367a49fc39a86fc$export$4c045e605d532c98 = (config)=>{
        return {
            'event:type': (0, (0, parcelRequire("58ihi")).mapEventType)(config.type)
        };
    };
});
parcelRegister("s2RB5", function(module, exports) {
    $parcel$export(module.exports, "featureFlags", ()=>$55aee3673a4f453c$export$e62953d023125748);
    const $55aee3673a4f453c$export$e62953d023125748 = (config, _data, globalConfig)=>{
        const localFeatureFlags = config.featureFlags?.reduce((acc, ffName)=>{
            acc[ffName] = globalConfig.ffClient.getValue(ffName);
            return acc;
        }, {}) || null;
        if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
        return {
            featureFlags: {
                ...localFeatureFlags,
                ...globalConfig.featureFlags
            }
        };
    };
});
parcelRegister("4J39k", function(module, exports) {
    $parcel$export(module.exports, "hostname", ()=>$b4ab0c02371f4c05$export$640106f6dc7d2706);
    const $b4ab0c02371f4c05$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
        return {
            hostname: globalConfig.hostname
        };
    };
});
parcelRegister("hLBIK", function(module, exports) {
    $parcel$export(module.exports, "customEventMetrics", ()=>$aa28784d9ad1dd3e$export$cab039265c52a2e9);
    var $fGNE2;
    const $aa28784d9ad1dd3e$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
        if (!(0, (0, parcelRequire("fGNE2")).isCustomConfig)(config)) return null;
        const payload = {
            'metric:duration': Math.round(data.stop - data.start)
        };
        if (config.slo?.threshold !== undefined) {
            payload['metric:duration:slo'] = payload['metric:duration'] <= config.slo?.threshold;
            payload['metric:duration:slo:threshold'] = config.slo?.threshold;
        }
        if (config.histogram?.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
        else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
        return payload;
    };
});
parcelRegister("eVisQ", function(module, exports) {
    $parcel$export(module.exports, "initialPageLoadMetrics", ()=>$759bff09d5fd9321$export$cc95aa3f6ea8e5cb);
    const $759bff09d5fd9321$export$cc95aa3f6ea8e5cb = ()=>{
        const metrics = {};
        performance.getEntriesByType('paint').forEach((entry)=>{
            if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
            if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
        });
        return metrics;
    };
});
parcelRegister("27Bxr", function(module, exports) {
    $parcel$export(module.exports, "interactionMetrics", ()=>$660619cd317cd9d8$export$86db56030b57ba34);
    var $fGNE2;
    var $7vk4a;
    const $660619cd317cd9d8$export$86db56030b57ba34 = (config, data, globalConfig)=>{
        if (!(0, (0, parcelRequire("fGNE2")).isInteractionConfig)(config)) return null;
        const result = {
            'metric:result': Math.round(data.stop - data.start)
        };
        if (config.histogram?.result) result['metric:result:histogramBuckets'] = config.histogram.result;
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, (0, parcelRequire("7vk4a")).BMInteractionMetrics).result];
        }
        if (config.slo && (0, (0, parcelRequire("7vk4a")).isInteractionMetricsSlo)(config.slo) && config.slo.result) {
            result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
            result['metric:result:slo:threshold'] = config.slo.result.threshold;
        }
        if (data.marks['feedback']) {
            result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
            if (config.histogram?.response) result['metric:response:histogramBuckets'] = config.histogram[(0, (0, parcelRequire("7vk4a")).BMInteractionMetrics).response];
            else if (globalConfig.histogram) {
                const histogram = globalConfig.histogram;
                if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, (0, parcelRequire("7vk4a")).BMInteractionMetrics).response];
            }
            if (config.slo && (0, (0, parcelRequire("7vk4a")).isInteractionMetricsSlo)(config.slo) && config.slo.response) {
                result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
                result['metric:response:slo:threshold'] = config.slo.response.threshold;
            }
        }
        return result;
    };
});
parcelRegister("eD0le", function(module, exports) {
    $parcel$export(module.exports, "navigationMetrics", ()=>$0c6d49a8be02a74f$export$b88d990436be0f8a);
    const $0c6d49a8be02a74f$export$b88d990436be0f8a = ()=>{
        const entries = performance.getEntriesByType('navigation');
        if (entries.length === 0) return null;
        const navigation = entries[0];
        const metrics = {
            redirectStart: Math.round(navigation.redirectStart),
            redirectEnd: Math.round(navigation.redirectEnd),
            fetchStart: Math.round(navigation.fetchStart),
            domainLookupStart: Math.round(navigation.domainLookupStart),
            domainLookupEnd: Math.round(navigation.domainLookupEnd),
            connectStart: Math.round(navigation.connectStart),
            connectEnd: Math.round(navigation.connectEnd),
            secureConnectionStart: Math.round(navigation.secureConnectionStart),
            requestStart: Math.round(navigation.requestStart),
            responseStart: Math.round(navigation.responseStart),
            responseEnd: Math.round(navigation.responseEnd),
            encodedBodySize: Math.round(navigation.encodedBodySize),
            decodedBodySize: Math.round(navigation.decodedBodySize),
            transferSize: Math.round(navigation.transferSize),
            redirectCount: navigation.redirectCount,
            type: navigation.type,
            unloadEventEnd: Math.round(navigation.unloadEventEnd),
            unloadEventStart: Math.round(navigation.unloadEventStart),
            workerStart: Math.round(navigation.workerStart)
        };
        return {
            'metrics:navigation': metrics
        };
    };
});
parcelRegister("c5WqZ", function(module, exports) {
    $parcel$export(module.exports, "pageLoadMetrics", ()=>$e15b59fb4fe53b0c$export$2878bf482e539059);
    var $fGNE2;
    var $7vk4a;
    const $e15b59fb4fe53b0c$var$getThreshold = (isInitial, metric)=>{
        return (0, (0, parcelRequire("7vk4a")).isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
    };
    const $e15b59fb4fe53b0c$var$getHistogram = (isInitial, metric, histogram)=>{
        return isInitial ? histogram.initial[metric] : histogram.transition[metric];
    };
    const $e15b59fb4fe53b0c$export$2878bf482e539059 = (config, data, globalConfig)=>{
        if (!(0, (0, parcelRequire("fGNE2")).isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
        const fmp = data.marks[(0, (0, parcelRequire("7vk4a")).BMPageLoadMetrics).fmp] || data.stop;
        const result = {
            'metric:fmp': Math.round(fmp - data.start),
            'metric:tti': Math.round(data.stop - data.start)
        };
        if (config.histogram) {
            result['metric:fmp:histogramBuckets'] = $e15b59fb4fe53b0c$var$getHistogram(data.isInitial, (0, (0, parcelRequire("7vk4a")).BMPageLoadMetrics).fmp, config.histogram);
            result['metric:tti:histogramBuckets'] = $e15b59fb4fe53b0c$var$getHistogram(data.isInitial, (0, (0, parcelRequire("7vk4a")).BMPageLoadMetrics).tti, config.histogram);
        } else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            result['metric:fmp:histogramBuckets'] = $e15b59fb4fe53b0c$var$getHistogram(data.isInitial, (0, (0, parcelRequire("7vk4a")).BMPageLoadMetrics).fmp, histogram);
            result['metric:tti:histogramBuckets'] = $e15b59fb4fe53b0c$var$getHistogram(data.isInitial, (0, (0, parcelRequire("7vk4a")).BMPageLoadMetrics).tti, histogram);
        }
        if (config.slo && config.slo.fmp) {
            const threshold = $e15b59fb4fe53b0c$var$getThreshold(data.isInitial, config.slo.fmp);
            result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
            result['metric:fmp:slo:threshold'] = threshold;
        }
        if (config.slo && config.slo.tti) {
            const threshold = $e15b59fb4fe53b0c$var$getThreshold(data.isInitial, config.slo.tti);
            result['metric:tti:slo'] = result['metric:tti'] <= threshold;
            result['metric:tti:slo:threshold'] = threshold;
        }
        return result;
    };
});
parcelRegister("8yRnE", function(module, exports) {
    $parcel$export(module.exports, "pageSegmentLoadMetrics", ()=>$e448358df8aa6f6e$export$ba86cb47f2f22db5);
    var $9QLE7;
    var $fGNE2;
    var $7vk4a;
    const $e448358df8aa6f6e$var$getThreshold = (isInitial, metric)=>{
        return (0, (0, parcelRequire("7vk4a")).isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
    };
    const $e448358df8aa6f6e$var$getHistogram = (isInitial, metric, histogram)=>{
        return isInitial ? histogram.initial[metric] : histogram.transition[metric];
    };
    const $e448358df8aa6f6e$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
        if (!(0, (0, parcelRequire("fGNE2")).isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
        const fmp = data.marks[(0, (0, parcelRequire("7vk4a")).BMPageSegmentLoadMetrics).fmp] || data.stop;
        const result = {
            'metric:fmp': Math.round(fmp - data.start),
            'metric:tti': Math.round(data.stop - data.start)
        };
        if (config.histogram) {
            result['metric:fmp:histogramBuckets'] = $e448358df8aa6f6e$var$getHistogram(data.isInitial, (0, (0, parcelRequire("7vk4a")).BMPageSegmentLoadMetrics).fmp, config.histogram);
            result['metric:tti:histogramBuckets'] = $e448358df8aa6f6e$var$getHistogram(data.isInitial, (0, (0, parcelRequire("7vk4a")).BMPageSegmentLoadMetrics).tti, config.histogram);
        } else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            result['metric:fmp:histogramBuckets'] = $e448358df8aa6f6e$var$getHistogram(data.isInitial, (0, (0, parcelRequire("7vk4a")).BMPageSegmentLoadMetrics).fmp, histogram);
            result['metric:tti:histogramBuckets'] = $e448358df8aa6f6e$var$getHistogram(data.isInitial, (0, (0, parcelRequire("7vk4a")).BMPageSegmentLoadMetrics).tti, histogram);
        }
        if (config.slo?.fmp) {
            const threshold = $e448358df8aa6f6e$var$getThreshold(data.isInitial, config.slo.fmp);
            result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
            result['metric:fmp:slo:threshold'] = threshold;
        }
        if (config.slo?.tti) {
            const threshold = $e448358df8aa6f6e$var$getThreshold(data.isInitial, config.slo.tti);
            result['metric:tti:slo'] = result['metric:tti'] <= threshold;
            result['metric:tti:slo:threshold'] = threshold;
        }
        if (config.includePageLoadTimings === (0, (0, parcelRequire("7vk4a")).PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, (0, parcelRequire("7vk4a")).PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
            const pageLoadData = (0, (0, parcelRequire("9QLE7")).pageLoadMetaMetric).getData();
            const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, (0, parcelRequire("7vk4a")).BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
            const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
            result['pageLoad'] = {
                fmp: fmp,
                tti: tti
            };
        }
        return result;
    };
});
parcelRegister("cV4Dr", function(module, exports) {
    $parcel$export(module.exports, "webVitalsMetrics", ()=>$574b7ebe3a82cc63$export$3731db279f590f30);
    var $dSGYO;
    var $5X7fp;
    var $hHWTZ;
    var $bfBZT;
    const $574b7ebe3a82cc63$export$3731db279f590f30 = async (config, data, globalConfig)=>{
        let pageVisibleState = data.pageVisibleState;
        const setPageVisibleStateToMixed = ()=>{
            pageVisibleState = (0, (0, parcelRequire("dSGYO")).PageVisibleState).MIXED;
        };
        (0, (0, parcelRequire("5X7fp")).visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
        const ttciEnabled = globalConfig.webVitals?.ttciEnabled !== undefined ? globalConfig.webVitals?.ttciEnabled : true;
        const webVitalMetrics = await $574b7ebe3a82cc63$export$193ae490b52081dd(ttciEnabled, globalConfig.webVitals?.timeout || 30000);
        (0, (0, parcelRequire("5X7fp")).visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
        return {
            ...webVitalMetrics,
            'pageVisible:state': pageVisibleState,
            ...(0, (0, parcelRequire("bfBZT")).pageVisibleValue)(config, data, globalConfig)
        };
    };
    const $574b7ebe3a82cc63$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
        await (ttciEnabled ? (0, (0, parcelRequire("hHWTZ")).webVitalsObserver).ttciDetermined : Promise.resolve());
        const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
        await Promise.race([
            timeoutWindow,
            (0, (0, parcelRequire("hHWTZ")).webVitalsObserver).webVitalsDetermined
        ]);
        return (0, (0, parcelRequire("hHWTZ")).webVitalsObserver).data;
    };
});
parcelRegister("bfBZT", function(module, exports) {
    $parcel$export(module.exports, "pageVisibleValue", ()=>$1dbe68b103f34983$export$177b923114656380);
    var $dSGYO;
    var $7vk4a;
    const $1dbe68b103f34983$export$177b923114656380 = (_config, data, globalConfig)=>{
        const value = globalConfig.pageVisibleValueOrigin === (0, (0, parcelRequire("7vk4a")).PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, (0, parcelRequire("dSGYO")).PageVisibleState).VISIBLE;
        return {
            'pageVisible:value': value
        };
    };
});
parcelRegister("lt03s", function(module, exports) {
    $parcel$export(module.exports, "pageVisibleState", ()=>$2fd28a509781ef0b$export$723b4c298aca63af);
    const $2fd28a509781ef0b$export$723b4c298aca63af = (_config, data)=>{
        return {
            'pageVisible:state': data.pageVisibleState
        };
    };
});
parcelRegister("a38a5", function(module, exports) {
    $parcel$export(module.exports, "productCustomData", ()=>$dcf70dada7ae97fa$export$fa2af6e412815a74);
    const $dcf70dada7ae97fa$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
        if (!globalConfig.custom && !globalConfig.plugins) return null;
        const result = {};
        if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
            result[`${globalConfig.product}:${key}`] = value;
        });
        if (globalConfig.plugins) {
            const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                    start: data.start,
                    stop: data.stop,
                    key: data.key
                })));
            pluginOutputs.forEach((pluginOutput)=>{
                if (pluginOutput === null) return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${globalConfig.product}:${key}`] = value;
                });
            });
        }
        return result;
    };
});
parcelRegister("kVwwi", function(module, exports) {
    $parcel$export(module.exports, "ssrFeatureFlags", ()=>$e563c2960438c903$export$fdbea518c19dfa8);
    var $7vk4a;
    const $e563c2960438c903$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
        try {
            const featureFlags = await getFeatureFlags();
            if (featureFlags) return {
                'ssr:featureFlags': featureFlags
            };
        } catch (e) {}
        return null;
    };
    const $e563c2960438c903$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
        if (!globalConfig.ssr?.getFeatureFlags) return null;
        const includeFeatureFlags = config.ssr?.includeFeatureFlags || globalConfig.ssr?.includeFeatureFlags || (0, (0, parcelRequire("7vk4a")).IncludeSSRFeatureFlagsConfig).WHEN_FMP;
        if (includeFeatureFlags === (0, (0, parcelRequire("7vk4a")).IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || config.ssr?.doneAsFmp && includeFeatureFlags === (0, (0, parcelRequire("7vk4a")).IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $e563c2960438c903$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
        return null;
    };
});
parcelRegister("ghQYo", function(module, exports) {
    $parcel$export(module.exports, "ssrSuccess", ()=>$46ed0cd5c08daa29$export$a3dc8251cf55b2e0);
    const $46ed0cd5c08daa29$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
        if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
            'ssr:success': true
        };
        return null;
    };
});
parcelRegister("3c7WV", function(module, exports) {
    $parcel$export(module.exports, "telemetryBrowser", ()=>$4ca6883670a73180$export$386b10ac64a50b1);
    var $4XKM3 = parcelRequire("4XKM3");
    const $4ca6883670a73180$export$386b10ac64a50b1 = ()=>{
        if (!(0, ($parcel$interopDefault($4XKM3))).getParser) return null;
        const browser = (0, ($parcel$interopDefault($4XKM3))).getParser(window.navigator.userAgent);
        return {
            'telemetry:browser:name': browser.getBrowserName(),
            'telemetry:browser:version': browser.getBrowserVersion()
        };
    };
});
parcelRegister("6DkJU", function(module, exports) {
    $parcel$export(module.exports, "telemetryCpu", ()=>$020455d4abe821cb$export$9f84cb359ed29139);
    const $020455d4abe821cb$export$9f84cb359ed29139 = ()=>{
        if (!navigator.hardwareConcurrency) return null;
        return {
            'telemetry:cpus': navigator.hardwareConcurrency
        };
    };
});
parcelRegister("9vhvF", function(module, exports) {
    $parcel$export(module.exports, "telemetryMemory", ()=>$2a5092babedc02b6$export$496c14d72b257e07);
    const $2a5092babedc02b6$export$496c14d72b257e07 = ()=>{
        if (!navigator.deviceMemory) return null;
        return {
            'telemetry:memory': navigator.deviceMemory
        };
    };
});
parcelRegister("1Jc9p", function(module, exports) {
    $parcel$export(module.exports, "telemetryNetwork", ()=>$a73904d1bf060248$export$88bf7b55f7fc4e8e);
    const $a73904d1bf060248$export$88bf7b55f7fc4e8e = ()=>{
        if (!navigator.connection) return null;
        return {
            'telemetry:network:effectiveType': navigator.connection.effectiveType,
            'telemetry:network:rtt': navigator.connection.rtt,
            'telemetry:network:downlink': navigator.connection.downlink
        };
    };
});
parcelRegister("cSRv5", function(module, exports) {
    $parcel$export(module.exports, "appTimings", ()=>$e614851139d53d2a$export$e952f50a4f2d02da);
    var $7vk4a;
    var $4am0u;
    var $kJVMR;
    const $e614851139d53d2a$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
        const explicitTimings = config.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_LOAD && data.explicitTimings || null;
        const timings = (0, (0, parcelRequire("4am0u")).customTimings)(config, data);
        const ssr = config.type === (0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_LOAD && data.isInitial ? (0, (0, parcelRequire("kJVMR")).ssrTimings)(config, data, globalConfig) : null;
        const timingsApp = (explicitTimings || timings || ssr) && {
            ...explicitTimings,
            ...timings,
            ...ssr
        };
        if (!timingsApp) return null;
        return {
            'timings:app': timingsApp
        };
    };
});
parcelRegister("4am0u", function(module, exports) {
    $parcel$export(module.exports, "customTimings", ()=>$c74f157d2d9f2295$export$6126f85083a72c6e);
    const $c74f157d2d9f2295$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
        const configTimings = config.timings || [];
        const timings = configTimings.reduce((entries, timing)=>{
            if (timing.startMark && !data.marks[timing.startMark]) return entries;
            if (timing.endMark && !data.marks[timing.endMark]) return entries;
            if (data.start === null || data.stop === null) return null;
            const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
            const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
            entries[`${prefix}${timing.key}`] = {
                startTime: startTime,
                duration: duration
            };
            return entries;
        }, {});
        return timings;
    };
    const $c74f157d2d9f2295$export$6126f85083a72c6e = (config, data)=>{
        if (!config.timings && data.submetrics.length === 0) return null;
        const timings = $c74f157d2d9f2295$var$retrieveTimings(config, data);
        data.submetrics.forEach((submetric)=>{
            if (submetric.start !== null && submetric.stop !== null) {
                const submetricPrefix = `include:${submetric.config.key}`;
                timings[submetricPrefix] = {
                    startTime: Math.round(submetric.start - data.start),
                    duration: Math.round(submetric.stop - submetric.start)
                };
                Object.assign(timings, $c74f157d2d9f2295$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $671c304dce8903bc$export$b98e411ae80c806f)));
            }
        });
        if (Object.keys(timings).length === 0) return null;
        return timings;
    };
});
const $671c304dce8903bc$export$b98e411ae80c806f = '/';
parcelRegister("kJVMR", function(module, exports) {
    $parcel$export(module.exports, "ssrTimings", ()=>$8aade80bbbd6153a$export$130f411261a599c5);
    const $8aade80bbbd6153a$var$filterEntry = (entry)=>{
        return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
    };
    const $8aade80bbbd6153a$var$mapEntry = (entry)=>{
        return {
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration)
        };
    };
    const $8aade80bbbd6153a$var$SSR_PREFIX = 'ssr';
    const $8aade80bbbd6153a$var$mapKey = (key)=>{
        if (key === 'total') return $8aade80bbbd6153a$var$SSR_PREFIX;
        return `${$8aade80bbbd6153a$var$SSR_PREFIX}${0, $671c304dce8903bc$export$b98e411ae80c806f}${key}`;
    };
    const $8aade80bbbd6153a$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
        if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
        const timings = globalConfig.ssr.getTimings();
        if (!timings) return null;
        const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
            if ($8aade80bbbd6153a$var$filterEntry(entry[1])) acc[$8aade80bbbd6153a$var$mapKey(entry[0])] = $8aade80bbbd6153a$var$mapEntry(entry[1]);
            return acc;
        }, {});
        if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
        return ssrTimings;
    };
});
parcelRegister("iOCAc", function(module, exports) {
    $parcel$export(module.exports, "bundleEvalTimings", ()=>$2806ef33e504c386$export$1a2bb347935fc536);
    const $2806ef33e504c386$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
        const started = {};
        const timings = {};
        const enableBundleEvalTimings = globalConfig?.enableBundleEvalTimings ?? true;
        performance.getEntriesByType('mark').forEach((mark)=>{
            if (!globalConfig.bundleEvalTimings) return;
            const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
            if (!result) return;
            const { type: type, name: name } = result;
            if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
                started[name] = mark;
                return;
            }
            if (type === 'end' && started[name]) {
                timings[name] = {
                    startTime: Math.round(started[name].startTime - data.start),
                    duration: Math.round(mark.startTime - started[name].startTime)
                };
                delete started[name];
            }
        });
        if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
            const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
            if (result) Object.entries(result).forEach(([key, value])=>{
                timings[key] = value;
            });
        }
        if (Object.keys(timings).length === 0) return null;
        return {
            'timings:bundleEval': timings
        };
    };
    const $2806ef33e504c386$export$1a2bb347935fc536 = (...args)=>{
        return new Promise((resolve)=>{
            setTimeout(()=>{
                resolve($2806ef33e504c386$var$bundleEvalTimingsInternal(...args));
            });
        });
    };
});
parcelRegister("joKrc", function(module, exports) {
    $parcel$export(module.exports, "resourceTimings", ()=>$38aedcf0da95431a$export$81a7d52441a06b50);
    const $38aedcf0da95431a$var$cacheableTypes = [
        'script',
        'link'
    ];
    const $38aedcf0da95431a$var$resourceTypes = [
        'fetch',
        'xmlhttprequest'
    ];
    const $38aedcf0da95431a$var$CACHE_NETWORK = 'network';
    const $38aedcf0da95431a$var$CACHE_MEMORY = 'memory';
    const $38aedcf0da95431a$var$CACHE_DISK = 'disk';
    const $38aedcf0da95431a$var$calculateTransferType = (type, duration, size)=>{
        if (!$38aedcf0da95431a$var$cacheableTypes.includes(type)) return $38aedcf0da95431a$var$CACHE_NETWORK;
        if ((size === undefined || size === 0) && duration === 0) return $38aedcf0da95431a$var$CACHE_MEMORY;
        if (size === 0 && duration > 0) return $38aedcf0da95431a$var$CACHE_DISK;
        if (size === undefined) return null;
        return $38aedcf0da95431a$var$CACHE_NETWORK;
    };
    const $38aedcf0da95431a$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
        return !$38aedcf0da95431a$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
    };
    const $38aedcf0da95431a$var$getReportedInitiatorTypes = (xhrEnabled)=>{
        if (xhrEnabled) return [
            'script',
            'link',
            'fetch',
            'xmlhttprequest'
        ];
        return [
            'script',
            'link',
            'fetch'
        ];
    };
    const $38aedcf0da95431a$var$withoutHeaders = ()=>false;
    const $38aedcf0da95431a$var$evaluateAccessToResourceTimings = (entry)=>{
        if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
        return true;
    };
    const $38aedcf0da95431a$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $38aedcf0da95431a$var$withoutHeaders)=>{
        if (!enabled) return null;
        const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
        const autoResolution = $38aedcf0da95431a$var$evaluateAccessToResourceTimings(entry);
        return {
            m_h: manualResolution,
            a_h: autoResolution
        };
    };
    const $38aedcf0da95431a$var$getSizeObject = (size)=>size !== undefined ? {
            size: size
        } : null;
    const $38aedcf0da95431a$var$getNetworkData = (item, eventStart, hasTimingHeaders = $38aedcf0da95431a$var$withoutHeaders)=>{
        const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
        const ttfb = Math.round(responseStart - eventStart);
        if (!$38aedcf0da95431a$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
        if ($38aedcf0da95431a$var$cacheableTypes.includes(type)) {
            const transferType = $38aedcf0da95431a$var$calculateTransferType(type, duration, size);
            if (!transferType) return {
                ttfb: ttfb,
                ...$38aedcf0da95431a$var$getSizeObject(size)
            };
            if (transferType !== $38aedcf0da95431a$var$CACHE_NETWORK) return {
                transferType: transferType
            };
            return {
                ttfb: ttfb,
                transferType: transferType,
                ...$38aedcf0da95431a$var$getSizeObject(size)
            };
        }
        return {
            ttfb: ttfb,
            ...$38aedcf0da95431a$var$getSizeObject(size)
        };
    };
    const $38aedcf0da95431a$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
        if (data.start === null) return null;
        const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
        if (!resources.length) return null;
        const resourceTiming = {};
        const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
        const reportedInitiatorTypes = $38aedcf0da95431a$var$getReportedInitiatorTypes(!!xhrFilter);
        resources.forEach((item)=>{
            if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
            const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
            if (!name) return;
            if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
            const url = $38aedcf0da95431a$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
            if (resourceTiming[url]) return;
            resourceTiming[url] = {
                startTime: Math.round(startTime - data.start),
                duration: Math.round(duration),
                workerStart: Math.max(Math.round(workerStart - data.start), 0),
                fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
                type: type,
                ...$38aedcf0da95431a$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
                ...$38aedcf0da95431a$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
            };
        });
        return {
            'timings:resource': resourceTiming
        };
    };
});
parcelRegister("1YAnF", function(module, exports) {
    $parcel$export(module.exports, "makeShareableGlobalConfig", ()=>$ee3258ca0460ff95$export$5b4fb14409a2a825);
    var $7vk4a;
    const $ee3258ca0460ff95$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
        const featureFlagsForType = [];
        if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
        if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
        return featureFlagsForType;
    };
    const $ee3258ca0460ff95$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
        const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
        const eventConfigCustom = eventConfig && eventConfig.custom;
        const custom = (allEventsConfigCustom || eventConfigCustom) && {
            ...allEventsConfigCustom,
            ...eventConfigCustom
        } || undefined;
        const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
        const eventConfigPlugins = eventConfig && eventConfig.plugins;
        const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
            ...allEventsConfigPlugins || [],
            ...eventConfigPlugins || []
        ] || undefined;
        const pageVisibleValueOrigin = eventConfig?.pageVisibleValueOrigin ?? allEventsConfig?.pageVisibleValueOrigin ?? (0, (0, parcelRequire("7vk4a")).PageVisibleValueOrigin).documentHidden;
        return Object.freeze({
            ...global,
            featureFlags: Object.freeze($ee3258ca0460ff95$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
                acc[value] = ffClient.getValue(value);
                return acc;
            }, {})),
            custom: custom,
            plugins: plugins,
            histogram: eventConfig?.histogram,
            pageVisibleValueOrigin: pageVisibleValueOrigin,
            enableBundleEvalTimings: eventConfig?.enableBundleEvalTimings
        });
    };
    const $ee3258ca0460ff95$export$5b4fb14409a2a825 = async (globalConfig)=>{
        const ffClient = await globalConfig.plugins.featureFlags.client;
        const global = {
            app: globalConfig.info.app,
            product: globalConfig.info.product,
            region: globalConfig.info.region,
            resourceTimings: globalConfig.plugins.resourceTimings,
            bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
            ffClient: ffClient,
            hostname: globalConfig.info.hostname || window.location.hostname,
            ssr: globalConfig.ssr,
            enableReactUFOTracker: globalConfig.enableReactUFOTracker,
            webVitals: {
                enabled: globalConfig.events[(0, (0, parcelRequire("7vk4a")).BMEventsType).WEB_VITALS]?.enabled,
                timeout: globalConfig.events[(0, (0, parcelRequire("7vk4a")).BMEventsType).WEB_VITALS]?.timeout,
                ttciEnabled: globalConfig.events[(0, (0, parcelRequire("7vk4a")).BMEventsType).WEB_VITALS]?.ttciEnabled
            }
        };
        return {
            [(0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_LOAD]: $ee3258ca0460ff95$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_LOAD]),
            [(0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_SEGMENT_LOAD]: $ee3258ca0460ff95$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, (0, parcelRequire("7vk4a")).BMEventsType).PAGE_SEGMENT_LOAD]),
            [(0, (0, parcelRequire("7vk4a")).BMEventsType).INLINE_RESULT]: $ee3258ca0460ff95$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, (0, parcelRequire("7vk4a")).BMEventsType).INLINE_RESULT]),
            [(0, (0, parcelRequire("7vk4a")).BMEventsType).CUSTOM]: $ee3258ca0460ff95$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, (0, parcelRequire("7vk4a")).BMEventsType).CUSTOM]),
            [(0, (0, parcelRequire("7vk4a")).BMEventsType).WEB_VITALS]: $ee3258ca0460ff95$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, (0, parcelRequire("7vk4a")).BMEventsType).WEB_VITALS])
        };
    };
});
parcelRegister("WQRtS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05ea1baea7ac44cb$export$2e2bcd8739ae039);
    var $bXrHm = parcelRequire("bXrHm");
    var $gN6JS;
    var $035Fh;
    const $05ea1baea7ac44cb$var$packageVersion = "0.0.0-use.local";
    const $05ea1baea7ac44cb$var$originParamName = 'atlOrigin';
    const $05ea1baea7ac44cb$var$originVersioningAttributes = {
        originLibrary: `origin-tracing.js@${$05ea1baea7ac44cb$var$packageVersion}`
    };
    class $05ea1baea7ac44cb$export$2e2bcd8739ae039 {
        constructor({ id: id = $05ea1baea7ac44cb$export$2e2bcd8739ae039.generateId(), product: product, dangerouslySkipValidation: dangerouslySkipValidation = false }){
            this.id = id;
            this.product = product;
            if (!dangerouslySkipValidation) this.validate();
        }
        static isValidId(value) {
            return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
        }
        static isValidProduct(value) {
            return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
        }
        static generateId() {
            const id = (0, ($parcel$interopDefault($bXrHm)))();
            return id.replace(/-/g, '');
        }
        static createEmpty() {
            return new $05ea1baea7ac44cb$var$EmptyOriginTracer();
        }
        static createMalformed() {
            return new $05ea1baea7ac44cb$var$MalformedOriginTracer();
        }
        static fromUrl(url) {
            let params = new ((0, (0, parcelRequire("035Fh")).getEnv)()).URLSearchParams();
            $05ea1baea7ac44cb$var$replaceQuery(url, (queryString)=>{
                params = new ((0, (0, parcelRequire("035Fh")).getEnv)()).URLSearchParams(queryString);
            });
            return $05ea1baea7ac44cb$export$2e2bcd8739ae039.fromEncoded(params.get($05ea1baea7ac44cb$var$originParamName));
        }
        static fromEncoded(encoded) {
            if (!encoded) return $05ea1baea7ac44cb$export$2e2bcd8739ae039.createEmpty();
            try {
                return $05ea1baea7ac44cb$export$2e2bcd8739ae039.decode(encoded);
            } catch (e) {
                return $05ea1baea7ac44cb$export$2e2bcd8739ae039.createMalformed();
            }
        }
        static removeFromUrl(url) {
            return $05ea1baea7ac44cb$var$replaceQuery(url, (queryString)=>{
                const params = new ((0, (0, parcelRequire("035Fh")).getEnv)()).URLSearchParams(queryString);
                params.delete($05ea1baea7ac44cb$var$originParamName);
                return params.toString();
            });
        }
        static decode(encodedOrigin) {
            const originData = (0, (0, parcelRequire("gN6JS")).decode)(encodedOrigin);
            return new $05ea1baea7ac44cb$export$2e2bcd8739ae039(originData);
        }
        encode() {
            return (0, (0, parcelRequire("gN6JS")).encode)({
                id: this.id,
                product: this.product
            });
        }
        addToUrl(url) {
            return $05ea1baea7ac44cb$var$replaceQuery(url, (originalQueryString)=>{
                const params = new ((0, (0, parcelRequire("035Fh")).getEnv)()).URLSearchParams(originalQueryString);
                params.set($05ea1baea7ac44cb$var$originParamName, this.encode());
                return params.toString();
            });
        }
        isEmpty() {
            return false;
        }
        isMalformed() {
            return !this.isEmpty() && !this.isValid();
        }
        isValid() {
            return true;
        }
        toAnalyticsAttributes({ transformValue: transformValue = (v)=>v === null ? undefined : v, hasGeneratedId: hasGeneratedId = false } = {}) {
            const originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
            return {
                [originIdProp]: transformValue(this.id),
                originProduct: transformValue(this.product),
                ...$05ea1baea7ac44cb$var$originVersioningAttributes
            };
        }
        validate() {
            if (!$05ea1baea7ac44cb$export$2e2bcd8739ae039.isValidId(this.id)) throw new TypeError('Invalid Origin id');
            if (!$05ea1baea7ac44cb$export$2e2bcd8739ae039.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
        }
    }
    class $05ea1baea7ac44cb$var$EmptyOriginTracer extends $05ea1baea7ac44cb$export$2e2bcd8739ae039 {
        constructor(){
            super({
                id: null,
                product: null,
                dangerouslySkipValidation: true
            });
        }
        isValid() {
            return false;
        }
        isEmpty() {
            return true;
        }
        toAnalyticsAttributes() {
            return {
                ...$05ea1baea7ac44cb$var$originVersioningAttributes
            };
        }
    }
    class $05ea1baea7ac44cb$var$MalformedOriginTracer extends $05ea1baea7ac44cb$export$2e2bcd8739ae039 {
        constructor(){
            super({
                id: null,
                product: null,
                dangerouslySkipValidation: true
            });
        }
        isValid() {
            return false;
        }
        isEmpty() {
            return false;
        }
        toAnalyticsAttributes() {
            return {
                originMalformed: true,
                ...$05ea1baea7ac44cb$var$originVersioningAttributes
            };
        }
    }
    function $05ea1baea7ac44cb$var$replaceQuery(url, replacer) {
        const urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
        const urlString = String(url);
        return urlString.replace(urlWithQueryStringRegex, (_wholeMatch, beforeQuery, queryString, afterQuery)=>{
            let newQueryString = replacer(queryString);
            if (newQueryString) newQueryString = `?${newQueryString}`;
            return `${beforeQuery}${newQueryString}${afterQuery}`;
        });
    }
});
parcelRegister("gN6JS", function(module, exports) {
    $parcel$export(module.exports, "encode", ()=>$24ac58cd6c454929$export$c564cdbbe6da493);
    $parcel$export(module.exports, "decode", ()=>$24ac58cd6c454929$export$2f872c0f2117be69);
    var $aj50U;
    var $035Fh;
    const $24ac58cd6c454929$var$productShorthands = {
        confluence: 'c',
        jira: 'j',
        stride: 's',
        bitbucket: 'b',
        trello: 't'
    };
    function $24ac58cd6c454929$export$c564cdbbe6da493(originData) {
        const json = JSON.stringify($24ac58cd6c454929$export$4bc4b533a565aabe(originData));
        const base64 = (0, (0, parcelRequire("035Fh")).getEnv)().btoa(json);
        return (0, (0, parcelRequire("aj50U")).base64ToBase64Url)(base64);
    }
    function $24ac58cd6c454929$export$2f872c0f2117be69(encodedOriginString) {
        const base64 = (0, (0, parcelRequire("aj50U")).base64UrlToBase64)(encodedOriginString);
        const json = (0, (0, parcelRequire("035Fh")).getEnv)().atob(base64);
        return $24ac58cd6c454929$export$46d5cda6b884b7ab(JSON.parse(json));
    }
    function $24ac58cd6c454929$export$4bc4b533a565aabe({ id: id, product: product }) {
        return {
            i: id,
            p: product && product in $24ac58cd6c454929$var$productShorthands ? $24ac58cd6c454929$var$productShorthands[product] : product
        };
    }
    function $24ac58cd6c454929$export$46d5cda6b884b7ab(originJSONObject) {
        const originData = {};
        if (originJSONObject.i) originData.id = originJSONObject.i;
        if (originJSONObject.p) originData.product = $24ac58cd6c454929$var$expandProductShorthand(originJSONObject.p);
        return originData;
    }
    function $24ac58cd6c454929$var$expandProductShorthand(maybeShorthand) {
        const products = Object.keys($24ac58cd6c454929$var$productShorthands);
        for(let i = 0; i < products.length; i++){
            const product = products[i];
            const shorthand = $24ac58cd6c454929$var$productShorthands[product];
            if (maybeShorthand === shorthand) return product;
        }
        return maybeShorthand;
    }
});
parcelRegister("aj50U", function(module, exports) {
    $parcel$export(module.exports, "base64ToBase64Url", ()=>$ef2efd1284352612$export$3b91e21dac1023c6);
    $parcel$export(module.exports, "base64UrlToBase64", ()=>$ef2efd1284352612$export$47c5265a25535d02);
    function $ef2efd1284352612$export$3b91e21dac1023c6(base64) {
        if (base64 == null) return '';
        return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    }
    function $ef2efd1284352612$export$47c5265a25535d02(base64url) {
        if (base64url == null) return '';
        const base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
        const padLength = (4 - base64url.length % 4) % 4;
        const pad = '==='.slice(0, padLength);
        return base64 + pad;
    }
});
parcelRegister("035Fh", function(module, exports) {
    $parcel$export(module.exports, "getEnv", ()=>$4929ffed70bb7c1b$export$4bd44a2aa29d3d6e);
    var $5k7LC = parcelRequire("5k7LC");
    const $4929ffed70bb7c1b$export$d3cd91e0fdbfdbc0 = ()=>({
            atob: typeof atob === 'function' && atob.bind(undefined) || typeof (0, $5k7LC.Buffer) !== 'undefined' && ((encoded)=>(0, $5k7LC.Buffer).from(encoded, 'base64').toString()),
            btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $5k7LC.Buffer) !== 'undefined' && ((str)=>(0, $5k7LC.Buffer).from(str).toString('base64')),
            URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (0, (parcelRequire("6vAaw")).URLSearchParams)
        });
    let $4929ffed70bb7c1b$var$env;
    const $4929ffed70bb7c1b$export$4bd44a2aa29d3d6e = ()=>$4929ffed70bb7c1b$var$env || ($4929ffed70bb7c1b$var$env = $4929ffed70bb7c1b$var$validateEnv($4929ffed70bb7c1b$export$d3cd91e0fdbfdbc0()));
    const $4929ffed70bb7c1b$var$validateEnv = (env)=>{
        if (!(env.atob && env.btoa && env.URLSearchParams)) throw new TypeError(`Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).`);
        return env;
    };
});
parcelRegister("3U66g", function(module, exports) {
    $parcel$export(module.exports, "canCompress", ()=>$76138b2007ecaafb$export$ec3662f84d9f778c);
    $parcel$export(module.exports, "buildCompressionFunction", ()=>$76138b2007ecaafb$export$20de0576abb0bcc5);
    const $76138b2007ecaafb$export$ec3662f84d9f778c = (event)=>event.actionSubject === 'feature' && event.action === 'exposed' && event.eventType === 'operational' && event.attributes && event.tags && event.tags.includes('measurement') && !event.tags.includes('hasCustomAttributes');
    const $76138b2007ecaafb$export$ca25d5d7792a4f37 = (events, batchSize = 50)=>{
        if (!events || events.length <= 0) return [];
        if (batchSize <= 0) throw new Error('Batch size must be greater than 0');
        const flagEvaluations = events.map((currentEvent)=>{
            const { flagKey: flagKey, value: value, reason: reason, ruleId: ruleId, errorKind: errorKind } = currentEvent.attributes;
            return {
                key: flagKey,
                value: value,
                ...reason && {
                    reason: reason
                },
                ...ruleId && {
                    ruleId: ruleId
                },
                ...errorKind && {
                    errorKind: errorKind
                }
            };
        });
        return $76138b2007ecaafb$var$createBatches(flagEvaluations, batchSize);
    };
    const $76138b2007ecaafb$var$createBatches = (array, batchSize)=>{
        let compressedEvaluations = [];
        for(let i = 0; i < array.length; i += batchSize){
            let evaluationBatch = array.slice(i, i + batchSize);
            compressedEvaluations.push({
                actionSubject: 'features',
                action: 'exposed',
                eventType: 'operational',
                attributes: {
                    evaluations: evaluationBatch
                },
                tags: [
                    'measurement'
                ],
                source: '@atlassian/exposure-events-compressor'
            });
        }
        return compressedEvaluations;
    };
    const $76138b2007ecaafb$export$20de0576abb0bcc5 = (batchSize)=>(events)=>$76138b2007ecaafb$export$ca25d5d7792a4f37(events, batchSize);
});
parcelRegister("6gaDB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4822933091cd7d74$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fpTxz;
    var $4skgo;
    var $fuupf;
    var $cnq6K;
    const $4822933091cd7d74$var$EngagementProviderWithEvents = (0, (0, parcelRequire("fpTxz")).default)()((0, (0, parcelRequire("cnq6K")).EngagementProvider));
    const $4822933091cd7d74$var$EngagementProviderWithDefaultStore = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($4822933091cd7d74$var$EngagementProviderWithEvents, {
            ...props,
            store: (0, (0, parcelRequire("fuupf")).default)(props.config)
        });
    };
    var $4822933091cd7d74$export$2e2bcd8739ae039 = (0, (0, parcelRequire("4skgo")).default)($4822933091cd7d74$var$EngagementProviderWithDefaultStore);
});
parcelRegister("4skgo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a0e461e2199cdec$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $8a0e461e2199cdec$export$2e2bcd8739ae039(Component) {
        const PreventNestedInstancesContext = (0, ($parcel$interopDefault($5uXOq))).createContext(false);
        return function PreventNestedInstances(props) {
            return ((0, ($parcel$interopDefault($5uXOq))).createElement(PreventNestedInstancesContext.Consumer, null, (shouldPreventInstantiation)=>shouldPreventInstantiation ? props.children : (0, ($parcel$interopDefault($5uXOq))).createElement(PreventNestedInstancesContext.Provider, {
                    value: true
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props))));
        };
    }
});
parcelRegister("fuupf", function(module, exports) {
    $parcel$export(module.exports, "store", ()=>$813f1ded934255a5$export$6f57813fe9f31bf9);
    $parcel$export(module.exports, "default", ()=>$813f1ded934255a5$export$2e2bcd8739ae039);
    var $ajpes = parcelRequire("ajpes");
    var $3f2cs = parcelRequire("3f2cs");
    var $4mVt6;
    var $bkCgs;
    var $csA48;
    var $skIMw;
    const $813f1ded934255a5$export$36d128238e6b60f5 = {
        messageMapping: new Map(),
        current: null,
        initialized: false,
        initializing: false,
        config: {
            cloudId: '',
            aaid: '',
            locale: '',
            product: '',
            stargateUrl: '',
            orgId: '',
            workspaceId: ''
        }
    };
    let $813f1ded934255a5$var$processMessagesCancellationToken = (0, (0, parcelRequire("4mVt6")).createCancellationToken)();
    function $813f1ded934255a5$export$7a10f46f72407bc5(messageMapping, component) {
        const newMapping = new Map();
        messageMapping.forEach((value, key)=>{
            if (!(0, ($parcel$interopDefault($ajpes)))(value.component, component)) newMapping.set(key, value);
        });
        return newMapping;
    }
    const $813f1ded934255a5$export$6f57813fe9f31bf9 = (0, $3f2cs.createStore)((state = $813f1ded934255a5$export$36d128238e6b60f5, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("csA48")).SET_MESSAGE_MAPPING:
                return {
                    ...state,
                    initialized: true,
                    initializing: false,
                    messageMapping: action.messageMapping
                };
            case 0, (0, parcelRequire("csA48")).SET_INITIALIZING:
                return {
                    ...state,
                    config: action.config,
                    initializing: true
                };
            case 0, (0, parcelRequire("csA48")).SET_CURRENT:
                {
                    const { eventMapping: eventMapping } = action;
                    const { message: message, component: component } = eventMapping;
                    const messageMapping = $813f1ded934255a5$export$7a10f46f72407bc5(state.messageMapping, component);
                    return {
                        ...state,
                        current: {
                            messageId: message.messageId,
                            variationId: message.variationId,
                            ...component
                        },
                        messageMapping: messageMapping
                    };
                }
            case 0, (0, parcelRequire("csA48")).CLEAR_CURRENT:
                return {
                    ...state,
                    current: null
                };
            case 0, (0, parcelRequire("csA48")).RESET_STORE:
                return $813f1ded934255a5$export$36d128238e6b60f5;
            default:
                return state;
        }
    });
    var $813f1ded934255a5$export$2e2bcd8739ae039 = (config)=>{
        const state = $813f1ded934255a5$export$6f57813fe9f31bf9.getState();
        if (state.initializing || state.initialized) {
            if (state.config.cloudId === config.cloudId) return $813f1ded934255a5$export$6f57813fe9f31bf9;
            $813f1ded934255a5$var$processMessagesCancellationToken.isCancelled = true;
            $813f1ded934255a5$var$processMessagesCancellationToken = (0, (0, parcelRequire("4mVt6")).createCancellationToken)();
            $813f1ded934255a5$export$6f57813fe9f31bf9.dispatch((0, (0, parcelRequire("csA48")).resetStore)());
        }
        const newConfig = {
            ...config
        };
        newConfig.locale = newConfig.locale.replace('_', '-');
        $813f1ded934255a5$export$6f57813fe9f31bf9.dispatch((0, (0, parcelRequire("csA48")).initialize)(newConfig));
        if ((0, (0, parcelRequire("bkCgs")).isMessagingEnabled)()) (0, (0, parcelRequire("skIMw")).processMessages)($813f1ded934255a5$export$6f57813fe9f31bf9, newConfig, $813f1ded934255a5$var$processMessagesCancellationToken);
        return $813f1ded934255a5$export$6f57813fe9f31bf9;
    };
});
parcelRegister("4mVt6", function(module, exports) {
    $parcel$export(module.exports, "createCancellationToken", ()=>$4da365a1a2a3214b$export$eac027797b968991);
    function $4da365a1a2a3214b$export$eac027797b968991(isCancelled = false) {
        return {
            isCancelled: isCancelled
        };
    }
});
parcelRegister("bkCgs", function(module, exports) {
    $parcel$export(module.exports, "isMessagingEnabled", ()=>$d7020317db87373f$export$a77934ac158768dd);
    var $1WqFo;
    function $d7020317db87373f$export$a77934ac158768dd() {
        return !(0, (0, parcelRequire("1WqFo")).isFedRamp)();
    }
});
parcelRegister("csA48", function(module, exports) {
    $parcel$export(module.exports, "SET_MESSAGE_MAPPING", ()=>$8c631bc80e6b3aa9$export$d05fe3e897340c89);
    $parcel$export(module.exports, "SET_INITIALIZING", ()=>$8c631bc80e6b3aa9$export$eacd3ec165715d8);
    $parcel$export(module.exports, "RESET_STORE", ()=>$8c631bc80e6b3aa9$export$874c5149d7f0e3b8);
    $parcel$export(module.exports, "CLEAR_CURRENT", ()=>$8c631bc80e6b3aa9$export$cb5041d68cb18859);
    $parcel$export(module.exports, "SET_CURRENT", ()=>$8c631bc80e6b3aa9$export$a9319af002a4c677);
    $parcel$export(module.exports, "resetStore", ()=>$8c631bc80e6b3aa9$export$a20a1205b2a2b7e4);
    $parcel$export(module.exports, "initialize", ()=>$8c631bc80e6b3aa9$export$2a47f398eeff8b01);
    $parcel$export(module.exports, "setMessageMapping", ()=>$8c631bc80e6b3aa9$export$375dd0a76fecd4c7);
    $parcel$export(module.exports, "setCurrent", ()=>$8c631bc80e6b3aa9$export$5f80f094fd31fffd);
    $parcel$export(module.exports, "clearCurrent", ()=>$8c631bc80e6b3aa9$export$96105f873ade39d7);
    const $8c631bc80e6b3aa9$export$d05fe3e897340c89 = 'SET_MESSAGE_MAPPING';
    const $8c631bc80e6b3aa9$export$eacd3ec165715d8 = 'SET_INITIALIZING';
    const $8c631bc80e6b3aa9$export$874c5149d7f0e3b8 = 'RESET_STORE';
    const $8c631bc80e6b3aa9$export$cb5041d68cb18859 = 'CLEAR_CURRENT';
    const $8c631bc80e6b3aa9$export$a9319af002a4c677 = 'SET_CURRENT';
    const $8c631bc80e6b3aa9$export$a20a1205b2a2b7e4 = ()=>({
            type: $8c631bc80e6b3aa9$export$874c5149d7f0e3b8
        });
    const $8c631bc80e6b3aa9$export$2a47f398eeff8b01 = (config)=>({
            type: $8c631bc80e6b3aa9$export$eacd3ec165715d8,
            config: config
        });
    const $8c631bc80e6b3aa9$export$375dd0a76fecd4c7 = (messageMapping)=>({
            type: $8c631bc80e6b3aa9$export$d05fe3e897340c89,
            messageMapping: messageMapping
        });
    function $8c631bc80e6b3aa9$export$5f80f094fd31fffd(eventMapping) {
        return {
            type: $8c631bc80e6b3aa9$export$a9319af002a4c677,
            eventMapping: eventMapping
        };
    }
    function $8c631bc80e6b3aa9$export$96105f873ade39d7() {
        return {
            type: $8c631bc80e6b3aa9$export$cb5041d68cb18859
        };
    }
});
parcelRegister("skIMw", function(module, exports) {
    $parcel$export(module.exports, "processMessages", ()=>$cf4e91ec320736dd$export$d2e92820f98a2592);
    var $bTKhp;
    var $csA48;
    var $fuupf;
    const $cf4e91ec320736dd$export$a9d4ce3abb5d2365 = (messages)=>{
        const mapping = new Map();
        messages.forEach((message)=>{
            const components = message.components;
            components.forEach((component, index)=>{
                component.triggers.forEach((trigger)=>{
                    mapping.set(trigger, {
                        message: message,
                        component: {
                            componentId: index,
                            isLast: index === components.length - 1,
                            ...component
                        }
                    });
                });
            });
        });
        return mapping;
    };
    async function $cf4e91ec320736dd$export$d2e92820f98a2592(engagementStore, config, cancellationToken) {
        if (cancellationToken.isCancelled) return;
        const state = (0, (0, parcelRequire("fuupf")).store).getState();
        const { cloudId: cloudId, stargateUrl: stargateUrl, product: product, locale: locale } = config;
        let messages, interval;
        try {
            const results = await (0, (0, parcelRequire("bTKhp")).getMessages)(cloudId, stargateUrl, product, locale);
            if (cancellationToken.isCancelled) return;
            messages = results.messages;
            interval = results.interval;
        } catch (e) {
            return;
        }
        if (state.current === null) {
            const messageMapping = $cf4e91ec320736dd$export$a9d4ce3abb5d2365(messages);
            engagementStore.dispatch((0, (0, parcelRequire("csA48")).setMessageMapping)(messageMapping));
        }
        if (interval !== 0) setTimeout(()=>{
            $cf4e91ec320736dd$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
        }, interval * 1000);
    }
});
parcelRegister("bTKhp", function(module, exports) {
    $parcel$export(module.exports, "getMessages", ()=>$58f6563607092f33$export$8c20ab16ac9cf14f);
    $parcel$export(module.exports, "startMessage", ()=>$58f6563607092f33$export$7a77c9a7b182680b);
    $parcel$export(module.exports, "stopMessage", ()=>$58f6563607092f33$export$159ff839f1f095d2);
    $parcel$export(module.exports, "sendUserResponse", ()=>$58f6563607092f33$export$e1fd1449cf83c1f5);
    $parcel$export(module.exports, "markAsSeenAndFatigued", ()=>$58f6563607092f33$export$3683393f780c6905);
    var $M4Zg0 = parcelRequire("M4Zg0");
    var $f1fxJ;
    var $7mQLn;
    const $58f6563607092f33$export$f4d1b02d312560f5 = '2';
    const $58f6563607092f33$var$inProductMessagesUrlTemplate = (0, ($parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/{cloudId}/in-product-messages{?product,schema,locale}');
    async function $58f6563607092f33$export$8c20ab16ac9cf14f(cloudId, stargateUrl, product, locale) {
        return (0, (0, parcelRequire("7mQLn")).stargateFetch)(`${stargateUrl}${$58f6563607092f33$var$inProductMessagesUrlTemplate.expand({
            cloudId: cloudId,
            product: product,
            schema: $58f6563607092f33$export$f4d1b02d312560f5,
            locale: locale
        })}`).then((0, (0, parcelRequire("7mQLn")).errorIfNotOk)).then((r)=>r.json().then((messages)=>({
                    messages: messages,
                    interval: Number.parseFloat(r.headers.get('POLL-INTERVAL') || '0')
                })));
    }
    function $58f6563607092f33$var$handleStartStopMessageResponse(response) {
        return response.status === (0, $ac85ba4533d29a9f$export$3288b14b6745c572);
    }
    const $58f6563607092f33$var$startMessageUrlTemplate = (0, ($parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start');
    const $58f6563607092f33$var$startMessageWithVariationIdUrlTemplate = (0, ($parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start/{variationId}');
    const $58f6563607092f33$var$stopMessageUrlTemplate = (0, ($parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/messages/{messageId}/stop');
    var $58f6563607092f33$export$56ac8ebc9870b1b9;
    (function(envType) {
        envType["LOCAL"] = "local";
        envType["DEV"] = "dev";
        envType["STAGING"] = "staging";
        envType["PROD"] = "prod";
    })($58f6563607092f33$export$56ac8ebc9870b1b9 || ($58f6563607092f33$export$56ac8ebc9870b1b9 = {}));
    let $58f6563607092f33$var$choreographerPlugin;
    async function $58f6563607092f33$export$7a77c9a7b182680b(startMessageConfig, options) {
        if (options?.enableChoreographer) return $58f6563607092f33$var$startMessageWithChoreographer(startMessageConfig, options);
        return $58f6563607092f33$var$startMessageWithCoordination(startMessageConfig);
    }
    async function $58f6563607092f33$export$159ff839f1f095d2(stopMessageConfig, options) {
        if (options?.enableChoreographer) return $58f6563607092f33$var$stopMessageWithChoreographer(stopMessageConfig, options);
        return $58f6563607092f33$var$stopMessageWithCoordination(stopMessageConfig);
    }
    async function $58f6563607092f33$var$startMessageWithChoreographer(startMessageConfig, options) {
        if (!$58f6563607092f33$var$choreographerPlugin) $58f6563607092f33$var$choreographerPlugin = new (0, (0, parcelRequire("f1fxJ")).EngagekitChoreographerPlugin)(options.envType ?? "local");
        return $58f6563607092f33$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, ()=>$58f6563607092f33$var$startMessageWithCoordination(startMessageConfig, true), options.additionalData);
    }
    async function $58f6563607092f33$var$stopMessageWithChoreographer(stopMessageConfig, options) {
        if (!$58f6563607092f33$var$choreographerPlugin) $58f6563607092f33$var$choreographerPlugin = new (0, (0, parcelRequire("f1fxJ")).EngagekitChoreographerPlugin)(options.envType ?? "local");
        return $58f6563607092f33$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, ()=>$58f6563607092f33$var$stopMessageWithCoordination(stopMessageConfig, true), options.additionalData);
    }
    async function $58f6563607092f33$var$startMessageWithCoordination(startMessageConfig, choreographerEnabled = false) {
        const requestBody = {
            cloudId: startMessageConfig.cloudId,
            orgId: startMessageConfig.orgId,
            workspaceId: startMessageConfig.workspaceId,
            choreographerEnabled: choreographerEnabled
        };
        return (0, (0, parcelRequire("7mQLn")).stargateFetch)(startMessageConfig.variationId ? `${startMessageConfig.stargateUrl}${$58f6563607092f33$var$startMessageWithVariationIdUrlTemplate.expand({
            messageId: startMessageConfig.messageId,
            variationId: startMessageConfig.variationId
        })}` : `${startMessageConfig.stargateUrl}${$58f6563607092f33$var$startMessageUrlTemplate.expand({
            messageId: startMessageConfig.messageId
        })}`, {
            method: 'post',
            body: JSON.stringify(requestBody),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((0, (0, parcelRequire("7mQLn")).pullResponseTextIfNotOk)).then($58f6563607092f33$var$handleStartStopMessageResponse);
    }
    async function $58f6563607092f33$var$stopMessageWithCoordination(stopMessageConfig, choreographerEnabled = false) {
        const requestBody = {
            cloudId: stopMessageConfig.cloudId,
            orgId: stopMessageConfig.orgId,
            workspaceId: stopMessageConfig.workspaceId,
            choreographerEnabled: choreographerEnabled
        };
        return (0, (0, parcelRequire("7mQLn")).stargateFetch)(`${stopMessageConfig.stargateUrl}${$58f6563607092f33$var$stopMessageUrlTemplate.expand({
            messageId: stopMessageConfig.messageId
        })}`, {
            method: 'post',
            body: JSON.stringify(requestBody),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((0, (0, parcelRequire("7mQLn")).pullResponseTextIfNotOk)).then($58f6563607092f33$var$handleStartStopMessageResponse);
    }
    const $58f6563607092f33$var$userResponseUrlTemplate = (0, ($parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/{cloudId}/messages/{messageId}/response');
    async function $58f6563607092f33$export$e1fd1449cf83c1f5(cloudId, stargateUrl, messageId, payload) {
        return (0, (0, parcelRequire("7mQLn")).stargateFetch)(`${stargateUrl}${$58f6563607092f33$var$userResponseUrlTemplate.expand({
            cloudId: cloudId,
            messageId: messageId
        })}`, {
            method: 'post',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((0, (0, parcelRequire("7mQLn")).pullResponseTextIfNotOk)).then(()=>Promise.resolve());
    }
    const $58f6563607092f33$var$markSeenAndFatigueUrlTemplate = (0, ($parcel$interopDefault($M4Zg0))).parse('/engage-targeting/api/v2/user/messages/{messageId}/seen');
    async function $58f6563607092f33$export$3683393f780c6905(seenMessageConfig) {
        const requestBody = {
            cloudId: seenMessageConfig.cloudId,
            orgId: seenMessageConfig.orgId,
            workspaceId: seenMessageConfig.workspaceId
        };
        return (0, (0, parcelRequire("7mQLn")).stargateFetch)(`${seenMessageConfig.stargateUrl}${$58f6563607092f33$var$markSeenAndFatigueUrlTemplate.expand({
            messageId: seenMessageConfig.messageId
        })}`, {
            method: 'post',
            body: JSON.stringify(requestBody),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((0, (0, parcelRequire("7mQLn")).pullResponseTextIfNotOk)).then(()=>Promise.resolve());
    }
});
parcelRegister("f1fxJ", function(module, exports) {
    $parcel$export(module.exports, "EngagekitChoreographerPlugin", ()=>$261c41131eedf7c2$export$da23bd36e2d631b);
    var $g1SPn;
    var $3iMQo;
    var $aMP3x;
    var $aI8B5;
    var $6XCGo;
    const $261c41131eedf7c2$export$63ce1a41d951945d = 300000;
    class $261c41131eedf7c2$export$da23bd36e2d631b extends (0, (0, parcelRequire("6XCGo")).ChoreographerPlugin) {
        constructor(env, metaMetricsData = {}){
            super((0, (0, parcelRequire("3iMQo")).ProductIds).ENGAGEKIT, env, metaMetricsData);
        }
        shouldLogEvent(event) {
            return event.actionSubject !== (0, (0, parcelRequire("3iMQo")).MessageAction).START || event.action !== (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).BLOCKED;
        }
        isValidDuplicateStartRequest(messageId) {
            const currentMessage = (0, (0, parcelRequire("g1SPn")).Choreographer).getInstance().getCurrentMessage() ?? (0, (0, parcelRequire("g1SPn")).Choreographer).getInstance().getCurrentPendingMessage();
            return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < $261c41131eedf7c2$export$63ce1a41d951945d);
        }
        async startMessageWithPlugin(messageId, callback, additionalData = {}) {
            const debugLogger = new (0, (0, parcelRequire("aMP3x")).DebugLogger)(this.state.productId, messageId);
            const actionSubject = (0, (0, parcelRequire("3iMQo")).MessageAction).START;
            debugLogger.trace({
                verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
            });
            const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
            if (isValidDuplicateStartRequest) {
                const logger = new (0, (0, parcelRequire("aI8B5")).Logger)(actionSubject, messageId, {
                    ...this.state.metaMetricsData,
                    ...additionalData
                }, this.analyticsClient);
                const didStart = Boolean(await callback());
                if (didStart) {
                    logger.started();
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            plugin: this.constructor.name,
                            disposition: (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STARTED,
                            timestamp: performance.now()
                        }
                    });
                }
                return didStart;
            }
            this.onStart(messageId, callback);
            const result = await this.startMessage(messageId, additionalData);
            return result === (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STARTED;
        }
        async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
            const debugLogger = new (0, (0, parcelRequire("aMP3x")).DebugLogger)(this.state.productId, messageId);
            debugLogger.trace({
                verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
            });
            this.onStop(messageId, callback);
            const result = await this.stopMessage(messageId, additionalData);
            return result === (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STOPPED;
        }
    }
});
parcelRegister("g1SPn", function(module, exports) {
    $parcel$export(module.exports, "Choreographer", ()=>$f0fa334b8a6c170d$export$236158f15971c92e);
    var $3iMQo;
    var $aMP3x;
    var $aI8B5;
    var $8ad3G;
    const $f0fa334b8a6c170d$var$CHOREOGRAPHER_MESSAGE_TTL = 300000;
    let $f0fa334b8a6c170d$var$singleton;
    class $f0fa334b8a6c170d$export$236158f15971c92e {
        static getInstance() {
            if (!$f0fa334b8a6c170d$var$singleton) $f0fa334b8a6c170d$var$singleton = new this();
            return $f0fa334b8a6c170d$var$singleton;
        }
        constructor(){
            this.state = {
                currentMessage: null,
                isDisabled: false,
                messages: new Map(),
                messageQueue: [],
                messageTtl: null,
                plugins: new Map(),
                queueingBehindMessage: null,
                shouldQueueMessages: false
            };
        }
        stopCurrentMessage() {
            if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, this.state.currentMessage.plugin, true).then(()=>{
                this.clearMessageTtl();
                this.enablePlugins();
            });
        }
        queueMessages(productId, messageId) {
            this.state.shouldQueueMessages = true;
            this.state.queueingBehindMessage = {
                productId: productId,
                messageId: messageId,
                timestamp: Date.now()
            };
        }
        queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
            return new Promise((resolve)=>{
                this.state.messageQueue.push({
                    productId: productId,
                    messageId: messageId,
                    analyticsClient: analyticsClient,
                    metricsData: metricsData,
                    plugin: plugin,
                    resolve: resolve
                });
            });
        }
        processQueuedMessage() {
            const queuedMessage = this.state.messageQueue.shift();
            this.state.shouldQueueMessages = false;
            this.state.queueingBehindMessage = null;
            if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
        }
        destroyMessageQueue(plugin) {
            this.state.shouldQueueMessages = false;
            this.state.queueingBehindMessage = null;
            while(this.state.messageQueue.length > 0){
                const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
                const attributes = {
                    ...metricsData,
                    productId: productId,
                    messageId: messageId
                };
                const actionSubject = (0, (0, parcelRequire("3iMQo")).MessageAction).START;
                const logger = new (0, (0, parcelRequire("aI8B5")).Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
                const debugLogger = new (0, (0, parcelRequire("aMP3x")).DebugLogger)(productId, messageId);
                logger.blocked({
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).BLOCKED,
                        blockedByProductId: this.state.currentMessage?.productId,
                        blockedByMessageId: this.state.currentMessage?.messageId
                    }
                });
                resolve((0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).BLOCKED);
            }
        }
        setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin) {
            this.state.currentMessage = {
                productId: productId,
                messageId: messageId,
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                timestamp: Date.now()
            };
            this.state.messageTtl = setTimeout(()=>{
                if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
            }, $f0fa334b8a6c170d$var$CHOREOGRAPHER_MESSAGE_TTL);
        }
        isCurrentMessage(productId, messageId) {
            return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
        }
        getCurrentMessage() {
            return this.state.currentMessage;
        }
        getCurrentPendingMessage() {
            return this.state.queueingBehindMessage;
        }
        clearMessageTtl() {
            this.state.currentMessage = null;
            if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
        }
        disablePlugins(exceptFor) {
            this.state.isDisabled = true;
            [
                ...this.state.plugins.values()
            ].forEach((p)=>{
                if (p !== exceptFor) p.disable();
            });
        }
        enablePlugins() {
            [
                ...this.state.plugins.values()
            ].forEach((p)=>p.enable());
            this.state.isDisabled = false;
        }
        unregisterPlugin(productId) {
            if (this.state.currentMessage?.productId === productId) this.stopCurrentMessage();
            this.state.messages.delete(productId);
            this.state.plugins.delete(productId);
        }
        isDisplayingMessage() {
            return Boolean(this.state.currentMessage || [
                ...this.state.plugins.values()
            ].reduce((isDisplayingMessage, p)=>{
                return isDisplayingMessage || p.isDisplayingMessage();
            }, false));
        }
        getMessages(productId) {
            return this.state.messages.get(productId) ?? new Map();
        }
        async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
            if ((0, (0, parcelRequire("8ad3G")).isChoreographerSuppressed)()) {
                if (this.hasMessageRecord(productId, messageId)) {
                    const message = this.ensureMessageRecord(productId, messageId);
                    const didStart = await message.start?.() ?? true;
                    if (didStart) {
                        message.onStart?.();
                        return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STARTED;
                    }
                    return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).CANCELED;
                }
                return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).UNREGISTERED;
            }
            const debugLogger = new (0, (0, parcelRequire("aMP3x")).DebugLogger)(productId, messageId);
            const actionSubject = (0, (0, parcelRequire("3iMQo")).MessageAction).START;
            const requestTimestamp = performance.now();
            debugLogger.log({
                info: {
                    phase: actionSubject,
                    timestamp: requestTimestamp
                },
                verbose: {
                    phase: actionSubject,
                    timestamp: requestTimestamp
                }
            });
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const logger = new (0, (0, parcelRequire("aI8B5")).Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
            try {
                if (!this.hasMessageRecord(productId, messageId)) {
                    logger.unregistered();
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            disposition: (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).UNREGISTERED
                        }
                    });
                    return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).UNREGISTERED;
                }
                if (this.state.shouldQueueMessages) {
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            disposition: `queued behind ${this.state.queueingBehindMessage?.productId} ${this.state.queueingBehindMessage?.messageId}`
                        }
                    });
                    return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
                }
                if (this.state.isDisabled || this.isDisplayingMessage()) {
                    logger.blocked({
                        blockedByProductId: this.state.currentMessage?.productId,
                        blockedByMessageId: this.state.currentMessage?.messageId
                    });
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            disposition: (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).BLOCKED,
                            blockedByProductId: this.state.currentMessage?.productId,
                            blockedByMessageId: this.state.currentMessage?.messageId
                        }
                    });
                    return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).BLOCKED;
                }
                const message = this.ensureMessageRecord(productId, messageId);
                this.queueMessages(productId, messageId);
                const didStart = await message.start?.() ?? true;
                if (didStart) {
                    message.onStart?.();
                    logger.started();
                    this.disablePlugins(plugin);
                    this.setMessageTtl(productId, messageId, analyticsClient, metricsData);
                    this.destroyMessageQueue(plugin);
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            disposition: (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STARTED
                        }
                    });
                    return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STARTED;
                }
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).CANCELED
                    }
                });
                return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).CANCELED;
            } catch (error) {
                const e = error;
                logger.error({
                    reason: e.message
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).ERROR
                    }
                });
                return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).ERROR;
            }
        }
        async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, plugin, forceStop = false) {
            if ((0, (0, parcelRequire("8ad3G")).isChoreographerSuppressed)()) {
                if (this.hasMessageRecord(productId, messageId)) {
                    const message = this.ensureMessageRecord(productId, messageId);
                    const didStop = await message.stop?.() ?? true;
                    if (didStop) {
                        message.onStop?.();
                        return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STOPPED;
                    }
                    return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).CANCELED;
                }
                return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).UNREGISTERED;
            }
            const debugLogger = new (0, (0, parcelRequire("aMP3x")).DebugLogger)(productId, messageId);
            const actionSubject = (0, (0, parcelRequire("3iMQo")).MessageAction).STOP;
            const requestTimestamp = performance.now();
            debugLogger.log({
                info: {
                    phase: actionSubject,
                    timestamp: requestTimestamp
                },
                verbose: {
                    phase: actionSubject,
                    timestamp: requestTimestamp
                }
            });
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const logger = new (0, (0, parcelRequire("aI8B5")).Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
            try {
                if (!this.hasMessageRecord(productId, messageId)) {
                    logger.unregistered();
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            disposition: (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).UNREGISTERED
                        }
                    });
                    return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).UNREGISTERED;
                }
                const message = this.ensureMessageRecord(productId, messageId);
                if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
                const didStop = await message.stop?.() ?? true;
                if (didStop || forceStop) {
                    if (this.isCurrentMessage(productId, messageId)) {
                        message.onStop?.();
                        logger.stopped(forceStop ? {
                            forceStop: forceStop,
                            didStop: didStop
                        } : undefined);
                        this.clearMessageTtl();
                        this.enablePlugins();
                    }
                    this.processQueuedMessage();
                    debugLogger.log({
                        verbose: {
                            phase: actionSubject,
                            disposition: (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STOPPED
                        }
                    });
                    return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STOPPED;
                }
                this.destroyMessageQueue(plugin);
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).CANCELED
                    }
                });
                return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).CANCELED;
            } catch (error) {
                const e = error;
                logger.error({
                    reason: e.message
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).ERROR
                    }
                });
                return (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).ERROR;
            }
        }
        async stopMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
            return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData, plugin);
        }
        registerPlugin(productId, plugin) {
            if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
            this.state.plugins = this.state.plugins.set(productId, plugin);
            if (this.state.isDisabled) plugin.disable();
            return ()=>{
                this.unregisterPlugin(productId);
            };
        }
        ensureMessageRecord(productId, messageId) {
            let productMessages = this.state.messages.get(productId);
            if (!productMessages) {
                productMessages = new Map();
                this.state.messages.set(productId, productMessages);
            }
            let message = productMessages.get(messageId);
            if (!message) {
                message = {};
                productMessages.set(messageId, message);
            }
            return message;
        }
        hasMessageRecord(productId, messageId) {
            return Boolean(this.state.messages.get(productId)?.has?.(messageId));
        }
        on(productId, messageId, options = {}, finalizers = {}) {
            const message = {
                ...this.ensureMessageRecord(productId, messageId),
                ...options,
                ...finalizers
            };
            this.state.messages.get(productId).set(messageId, message);
        }
        onStart(productId, messageId, startCallback, finalizers) {
            this.on(productId, messageId, {
                start: startCallback
            }, finalizers);
        }
        onStop(productId, messageId, stopCallback, finalizers = {}) {
            this.on(productId, messageId, {
                stop: stopCallback
            }, finalizers);
        }
        off(productId, messageId) {
            this.state.messages.get(productId)?.delete?.(messageId);
        }
    }
});
parcelRegister("3iMQo", function(module, exports) {
    $parcel$export(module.exports, "MessageEventType", ()=>$3ff34efc9153020e$export$d33b097e0a285bc2);
    $parcel$export(module.exports, "MessageDeliveryStatus", ()=>$3ff34efc9153020e$export$f6a9504bc1305cf0);
    $parcel$export(module.exports, "ProductIds", ()=>$3ff34efc9153020e$export$7fb117db98868be6);
    $parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", ()=>$3ff34efc9153020e$export$dbe9e38c9d6f26d0);
    $parcel$export(module.exports, "MessageAction", ()=>$3ff34efc9153020e$export$865c0eaaa43d90f8);
    const $3ff34efc9153020e$export$d33b097e0a285bc2 = {
        START: 'start',
        STOP: 'stop'
    };
    const $3ff34efc9153020e$export$f6a9504bc1305cf0 = {
        BLOCKED: 'blocked',
        CANCELED: 'canceled',
        ERROR: 'error',
        STARTED: 'started',
        STOPPED: 'stopped',
        UNREGISTERED: 'unregistered'
    };
    var $3ff34efc9153020e$export$7fb117db98868be6;
    (function(ProductIds) {
        ProductIds["CONFLUENCE"] = "confluence";
        ProductIds["ENGAGEKIT"] = "Engagekit";
        ProductIds["INTERCOM"] = "intercom";
        ProductIds["JIRA"] = "jira";
        ProductIds["PENDO"] = "pendo";
        ProductIds["CLOUDADMIN"] = "cloudadmin";
        ProductIds["BITBUCKET"] = "bitbucket";
        ProductIds["POST_OFFICE"] = "post-office";
    })($3ff34efc9153020e$export$7fb117db98868be6 || ($3ff34efc9153020e$export$7fb117db98868be6 = {}));
    const $3ff34efc9153020e$export$94e85cf3348f045a = {
        ENGAGEMENT: 'engagement',
        MARKETING: 'marketing',
        TRANSACTIONAL: 'transactional'
    };
    const $3ff34efc9153020e$export$dbe9e38c9d6f26d0 = [
        $3ff34efc9153020e$export$94e85cf3348f045a.ENGAGEMENT,
        $3ff34efc9153020e$export$94e85cf3348f045a.MARKETING
    ];
    const $3ff34efc9153020e$export$865c0eaaa43d90f8 = {
        START: 'messageStart',
        STOP: 'messageStop'
    };
    const $3ff34efc9153020e$export$fc6a8b8cb405f50 = {
        INFO: 'info',
        VERBOSE: 'verbose'
    };
});
parcelRegister("aMP3x", function(module, exports) {
    $parcel$export(module.exports, "DebugLogger", ()=>$7a8c46835ca86bc2$export$21e6cc849c1dc1ab);
    function $7a8c46835ca86bc2$var$getCurrentLoggingLevel() {
        return window.choreographerLoggingLevel;
    }
    function $7a8c46835ca86bc2$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
        if ($7a8c46835ca86bc2$var$getCurrentLoggingLevel() === loggingLevel) console.table(data);
    }
    function $7a8c46835ca86bc2$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
        if ($7a8c46835ca86bc2$var$getCurrentLoggingLevel() === loggingLevel) console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
    }
    class $7a8c46835ca86bc2$export$21e6cc849c1dc1ab {
        constructor(productId, messageId){
            this.log = (messages)=>{
                [
                    ...Object.keys(messages)
                ].forEach((loggingLevel)=>{
                    $7a8c46835ca86bc2$var$logMessageIfValidLoggingLevel(loggingLevel, {
                        productId: this.state.productId,
                        messageId: this.state.messageId,
                        ...messages[loggingLevel] ?? {},
                        ...loggingLevel === 'verbose' ? {
                            timestamp: performance.now()
                        } : {}
                    });
                });
            };
            this.trace = (messages)=>{
                [
                    ...Object.keys(messages)
                ].forEach((loggingLevel)=>{
                    $7a8c46835ca86bc2$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === 'verbose' ? ` (${performance.now()})` : ''}`);
                });
            };
            this.state = {
                productId: productId,
                messageId: messageId
            };
        }
    }
});
parcelRegister("aI8B5", function(module, exports) {
    $parcel$export(module.exports, "Logger", ()=>$efe3ad7eb98e67fe$export$efa9a398d6368992);
    var $294ns;
    var $3iMQo;
    class $efe3ad7eb98e67fe$export$efa9a398d6368992 {
        constructor(actionSubject, actionSubjectId, metricsData, analyticsClient, plugin){
            this.state = {
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                metricsData: metricsData,
                analyticsClient: analyticsClient,
                plugin: plugin
            };
        }
        sendOperationalEvent(action, additionalAttributes) {
            if ((0, (0, parcelRequire("294ns")).fg)('platform.post-office.enable-full-choreographer-logging')) {
                const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes, plugin: plugin } = this.state;
                const event = {
                    source: 'choreographer',
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    attributes: {
                        ...attributes ?? {},
                        ...additionalAttributes ?? {}
                    },
                    tags: [
                        'postOffice'
                    ]
                };
                if (plugin?.shouldLogEvent?.(event) ?? true) analyticsClient.sendOperationalEvent(event);
            }
        }
        blocked(additionalAttributes) {
            this.sendOperationalEvent((0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).BLOCKED, additionalAttributes);
        }
        error(additionalAttributes) {
            this.sendOperationalEvent((0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).ERROR, additionalAttributes);
        }
        unregistered(additionalAttributes) {
            this.sendOperationalEvent((0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).UNREGISTERED, additionalAttributes);
        }
        started(additionalAttributes) {
            this.sendOperationalEvent((0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STARTED, additionalAttributes);
        }
        stopped(additionalAttributes) {
            this.sendOperationalEvent((0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STOPPED, additionalAttributes);
        }
    }
});
parcelRegister("8ad3G", function(module, exports) {
    $parcel$export(module.exports, "isChoreographerSuppressed", ()=>$34836da21a333c68$export$a0c8fa5038db1b93);
    var $70qxv;
    function $34836da21a333c68$export$a0c8fa5038db1b93() {
        return (0, (0, parcelRequire("70qxv")).default).initializeCompleted() && (0, (0, parcelRequire("70qxv")).default).getExperimentValue('post-office_ipm_choreographer_new_tenants', 'supressChoreographer', false);
    }
});
parcelRegister("6XCGo", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerPlugin", ()=>$0420bc66a8ada6d0$export$71324a662782c710);
    var $1o4Nl;
    var $bpIMA;
    var $g1SPn;
    class $0420bc66a8ada6d0$export$71324a662782c710 {
        constructor(productId, env, metaMetricsData = {}){
            this.state = {
                isDisabled: false,
                isDisplayingMessage: false,
                metaMetricsData: metaMetricsData,
                productId: productId,
                unregisterPlugin: ()=>{}
            };
            this.analyticsClient = this.createAnalyticsClient(env);
            this.finalizers = {
                onStart: ()=>this.blockDisplayState(),
                onStop: ()=>this.clearDisplayState()
            };
            this.state.unregisterPlugin = this.registerPlugin(productId);
        }
        destroy() {
            this.state.unregisterPlugin();
        }
        isDisplayingMessage() {
            return this.state.isDisplayingMessage;
        }
        blockDisplayState() {
            this.state.isDisplayingMessage = true;
        }
        clearDisplayState() {
            this.state.isDisplayingMessage = false;
        }
        disable() {
            this.state.isDisabled = true;
        }
        enable() {
            this.state.isDisabled = false;
        }
        async startMessage(messageId, additionalData = {}) {
            return (0, (0, parcelRequire("g1SPn")).Choreographer).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, {
                ...this.state.metaMetricsData,
                ...additionalData
            }, this);
        }
        async stopMessage(messageId, additionalData = {}) {
            return (0, (0, parcelRequire("g1SPn")).Choreographer).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, {
                ...this.state.metaMetricsData,
                ...additionalData
            });
        }
        on(messageId, options = {}) {
            return (0, (0, parcelRequire("g1SPn")).Choreographer).getInstance().on(this.state.productId, messageId, options, this.finalizers);
        }
        onStart(messageId, startCallback) {
            return (0, (0, parcelRequire("g1SPn")).Choreographer).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
        }
        onStop(messageId, stopCallback) {
            return (0, (0, parcelRequire("g1SPn")).Choreographer).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
        }
        off(messageId) {
            return (0, (0, parcelRequire("g1SPn")).Choreographer).getInstance().off(this.state.productId, messageId);
        }
        registerPlugin(productId) {
            return (0, (0, parcelRequire("g1SPn")).Choreographer).getInstance().registerPlugin(productId, this);
        }
        createAnalyticsClient(env) {
            const analyticsClient = new (0, (0, parcelRequire("1o4Nl")).default)({
                env: env,
                product: 'postOffice',
                origin: (0, (0, parcelRequire("bpIMA")).originType).WEB
            });
            return analyticsClient;
        }
    }
});
const $ac85ba4533d29a9f$export$3288b14b6745c572 = 204;
const $ac85ba4533d29a9f$export$c09e7ea0fc79f34f = 409;
const $ac85ba4533d29a9f$export$974c37534b0191b1 = 503;
parcelRegister("7mQLn", function(module, exports) {
    $parcel$export(module.exports, "errorIfNotOk", ()=>$c8b932ca79565fa5$export$4adbd37839ed7718);
    $parcel$export(module.exports, "pullResponseTextIfNotOk", ()=>$c8b932ca79565fa5$export$2ba4cde277adb6b1);
    $parcel$export(module.exports, "stargateFetch", ()=>$c8b932ca79565fa5$export$317bcea84a3bea48);
    var $1puKZ;
    const $c8b932ca79565fa5$export$1f86472c1374185a = 3;
    const $c8b932ca79565fa5$export$a2d611d5c7be4bb1 = 0.1;
    const $c8b932ca79565fa5$export$957d605a51548b59 = 2;
    const $c8b932ca79565fa5$export$80aa83cae6a6c290 = 1000;
    async function $c8b932ca79565fa5$export$4adbd37839ed7718(response) {
        if (!response.ok) throw Error(`${response.status}: ${await response.text()}`);
        return response;
    }
    async function $c8b932ca79565fa5$export$2ba4cde277adb6b1(response) {
        if (!response.ok) await response.text();
        return response;
    }
    function $c8b932ca79565fa5$export$317bcea84a3bea48(input, reqOptions) {
        return $c8b932ca79565fa5$var$fetchWithRetry({
            input: input,
            reqOptions: reqOptions,
            numRetries: 0,
            maxRetries: $c8b932ca79565fa5$export$1f86472c1374185a,
            waitTimeMs: $c8b932ca79565fa5$export$80aa83cae6a6c290,
            backoffFn: $c8b932ca79565fa5$export$924aee1254634401
        });
    }
    function $c8b932ca79565fa5$var$fetchWithRetry({ input: input, reqOptions: reqOptions, numRetries: numRetries = 0, maxRetries: maxRetries = 0, waitTimeMs: waitTimeMs = 0, backoffFn: backoffFn = $c8b932ca79565fa5$export$924aee1254634401 }) {
        if (numRetries > maxRetries) throw new Error(`Failed to fetch ${input}: Max retries exceeded`);
        const options = {
            ...reqOptions,
            credentials: (0, (0, parcelRequire("1puKZ")).default).includes(location.host) ? 'include' : 'same-origin'
        };
        const retryAttempt = ()=>new Promise((resolve)=>{
                setTimeout(()=>{
                    resolve($c8b932ca79565fa5$var$fetchWithRetry({
                        input: input,
                        reqOptions: reqOptions,
                        numRetries: numRetries + 1,
                        maxRetries: maxRetries,
                        waitTimeMs: backoffFn(waitTimeMs),
                        backoffFn: backoffFn
                    }));
                }, waitTimeMs);
            });
        return fetch(input, options).then((response)=>{
            if (response.status >= 500 && response.status <= 599) return retryAttempt();
            return response;
        }).catch(()=>{
            return retryAttempt();
        });
    }
    function $c8b932ca79565fa5$export$924aee1254634401(waitTimeMs) {
        const nextWaitTime = waitTimeMs * $c8b932ca79565fa5$export$957d605a51548b59;
        const jitter = nextWaitTime * $c8b932ca79565fa5$export$a2d611d5c7be4bb1 * Math.random();
        return nextWaitTime + jitter;
    }
});
parcelRegister("1puKZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e47d31fc413e3a0$export$2e2bcd8739ae039);
    var $8e47d31fc413e3a0$export$2e2bcd8739ae039 = [
        'bitbucket-pipelines.dev.public.atl-paas.net',
        'bitbucket-pipelines.staging.public.atl-paas.net',
        'bitbucket-pipelines.prod.public.atl-paas.net'
    ];
});
parcelRegister("cnq6K", function(module, exports) {
    $parcel$export(module.exports, "EngagementProvider", ()=>$5a6e1b2acc91c182$export$83b8ae7ce7b4d59c);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8l56 = parcelRequire("f8l56");
    var $bxYf9 = parcelRequire("bxYf9");
    var $8rCP3;
    var $dyczo = parcelRequire("dyczo");
    var $1IwGM;
    var $3QJTu;
    var $3iMQo;
    var $aPRQd;
    var $bTKhp;
    var $5HGUB;
    var $986je;
    var $1SgSi;
    var $bkCgs;
    var $csA48;
    var $hx3r8;
    const $5a6e1b2acc91c182$var$MAX_EVENT_QUEUE_SIZE = 100;
    const $5a6e1b2acc91c182$var$EK_LOADED_EVENT = 'engagement.inproduct.loaded';
    const $5a6e1b2acc91c182$export$5306bd00631dbf8c = 'ep.analyticEvent';
    function $5a6e1b2acc91c182$var$collapseEventToPayload(event) {
        const payload = {
            ...event.payload,
            context: {}
        };
        Object.assign(payload.context, ...event.context);
        return payload;
    }
    function $5a6e1b2acc91c182$var$findMatchingTrigger(messageMapping, payload) {
        return Array.from(messageMapping.keys()).find((trigger)=>{
            return (0, ($parcel$interopDefault($f8l56)))(payload, trigger);
        });
    }
    function $5a6e1b2acc91c182$var$fireExposureEvent(attributes, clientOrPromise) {
        const analyticsEvent = new (0, (0, parcelRequire("1IwGM")).default)({
            payload: {
                action: 'exposed',
                actionSubject: 'feature',
                actionSubjectId: attributes.flagKey,
                source: 'engagement-platform',
                attributes: attributes
            }
        });
        Promise.resolve(clientOrPromise).then((client)=>{
            client.sendTrackEvent(analyticsEvent.payload);
        });
    }
    function $5a6e1b2acc91c182$var$getExposureAttributes(messageId, cohort, additionalProps) {
        return {
            reason: 'RULE_MATCH',
            ruleId: 'engagement.inproduct',
            flagKey: `engagement.inproduct.${messageId}`,
            value: cohort,
            ...additionalProps
        };
    }
    function $5a6e1b2acc91c182$var$getBaseAttributes(messageId, variationId, componentId, locale) {
        return {
            messageId: messageId,
            variationId: variationId,
            componentIndex: componentId,
            locale: locale
        };
    }
    async function $5a6e1b2acc91c182$export$473a2bbbfd90c87b(eventMapping, config, store, clientOrPromise, coordinationOptions, componentConfig) {
        const { locale: locale } = config;
        const { message: message, component: component } = eventMapping;
        if (message.holdout) {
            await (0, (0, parcelRequire("bTKhp")).startMessage)({
                cloudId: config.cloudId,
                stargateUrl: config.stargateUrl,
                messageId: message.messageId,
                variationId: message.variationId,
                orgId: config.orgId,
                workspaceId: config.workspaceId
            }, coordinationOptions);
            await (0, (0, parcelRequire("bTKhp")).stopMessage)({
                cloudId: config.cloudId,
                stargateUrl: config.stargateUrl,
                messageId: message.messageId,
                orgId: config.orgId,
                workspaceId: config.workspaceId
            }, coordinationOptions);
            $5a6e1b2acc91c182$var$fireExposureEvent($5a6e1b2acc91c182$var$getExposureAttributes(message.messageId, 'holdout', {
                locale: locale
            }), clientOrPromise);
            return;
        }
        if (component.componentId === 0) {
            const success = await (0, (0, parcelRequire("bTKhp")).startMessage)({
                cloudId: config.cloudId,
                stargateUrl: config.stargateUrl,
                messageId: message.messageId,
                variationId: message.variationId,
                orgId: config.orgId,
                workspaceId: config.workspaceId
            }, coordinationOptions);
            if (coordinationOptions?.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(success ? (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STARTED : (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).BLOCKED);
            if (success) {
                $5a6e1b2acc91c182$var$fireExposureEvent($5a6e1b2acc91c182$var$getExposureAttributes(message.messageId, message.variationId, {
                    locale: locale
                }), clientOrPromise);
                store.dispatch((0, (0, parcelRequire("csA48")).setCurrent)(eventMapping));
            }
        } else {
            $5a6e1b2acc91c182$var$fireExposureEvent($5a6e1b2acc91c182$var$getExposureAttributes(message.messageId, message.variationId, {
                locale: locale
            }), clientOrPromise);
            store.dispatch((0, (0, parcelRequire("csA48")).setCurrent)(eventMapping));
        }
    }
    class $5a6e1b2acc91c182$export$83b8ae7ce7b4d59c extends (0, $5uXOq.Component) {
        static{
            this.componentConfig = new Map();
        }
        static{
            this.childContextTypes = {
                subscribeEngagementState: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
                setComponentConfig: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func
            };
        }
        static{
            this.defaultProps = {
                eventTarget: (0, ($parcel$interopDefault($dyczo)))
            };
        }
        static{
            this.hasInitializedAtLeastOneEngagementProvider = false;
        }
        constructor(props){
            super(props), this.onStoreChange = (state)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                const config = this.getConfig();
                const { locale: locale } = config;
                if (state.initialized) {
                    if (!$5a6e1b2acc91c182$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider) {
                        this.sendOperationalEventWithClient({
                            action: 'loaded',
                            actionSubject: 'messages',
                            actionSubjectId: undefined,
                            source: 'engagekit',
                            attributes: {
                                locale: locale
                            }
                        });
                        const browserInfo = (0, (0, parcelRequire("986je")).getBrowserInfo)();
                        this.onEvent(createAnalyticsEvent({
                            event: $5a6e1b2acc91c182$var$EK_LOADED_EVENT,
                            properties: {
                                browser: browserInfo.name,
                                browserVersion: browserInfo.version
                            }
                        }));
                        $5a6e1b2acc91c182$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = true;
                    }
                    this.analyticsEventQueue.flush(this.onEvent);
                    if (this.unsubscribeFromStore) this.unsubscribeFromStore();
                }
            }, this.onEvent = (event)=>{
                const state = this.getState();
                if (!state.initialized) {
                    const success = this.analyticsEventQueue.enqueue(event);
                    if (!success) this.fireQueueOverflowEvent();
                    return;
                }
                const { eventTarget: eventTarget, store: store, analyticsClientInstance: analyticsClientInstance } = this.props;
                const config = this.getConfig();
                const { current: current, messageMapping: messageMapping } = state;
                const payload = $5a6e1b2acc91c182$var$collapseEventToPayload(event);
                eventTarget.dispatchEvent((0, (0, parcelRequire("1SgSi")).default)({
                    eventName: $5a6e1b2acc91c182$export$5306bd00631dbf8c,
                    canBubble: false,
                    cancellable: false,
                    detail: payload
                }));
                if (!(0, (0, parcelRequire("bkCgs")).isMessagingEnabled)()) return;
                if (current) return;
                const trigger = $5a6e1b2acc91c182$var$findMatchingTrigger(messageMapping, payload);
                if (!trigger) return;
                const eventMapping = messageMapping.get(trigger);
                let componentConfig;
                if (eventMapping.component?.componentType) {
                    const componentConfigId = this.getConfigId(eventMapping.component.componentType, eventMapping.component.target);
                    componentConfig = $5a6e1b2acc91c182$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
                }
                const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
                $5a6e1b2acc91c182$export$473a2bbbfd90c87b(eventMapping, config, store, analyticsClientInstance, coordinationOptions, componentConfig);
            }, this.onEngagementEvent = (event)=>{
                const { action: action, clickType: clickType, ekMessageId: ekMessageId, ekVariationId: ekVariationId, ekComponentId: ekComponentId, ekComponentType: ekComponentType, ekIsLast: ekIsLast } = event.payload;
                const config = this.getConfig();
                const { locale: locale } = config;
                const attributes = $5a6e1b2acc91c182$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
                if (action === 'click') {
                    this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                    attributes.buttonType = clickType;
                    this.sendUIEventWithClient({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: `${clickType}Button`,
                        source: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                } else {
                    if (action === 'shown') {
                        attributes.componentType = ekComponentType;
                        this.sendScreenEventWithClient({
                            name: `engagement_${ekComponentType}`,
                            attributes: attributes
                        });
                    }
                    if (action === 'hidden') {
                        attributes.isLast = ekIsLast;
                        this.sendUIEventWithClient({
                            action: 'hid',
                            actionSubject: 'component',
                            actionSubjectId: undefined,
                            source: `engagement_${ekComponentType}`,
                            attributes: attributes
                        });
                    }
                }
                this.onEvent(event);
            }, this.subscribeEngagementState = (callback)=>{
                const { store: store } = this.props;
                callback(store.getState());
                return store.subscribe(()=>{
                    callback(store.getState());
                });
            }, this.getComponentCoordinationOptions = (componentConfig)=>{
                const enableChoreographer = Boolean(this.props.coordinationOptions?.enableChoreographer);
                return {
                    ...this.props.coordinationOptions,
                    enableChoreographer: componentConfig?.messageType ? (0, (0, parcelRequire("aPRQd")).shouldBeChoreographed)(componentConfig, {
                        enableChoreographer: true
                    }) : enableChoreographer
                };
            }, this.getConfigId = (componentType, engagementId)=>{
                return engagementId ? `${componentType}-${engagementId}` : componentType;
            }, this.setComponentConfig = (componentType, config, engagementId)=>{
                const configId = this.getConfigId(componentType, engagementId);
                $5a6e1b2acc91c182$export$83b8ae7ce7b4d59c.componentConfig.set(configId, config);
                return ()=>this.removeComponentConfig(configId);
            }, this.removeComponentConfig = (configId)=>{
                if ($5a6e1b2acc91c182$export$83b8ae7ce7b4d59c.componentConfig.has(configId)) $5a6e1b2acc91c182$export$83b8ae7ce7b4d59c.componentConfig.delete(configId);
            };
            const { analyticsClientInstance: analyticsClientInstance } = this.props;
            this.sendUIEventWithClient = (0, (0, parcelRequire("5HGUB")).sendUIEvent).bind(null, analyticsClientInstance);
            this.sendScreenEventWithClient = (0, (0, parcelRequire("5HGUB")).sendScreenEvent).bind(null, analyticsClientInstance);
            this.sendOperationalEventWithClient = (0, (0, parcelRequire("5HGUB")).sendOperationalEvent).bind(null, analyticsClientInstance);
            this.analyticsEventQueue = new (0, (0, parcelRequire("hx3r8")).default)($5a6e1b2acc91c182$var$MAX_EVENT_QUEUE_SIZE);
            this.unsubscribeFromStore = this.subscribeEngagementState(this.onStoreChange);
            this.fireQueueOverflowEvent = (0, ($parcel$interopDefault($bxYf9)))(()=>{});
        }
        getConfig() {
            const { config: config } = this.getState();
            return config;
        }
        getChildContext() {
            return {
                subscribeEngagementState: this.subscribeEngagementState,
                setComponentConfig: this.setComponentConfig
            };
        }
        getState() {
            return this.props.store.getState();
        }
        getActiveMessage() {
            return this.getState().current;
        }
        async completeMessage(messageId, componentConfig) {
            const config = this.getConfig();
            const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
            const disposition = await (0, (0, parcelRequire("bTKhp")).stopMessage)({
                cloudId: config.cloudId,
                stargateUrl: config.stargateUrl,
                messageId: messageId,
                orgId: config.orgId,
                workspaceId: config.workspaceId
            }, coordinationOptions);
            if (coordinationOptions.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(disposition ? (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).STOPPED : (0, (0, parcelRequire("3iMQo")).MessageDeliveryStatus).CANCELED);
        }
        handleClickEvent(messageId, variationId, componentId) {
            const activeMessage = this.getActiveMessage();
            if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
            let componentConfig;
            if (activeMessage.componentType) {
                const componentConfigId = this.getConfigId(activeMessage.componentType, activeMessage.target);
                componentConfig = $5a6e1b2acc91c182$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
            }
            if (activeMessage.isLast) this.completeMessage(messageId, componentConfig);
            this.props.store.dispatch((0, (0, parcelRequire("csA48")).clearCurrent)());
        }
        componentWillUnmount() {
            this.unsubscribeFromStore && this.unsubscribeFromStore();
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3QJTu")).default), {
                channel: "*",
                onEvent: this.onEvent
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3QJTu")).default), {
                channel: "engagement",
                onEvent: this.onEngagementEvent
            }, this.props.children));
        }
    }
});
parcelRegister("aPRQd", function(module, exports) {
    $parcel$export(module.exports, "shouldBeChoreographed", ()=>$c7da2833e69f0a55$export$a8ba9111c7eec9ac);
    $parcel$export(module.exports, "wrapComponentForChoreographer", ()=>$c7da2833e69f0a55$export$51d40de083bcc6e7);
    $parcel$export(module.exports, "wrapToggleableComponentForChoreographer", ()=>$c7da2833e69f0a55$export$7c574bc7a8b74124);
    var $5uXOq = parcelRequire("5uXOq");
    var $3iMQo;
    const $c7da2833e69f0a55$export$a8ba9111c7eec9ac = (props, coordinationOptions)=>{
        return Boolean(coordinationOptions?.enableChoreographer) && props?.messageType !== undefined && (0, (0, parcelRequire("3iMQo")).IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
    };
    const $c7da2833e69f0a55$export$51d40de083bcc6e7 = (Component)=>{
        function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedRender: withChoreographedRender, ...props }) {
            const ChoreographedComponent = (0, $5uXOq.useMemo)(()=>withChoreographedRender(Component), [
                withChoreographedRender
            ]);
            if (shouldBeChoreographedProp(props)) {
                const { messageType: messageType, ...rest } = props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(ChoreographedComponent, rest);
            }
            const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, rest);
        }
        WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
        return WrapperComponent;
    };
    const $c7da2833e69f0a55$export$7c574bc7a8b74124 = (Component, toggleableProp)=>{
        function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedToggle: withChoreographedToggle, ...props }) {
            const ChoreographedComponent = (0, $5uXOq.useMemo)(()=>withChoreographedToggle(Component, toggleableProp), [
                withChoreographedToggle
            ]);
            if (shouldBeChoreographedProp(props)) {
                const { messageType: messageType, ...rest } = props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(ChoreographedComponent, rest);
            }
            const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, rest);
        }
        WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
        return WrapperComponent;
    };
});
parcelRegister("5HGUB", function(module, exports) {
    $parcel$export(module.exports, "sendScreenEvent", ()=>$5a8b26315d9ada6d$export$22a3b1671f38a193);
    $parcel$export(module.exports, "sendUIEvent", ()=>$5a8b26315d9ada6d$export$1aecf263098db667);
    $parcel$export(module.exports, "sendOperationalEvent", ()=>$5a8b26315d9ada6d$export$e5f89b51c6d4e36b);
    function $5a8b26315d9ada6d$export$22a3b1671f38a193(clientOrPromise, payload) {
        Promise.resolve(clientOrPromise).then((client)=>{
            client.sendScreenEvent(payload);
        });
    }
    function $5a8b26315d9ada6d$export$1aecf263098db667(clientOrPromise, payload) {
        Promise.resolve(clientOrPromise).then((client)=>{
            client.sendUIEvent(payload);
        });
    }
    function $5a8b26315d9ada6d$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
        Promise.resolve(clientOrPromise).then((client)=>{
            client.sendOperationalEvent(payload);
        });
    }
});
parcelRegister("986je", function(module, exports) {
    $parcel$export(module.exports, "getBrowserInfo", ()=>$718d6ea6ccdd2947$export$6c724a6ffa2dc3e1);
    const $718d6ea6ccdd2947$var$browserMatchers = [
        {
            name: 'IE',
            pattern: /Trident\/.*; rv:([^;)]+)/
        },
        {
            name: 'Chrome',
            pattern: /Chrome\/([^ )]+)/
        },
        {
            name: 'Firefox',
            pattern: /Firefox\/([^ )]+)/
        }
    ];
    const $718d6ea6ccdd2947$export$cda2203640e08931 = {
        name: 'unknown',
        version: 'unknown'
    };
    function $718d6ea6ccdd2947$export$6c724a6ffa2dc3e1(userAgent) {
        if (!window.navigator) return $718d6ea6ccdd2947$export$cda2203640e08931;
        if (!userAgent) userAgent = window.navigator.userAgent;
        for (const matcher of $718d6ea6ccdd2947$var$browserMatchers){
            const versionMatch = userAgent.match(matcher.pattern);
            if (versionMatch) return {
                name: matcher.name,
                version: versionMatch[1]
            };
        }
        return $718d6ea6ccdd2947$export$cda2203640e08931;
    }
});
parcelRegister("1SgSi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5015dd2d3bb3f8be$export$2e2bcd8739ae039);
    const $5015dd2d3bb3f8be$var$createCustomEvent = ({ eventName: eventName, canBubble: canBubble, cancellable: cancellable, detail: detail })=>{
        const customEvent = document.createEvent('CustomEvent');
        customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
        return customEvent;
    };
    var $5015dd2d3bb3f8be$export$2e2bcd8739ae039 = $5015dd2d3bb3f8be$var$createCustomEvent;
});
parcelRegister("hx3r8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a54103c58b5d2717$export$2e2bcd8739ae039);
    class $a54103c58b5d2717$export$2e2bcd8739ae039 {
        constructor(maxSize){
            this.queue = [];
            this.maxSize = maxSize;
        }
        enqueue(item) {
            if (this.queue.length === this.maxSize) return false;
            this.queue.push(item);
            return true;
        }
        flush(callback) {
            this.queue.forEach(callback);
            this.queue = [];
        }
        getSize() {
            return this.queue.length;
        }
    }
});
parcelRegister("clxrE", function(module, exports) {
    $parcel$export(module.exports, "setCurrent", ()=>$e0b3d20589708a48$export$5f80f094fd31fffd);
    $parcel$export(module.exports, "LazyPhaseContext", ()=>$e0b3d20589708a48$export$5a25eca35e5debcb);
    $parcel$export(module.exports, "useLazyPhase", ()=>$e0b3d20589708a48$export$1dc361b277327f88);
    var $5uXOq = parcelRequire("5uXOq");
    var $55aVQ;
    var $j1NL0;
    var $dYVcm;
    let $e0b3d20589708a48$var$CURRENT_PHASE = (0, (0, parcelRequire("55aVQ")).PHASE).PAINT;
    const $e0b3d20589708a48$export$5f80f094fd31fffd = (phase)=>{
        $e0b3d20589708a48$var$CURRENT_PHASE = phase;
        (0, (0, parcelRequire("j1NL0")).LISTENERS).slice(0).forEach((listener)=>listener(phase));
    };
    const $e0b3d20589708a48$export$5a25eca35e5debcb = (0, $5uXOq.createContext)({
        subscribe: (0, (0, parcelRequire("dYVcm")).createSubscribe)((0, (0, parcelRequire("j1NL0")).LISTENERS)),
        currentValue: ()=>$e0b3d20589708a48$var$CURRENT_PHASE,
        api: {
            startNextPhase: ()=>{
                $e0b3d20589708a48$export$5f80f094fd31fffd((0, (0, parcelRequire("55aVQ")).PHASE).AFTER_PAINT);
            },
            resetPhase: ()=>$e0b3d20589708a48$export$5f80f094fd31fffd((0, (0, parcelRequire("55aVQ")).PHASE).PAINT)
        }
    });
    const $e0b3d20589708a48$export$1dc361b277327f88 = ()=>{
        const v = (0, $5uXOq.useContext)($e0b3d20589708a48$export$5a25eca35e5debcb);
        return v.api;
    };
});
parcelRegister("55aVQ", function(module, exports) {
    $parcel$export(module.exports, "PHASE", ()=>$66ebc43002302dc7$export$2cc7a2eaaea7809f);
    $parcel$export(module.exports, "COLLECTED", ()=>$66ebc43002302dc7$export$4831ef3968ea94ef);
    const $66ebc43002302dc7$export$2cc7a2eaaea7809f = {
        PAINT: 0,
        AFTER_PAINT: 1,
        LAZY: 2
    };
    const $66ebc43002302dc7$export$4831ef3968ea94ef = new Map();
});
parcelRegister("j1NL0", function(module, exports) {
    $parcel$export(module.exports, "LISTENERS", ()=>$2c5a56ba20d04266$export$81b9c458a026d68f);
    const $2c5a56ba20d04266$export$81b9c458a026d68f = [];
});
parcelRegister("dYVcm", function(module, exports) {
    $parcel$export(module.exports, "createSubscribe", ()=>$9d28ac0015c9d41e$export$364097d812234b3f);
    const $9d28ac0015c9d41e$export$364097d812234b3f = (listeners)=>(listener)=>{
            listeners.push(listener);
            return ()=>{
                const index = listeners.indexOf(listener);
                if (index !== -1) listeners.splice(index, 1);
            };
        };
});
parcelRegister("7NJFp", function(module, exports) {
    $parcel$export(module.exports, "createLoaderError", ()=>$b52e4909ca29dc3d$export$c73a6a6f0bf7d425);
    $parcel$export(module.exports, "isLoaderError", ()=>$b52e4909ca29dc3d$export$16a03aca4a3508b4);
    const $b52e4909ca29dc3d$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
    const $b52e4909ca29dc3d$export$c73a6a6f0bf7d425 = (error)=>{
        if (typeof error === 'object') return Object.assign(error, {
            [$b52e4909ca29dc3d$export$6aa69c1258005366]: true
        });
        return error;
    };
    const $b52e4909ca29dc3d$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($b52e4909ca29dc3d$export$6aa69c1258005366);
});
parcelRegister("1iaoS", function(module, exports) {
    $parcel$export(module.exports, "LazySuspense", ()=>$0b6b3a5272f89073$export$256c542058532d6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $ljLQI;
    var $dqDbS;
    class $0b6b3a5272f89073$export$256c542058532d6f extends (0, $5uXOq.Component) {
        constructor(props){
            super(props), this.state = {
                fallback: this.props.fallback,
                setFallback: (fallback)=>{
                    if (this.hydrationFallback === fallback) return;
                    this.hydrationFallback = fallback;
                    if (this.mounted) this.forceUpdate();
                },
                name: this.props.name
            }, this.hydrationFallback = null, this.mounted = false, this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
                (0, $5uXOq.useLayoutEffect)(()=>{
                    return ()=>{
                        if (!outsideSuspense) this.state.setFallback(null);
                    };
                }, [
                    outsideSuspense
                ]);
                return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
            };
            this.DynamicFallback.displayName = 'DynamicFallback';
        }
        componentDidMount() {
            this.mounted = true;
        }
        renderFallback(outsideSuspense) {
            const { DynamicFallback: DynamicFallback } = this;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DynamicFallback, {
                outsideSuspense: outsideSuspense
            }, (fallback)=>fallback);
        }
        renderServer() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dqDbS")).LazySuspenseContext).Provider, {
                value: this.state
            }, this.props.children);
        }
        renderClient() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dqDbS")).LazySuspenseContext).Provider, {
                value: this.state
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                fallback: this.renderFallback(false)
            }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
        }
        render() {
            return (0, (0, parcelRequire("ljLQI")).isNodeEnvironment)() ? this.renderServer() : this.renderClient();
        }
    }
});
parcelRegister("ljLQI", function(module, exports) {
    $parcel$export(module.exports, "getExport", ()=>$ed81d8fc000d5c8f$export$d4c07b1daf44a7f);
    $parcel$export(module.exports, "displayNameFromId", ()=>$ed81d8fc000d5c8f$export$4429f98ef60d2d87);
    $parcel$export(module.exports, "isNodeEnvironment", ()=>$ed81d8fc000d5c8f$export$283635c04a02cc36);
    $parcel$export(module.exports, "attrToProp", ()=>$ed81d8fc000d5c8f$export$62bf630d0de3d781);
    var $72OTY;
    const $ed81d8fc000d5c8f$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
    const $ed81d8fc000d5c8f$export$4429f98ef60d2d87 = (id)=>{
        const fName = id.split('/').slice(-3).join('/');
        return fName || 'Component';
    };
    const $ed81d8fc000d5c8f$export$283635c04a02cc36 = ()=>{
        if (typeof window === 'undefined') return true;
        if (window.name === 'nodejs') return true;
        return false;
    };
    function $ed81d8fc000d5c8f$export$62bf630d0de3d781(props, attr) {
        switch(attr.name){
            case 'style':
                break;
            case 'class':
                props.className = attr.value;
                break;
            case 'crossorigin':
                props.crossOrigin = attr.value;
                break;
            default:
                props[attr.name] = attr.value;
        }
        return props;
    }
});
parcelRegister("72OTY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61b541cf2d1972d4$export$2e2bcd8739ae039);
    function $61b541cf2d1972d4$export$2e2bcd8739ae039(str) {
        var l = str.length, h = l ^ l, i = 0, k;
        while(l >= 4){
            k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
            k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
            k ^= k >>> 24;
            k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
            l -= 4;
            ++i;
        }
        switch(l){
            case 3:
                h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
            case 2:
                h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
            case 1:
                h ^= str.charCodeAt(i) & 0xff;
                h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        }
        h ^= h >>> 13;
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h ^= h >>> 15;
        return (h >>> 0).toString(36);
    }
});
parcelRegister("dqDbS", function(module, exports) {
    $parcel$export(module.exports, "LazySuspenseContext", ()=>$03c34a6ed188c21c$export$c33990e84065970c);
    var $5uXOq = parcelRequire("5uXOq");
    const $03c34a6ed188c21c$export$c33990e84065970c = (0, $5uXOq.createContext)({
        fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null),
        setFallback: ()=>{
            console.warn('Missing <LooselySuspense /> boundary');
        }
    });
});
parcelRegister("hJDE6", function(module, exports) {
    $parcel$export(module.exports, "WaitContext", ()=>$941f8bc1b9b5fcd7$export$9ba3fe09d15de47b);
    var $5uXOq = parcelRequire("5uXOq");
    var $hORJV;
    const $941f8bc1b9b5fcd7$export$9ba3fe09d15de47b = (0, $5uXOq.createContext)({
        subscribe: ()=>(0, (0, parcelRequire("hORJV")).noopCleanup),
        currentValue: ()=>1
    });
});
parcelRegister("hORJV", function(module, exports) {
    $parcel$export(module.exports, "noopCleanup", ()=>$f291ff09f370fe66$export$276c7dbda7675aec);
    const $f291ff09f370fe66$export$276c7dbda7675aec = ()=>{};
});
parcelRegister("hPtZI", function(module, exports) {
    $parcel$export(module.exports, "lazyForPaint", ()=>$442b6b30bdf043bc$export$c952e5f94576010e);
    $parcel$export(module.exports, "lazyAfterPaint", ()=>$442b6b30bdf043bc$export$291dd592399bdafa);
    $parcel$export(module.exports, "lazy", ()=>$442b6b30bdf043bc$export$488013bae63b21da);
    var $hxZ3X;
    var $6MBHi;
    var $55aVQ;
    var $ljLQI;
    var $72OTY;
    var $d9Gxx;
    var $cCY5q;
    var $30GKG;
    var $h6rTN;
    var $aOd2o;
    var $8EryS;
    var $7NJFp;
    function $442b6b30bdf043bc$var$lazyProxy(loader, { defer: defer = (0, (0, parcelRequire("55aVQ")).PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
        const isServer = (0, (0, parcelRequire("ljLQI")).isNodeEnvironment)();
        const dataLazyId = (0, (0, parcelRequire("72OTY")).default)(moduleId);
        const LazyInternal = isServer ? (0, (0, parcelRequire("cCY5q")).createComponentServer)({
            dataLazyId: dataLazyId,
            defer: defer,
            loader: loader,
            moduleId: moduleId,
            ssr: ssr
        }) : (0, (0, parcelRequire("d9Gxx")).createComponentClient)({
            dataLazyId: dataLazyId,
            defer: defer,
            deferred: (0, (0, parcelRequire("h6rTN")).createDeferred)({
                loader: ()=>{
                    const { retry: maxAttempts } = (0, (0, parcelRequire("6MBHi")).getConfig)();
                    return (0, (0, parcelRequire("8EryS")).retry)(loader, {
                        delay: (0, (0, parcelRequire("30GKG")).RETRY_DELAY),
                        factor: (0, (0, parcelRequire("30GKG")).RETRY_FACTOR),
                        maxAttempts: maxAttempts
                    });
                },
                preload: loader
            }),
            moduleId: moduleId
        });
        LazyInternal.displayName = `Lazy(${(0, (0, parcelRequire("ljLQI")).displayNameFromId)(moduleId)})`;
        const getAssetUrls = ()=>{
            const { manifest: manifest } = (0, (0, parcelRequire("6MBHi")).getConfig)();
            return (0, (0, parcelRequire("hxZ3X")).getAssetUrlsFromId)(manifest, moduleId);
        };
        const preload = (priority)=>{
            const p = priority ?? (defer === (0, (0, parcelRequire("55aVQ")).PHASE).PAINT ? (0, (0, parcelRequire("30GKG")).PRIORITY).HIGH : (0, (0, parcelRequire("30GKG")).PRIORITY).LOW);
            return (0, (0, parcelRequire("aOd2o")).preloadAsset)({
                loader: loader,
                moduleId: moduleId,
                priority: p
            });
        };
        return Object.assign(LazyInternal, {
            getAssetUrls: getAssetUrls,
            preload: preload
        });
    }
    const $442b6b30bdf043bc$export$93ca5d3f8675ae4c = {
        lazyForPaint: {
            ssr: true,
            defer: (0, (0, parcelRequire("55aVQ")).PHASE).PAINT
        },
        lazyAfterPaint: {
            ssr: true,
            defer: (0, (0, parcelRequire("55aVQ")).PHASE).AFTER_PAINT
        },
        lazy: {
            ssr: false,
            defer: (0, (0, parcelRequire("55aVQ")).PHASE).LAZY
        }
    };
    function $442b6b30bdf043bc$export$c952e5f94576010e(loader, opts) {
        return $442b6b30bdf043bc$var$lazyProxy(loader, {
            ...$442b6b30bdf043bc$export$93ca5d3f8675ae4c.lazyForPaint,
            ...opts || {}
        });
    }
    function $442b6b30bdf043bc$export$291dd592399bdafa(loader, opts) {
        return $442b6b30bdf043bc$var$lazyProxy(loader, {
            ...$442b6b30bdf043bc$export$93ca5d3f8675ae4c.lazyAfterPaint,
            ...opts || {}
        });
    }
    function $442b6b30bdf043bc$export$488013bae63b21da(loader, opts) {
        return $442b6b30bdf043bc$var$lazyProxy(loader, {
            ...$442b6b30bdf043bc$export$93ca5d3f8675ae4c.lazy,
            ...opts || {}
        });
    }
});
parcelRegister("hxZ3X", function(module, exports) {
    $parcel$export(module.exports, "getAssetUrlsFromId", ()=>$71964a3a5df083bc$export$303f43e55cf1ef2f);
    const $71964a3a5df083bc$export$303f43e55cf1ef2f = (manifest, id)=>{
        if (!manifest.assets || !manifest.assets[id]) return;
        return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
    };
});
parcelRegister("6MBHi", function(module, exports) {
    $parcel$export(module.exports, "getConfig", ()=>$0b62e003cb9dd9be$export$44487a86467333c3);
    $parcel$export(module.exports, "setConfig", ()=>$0b62e003cb9dd9be$export$940a7873bb071df8);
    $parcel$export(module.exports, "MODE", ()=>(parcelRequire("jTyr9")).MODE);
    var $jTyr9;
    const $0b62e003cb9dd9be$var$DEFAULT_CROSS_ORIGIN = undefined;
    const $0b62e003cb9dd9be$var$DEFAULT_MANIFEST = {
        publicPath: '/',
        assets: {}
    };
    const $0b62e003cb9dd9be$var$DEFAULT_MODE = (0, (0, parcelRequire("jTyr9")).MODE).HYDRATE;
    const $0b62e003cb9dd9be$var$DEFAULT_RETRY = 2;
    const $0b62e003cb9dd9be$var$config = {
        crossOrigin: $0b62e003cb9dd9be$var$DEFAULT_CROSS_ORIGIN,
        manifest: $0b62e003cb9dd9be$var$DEFAULT_MANIFEST,
        mode: $0b62e003cb9dd9be$var$DEFAULT_MODE,
        retry: $0b62e003cb9dd9be$var$DEFAULT_RETRY
    };
    const $0b62e003cb9dd9be$export$44487a86467333c3 = ()=>$0b62e003cb9dd9be$var$config;
    const $0b62e003cb9dd9be$export$940a7873bb071df8 = (nextConfig)=>{
        $0b62e003cb9dd9be$var$config.crossOrigin = nextConfig.crossOrigin ?? $0b62e003cb9dd9be$var$DEFAULT_CROSS_ORIGIN;
        $0b62e003cb9dd9be$var$config.manifest = nextConfig.manifest ?? $0b62e003cb9dd9be$var$DEFAULT_MANIFEST;
        $0b62e003cb9dd9be$var$config.mode = nextConfig.mode ?? $0b62e003cb9dd9be$var$DEFAULT_MODE;
        $0b62e003cb9dd9be$var$config.retry = nextConfig.retry ?? $0b62e003cb9dd9be$var$DEFAULT_RETRY;
    };
});
parcelRegister("jTyr9", function(module, exports) {
    $parcel$export(module.exports, "MODE", ()=>$2f7620ceb37b35e1$export$e48589d9e4824227);
    const $2f7620ceb37b35e1$export$e48589d9e4824227 = {
        RENDER: 'RENDER',
        HYDRATE: 'HYDRATE'
    };
});
parcelRegister("d9Gxx", function(module, exports) {
    $parcel$export(module.exports, "createComponentClient", ()=>$cb3a24b979ecee73$export$6898b5504b58699a);
    var $5uXOq = parcelRequire("5uXOq");
    var $6MBHi;
    var $jTyr9;
    var $55aVQ;
    var $hJDE6;
    var $clxrE;
    var $7UTZj;
    var $dqDbS;
    var $7NJFp;
    var $4HMSG;
    var $cYTsJ;
    var $5Txpn;
    function $cb3a24b979ecee73$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
        const ResolvedLazy = (0, $5uXOq.lazy)(()=>deferred.promise);
        return (props)=>{
            const [status, bubbleError] = (0, $5uXOq.useState)(()=>({
                    noWait: undefined,
                    phase: defer === (0, (0, parcelRequire("55aVQ")).PHASE).AFTER_PAINT ? false : true,
                    preloaded: defer === (0, (0, parcelRequire("55aVQ")).PHASE).AFTER_PAINT ? false : true,
                    started: false
                }));
            const profiler = (0, $5uXOq.useContext)((0, (0, parcelRequire("7UTZj")).ProfilerContext)).current;
            const load = ()=>{
                if (status.started || !status.phase || !status.noWait) return;
                status.started = true;
                let onResolve;
                if (profiler) {
                    const eventInfo = {
                        identifier: moduleId
                    };
                    onResolve = ()=>{
                        profiler.onLoadComplete(eventInfo);
                    };
                    profiler.onLoadStart(eventInfo);
                }
                const result = deferred.start().catch((err)=>{
                    bubbleError(()=>{
                        throw (0, (0, parcelRequire("7NJFp")).createLoaderError)(err);
                    });
                });
                if (onResolve) result.then(onResolve);
            };
            (0, (0, parcelRequire("5Txpn")).useSubscription)({
                context: (0, (0, parcelRequire("hJDE6")).WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, (0, parcelRequire("55aVQ")).PHASE).AFTER_PAINT) (0, (0, parcelRequire("5Txpn")).useSubscription)({
                context: (0, (0, parcelRequire("clxrE")).LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            const { setFallback: setFallback } = (0, $5uXOq.useContext)((0, (0, parcelRequire("dqDbS")).LazySuspenseContext));
            (0, $5uXOq.useMemo)(()=>{
                const content = ((0, (0, parcelRequire("55aVQ")).COLLECTED).get(dataLazyId) || []).shift();
                if (!content) return;
                const component = (0, (0, parcelRequire("6MBHi")).getConfig)().mode === (0, (0, parcelRequire("jTyr9")).MODE).RENDER ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cYTsJ")).PlaceholderFallbackRender), {
                    id: dataLazyId,
                    content: content
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4HMSG")).PlaceholderFallbackHydrate), {
                    id: dataLazyId,
                    content: content
                });
                setFallback(component);
            }, [
                setFallback
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ResolvedLazy, props);
        };
    }
});
parcelRegister("7UTZj", function(module, exports) {
    $parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", ()=>$f8e8d3007e14300e$export$e2d53c0cbedd2710);
    $parcel$export(module.exports, "ProfilerContext", ()=>$f8e8d3007e14300e$export$8146ab57a3f7a7cb);
    var $5uXOq = parcelRequire("5uXOq");
    const $f8e8d3007e14300e$export$e2d53c0cbedd2710 = {
        current: null
    };
    const $f8e8d3007e14300e$export$8146ab57a3f7a7cb = (0, $5uXOq.createContext)($f8e8d3007e14300e$export$e2d53c0cbedd2710);
});
parcelRegister("4HMSG", function(module, exports) {
    $parcel$export(module.exports, "PlaceholderFallbackHydrate", ()=>$4227fb0a875449d1$export$ca5b8fbc835d95e4);
    var $5uXOq = parcelRequire("5uXOq");
    var $ljLQI;
    const $4227fb0a875449d1$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": id
        }), content.map((el, i)=>{
            const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
            const props = Array.from(attributes).reduce((0, (0, parcelRequire("ljLQI")).attrToProp), {
                key: String(i)
            });
            if (!tagName) return (0, $5uXOq.createElement)((0, $5uXOq.Fragment), props, el.textContent);
            if (!childNodes.length) return (0, $5uXOq.createElement)(tagName.toLowerCase(), props);
            return (0, $5uXOq.createElement)(tagName.toLowerCase(), {
                ...props,
                dangerouslySetInnerHTML: {
                    __html: ''
                },
                suppressHydrationWarning: true
            });
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-end": id
        }));
    };
});
parcelRegister("cYTsJ", function(module, exports) {
    $parcel$export(module.exports, "PlaceholderFallbackRender", ()=>$9ef9a9eb7b262cf9$export$d55db778a3e1446b);
    var $5uXOq = parcelRequire("5uXOq");
    var $7UTZj;
    var $hJDE6;
    var $dqDbS;
    function $9ef9a9eb7b262cf9$var$isLinkPrefetch(el) {
        return el.tagName === 'LINK' && el.rel === 'prefetch';
    }
    const $9ef9a9eb7b262cf9$var$usePlaceholderRender = (resolveId, content)=>{
        const hydrationRef = (0, $5uXOq.useRef)(null);
        const { current: ssrDomNodes } = (0, $5uXOq.useRef)(content || []);
        const profilerContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("7UTZj")).ProfilerContext)).current;
        const waitContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("hJDE6")).WaitContext));
        const suspenseContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("dqDbS")).LazySuspenseContext));
        (0, $5uXOq.useLayoutEffect)(()=>{
            const element = hydrationRef.current;
            const { parentNode: parentNode } = element || {};
            profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
                if ($9ef9a9eb7b262cf9$var$isLinkPrefetch(node)) node.rel = '';
                parentNode.insertBefore(node, element.nextSibling);
            });
            return ()=>{
                profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
                ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
            };
        }, []);
        return hydrationRef;
    };
    const $9ef9a9eb7b262cf9$export$d55db778a3e1446b = ({ id: id, content: content })=>{
        const placeholderRef = $9ef9a9eb7b262cf9$var$usePlaceholderRender(id, content);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": id,
            ref: placeholderRef
        });
    };
});
parcelRegister("5Txpn", function(module, exports) {
    $parcel$export(module.exports, "useSubscription", ()=>$454d48b48c4e1b68$export$368b4214baeb914c);
    var $5uXOq = parcelRequire("5uXOq");
    function $454d48b48c4e1b68$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
        const { subscribe: subscribe, currentValue: currentValue } = (0, $5uXOq.useContext)(context);
        (0, $5uXOq.useMemo)(()=>{
            let unsubscribe = null;
            const check = ()=>{
                const done = onValue(currentValue());
                if (done) load();
                if (done && unsubscribe) unsubscribe();
                return done;
            };
            unsubscribe = !check() ? subscribe(check) : null;
        }, []);
    }
});
parcelRegister("cCY5q", function(module, exports) {
    $parcel$export(module.exports, "createComponentServer", ()=>$7f75989860b2d939$export$eb2e4b04351cdd9e);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxZ3X;
    var $6MBHi;
    var $55aVQ;
    var $dqDbS;
    var $ljLQI;
    var $7NJFp;
    function $7f75989860b2d939$var$load(moduleId, loader) {
        try {
            return (0, (0, parcelRequire("ljLQI")).getExport)(loader());
        } catch (err) {
            throw (0, (0, parcelRequire("7NJFp")).createLoaderError)(err);
        }
    }
    function $7f75989860b2d939$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
        return (props)=>{
            const Resolved = ssr ? $7f75989860b2d939$var$load(moduleId, loader) : null;
            const { fallback: fallback } = (0, $5uXOq.useContext)((0, (0, parcelRequire("dqDbS")).LazySuspenseContext));
            const { crossOrigin: crossOrigin, manifest: manifest } = (0, (0, parcelRequire("6MBHi")).getConfig)();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                type: "hidden",
                "data-lazy-begin": dataLazyId
            }), defer !== (0, (0, parcelRequire("55aVQ")).PHASE).LAZY && (0, (0, parcelRequire("hxZ3X")).getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>(0, ($parcel$interopDefault($5uXOq))).createElement("link", {
                    key: url,
                    rel: defer === (0, (0, parcelRequire("55aVQ")).PHASE).PAINT ? 'preload' : 'prefetch',
                    href: url,
                    crossOrigin: crossOrigin,
                    as: "script"
                })), Resolved ? (0, ($parcel$interopDefault($5uXOq))).createElement(Resolved, props) : fallback, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                type: "hidden",
                "data-lazy-end": dataLazyId
            }));
        };
    }
});
parcelRegister("30GKG", function(module, exports) {
    $parcel$export(module.exports, "PRIORITY", ()=>$1e2509fc9e13f2d0$export$bb34f3538ba26c7e);
    $parcel$export(module.exports, "RETRY_DELAY", ()=>$1e2509fc9e13f2d0$export$a339266ad71b2447);
    $parcel$export(module.exports, "RETRY_FACTOR", ()=>$1e2509fc9e13f2d0$export$ba64c908e55507fe);
    const $1e2509fc9e13f2d0$export$bb34f3538ba26c7e = {
        HIGH: 0,
        LOW: 2
    };
    const $1e2509fc9e13f2d0$export$a339266ad71b2447 = 300;
    const $1e2509fc9e13f2d0$export$ba64c908e55507fe = 1;
});
parcelRegister("h6rTN", function(module, exports) {
    $parcel$export(module.exports, "createDeferred", ()=>$1c1fef7a07326ad7$export$e673efccd97e4223);
    const $1c1fef7a07326ad7$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
        let resolve;
        const deferred = {
            promise: new Promise((res)=>{
                resolve = (m)=>{
                    let withDefault;
                    deferred.result = m;
                    if (!m.default) withDefault = {
                        default: m
                    };
                    res(withDefault ? withDefault : m);
                };
            }),
            result: undefined,
            preload: ()=>{
                if (deferred.result) return;
                preload().then((m)=>{
                    deferred.result = m;
                }).catch(()=>{});
            },
            start: ()=>{
                if (deferred.result) {
                    resolve(deferred.result);
                    return Promise.resolve();
                }
                return loader().then(resolve);
            }
        };
        return deferred;
    };
});
parcelRegister("aOd2o", function(module, exports) {
    $parcel$export(module.exports, "preloadAsset", ()=>$ddb1facb367ac522$export$25bad4aa00c45355);
    var $hxZ3X;
    var $hORJV;
    var $6MBHi;
    var $7UTZj;
    var $ljLQI;
    var $30GKG;
    var $8OG7s;
    function $ddb1facb367ac522$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
        const { manifest: manifest } = (0, (0, parcelRequire("6MBHi")).getConfig)();
        const assets = (0, (0, parcelRequire("hxZ3X")).getAssetUrlsFromId)(manifest, moduleId);
        if (!assets) throw new Error('Unsupported preload strategy');
        const cleanupLinkTags = assets.map((url)=>(0, (0, parcelRequire("8OG7s")).insertLinkTag)(url, rel));
        return ()=>{
            for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
        };
    }
    const $ddb1facb367ac522$var$fakePromise = {
        then: ()=>$ddb1facb367ac522$var$fakePromise,
        catch: ()=>$ddb1facb367ac522$var$fakePromise,
        finally: ()=>$ddb1facb367ac522$var$fakePromise
    };
    function $ddb1facb367ac522$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
        if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
        const requireEnsure = __webpack_require__.e;
        const cleanupLinkTags = [];
        __webpack_require__.e = function requirePreload(chunkId) {
            const href = __webpack_get_script_filename__(chunkId);
            cleanupLinkTags.push((0, (0, parcelRequire("8OG7s")).insertLinkTag)(href, rel));
            return $ddb1facb367ac522$var$fakePromise;
        };
        try {
            loader();
        } catch (err) {}
        __webpack_require__.e = requireEnsure;
        return ()=>{
            for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
        };
    }
    function $ddb1facb367ac522$export$eb05139fa4dcf992({ loader: loader }) {
        loader();
        return 0, (0, parcelRequire("hORJV")).noopCleanup;
    }
    function $ddb1facb367ac522$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
        if ((0, (0, parcelRequire("ljLQI")).isNodeEnvironment)()) return 0, (0, parcelRequire("hORJV")).noopCleanup;
        (0, (0, parcelRequire("7UTZj")).GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
        const rel = priority === (0, (0, parcelRequire("30GKG")).PRIORITY).HIGH ? 'preload' : 'prefetch';
        const preloadStrategies = [
            $ddb1facb367ac522$export$3af04dbcb01bad4d,
            $ddb1facb367ac522$export$1046fd6a49d5e7a,
            $ddb1facb367ac522$export$eb05139fa4dcf992
        ];
        for (const strategy of preloadStrategies)try {
            return strategy({
                loader: loader,
                moduleId: moduleId,
                rel: rel
            });
        } catch (_) {}
        return 0, (0, parcelRequire("hORJV")).noopCleanup;
    }
});
parcelRegister("8OG7s", function(module, exports) {
    $parcel$export(module.exports, "insertLinkTag", ()=>$31885bfb91291959$export$6610512821c8a4ce);
    var $hORJV;
    var $6MBHi;
    var $7UTZj;
    function $31885bfb91291959$export$6610512821c8a4ce(href, rel) {
        if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, (0, parcelRequire("hORJV")).noopCleanup;
        const { crossOrigin: crossOrigin } = (0, (0, parcelRequire("6MBHi")).getConfig)();
        const link = document.createElement('link');
        link.rel = rel;
        link.as = 'script';
        if (crossOrigin) link.crossOrigin = crossOrigin;
        link.href = href;
        const profiler = (0, (0, parcelRequire("7UTZj")).GlobalReactLooselyLazyProfiler).current;
        let removableListener = null;
        if (profiler) {
            const eventInfo = {
                identifier: href
            };
            const listener = ()=>{
                link.removeEventListener('onload', listener);
                removableListener = null;
                profiler.onLoadComplete(eventInfo);
            };
            link.addEventListener('onload', listener);
            removableListener = listener;
            profiler.onLoadStart(eventInfo);
        }
        document.head?.appendChild(link);
        return ()=>{
            if (link.parentNode === document.head) document.head?.removeChild(link);
            if (removableListener) link.removeEventListener('onload', removableListener);
        };
    }
});
parcelRegister("8EryS", function(module, exports) {
    $parcel$export(module.exports, "retry", ()=>$c0dfab34c32a8fa2$export$9369b12211e1fce4);
    const $c0dfab34c32a8fa2$var$calculateDelay = (context, policy)=>{
        const { attempt: attempt } = context;
        const { delay: delay, factor: factor } = policy;
        const retryAttempt = attempt - 1;
        if (retryAttempt === 1 || delay === 0) return 0;
        const add = factor * delay;
        return delay + add * (retryAttempt - 2);
    };
    const $c0dfab34c32a8fa2$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
    const $c0dfab34c32a8fa2$var$getPolicy = (configuration)=>({
            delay: Math.max(0, configuration.delay ?? 0),
            factor: Math.max(0, configuration.factor ?? 0),
            maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
        });
    function $c0dfab34c32a8fa2$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
        const policy = $c0dfab34c32a8fa2$var$getPolicy(policyConfiguration);
        const { maxAttempts: maxAttempts } = policy;
        const context = {
            attempt: 1,
            attemptsRemaining: maxAttempts
        };
        const onError = async (err)=>{
            if (context.attemptsRemaining === 0) throw err;
            context.attempt += 1;
            context.attemptsRemaining -= 1;
            const delay = $c0dfab34c32a8fa2$var$calculateDelay(context, policy);
            if (delay) await $c0dfab34c32a8fa2$var$sleep(delay);
            return retryable().catch(onError);
        };
        return retryable().catch(onError);
    }
});
parcelRegister("fCuES", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcb38b1b0bd499d0$export$2e2bcd8739ae039);
    var $bhUJ4 = parcelRequire("bhUJ4");
    var $k0HOQ;
    const $bcb38b1b0bd499d0$var$DEFAULT_TIMING = {
        initialPollInterval: 5000,
        idleTimeout: 30000,
        multiplierCallback: (x)=>x + x
    };
    class $bcb38b1b0bd499d0$export$2e2bcd8739ae039 {
        constructor(trackCallback, eventData, searchSessionId, timingOptions){
            this.start = ()=>{
                this.browserInteractionTime.startTimer();
                this.browserInteractionTime.addTimeIntervalEllapsedCallback({
                    callback: (timeInMilliseconds)=>this._sendDwellEvent(this._eventData, this._searchSessionId, timeInMilliseconds, false),
                    timeInMilliseconds: this._timing.initialPollInterval,
                    multiplier: this._timing.multiplierCallback
                });
                if (typeof window !== 'undefined') window.addEventListener('beforeunload', this._onBeforeUnload);
            };
            this.stop = ()=>{
                if (this.browserInteractionTime.isRunning()) this._sendDwellEvent(this._eventData, this._searchSessionId, this.browserInteractionTime.getTimeInMilliseconds(), true);
                this.browserInteractionTime.stopTimer();
            };
            this.newPage = (eventData, searchSessionId)=>{
                (0, (0, parcelRequire("k0HOQ")).validateDwellBaseEvent)(eventData);
                this.stop();
                this.browserInteractionTime.reset();
                this.setEventData(eventData);
                this.setSearchSessionId(searchSessionId);
                this.start();
            };
            this.setEventData = (eventData)=>{
                this._eventData = eventData;
            };
            this.getEventData = ()=>this._eventData;
            this.setSearchSessionId = (searchSessionId)=>{
                this._searchSessionId = searchSessionId;
            };
            this.getSearchSessionId = ()=>this._searchSessionId;
            this.destroy = ()=>{
                this.browserInteractionTime.destroy();
                if (typeof window !== 'undefined') window.removeEventListener('beforeunload', this._onBeforeUnload);
            };
            this._onBeforeUnload = ()=>{
                this.stop();
                this.destroy();
            };
            this._sendDwellEvent = (eventData, searchSessionId, timeInMilliseconds, isFinalDwellEvent)=>{
                const dwellAttributes = {
                    dwellTime: timeInMilliseconds,
                    searchReferrer: searchSessionId,
                    finalDwellEvent: isFinalDwellEvent
                };
                this._trackCallback({
                    action: 'dwelled',
                    actionSubject: eventData.actionSubject,
                    actionSubjectId: eventData.actionSubjectId,
                    source: eventData.source,
                    containerType: eventData.containerType,
                    containerId: eventData.containerId,
                    objectType: eventData.objectType,
                    objectId: eventData.objectId,
                    attributes: {
                        ...dwellAttributes,
                        ...eventData.attributes
                    },
                    tags: eventData.tags
                });
            };
            if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
            (0, (0, parcelRequire("k0HOQ")).validateDwellBaseEvent)(eventData);
            this._trackCallback = trackCallback;
            this._eventData = eventData;
            this._searchSessionId = searchSessionId;
            this._timing = {
                ...$bcb38b1b0bd499d0$var$DEFAULT_TIMING,
                ...timingOptions
            };
            this.browserInteractionTime = new (0, $bhUJ4.default)({
                idleTimeoutMs: this._timing.idleTimeout,
                checkCallbacksIntervalMs: 500
            });
        }
    }
});
parcelRegister("3qQLk", function(module, exports) {
    $parcel$export(module.exports, "LazyWait", ()=>$ac537bcceff34b55$export$7bf6cf03fd32cddb);
    var $5uXOq = parcelRequire("5uXOq");
    var $hJDE6;
    const $ac537bcceff34b55$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
        const closestWait = (0, $5uXOq.useContext)((0, (0, parcelRequire("hJDE6")).WaitContext));
        const value = (0, $5uXOq.useRef)(until && closestWait.currentValue() ? 1 : 0);
        const subscribers = (0, $5uXOq.useRef)(new Set());
        const api = (0, $5uXOq.useRef)({
            subscribe: (subscriber)=>{
                subscribers.current.add(subscriber);
                return ()=>{
                    subscribers.current.delete(subscriber);
                };
            },
            currentValue: ()=>value.current
        });
        (0, $5uXOq.useEffect)(()=>{
            const notify = ()=>{
                value.current = closestWait.currentValue() && until ? 1 : 0;
                subscribers.current.forEach((subscriber)=>subscriber());
            };
            notify();
            return closestWait.subscribe(notify);
        }, [
            closestWait,
            until
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJDE6")).WaitContext).Provider, {
            value: api.current
        }, children);
    };
});
parcelRegister("dYcrb", function(module, exports) {
    $parcel$export(module.exports, "LooselyLazy", ()=>$ca7ec2aa23ec10e7$export$33c5f161e1d4706);
    var $hihWl;
    var $6MBHi;
    var $j1NL0;
    var $clxrE;
    var $ljLQI;
    const $ca7ec2aa23ec10e7$export$33c5f161e1d4706 = {
        init: (config)=>{
            (0, (0, parcelRequire("6MBHi")).setConfig)(config);
            (0, (0, parcelRequire("j1NL0")).LISTENERS).length = 0;
            (0, (0, parcelRequire("clxrE")).setCurrent)(0);
            if (!(0, (0, parcelRequire("ljLQI")).isNodeEnvironment)()) (0, (0, parcelRequire("hihWl")).collect)();
        }
    };
});
parcelRegister("hihWl", function(module, exports) {
    $parcel$export(module.exports, "collect", ()=>$7b9432fffde207ee$export$bb44f104e3c54dae);
    var $6MBHi;
    var $jTyr9;
    var $55aVQ;
    var $fbFWZ;
    var $5Rjp9;
    const $7b9432fffde207ee$export$bb44f104e3c54dae = ()=>{
        const markers = document.querySelectorAll('input[data-lazy-begin]');
        const { mode: mode } = (0, (0, parcelRequire("6MBHi")).getConfig)();
        for(let i = 0, j = markers.length; i < j; i += 1){
            const el = markers[i];
            const { lazyBegin: lazyBegin } = el.dataset || {};
            const value = mode === (0, (0, parcelRequire("jTyr9")).MODE).RENDER ? (0, (0, parcelRequire("fbFWZ")).cloneElements)(markers[i], lazyBegin) : (0, (0, parcelRequire("5Rjp9")).refElements)(markers[i], lazyBegin);
            if ((0, (0, parcelRequire("55aVQ")).COLLECTED).has(lazyBegin)) (0, (0, parcelRequire("55aVQ")).COLLECTED).get(lazyBegin).push(value);
            else (0, (0, parcelRequire("55aVQ")).COLLECTED).set(lazyBegin, [
                value
            ]);
        }
    };
});
parcelRegister("fbFWZ", function(module, exports) {
    $parcel$export(module.exports, "cloneElements", ()=>$b881740e6d2493f4$export$c42217d53a7ebafb);
    const $b881740e6d2493f4$export$c42217d53a7ebafb = (fromEl, id)=>{
        const fragment = document.createElement('div');
        let el = fromEl;
        while(el = el.nextSibling){
            if (el.dataset && el.dataset.lazyEnd === id) break;
            fragment.appendChild(el.cloneNode(true));
        }
        return Array.from(fragment.childNodes);
    };
});
parcelRegister("5Rjp9", function(module, exports) {
    $parcel$export(module.exports, "refElements", ()=>$2d8f7b97c875126b$export$c69443129766a7fc);
    const $2d8f7b97c875126b$export$c69443129766a7fc = (fromEl, id)=>{
        const result = [];
        let el = fromEl;
        while(el = el.nextSibling){
            if (el.dataset && el.dataset.lazyEnd === id) break;
            result.push(el);
        }
        return result;
    };
});
parcelRegister("hgqoY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3de87441ce10002$export$2e2bcd8739ae039);
    var $awmeS = parcelRequire("awmeS");
    var $k0HOQ;
    const $a3de87441ce10002$var$DEFAULT_TIMING = {
        initialPollInterval: 5,
        pollBackoffRate: 2,
        idleTimeout: 30
    };
    class $a3de87441ce10002$export$2e2bcd8739ae039 {
        constructor(trackCallback, eventData, searchSessionId, timingOptions, dwellTimeHelperOptions){
            this.timeMeInitialized = false;
            this.start = ()=>{
                if (this.timeMeInitialized) throw new Error('DwellTimeHelper should only be initialised once per page load.');
                this.timeMeInitialized = true;
                this._initDwellTimeCounterAndPolling();
                if (typeof window !== 'undefined') window.addEventListener('beforeunload', ()=>{
                    this.stop();
                });
            };
            this.stop = ()=>{
                if ((0, ($parcel$interopDefault($awmeS))).isUserCurrentlyOnPage) this._sendDwellEvent(this._eventData, this._searchSessionId, true);
                (0, ($parcel$interopDefault($awmeS))).stopAllTimers();
                (0, ($parcel$interopDefault($awmeS))).resetAllRecordedPageTimes();
                (0, ($parcel$interopDefault($awmeS))).timeElapsedCallbacks = [];
                this.timeMeInitialized = false;
            };
            this.newPage = (eventData, searchSessionId)=>{
                (0, (0, parcelRequire("k0HOQ")).validateDwellBaseEvent)(eventData);
                this.stop();
                this._eventData = eventData;
                this._searchSessionId = searchSessionId;
                this._initDwellTimeCounterAndPolling();
            };
            this._listForIdleEvents = ()=>{
                document.addEventListener('mousemove', ()=>{
                    (0, ($parcel$interopDefault($awmeS))).userActivityDetected();
                });
                document.addEventListener('keyup', ()=>{
                    (0, ($parcel$interopDefault($awmeS))).userActivityDetected();
                });
                document.addEventListener('touchstart', ()=>{
                    (0, ($parcel$interopDefault($awmeS))).userActivityDetected();
                });
                window.addEventListener('scroll', ()=>{
                    (0, ($parcel$interopDefault($awmeS))).userActivityDetected();
                });
                const iframes = document.getElementsByTagName('iframe');
                for(let i = 0; i < iframes.length; i++){
                    const iframe = iframes[i];
                    try {
                        iframe?.contentWindow?.document.addEventListener('mousemove', ()=>{
                            (0, ($parcel$interopDefault($awmeS))).userActivityDetected();
                        });
                        iframe?.contentWindow?.document.addEventListener('keyup', ()=>{
                            (0, ($parcel$interopDefault($awmeS))).userActivityDetected();
                        });
                        iframe?.contentWindow?.document.addEventListener('touchstart', ()=>{
                            (0, ($parcel$interopDefault($awmeS))).userActivityDetected();
                        });
                    } catch (e) {}
                }
                setInterval(()=>{
                    if ((0, ($parcel$interopDefault($awmeS))).isUserCurrentlyIdle !== true) {
                        (0, ($parcel$interopDefault($awmeS))).checkIdleState();
                        (0, ($parcel$interopDefault($awmeS))).startTimer();
                    }
                }, (0, ($parcel$interopDefault($awmeS))).checkIdleStateRateMs);
            };
            this._initDwellTimeCounterAndPolling = ()=>{
                if (this._dwellTimeHelperOptions?.iframeDwell) (0, ($parcel$interopDefault($awmeS))).listForIdleEvents = this._listForIdleEvents;
                (0, ($parcel$interopDefault($awmeS))).initialize({
                    idleTimeoutInSeconds: this._timing.idleTimeout
                });
                this._pollDwellTime(this._timing.initialPollInterval, this._searchSessionId, this._eventData);
            };
            this._pollDwellTime = (pollTime, searchSessionId, eventData)=>{
                (0, ($parcel$interopDefault($awmeS))).callAfterTimeElapsedInSeconds(pollTime, ()=>{
                    this._sendDwellEvent(eventData, searchSessionId, false);
                    this._pollDwellTime(pollTime * this._timing.pollBackoffRate, searchSessionId, eventData);
                });
            };
            this._sendDwellEvent = (eventData, searchSessionId, isFinalDwellEvent)=>{
                const dwellAttributes = {
                    dwellTime: (0, ($parcel$interopDefault($awmeS))).getTimeOnCurrentPageInMilliseconds(),
                    searchReferrer: searchSessionId,
                    finalDwellEvent: isFinalDwellEvent
                };
                this._trackCallback({
                    action: 'dwelled',
                    actionSubject: eventData.actionSubject,
                    actionSubjectId: eventData.actionSubjectId,
                    source: eventData.source,
                    containerType: eventData.containerType,
                    containerId: eventData.containerId,
                    containers: eventData.containers,
                    objectType: eventData.objectType,
                    objectId: eventData.objectId,
                    attributes: {
                        ...dwellAttributes,
                        ...eventData.attributes
                    },
                    tags: eventData.tags
                });
            };
            if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
            (0, (0, parcelRequire("k0HOQ")).validateDwellBaseEvent)(eventData);
            this._trackCallback = trackCallback;
            this._eventData = eventData;
            this._searchSessionId = searchSessionId;
            this._timing = {
                ...$a3de87441ce10002$var$DEFAULT_TIMING,
                ...timingOptions
            };
            this._dwellTimeHelperOptions = dwellTimeHelperOptions;
        }
    }
});
const $0ec629ff645fb0d9$export$70df29c238ba7306 = 'mediaCtx';
var $5e0c0d4e15efb4a6$exports = {};
$parcel$export($5e0c0d4e15efb4a6$exports, "R50", ()=>$5e0c0d4e15efb4a6$export$4b84fd0e2c617bd);
$parcel$export($5e0c0d4e15efb4a6$exports, "R75", ()=>$5e0c0d4e15efb4a6$export$b34b069eff244586);
$parcel$export($5e0c0d4e15efb4a6$exports, "R100", ()=>$5e0c0d4e15efb4a6$export$be802dd0d8b57f35);
$parcel$export($5e0c0d4e15efb4a6$exports, "R200", ()=>$5e0c0d4e15efb4a6$export$60847d42f9da92a6);
$parcel$export($5e0c0d4e15efb4a6$exports, "R300", ()=>$5e0c0d4e15efb4a6$export$4a7404f376229999);
$parcel$export($5e0c0d4e15efb4a6$exports, "R400", ()=>$5e0c0d4e15efb4a6$export$2010d0fb4295b346);
$parcel$export($5e0c0d4e15efb4a6$exports, "R500", ()=>$5e0c0d4e15efb4a6$export$2837b5a1a71d5c02);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y50", ()=>$5e0c0d4e15efb4a6$export$8d9596b529bbb9cf);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y75", ()=>$5e0c0d4e15efb4a6$export$41060a744ab0b7ae);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y100", ()=>$5e0c0d4e15efb4a6$export$1cc05bbbf340e559);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y200", ()=>$5e0c0d4e15efb4a6$export$5aae31392d72caaa);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y300", ()=>$5e0c0d4e15efb4a6$export$c6930421db9fa514);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y400", ()=>$5e0c0d4e15efb4a6$export$59619663aa6500fb);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y500", ()=>$5e0c0d4e15efb4a6$export$874739ea9e379ab6);
$parcel$export($5e0c0d4e15efb4a6$exports, "G50", ()=>$5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6);
$parcel$export($5e0c0d4e15efb4a6$exports, "G75", ()=>$5e0c0d4e15efb4a6$export$69a3bf21b9686c2b);
$parcel$export($5e0c0d4e15efb4a6$exports, "G100", ()=>$5e0c0d4e15efb4a6$export$afbce1382ec95f73);
$parcel$export($5e0c0d4e15efb4a6$exports, "G200", ()=>$5e0c0d4e15efb4a6$export$747d86715d4175de);
$parcel$export($5e0c0d4e15efb4a6$exports, "G300", ()=>$5e0c0d4e15efb4a6$export$940e1f69e873f202);
$parcel$export($5e0c0d4e15efb4a6$exports, "G400", ()=>$5e0c0d4e15efb4a6$export$a49394138f7b8e85);
$parcel$export($5e0c0d4e15efb4a6$exports, "G500", ()=>$5e0c0d4e15efb4a6$export$6fa04827ac68a4fb);
$parcel$export($5e0c0d4e15efb4a6$exports, "B50", ()=>$5e0c0d4e15efb4a6$export$226de0355ed012f8);
$parcel$export($5e0c0d4e15efb4a6$exports, "B75", ()=>$5e0c0d4e15efb4a6$export$8c13c2ee36917869);
$parcel$export($5e0c0d4e15efb4a6$exports, "B100", ()=>$5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a);
$parcel$export($5e0c0d4e15efb4a6$exports, "B200", ()=>$5e0c0d4e15efb4a6$export$215b7063051591f1);
$parcel$export($5e0c0d4e15efb4a6$exports, "B300", ()=>$5e0c0d4e15efb4a6$export$e62e8919cca44969);
$parcel$export($5e0c0d4e15efb4a6$exports, "B400", ()=>$5e0c0d4e15efb4a6$export$b3de0ae08da2ce64);
$parcel$export($5e0c0d4e15efb4a6$exports, "B500", ()=>$5e0c0d4e15efb4a6$export$a6ee3d71bc067634);
$parcel$export($5e0c0d4e15efb4a6$exports, "B600", ()=>$5e0c0d4e15efb4a6$export$67f15409e87642a1);
$parcel$export($5e0c0d4e15efb4a6$exports, "B700", ()=>$5e0c0d4e15efb4a6$export$f0539dbc42dbb067);
$parcel$export($5e0c0d4e15efb4a6$exports, "P50", ()=>$5e0c0d4e15efb4a6$export$363e4475840015bb);
$parcel$export($5e0c0d4e15efb4a6$exports, "P75", ()=>$5e0c0d4e15efb4a6$export$4b0a4417ed59760f);
$parcel$export($5e0c0d4e15efb4a6$exports, "P100", ()=>$5e0c0d4e15efb4a6$export$6011520a64d9a187);
$parcel$export($5e0c0d4e15efb4a6$exports, "P200", ()=>$5e0c0d4e15efb4a6$export$a7175d4e9206bc80);
$parcel$export($5e0c0d4e15efb4a6$exports, "P300", ()=>$5e0c0d4e15efb4a6$export$b48405b95304b5a1);
$parcel$export($5e0c0d4e15efb4a6$exports, "P400", ()=>$5e0c0d4e15efb4a6$export$c71e4279dd54a18d);
$parcel$export($5e0c0d4e15efb4a6$exports, "P500", ()=>$5e0c0d4e15efb4a6$export$147899de772240ec);
$parcel$export($5e0c0d4e15efb4a6$exports, "T50", ()=>$5e0c0d4e15efb4a6$export$2cf711fe14c66f06);
$parcel$export($5e0c0d4e15efb4a6$exports, "T75", ()=>$5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c);
$parcel$export($5e0c0d4e15efb4a6$exports, "T100", ()=>$5e0c0d4e15efb4a6$export$776c9c497ef08533);
$parcel$export($5e0c0d4e15efb4a6$exports, "T200", ()=>$5e0c0d4e15efb4a6$export$69cb3ca10c1e330e);
$parcel$export($5e0c0d4e15efb4a6$exports, "T300", ()=>$5e0c0d4e15efb4a6$export$9dc1ef0f3f48059b);
$parcel$export($5e0c0d4e15efb4a6$exports, "T400", ()=>$5e0c0d4e15efb4a6$export$7c835c78b6fcdef8);
$parcel$export($5e0c0d4e15efb4a6$exports, "T500", ()=>$5e0c0d4e15efb4a6$export$6036577f95c3877e);
$parcel$export($5e0c0d4e15efb4a6$exports, "N0", ()=>$5e0c0d4e15efb4a6$export$29a4f05edc054374);
$parcel$export($5e0c0d4e15efb4a6$exports, "N10", ()=>$5e0c0d4e15efb4a6$export$e655ef011c4aa1a2);
$parcel$export($5e0c0d4e15efb4a6$exports, "N20", ()=>$5e0c0d4e15efb4a6$export$9fdfb749e33cdf97);
$parcel$export($5e0c0d4e15efb4a6$exports, "N30", ()=>$5e0c0d4e15efb4a6$export$3e51e8f1440314ba);
$parcel$export($5e0c0d4e15efb4a6$exports, "N40", ()=>$5e0c0d4e15efb4a6$export$1ce2d1575d444ceb);
$parcel$export($5e0c0d4e15efb4a6$exports, "N50", ()=>$5e0c0d4e15efb4a6$export$8754fc7e6d8b3000);
$parcel$export($5e0c0d4e15efb4a6$exports, "N60", ()=>$5e0c0d4e15efb4a6$export$c2e91cbeada39b8b);
$parcel$export($5e0c0d4e15efb4a6$exports, "N70", ()=>$5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de);
$parcel$export($5e0c0d4e15efb4a6$exports, "N80", ()=>$5e0c0d4e15efb4a6$export$eaa8c8a70ac22806);
$parcel$export($5e0c0d4e15efb4a6$exports, "N90", ()=>$5e0c0d4e15efb4a6$export$7c87d337fb91a97d);
$parcel$export($5e0c0d4e15efb4a6$exports, "N100", ()=>$5e0c0d4e15efb4a6$export$d6447c357493214f);
$parcel$export($5e0c0d4e15efb4a6$exports, "N200", ()=>$5e0c0d4e15efb4a6$export$f563ee71e9ee74cd);
$parcel$export($5e0c0d4e15efb4a6$exports, "N300", ()=>$5e0c0d4e15efb4a6$export$e2ef2124cf4024b1);
$parcel$export($5e0c0d4e15efb4a6$exports, "N400", ()=>$5e0c0d4e15efb4a6$export$eece5f492e429f08);
$parcel$export($5e0c0d4e15efb4a6$exports, "N500", ()=>$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae);
$parcel$export($5e0c0d4e15efb4a6$exports, "N600", ()=>$5e0c0d4e15efb4a6$export$7090862dc3038a9f);
$parcel$export($5e0c0d4e15efb4a6$exports, "N700", ()=>$5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa);
$parcel$export($5e0c0d4e15efb4a6$exports, "N800", ()=>$5e0c0d4e15efb4a6$export$7d61b15e0da132af);
$parcel$export($5e0c0d4e15efb4a6$exports, "N900", ()=>$5e0c0d4e15efb4a6$export$fbda843f0a27fe96);
$parcel$export($5e0c0d4e15efb4a6$exports, "N10A", ()=>$5e0c0d4e15efb4a6$export$791e57b27ca738ef);
$parcel$export($5e0c0d4e15efb4a6$exports, "N20A", ()=>$5e0c0d4e15efb4a6$export$8d43898f60b96a82);
$parcel$export($5e0c0d4e15efb4a6$exports, "N30A", ()=>$5e0c0d4e15efb4a6$export$920c0d5c49070351);
$parcel$export($5e0c0d4e15efb4a6$exports, "N40A", ()=>$5e0c0d4e15efb4a6$export$46987b49aab6d1a8);
$parcel$export($5e0c0d4e15efb4a6$exports, "N50A", ()=>$5e0c0d4e15efb4a6$export$7d3359664e8bb0e5);
$parcel$export($5e0c0d4e15efb4a6$exports, "N60A", ()=>$5e0c0d4e15efb4a6$export$d2d3bedfb276cac0);
$parcel$export($5e0c0d4e15efb4a6$exports, "N70A", ()=>$5e0c0d4e15efb4a6$export$6e5e7499ff054f6d);
$parcel$export($5e0c0d4e15efb4a6$exports, "N80A", ()=>$5e0c0d4e15efb4a6$export$59264b346c877fa7);
$parcel$export($5e0c0d4e15efb4a6$exports, "N90A", ()=>$5e0c0d4e15efb4a6$export$d092757d7c64925c);
$parcel$export($5e0c0d4e15efb4a6$exports, "N100A", ()=>$5e0c0d4e15efb4a6$export$486ab785e4bac3c6);
$parcel$export($5e0c0d4e15efb4a6$exports, "N200A", ()=>$5e0c0d4e15efb4a6$export$fba592bbc6419fea);
$parcel$export($5e0c0d4e15efb4a6$exports, "N300A", ()=>$5e0c0d4e15efb4a6$export$13609db0e6812ab8);
$parcel$export($5e0c0d4e15efb4a6$exports, "N400A", ()=>$5e0c0d4e15efb4a6$export$fbae4efaa892d883);
$parcel$export($5e0c0d4e15efb4a6$exports, "N500A", ()=>$5e0c0d4e15efb4a6$export$f13946d26f440ce6);
$parcel$export($5e0c0d4e15efb4a6$exports, "N600A", ()=>$5e0c0d4e15efb4a6$export$19f58225ac52a306);
$parcel$export($5e0c0d4e15efb4a6$exports, "N700A", ()=>$5e0c0d4e15efb4a6$export$6384f09da70e7b62);
$parcel$export($5e0c0d4e15efb4a6$exports, "N800A", ()=>$5e0c0d4e15efb4a6$export$d0dccc730683edc2);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN900", ()=>$5e0c0d4e15efb4a6$export$2f6319cf7d736c2a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN800", ()=>$5e0c0d4e15efb4a6$export$95126bc8884d6634);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN700", ()=>$5e0c0d4e15efb4a6$export$8338d8c35d44ff1);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN600", ()=>$5e0c0d4e15efb4a6$export$5368d76ae4fbbda7);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN500", ()=>$5e0c0d4e15efb4a6$export$9f0a771d16ec8d36);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN400", ()=>$5e0c0d4e15efb4a6$export$abcf8c38338b4aa5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN300", ()=>$5e0c0d4e15efb4a6$export$97e81faa16a182c7);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN200", ()=>$5e0c0d4e15efb4a6$export$bfe21c59123ecf33);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN100", ()=>$5e0c0d4e15efb4a6$export$ee82aa2ea6a1558);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN90", ()=>$5e0c0d4e15efb4a6$export$682927c6ed76be02);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN80", ()=>$5e0c0d4e15efb4a6$export$91fd9994c5be9757);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN70", ()=>$5e0c0d4e15efb4a6$export$d281fbfe3cff2df6);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN60", ()=>$5e0c0d4e15efb4a6$export$3902c91d8b98a753);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN50", ()=>$5e0c0d4e15efb4a6$export$8e8133c1ba5845b5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN40", ()=>$5e0c0d4e15efb4a6$export$33ff357f6620b39);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN30", ()=>$5e0c0d4e15efb4a6$export$633847cf062b69e0);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN20", ()=>$5e0c0d4e15efb4a6$export$9776a6e503bdbf76);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN10", ()=>$5e0c0d4e15efb4a6$export$6c813d5160dff5db);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN0", ()=>$5e0c0d4e15efb4a6$export$3d4f271a500072a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN800A", ()=>$5e0c0d4e15efb4a6$export$fe151285c22759ec);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN700A", ()=>$5e0c0d4e15efb4a6$export$a101c6190d0da34);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN600A", ()=>$5e0c0d4e15efb4a6$export$4b16f52932fda51);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN500A", ()=>$5e0c0d4e15efb4a6$export$a74bcd7b9845b0d8);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN400A", ()=>$5e0c0d4e15efb4a6$export$9209c179316d1751);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN300A", ()=>$5e0c0d4e15efb4a6$export$88f55133f636c8dd);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN200A", ()=>$5e0c0d4e15efb4a6$export$51126f85d1009512);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN100A", ()=>$5e0c0d4e15efb4a6$export$a069b547bd23af78);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN90A", ()=>$5e0c0d4e15efb4a6$export$40cce05af3b2600a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN80A", ()=>$5e0c0d4e15efb4a6$export$b78942185925a0d);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN70A", ()=>$5e0c0d4e15efb4a6$export$e058fb44b8eaafca);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN60A", ()=>$5e0c0d4e15efb4a6$export$92b0b8de26920c18);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN50A", ()=>$5e0c0d4e15efb4a6$export$67564f7459d3fc9e);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN40A", ()=>$5e0c0d4e15efb4a6$export$77868e1ca884ffa3);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN30A", ()=>$5e0c0d4e15efb4a6$export$2afd71d7d3ea2cd5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN20A", ()=>$5e0c0d4e15efb4a6$export$f2a0acaab9972c70);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN10A", ()=>$5e0c0d4e15efb4a6$export$9ab70e67d6475361);
$parcel$export($5e0c0d4e15efb4a6$exports, "T30", ()=>$5e0c0d4e15efb4a6$export$d2adc5dedf09fced);
$parcel$export($5e0c0d4e15efb4a6$exports, "L50", ()=>$5e0c0d4e15efb4a6$export$f51762073d2bb381);
$parcel$export($5e0c0d4e15efb4a6$exports, "L75", ()=>$5e0c0d4e15efb4a6$export$95e26d54def96891);
const $5e0c0d4e15efb4a6$export$4b84fd0e2c617bd = '#FFEBE6';
const $5e0c0d4e15efb4a6$export$b34b069eff244586 = '#FFBDAD';
const $5e0c0d4e15efb4a6$export$be802dd0d8b57f35 = '#FF8F73';
const $5e0c0d4e15efb4a6$export$60847d42f9da92a6 = '#FF7452';
const $5e0c0d4e15efb4a6$export$4a7404f376229999 = '#FF5630';
const $5e0c0d4e15efb4a6$export$2010d0fb4295b346 = '#DE350B';
const $5e0c0d4e15efb4a6$export$2837b5a1a71d5c02 = '#BF2600';
const $5e0c0d4e15efb4a6$export$8d9596b529bbb9cf = '#FFFAE6';
const $5e0c0d4e15efb4a6$export$41060a744ab0b7ae = '#FFF0B3';
const $5e0c0d4e15efb4a6$export$1cc05bbbf340e559 = '#FFE380';
const $5e0c0d4e15efb4a6$export$5aae31392d72caaa = '#FFC400';
const $5e0c0d4e15efb4a6$export$c6930421db9fa514 = '#FFAB00';
const $5e0c0d4e15efb4a6$export$59619663aa6500fb = '#FF991F';
const $5e0c0d4e15efb4a6$export$874739ea9e379ab6 = '#FF8B00';
const $5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $5e0c0d4e15efb4a6$export$69a3bf21b9686c2b = '#ABF5D1';
const $5e0c0d4e15efb4a6$export$afbce1382ec95f73 = '#79F2C0';
const $5e0c0d4e15efb4a6$export$747d86715d4175de = '#57D9A3';
const $5e0c0d4e15efb4a6$export$940e1f69e873f202 = '#36B37E';
const $5e0c0d4e15efb4a6$export$a49394138f7b8e85 = '#00875A';
const $5e0c0d4e15efb4a6$export$6fa04827ac68a4fb = '#006644';
const $5e0c0d4e15efb4a6$export$226de0355ed012f8 = '#DEEBFF';
const $5e0c0d4e15efb4a6$export$8c13c2ee36917869 = '#B3D4FF';
const $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a = '#4C9AFF';
const $5e0c0d4e15efb4a6$export$215b7063051591f1 = '#2684FF';
const $5e0c0d4e15efb4a6$export$e62e8919cca44969 = '#0065FF';
const $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64 = '#0052CC';
const $5e0c0d4e15efb4a6$export$a6ee3d71bc067634 = '#0747A6';
const $5e0c0d4e15efb4a6$export$67f15409e87642a1 = '#669DF1';
const $5e0c0d4e15efb4a6$export$f0539dbc42dbb067 = '#8FB8F6';
const $5e0c0d4e15efb4a6$export$363e4475840015bb = '#EAE6FF';
const $5e0c0d4e15efb4a6$export$4b0a4417ed59760f = '#C0B6F2';
const $5e0c0d4e15efb4a6$export$6011520a64d9a187 = '#998DD9';
const $5e0c0d4e15efb4a6$export$a7175d4e9206bc80 = '#8777D9';
const $5e0c0d4e15efb4a6$export$b48405b95304b5a1 = '#6554C0';
const $5e0c0d4e15efb4a6$export$c71e4279dd54a18d = '#5243AA';
const $5e0c0d4e15efb4a6$export$147899de772240ec = '#403294';
const $5e0c0d4e15efb4a6$export$2cf711fe14c66f06 = '#E6FCFF';
const $5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c = '#B3F5FF';
const $5e0c0d4e15efb4a6$export$776c9c497ef08533 = '#79E2F2';
const $5e0c0d4e15efb4a6$export$69cb3ca10c1e330e = '#00C7E6';
const $5e0c0d4e15efb4a6$export$9dc1ef0f3f48059b = '#00B8D9';
const $5e0c0d4e15efb4a6$export$7c835c78b6fcdef8 = '#00A3BF';
const $5e0c0d4e15efb4a6$export$6036577f95c3877e = '#008DA6';
const $5e0c0d4e15efb4a6$export$29a4f05edc054374 = '#FFFFFF';
const $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2 = '#FAFBFC';
const $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97 = '#F4F5F7';
const $5e0c0d4e15efb4a6$export$3e51e8f1440314ba = '#EBECF0';
const $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb = '#DFE1E6';
const $5e0c0d4e15efb4a6$export$8754fc7e6d8b3000 = '#C1C7D0';
const $5e0c0d4e15efb4a6$export$c2e91cbeada39b8b = '#B3BAC5';
const $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de = '#A5ADBA';
const $5e0c0d4e15efb4a6$export$eaa8c8a70ac22806 = '#97A0AF';
const $5e0c0d4e15efb4a6$export$7c87d337fb91a97d = '#8993A4';
const $5e0c0d4e15efb4a6$export$d6447c357493214f = '#7A869A';
const $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd = '#6B778C';
const $5e0c0d4e15efb4a6$export$e2ef2124cf4024b1 = '#5E6C84';
const $5e0c0d4e15efb4a6$export$eece5f492e429f08 = '#505F79';
const $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae = '#42526E';
const $5e0c0d4e15efb4a6$export$7090862dc3038a9f = '#344563';
const $5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa = '#253858';
const $5e0c0d4e15efb4a6$export$7d61b15e0da132af = '#172B4D';
const $5e0c0d4e15efb4a6$export$fbda843f0a27fe96 = '#091E42';
const $5e0c0d4e15efb4a6$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $5e0c0d4e15efb4a6$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $5e0c0d4e15efb4a6$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $5e0c0d4e15efb4a6$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $5e0c0d4e15efb4a6$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $5e0c0d4e15efb4a6$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $5e0c0d4e15efb4a6$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $5e0c0d4e15efb4a6$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $5e0c0d4e15efb4a6$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $5e0c0d4e15efb4a6$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $5e0c0d4e15efb4a6$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $5e0c0d4e15efb4a6$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $5e0c0d4e15efb4a6$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $5e0c0d4e15efb4a6$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $5e0c0d4e15efb4a6$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $5e0c0d4e15efb4a6$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $5e0c0d4e15efb4a6$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $5e0c0d4e15efb4a6$export$2f6319cf7d736c2a = '#E6EDFA';
const $5e0c0d4e15efb4a6$export$95126bc8884d6634 = '#DCE5F5';
const $5e0c0d4e15efb4a6$export$8338d8c35d44ff1 = '#CED9EB';
const $5e0c0d4e15efb4a6$export$5368d76ae4fbbda7 = '#B8C7E0';
const $5e0c0d4e15efb4a6$export$9f0a771d16ec8d36 = '#ABBBD6';
const $5e0c0d4e15efb4a6$export$abcf8c38338b4aa5 = '#9FB0CC';
const $5e0c0d4e15efb4a6$export$97e81faa16a182c7 = '#8C9CB8';
const $5e0c0d4e15efb4a6$export$bfe21c59123ecf33 = '#7988A3';
const $5e0c0d4e15efb4a6$export$ee82aa2ea6a1558 = '#67758F';
const $5e0c0d4e15efb4a6$export$682927c6ed76be02 = '#56637A';
const $5e0c0d4e15efb4a6$export$91fd9994c5be9757 = '#455166';
const $5e0c0d4e15efb4a6$export$d281fbfe3cff2df6 = '#3B475C';
const $5e0c0d4e15efb4a6$export$3902c91d8b98a753 = '#313D52';
const $5e0c0d4e15efb4a6$export$8e8133c1ba5845b5 = '#283447';
const $5e0c0d4e15efb4a6$export$33ff357f6620b39 = '#202B3D';
const $5e0c0d4e15efb4a6$export$633847cf062b69e0 = '#1B2638';
const $5e0c0d4e15efb4a6$export$9776a6e503bdbf76 = '#121A29';
const $5e0c0d4e15efb4a6$export$6c813d5160dff5db = '#0E1624';
const $5e0c0d4e15efb4a6$export$3d4f271a500072a = '#0D1424';
const $5e0c0d4e15efb4a6$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $5e0c0d4e15efb4a6$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $5e0c0d4e15efb4a6$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $5e0c0d4e15efb4a6$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $5e0c0d4e15efb4a6$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $5e0c0d4e15efb4a6$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $5e0c0d4e15efb4a6$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $5e0c0d4e15efb4a6$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $5e0c0d4e15efb4a6$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $5e0c0d4e15efb4a6$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $5e0c0d4e15efb4a6$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $5e0c0d4e15efb4a6$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $5e0c0d4e15efb4a6$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $5e0c0d4e15efb4a6$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $5e0c0d4e15efb4a6$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $5e0c0d4e15efb4a6$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $5e0c0d4e15efb4a6$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $5e0c0d4e15efb4a6$export$d2adc5dedf09fced = '#292A2E';
const $5e0c0d4e15efb4a6$export$f51762073d2bb381 = '#94C748';
const $5e0c0d4e15efb4a6$export$95e26d54def96891 = '#B3DF72';
const $c7bb017c5ac5a032$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $c7bb017c5ac5a032$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $c7bb017c5ac5a032$export$13f57c02915787b3 = 'atlaskit-portal';
const $ef175421935e79da$export$ed5835cc67e87f72 = 'akPortalMount';
const $ef175421935e79da$export$80816bd900e5bd00 = 'akPortalUnmount';
const $afa89fc5bcc96d10$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $afa89fc5bcc96d10$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $afa89fc5bcc96d10$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $0d194608dbbf0b94$export$d6830277b06edd6 = 'normal';
const $0d194608dbbf0b94$export$4f8f13a66ae77bdd = '--color';
const $0d194608dbbf0b94$export$e9244ec13bd422b5 = '--bg-color';
const $0d194608dbbf0b94$export$97e78d9745006c11 = '--bg-color-hover';
const $0d194608dbbf0b94$export$291d63757828f290 = '--bg-color-active';
const $a428e064f91eae50$export$a1562d08625f5d7e = 'ui';
const $a428e064f91eae50$export$947dac6c72b26f81 = 'track';
const $a428e064f91eae50$export$f1d537d508d2945a = 'screen';
const $a428e064f91eae50$export$12346a674644c156 = 'operational';
const $a428e064f91eae50$export$b055de0e665cb20c = 'unknown';
$parcel$global.rlb("2Lfdl");
